"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// node_modules/@mallardbay/lib-shared-helpers/dist/src/constants/constants.js
var require_constants = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/constants/constants.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.CODEGEN_SCALAR_TYPES = exports2.ADD_ON_CATEGORIES = exports2.SET_GUEST = exports2.PER_GUEST = exports2.SET_DAY = exports2.PER_DAY = exports2.UserTrackingPropertyName = exports2.ValuePropertyName = void 0;
    var ValuePropertyName;
    (function(ValuePropertyName2) {
      ValuePropertyName2["BooleanValue"] = "boolean_value";
      ValuePropertyName2["NumberValue"] = "number_value";
      ValuePropertyName2["StringValue"] = "string_value";
    })(ValuePropertyName || (exports2.ValuePropertyName = ValuePropertyName = {}));
    var UserTrackingPropertyName;
    (function(UserTrackingPropertyName2) {
      UserTrackingPropertyName2["DashboadVersion"] = "dashboardVersion";
      UserTrackingPropertyName2["FirstName"] = "firstName";
      UserTrackingPropertyName2["HasListings"] = "hasListings";
      UserTrackingPropertyName2["HasTapToPayAccess"] = "hasTapToPayAccess";
      UserTrackingPropertyName2["LastName"] = "lastName";
      UserTrackingPropertyName2["MobileVersion"] = "mobileVersion";
      UserTrackingPropertyName2["WebVersion"] = "webVersion";
    })(UserTrackingPropertyName || (exports2.UserTrackingPropertyName = UserTrackingPropertyName = {}));
    exports2.PER_DAY = "PER_DAY";
    exports2.SET_DAY = "SET_DAY";
    exports2.PER_GUEST = "PER_GUEST";
    exports2.SET_GUEST = "SET_GUEST";
    exports2.ADD_ON_CATEGORIES = {
      GUN_RENTAL: "GUN_RENTAL",
      MEAL_UPGRADE: "MEAL_UPGRADE",
      OTHER: "OTHER",
      TROPHY: "TROPHY"
    };
    exports2.CODEGEN_SCALAR_TYPES = {
      Timestamp: "number",
      TimeZone: "string",
      EmailAddress: "string",
      NonEmptyString: "string",
      NegativeFloat: "number",
      NegativeInt: "number",
      NonNegativeFloat: "number",
      NonNegativeInt: "number",
      NonPositiveFloat: "number",
      NonPositiveInt: "number",
      PhoneNumber: "string",
      PositiveFloat: "number",
      PositiveInt: "number",
      PostalCode: "string",
      UnsignedFloat: "number",
      UnsignedInt: "number",
      URL: "string",
      Latitude: "number",
      Longitude: "number"
    };
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/common-helpers.js
var require_common_helpers = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/common-helpers.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.getArrayOfCount = getArrayOfCount4;
    exports2.isNil = isNil;
    function getArrayOfCount4(length) {
      return Array.from({ length }).fill(null).map((_, index2) => index2);
    }
    function isNil(value) {
      return value === null || value === void 0;
    }
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/formatting-helpers.js
var require_formatting_helpers = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/formatting-helpers.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.formatPrice = formatPrice2;
    exports2.centsToDollars = centsToDollars2;
    function formatPrice2(price, shouldHideZeroCents = true) {
      const formattedPrice = centsToDollars2(price).toLocaleString(void 0, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const trimmedPrice = shouldHideZeroCents ? formattedPrice.replace(".00", "") : formattedPrice;
      return `$${trimmedPrice}`;
    }
    function centsToDollars2(cents) {
      return cents / 100;
    }
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/constants/copy.js
var require_copy = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/constants/copy.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.default = {
      PER_DAY_INFO: "We will automatically calculate the price based on the number of days booked and the quantity selected here.",
      PER_GUEST_INFO: "We will automatically calculate the price based on the number of guests booked and the quantity selected here.",
      PER_GUEST_PER_DAY_INFO: "We will automatically calculate the price based on the number of guests and days booked and the quantity selected here. Most bookings will only need this quantity set to 1.",
      TOTAL: "Total",
      DUE_AFTER_TRIP: "Due after trip",
      DEPOSIT: "Deposit",
      DAY: "day",
      GUEST: "guest"
    };
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/add-on-helpers.js
var require_add_on_helpers = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/add-on-helpers.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.getAddOnPriceCalculationInformation = getAddOnPriceCalculationInformation2;
    exports2.getPriceLabelAndSublabel = getPriceLabelAndSublabel3;
    exports2.sortCategories = sortCategories2;
    var constants_1 = require_constants();
    var common_helpers_1 = require_common_helpers();
    var formatting_helpers_1 = require_formatting_helpers();
    var copy_1 = __importDefault(require_copy());
    function getAddOnPriceCalculationInformation2({ priceByDay, priceByGuest, quantity }) {
      const isPricePerDayAndGuest = priceByDay === constants_1.PER_DAY && priceByGuest === constants_1.PER_GUEST;
      const isPricePerDay = priceByDay === constants_1.PER_DAY && priceByGuest === constants_1.SET_GUEST;
      const isPricePerGuest = priceByDay === constants_1.SET_DAY && priceByGuest === constants_1.PER_GUEST;
      if (isPricePerDayAndGuest && quantity > 1) {
        return copy_1.default.PER_GUEST_PER_DAY_INFO;
      }
      if (isPricePerDay && quantity > 1) {
        return copy_1.default.PER_DAY_INFO;
      }
      if (isPricePerGuest && quantity > 1) {
        return copy_1.default.PER_GUEST_INFO;
      }
      return "";
    }
    function getPriceLabelAndSublabel3(addOn) {
      const priceInformation = getPriceInformation(addOn);
      const priceLabel = getPriceLabel({
        dueBeforeTrip: priceInformation.dueBeforeTrip,
        isDeposit: !!priceInformation.dueAfterTrip,
        addOn
      });
      const priceSublabel = getPriceSublabel(priceInformation.total, priceInformation.dueAfterTrip);
      return { priceLabel, priceSublabel };
    }
    function sortCategories2(categories) {
      return categories.sort((category) => category === constants_1.ADD_ON_CATEGORIES.OTHER ? 1 : -1);
    }
    function getPriceLabel({ dueBeforeTrip, isDeposit, addOn }) {
      const formattedPrice = (0, formatting_helpers_1.formatPrice)(dueBeforeTrip);
      const priceLabelTexts = [
        formattedPrice,
        getDepositLabel(isDeposit),
        getPriceUnit2(addOn)
      ];
      return priceLabelTexts.filter(Boolean).join(" ");
    }
    function getPriceSublabel(total, dueAfterTrip) {
      if (!dueAfterTrip)
        return null;
      const formattedTotal = (0, formatting_helpers_1.formatPrice)(total);
      const formattedDueAfterTrip = (0, formatting_helpers_1.formatPrice)(dueAfterTrip);
      return `${formattedTotal} ${copy_1.default.TOTAL} ${formattedDueAfterTrip} ${copy_1.default.DUE_AFTER_TRIP}`;
    }
    function getDepositLabel(isDeposit) {
      return isDeposit ? copy_1.default.DEPOSIT : null;
    }
    function getPriceInformation(addOn) {
      if (!(0, common_helpers_1.isNil)(addOn.deposit_amount)) {
        return {
          total: addOn.unit_price,
          dueAfterTrip: addOn.unit_price - addOn.deposit_amount,
          dueBeforeTrip: addOn.deposit_amount
        };
      }
      if (!(0, common_helpers_1.isNil)(addOn.deposit_percentage)) {
        const percentageFraction = addOn.deposit_percentage / 100;
        return {
          total: addOn.unit_price,
          dueAfterTrip: addOn.unit_price * (1 - percentageFraction),
          dueBeforeTrip: addOn.unit_price * percentageFraction
        };
      }
      return {
        total: addOn.unit_price,
        dueAfterTrip: 0,
        dueBeforeTrip: addOn.unit_price
      };
    }
    function getPriceUnit2(entity) {
      const isPerGuest = isPricingPerGuest2(entity);
      const isPerDay = isPricingPerDay2(entity);
      const dayUnit = isPerDay ? `/ ${copy_1.default.DAY}` : "";
      const guestUnit = isPerGuest ? `/ ${copy_1.default.GUEST}` : "";
      if (dayUnit && guestUnit)
        return `${dayUnit} ${guestUnit}`;
      if (!dayUnit && !guestUnit)
        return "";
      return dayUnit || guestUnit;
    }
    function isPricingPerDay2(entity) {
      return entity.price_by_day === constants_1.PER_DAY;
    }
    function isPricingPerGuest2(entity) {
      return entity.price_by_guest === constants_1.PER_GUEST;
    }
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/appcues-helpers.js
var require_appcues_helpers = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/appcues-helpers.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.trackingPropsToHash = trackingPropsToHash;
    function trackingPropsToHash(props = []) {
      const initialHash = {};
      return props.reduce((hash, propertyObject) => {
        if (!propertyObject)
          return hash;
        const { prop: property, value_prop_name: valuePropertyName } = propertyObject;
        const value = propertyObject[valuePropertyName];
        hash[property] = value;
        return hash;
      }, initialHash);
    }
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/bookings-helpers.js
var require_bookings_helpers = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/bookings-helpers.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.EMAIL_DOMAIN = exports2.AUTO_GENERATED_EMAIL_PREFIX = void 0;
    exports2.formatUpdateBookingFormDataForApi = formatUpdateBookingFormDataForApi;
    exports2.formatDatesForApi = formatDatesForApi;
    exports2.getInitialDatesValue = getInitialDatesValue;
    exports2.getInitialGroupPayMembersValue = getInitialGroupPayMembersValue;
    exports2.getMinMaxGuestsAndAvailableSlots = getMinMaxGuestsAndAvailableSlots;
    exports2.formatGroupPayMembersForApi = formatGroupPayMembersForApi;
    exports2.isUpdateBookingSubmitButtonDisabled = isUpdateBookingSubmitButtonDisabled;
    exports2.getIsAutoGeneratedEmail = getIsAutoGeneratedEmail;
    var date_fns_1 = require("date-fns");
    var common_helpers_1 = require_common_helpers();
    exports2.AUTO_GENERATED_EMAIL_PREFIX = "offsite.booking+";
    exports2.EMAIL_DOMAIN = "@mallardbay.com";
    function formatUpdateBookingFormDataForApi({ dates, groupPayHost, groupPayMembers, numberOfGuests }) {
      const formattedDates = formatDatesForApi(dates);
      const formattedGroupPayHost = groupPayHost ? formatGroupPayMemberForApi(groupPayHost) : null;
      const formattedGroupPayMembers = formatGroupPayMembersForApi(groupPayMembers);
      return {
        dates: formattedDates,
        groupPayHost: formattedGroupPayHost,
        groupPayMembers: formattedGroupPayMembers,
        numberOfGuests
      };
    }
    function formatDatesForApi(dates) {
      const [startDate, endDate] = dates;
      if (!startDate)
        return [];
      if (!endDate)
        return [startDate.getTime()];
      const numberOfDays = (0, date_fns_1.differenceInDays)(endDate, startDate) + 1;
      return (0, common_helpers_1.getArrayOfCount)(numberOfDays).map((dayOffset) => (0, date_fns_1.addDays)(startDate, dayOffset).getTime());
    }
    function getInitialDatesValue(booking) {
      return [new Date(booking.start_date), new Date(booking.end_date)];
    }
    function getInitialGroupPayMembersValue(booking) {
      var _a, _b;
      const shares = (_b = (_a = booking.group_pay_share) === null || _a === void 0 ? void 0 : _a.shares) !== null && _b !== void 0 ? _b : [];
      const memberShares = shares.filter((share) => !share.is_host);
      return memberShares.map(({ member, slots }) => ({
        email: member.email,
        id: member.id,
        name: member.name,
        slots
      }));
    }
    function getMinMaxGuestsAndAvailableSlots({ groupPayHost, groupPayMembers, numberOfGuests, pricingPackage }) {
      var _a, _b;
      const minGuests = (_a = pricingPackage === null || pricingPackage === void 0 ? void 0 : pricingPackage.min_guests) !== null && _a !== void 0 ? _a : 1;
      const maxGuests = (_b = pricingPackage === null || pricingPackage === void 0 ? void 0 : pricingPackage.max_guests) !== null && _b !== void 0 ? _b : numberOfGuests;
      const slotsAvailableForMembers = calculateAvailableSlots({
        groupPayHost,
        groupPayMembers,
        numberOfGuests
      });
      return { maxGuests, minGuests, slotsAvailableForMembers };
    }
    function calculateAvailableSlots({ groupPayHost, groupPayMembers, numberOfGuests }) {
      var _a;
      const hostSlots = (_a = groupPayHost === null || groupPayHost === void 0 ? void 0 : groupPayHost.slots) !== null && _a !== void 0 ? _a : 0;
      const totalSlotsCoveredByMembers = groupPayMembers.reduce((count, member) => count + member.slots, 0);
      const totalSlotsCovered = totalSlotsCoveredByMembers + hostSlots;
      return numberOfGuests - totalSlotsCovered;
    }
    function formatGroupPayMembersForApi(groupPayMembers) {
      return groupPayMembers.map(formatGroupPayMemberForApi);
    }
    function isUpdateBookingSubmitButtonDisabled({ dates, slotsAvailableForMembers }) {
      return dates.length === 0 || slotsAvailableForMembers < 0;
    }
    function formatGroupPayMemberForApi({ id: id2, slots }) {
      return { id: id2, slots };
    }
    function getIsAutoGeneratedEmail(email) {
      if (!email)
        return false;
      return email.startsWith(exports2.AUTO_GENERATED_EMAIL_PREFIX) && email.endsWith(exports2.EMAIL_DOMAIN);
    }
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/date-helpers.js
var require_date_helpers = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/date-helpers.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.getAvailableDatesForCalendar = getAvailableDatesForCalendar;
    exports2.getSelectedDatesForCalendar = getSelectedDatesForCalendar2;
    exports2.getValidStartsForPackage = getValidStartsForPackage2;
    exports2.getDatesOnDateSelect = getDatesOnDateSelect2;
    exports2.filterDateForCalendar = filterDateForCalendar;
    exports2.hasConsecutiveAvailability = hasConsecutiveAvailability2;
    exports2.getUTCNoon = getUTCNoon;
    var date_fns_1 = require("date-fns");
    function getAvailableDatesForCalendar(availabilityList, totalGuests) {
      return availabilityList.filter((availability) => {
        const isFuture = availability.date >= Date.now();
        const hasEnoughSlots = availability.available_slots - totalGuests >= 0;
        return isFuture && hasEnoughSlots && availability.is_available;
      }).sort((availabilityL, availabilityR) => availabilityL.date - availabilityR.date).map((availability) => new Date(availability.date));
    }
    function getSelectedDatesForCalendar2(startDate, endDate) {
      const dates = [startDate, endDate].filter(Boolean);
      if (dates.length < 2)
        return dates;
      return (0, date_fns_1.eachDayOfInterval)({ end: dates[1], start: dates[0] }).map((date) => new Date(getUTCNoon(date)));
    }
    function getValidStartsForPackage2(availableDates, pricingPackageDaysIncluded) {
      if (!pricingPackageDaysIncluded)
        return [];
      return availableDates.filter((startDate) => {
        const endDate = (0, date_fns_1.addDays)(startDate, pricingPackageDaysIncluded - 1);
        const interval = { end: endDate, start: startDate };
        return hasConsecutiveAvailability2(interval, availableDates);
      });
    }
    function getDatesOnDateSelect2(dates, pricingPackage) {
      const datesForSelect = dates.filter(Boolean);
      const { pricingPackageDaysIncluded, pricingPackageIsSetDay } = pricingPackage;
      if (pricingPackageIsSetDay) {
        if (!datesForSelect[0])
          throw new Error("dates[0] must be set");
        const endDate = pricingPackageDaysIncluded > 1 ? (0, date_fns_1.addDays)(datesForSelect[0], pricingPackageDaysIncluded - 1) : datesForSelect[0];
        return [datesForSelect[0], endDate];
      }
      return datesForSelect;
    }
    function filterDateForCalendar(date, { availableDates, selectedDates }) {
      const noon = getUTCNoon(date);
      if (!selectedDates[0])
        throw new Error("selectedDates[] must not be empty");
      const firstSelDt = selectedDates[0] || noon;
      const [start, end] = [firstSelDt, noon].sort(date_fns_1.compareAsc);
      const interval = { end, start };
      return hasConsecutiveAvailability2(interval, availableDates);
    }
    function hasConsecutiveAvailability2(interval, availableDates) {
      const { end, start } = interval;
      const startUtcNoon = getUTCNoon(start);
      const endUtcNoon = getUTCNoon(end);
      let nextDt = startUtcNoon;
      while ((0, date_fns_1.isBefore)(nextDt, endUtcNoon) || (0, date_fns_1.isEqual)(nextDt, endUtcNoon)) {
        const isDateAvailable = availableDates.some((date) => (0, date_fns_1.isSameDay)(date, nextDt));
        if (!isDateAvailable) {
          return false;
        }
        nextDt = (0, date_fns_1.addDays)(nextDt, 1);
      }
      return true;
    }
    function getUTCNoon(date) {
      const temporaryDate = new Date(date);
      const month = 12;
      return new Date(Date.UTC(temporaryDate.getFullYear(), temporaryDate.getMonth(), temporaryDate.getDate(), month, 0, 0));
    }
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/function-helpers.js
var require_function_helpers = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/function-helpers.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.tryWithDelay = tryWithDelay;
    function tryWithDelay({ attemptNumber, captureException, delay: delay2, errorMessage, functionToCall, hasSucceeded, maxAttempts }) {
      if (hasSucceeded)
        return;
      if (attemptNumber > maxAttempts) {
        captureException(new Error(errorMessage));
        return;
      }
      setTimeout(() => {
        const didSucceed = functionToCall();
        tryWithDelay({
          attemptNumber: attemptNumber + 1,
          captureException,
          delay: delay2,
          errorMessage,
          functionToCall,
          hasSucceeded: didSucceed,
          maxAttempts
        });
      }, delay2);
    }
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/string-helpers.js
var require_string_helpers = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/string-helpers.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.formatEmailForApi = formatEmailForApi;
    function formatEmailForApi(email) {
      return email.toLowerCase().trim();
    }
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/feature-upsell-helpers.js
var require_feature_upsell_helpers = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/feature-upsell-helpers.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.FEATURE_UPSELLS_PREFIX = void 0;
    exports2.getFeatureUpsellUrl = getFeatureUpsellUrl;
    exports2.FEATURE_UPSELLS_PREFIX = "/embed/upsell";
    function getFeatureUpsellUrl({ featureKey, isLimitHit = false }) {
      const formattedKey = featureKey.toLowerCase();
      const suffix = isLimitHit ? "_limit" : "";
      return `${exports2.FEATURE_UPSELLS_PREFIX}/${formattedKey}${suffix}`;
    }
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/helpers.js
var require_helpers = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/helpers/helpers.js"(exports2) {
    "use strict";
    var __createBinding = exports2 && exports2.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    });
    var __exportStar = exports2 && exports2.__exportStar || function(m, exports3) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p)) __createBinding(exports3, m, p);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    __exportStar(require_add_on_helpers(), exports2);
    __exportStar(require_appcues_helpers(), exports2);
    __exportStar(require_bookings_helpers(), exports2);
    __exportStar(require_common_helpers(), exports2);
    __exportStar(require_date_helpers(), exports2);
    __exportStar(require_function_helpers(), exports2);
    __exportStar(require_string_helpers(), exports2);
    __exportStar(require_feature_upsell_helpers(), exports2);
    __exportStar(require_formatting_helpers(), exports2);
  }
});

// node_modules/@trycourier/courier-js/dist/index.mjs
var dist_exports = {};
__export(dist_exports, {
  default: () => src_default
});
function decode(clientKey) {
  const binaryString = atob(clientKey);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return String.fromCharCode(...bytes);
}
function encode(key) {
  const bytes = new Uint8Array(key.length);
  for (let i = 0; i < key.length; i++) {
    bytes[i] = key.charCodeAt(i);
  }
  return btoa(String.fromCharCode(...bytes));
}
async function tryCatch(fn, debug = true) {
  var _a, _b;
  const response = await fn();
  if (!response.ok && debug) {
    console.error(
      `Error invoking ${response.url}: ${(_a = response.status) != null ? _a : 404} because ${JSON.stringify((_b = await response.json()) == null ? void 0 : _b.message)}`
    );
  }
}
var version, Courier, client, src_default;
var init_dist = __esm({
  "node_modules/@trycourier/courier-js/dist/index.mjs"() {
    "use strict";
    version = "1.4.2";
    Courier = class {
      constructor({
        authorization,
        baseUrl,
        clientKey,
        debug = false,
        userId,
        userSignature
      }) {
        if (!clientKey) {
          throw new Error("Courier client key is required");
        }
        this.authorization = authorization;
        this.baseUrl = `${baseUrl != null ? baseUrl : "https://api.courier.com"}`;
        this.clientKey = clientKey;
        this.debug = debug;
        this.userId = userId;
        this.userSignature = userSignature;
      }
      getHeaders() {
        return new Headers({
          "Content-Type": "application/json",
          "x-courier-client-version": `courier-js@${version}`,
          "Access-Control-Allow-Origin": "*",
          ...this.authorization && { Authorization: this.authorization },
          ...this.userId && { "x-courier-user-id": this.userId },
          ...this.userSignature && {
            "x-courier-user-signature": this.userSignature
          },
          ...this.clientKey && { "x-courier-client-key": this.clientKey }
        });
      }
      async post(path, body, useClientPath = true) {
        const postFn = () => {
          return fetch(this.getPathURL(path, useClientPath), {
            body: JSON.stringify(body),
            headers: this.getHeaders(),
            method: "POST"
          });
        };
        await tryCatch(postFn, this.debug);
      }
      async put(path, body, useClientPath = true) {
        const putFn = () => {
          return fetch(this.getPathURL(path, useClientPath), {
            ...body ? { body: JSON.stringify(body) } : {},
            headers: this.getHeaders(),
            method: "PUT"
          });
        };
        await tryCatch(putFn, this.debug);
      }
      async delete(path, useClientPath = true) {
        const deleteFn = () => {
          return fetch(this.getPathURL(path, useClientPath), {
            headers: this.getHeaders(),
            method: "DELETE"
          });
        };
        await tryCatch(deleteFn, this.debug);
      }
      generatePreferencesUrl(userId, options) {
        var _a;
        if (!userId) {
          throw new Error("User ID is required to generate preferences URL");
        }
        const id2 = decode(this.clientKey);
        return `https://view.notificationcenter.app/p/${encode(
          `${id2}#${(_a = options == null ? void 0 : options.brandId) != null ? _a : ""}#${userId}${(options == null ? void 0 : options.tenantId) ? `#${options.tenantId}` : ""}#${false}`
        )}`;
      }
      getPathURL(path, useClientPath) {
        let pathUrl = this.baseUrl;
        if (useClientPath) {
          pathUrl = pathUrl.concat("/client");
        }
        return pathUrl.concat(path);
      }
    };
    client = {
      __instance: null,
      init(options) {
        this.__instance = new Courier(options);
      },
      get instance() {
        if (!this.__instance) {
          throw new Error("Courier instance not initialized");
        }
        return this.__instance;
      },
      async identify(userId, payload) {
        if (!userId) {
          throw new Error("userId is required");
        }
        await this.instance.post(`/identify/${userId}`, {
          profile: {
            ...payload
          }
        });
      },
      async subscribe(userId, listId) {
        if (!userId || !listId) {
          throw new Error("userId is required");
        }
        await this.instance.put(`/lists/${listId}/subscribe/${userId}`);
      },
      async track(event, properties) {
        if (!event) {
          throw new Error("event is required");
        }
        let indempotentKey = self.crypto.randomUUID ? self.crypto.randomUUID() : Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        await this.instance.post(`/inbound/courier`, {
          messageId: indempotentKey,
          type: "track",
          event,
          properties: { ...properties }
        }, false);
      },
      async unsubscribe(userId, listId) {
        if (!userId || !listId) {
          throw new Error("userId is required");
        }
        this.instance.delete(`/lists/${listId}/unsubscribe/${userId}`);
      },
      generatePreferencesUrl(userId, options) {
        return this.instance.generatePreferencesUrl(userId, options);
      }
    };
    src_default = client;
  }
});

// node_modules/@amplitude/analytics-core/node_modules/tslib/tslib.es6.mjs
function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return { value: op[1], done: false };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return { value: o && o[i++], done: !o };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var extendStatics, __assign;
var init_tslib_es6 = __esm({
  "node_modules/@amplitude/analytics-core/node_modules/tslib/tslib.es6.mjs"() {
    "use strict";
    extendStatics = function(d, b) {
      extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
      };
      return extendStatics(d, b);
    };
    __assign = function() {
      __assign = Object.assign || function __assign8(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/types/messages.js
var SUCCESS_MESSAGE, UNEXPECTED_ERROR_MESSAGE, MAX_RETRIES_EXCEEDED_MESSAGE, OPT_OUT_MESSAGE, MISSING_API_KEY_MESSAGE, INVALID_API_KEY, CLIENT_NOT_INITIALIZED;
var init_messages = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/types/messages.js"() {
    "use strict";
    SUCCESS_MESSAGE = "Event tracked successfully";
    UNEXPECTED_ERROR_MESSAGE = "Unexpected error occurred";
    MAX_RETRIES_EXCEEDED_MESSAGE = "Event rejected due to exceeded retry count";
    OPT_OUT_MESSAGE = "Event skipped due to optOut config";
    MISSING_API_KEY_MESSAGE = "Event rejected due to missing API key";
    INVALID_API_KEY = "Invalid API key";
    CLIENT_NOT_INITIALIZED = "Client not initialized";
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/types/status.js
var Status;
var init_status = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/types/status.js"() {
    "use strict";
    (function(Status3) {
      Status3["Unknown"] = "unknown";
      Status3["Skipped"] = "skipped";
      Status3["Success"] = "success";
      Status3["RateLimit"] = "rate_limit";
      Status3["PayloadTooLarge"] = "payload_too_large";
      Status3["Invalid"] = "invalid";
      Status3["Failed"] = "failed";
      Status3["Timeout"] = "Timeout";
      Status3["SystemError"] = "SystemError";
    })(Status || (Status = {}));
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/utils/result-builder.js
var buildResult;
var init_result_builder = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/utils/result-builder.js"() {
    "use strict";
    init_status();
    buildResult = function(event, code, message) {
      if (code === void 0) {
        code = 0;
      }
      if (message === void 0) {
        message = Status.Unknown;
      }
      return { event, code, message };
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/utils/uuid.js
var UUID;
var init_uuid = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/utils/uuid.js"() {
    "use strict";
    UUID = function(a) {
      return a ? (
        // a random number from 0 to 15
        (a ^ // unless b is 8,
        Math.random() * // in which case
        16 >> // a random number from
        a / 4).toString(16)
      ) : (
        // or otherwise a concatenated string:
        (String(1e7) + // 10000000 +
        String(-1e3) + // -1000 +
        String(-4e3) + // -4000 +
        String(-8e3) + // -80000000 +
        String(-1e11)).replace(
          // replacing
          /[018]/g,
          // zeroes, ones, and eights with
          UUID
        )
      );
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/timeline.js
var Timeline;
var init_timeline = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/timeline.js"() {
    "use strict";
    init_tslib_es6();
    init_result_builder();
    init_uuid();
    Timeline = /** @class */
    function() {
      function Timeline3(client2) {
        this.client = client2;
        this.queue = [];
        this.applying = false;
        this.plugins = [];
      }
      Timeline3.prototype.register = function(plugin, config2) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function() {
          return __generator(this, function(_c) {
            switch (_c.label) {
              case 0:
                if (this.plugins.some(function(existingPlugin) {
                  return existingPlugin.name === plugin.name;
                })) {
                  config2.loggerProvider.warn("Plugin with name ".concat(plugin.name, " already exists, skipping registration"));
                  return [
                    2
                    /*return*/
                  ];
                }
                if (plugin.name === void 0) {
                  plugin.name = UUID();
                  config2.loggerProvider.warn("Plugin name is undefined. \n      Generating a random UUID for plugin name: ".concat(plugin.name, ". \n      Set a name for the plugin to prevent it from being added multiple times."));
                }
                plugin.type = (_a = plugin.type) !== null && _a !== void 0 ? _a : "enrichment";
                return [4, (_b = plugin.setup) === null || _b === void 0 ? void 0 : _b.call(plugin, config2, this.client)];
              case 1:
                _c.sent();
                this.plugins.push(plugin);
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      Timeline3.prototype.deregister = function(pluginName, config2) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
          var index2, plugin;
          return __generator(this, function(_b) {
            switch (_b.label) {
              case 0:
                index2 = this.plugins.findIndex(function(plugin2) {
                  return plugin2.name === pluginName;
                });
                if (index2 === -1) {
                  config2.loggerProvider.warn("Plugin with name ".concat(pluginName, " does not exist, skipping deregistration"));
                  return [
                    2
                    /*return*/
                  ];
                }
                plugin = this.plugins[index2];
                this.plugins.splice(index2, 1);
                return [4, (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin)];
              case 1:
                _b.sent();
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      Timeline3.prototype.reset = function(client2) {
        this.applying = false;
        var plugins = this.plugins;
        plugins.map(function(plugin) {
          var _a;
          return (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin);
        });
        this.plugins = [];
        this.client = client2;
      };
      Timeline3.prototype.push = function(event) {
        var _this = this;
        return new Promise(function(resolve) {
          _this.queue.push([event, resolve]);
          _this.scheduleApply(0);
        });
      };
      Timeline3.prototype.scheduleApply = function(timeout2) {
        var _this = this;
        if (this.applying)
          return;
        this.applying = true;
        setTimeout(function() {
          void _this.apply(_this.queue.shift()).then(function() {
            _this.applying = false;
            if (_this.queue.length > 0) {
              _this.scheduleApply(0);
            }
          });
        }, timeout2);
      };
      Timeline3.prototype.apply = function(item) {
        return __awaiter(this, void 0, void 0, function() {
          var _a, event, _b, resolve, before, before_1, before_1_1, plugin, e, e_1_1, enrichment, enrichment_1, enrichment_1_1, plugin, e, e_2_1, destination, executeDestinations;
          var e_1, _c, e_2, _d;
          return __generator(this, function(_e) {
            switch (_e.label) {
              case 0:
                if (!item) {
                  return [
                    2
                    /*return*/
                  ];
                }
                _a = __read(item, 1), event = _a[0];
                _b = __read(item, 2), resolve = _b[1];
                before = this.plugins.filter(function(plugin2) {
                  return plugin2.type === "before";
                });
                _e.label = 1;
              case 1:
                _e.trys.push([1, 6, 7, 8]);
                before_1 = __values(before), before_1_1 = before_1.next();
                _e.label = 2;
              case 2:
                if (!!before_1_1.done) return [3, 5];
                plugin = before_1_1.value;
                if (!plugin.execute) {
                  return [3, 4];
                }
                return [4, plugin.execute(__assign({}, event))];
              case 3:
                e = _e.sent();
                if (e === null) {
                  resolve({ event, code: 0, message: "" });
                  return [
                    2
                    /*return*/
                  ];
                } else {
                  event = e;
                }
                _e.label = 4;
              case 4:
                before_1_1 = before_1.next();
                return [3, 2];
              case 5:
                return [3, 8];
              case 6:
                e_1_1 = _e.sent();
                e_1 = { error: e_1_1 };
                return [3, 8];
              case 7:
                try {
                  if (before_1_1 && !before_1_1.done && (_c = before_1.return)) _c.call(before_1);
                } finally {
                  if (e_1) throw e_1.error;
                }
                return [
                  7
                  /*endfinally*/
                ];
              case 8:
                enrichment = this.plugins.filter(function(plugin2) {
                  return plugin2.type === "enrichment" || plugin2.type === void 0;
                });
                _e.label = 9;
              case 9:
                _e.trys.push([9, 14, 15, 16]);
                enrichment_1 = __values(enrichment), enrichment_1_1 = enrichment_1.next();
                _e.label = 10;
              case 10:
                if (!!enrichment_1_1.done) return [3, 13];
                plugin = enrichment_1_1.value;
                if (!plugin.execute) {
                  return [3, 12];
                }
                return [4, plugin.execute(__assign({}, event))];
              case 11:
                e = _e.sent();
                if (e === null) {
                  resolve({ event, code: 0, message: "" });
                  return [
                    2
                    /*return*/
                  ];
                } else {
                  event = e;
                }
                _e.label = 12;
              case 12:
                enrichment_1_1 = enrichment_1.next();
                return [3, 10];
              case 13:
                return [3, 16];
              case 14:
                e_2_1 = _e.sent();
                e_2 = { error: e_2_1 };
                return [3, 16];
              case 15:
                try {
                  if (enrichment_1_1 && !enrichment_1_1.done && (_d = enrichment_1.return)) _d.call(enrichment_1);
                } finally {
                  if (e_2) throw e_2.error;
                }
                return [
                  7
                  /*endfinally*/
                ];
              case 16:
                destination = this.plugins.filter(function(plugin2) {
                  return plugin2.type === "destination";
                });
                executeDestinations = destination.map(function(plugin2) {
                  var eventClone = __assign({}, event);
                  return plugin2.execute(eventClone).catch(function(e2) {
                    return buildResult(eventClone, 0, String(e2));
                  });
                });
                void Promise.all(executeDestinations).then(function(_a2) {
                  var _b2 = __read(_a2, 1), result = _b2[0];
                  var resolveResult = result || buildResult(event, 100, "Event not tracked, no destination plugins on the instance");
                  resolve(resolveResult);
                });
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      Timeline3.prototype.flush = function() {
        return __awaiter(this, void 0, void 0, function() {
          var queue, destination, executeDestinations;
          var _this = this;
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                queue = this.queue;
                this.queue = [];
                return [4, Promise.all(queue.map(function(item) {
                  return _this.apply(item);
                }))];
              case 1:
                _a.sent();
                destination = this.plugins.filter(function(plugin) {
                  return plugin.type === "destination";
                });
                executeDestinations = destination.map(function(plugin) {
                  return plugin.flush && plugin.flush();
                });
                return [4, Promise.all(executeDestinations)];
              case 2:
                _a.sent();
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      return Timeline3;
    }();
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/types/constants.js
var UNSET_VALUE, AMPLITUDE_PREFIX, STORAGE_PREFIX, AMPLITUDE_SERVER_URL, EU_AMPLITUDE_SERVER_URL, AMPLITUDE_BATCH_SERVER_URL, EU_AMPLITUDE_BATCH_SERVER_URL;
var init_constants = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/types/constants.js"() {
    "use strict";
    UNSET_VALUE = "-";
    AMPLITUDE_PREFIX = "AMP";
    STORAGE_PREFIX = "".concat(AMPLITUDE_PREFIX, "_unsent");
    AMPLITUDE_SERVER_URL = "https://api2.amplitude.com/2/httpapi";
    EU_AMPLITUDE_SERVER_URL = "https://api.eu.amplitude.com/2/httpapi";
    AMPLITUDE_BATCH_SERVER_URL = "https://api2.amplitude.com/batch";
    EU_AMPLITUDE_BATCH_SERVER_URL = "https://api.eu.amplitude.com/batch";
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/utils/valid-properties.js
var MAX_PROPERTY_KEYS, isValidObject, isValidProperties;
var init_valid_properties = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/utils/valid-properties.js"() {
    "use strict";
    init_tslib_es6();
    MAX_PROPERTY_KEYS = 1e3;
    isValidObject = function(properties) {
      if (Object.keys(properties).length > MAX_PROPERTY_KEYS) {
        return false;
      }
      for (var key in properties) {
        var value = properties[key];
        if (!isValidProperties(key, value))
          return false;
      }
      return true;
    };
    isValidProperties = function(property, value) {
      var e_1, _a;
      if (typeof property !== "string")
        return false;
      if (Array.isArray(value)) {
        var isValid = true;
        try {
          for (var value_1 = __values(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
            var valueElement = value_1_1.value;
            if (Array.isArray(valueElement)) {
              return false;
            } else if (typeof valueElement === "object") {
              isValid = isValid && isValidObject(valueElement);
            } else if (!["number", "string"].includes(typeof valueElement)) {
              return false;
            }
            if (!isValid) {
              return false;
            }
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      } else if (value === null || value === void 0) {
        return false;
      } else if (typeof value === "object") {
        return isValidObject(value);
      } else if (!["number", "string", "boolean"].includes(typeof value)) {
        return false;
      }
      return true;
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/identify.js
var Identify, IdentifyOperation;
var init_identify = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/identify.js"() {
    "use strict";
    init_tslib_es6();
    init_constants();
    init_valid_properties();
    Identify = /** @class */
    function() {
      function Identify2() {
        this._propertySet = /* @__PURE__ */ new Set();
        this._properties = {};
      }
      Identify2.prototype.getUserProperties = function() {
        return __assign({}, this._properties);
      };
      Identify2.prototype.set = function(property, value) {
        this._safeSet(IdentifyOperation.SET, property, value);
        return this;
      };
      Identify2.prototype.setOnce = function(property, value) {
        this._safeSet(IdentifyOperation.SET_ONCE, property, value);
        return this;
      };
      Identify2.prototype.append = function(property, value) {
        this._safeSet(IdentifyOperation.APPEND, property, value);
        return this;
      };
      Identify2.prototype.prepend = function(property, value) {
        this._safeSet(IdentifyOperation.PREPEND, property, value);
        return this;
      };
      Identify2.prototype.postInsert = function(property, value) {
        this._safeSet(IdentifyOperation.POSTINSERT, property, value);
        return this;
      };
      Identify2.prototype.preInsert = function(property, value) {
        this._safeSet(IdentifyOperation.PREINSERT, property, value);
        return this;
      };
      Identify2.prototype.remove = function(property, value) {
        this._safeSet(IdentifyOperation.REMOVE, property, value);
        return this;
      };
      Identify2.prototype.add = function(property, value) {
        this._safeSet(IdentifyOperation.ADD, property, value);
        return this;
      };
      Identify2.prototype.unset = function(property) {
        this._safeSet(IdentifyOperation.UNSET, property, UNSET_VALUE);
        return this;
      };
      Identify2.prototype.clearAll = function() {
        this._properties = {};
        this._properties[IdentifyOperation.CLEAR_ALL] = UNSET_VALUE;
        return this;
      };
      Identify2.prototype._safeSet = function(operation, property, value) {
        if (this._validate(operation, property, value)) {
          var userPropertyMap = this._properties[operation];
          if (userPropertyMap === void 0) {
            userPropertyMap = {};
            this._properties[operation] = userPropertyMap;
          }
          userPropertyMap[property] = value;
          this._propertySet.add(property);
          return true;
        }
        return false;
      };
      Identify2.prototype._validate = function(operation, property, value) {
        if (this._properties[IdentifyOperation.CLEAR_ALL] !== void 0) {
          return false;
        }
        if (this._propertySet.has(property)) {
          return false;
        }
        if (operation === IdentifyOperation.ADD) {
          return typeof value === "number";
        }
        if (operation !== IdentifyOperation.UNSET && operation !== IdentifyOperation.REMOVE) {
          return isValidProperties(property, value);
        }
        return true;
      };
      return Identify2;
    }();
    (function(IdentifyOperation4) {
      IdentifyOperation4["SET"] = "$set";
      IdentifyOperation4["SET_ONCE"] = "$setOnce";
      IdentifyOperation4["ADD"] = "$add";
      IdentifyOperation4["APPEND"] = "$append";
      IdentifyOperation4["PREPEND"] = "$prepend";
      IdentifyOperation4["REMOVE"] = "$remove";
      IdentifyOperation4["PREINSERT"] = "$preInsert";
      IdentifyOperation4["POSTINSERT"] = "$postInsert";
      IdentifyOperation4["UNSET"] = "$unset";
      IdentifyOperation4["CLEAR_ALL"] = "$clearAll";
    })(IdentifyOperation || (IdentifyOperation = {}));
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/types/event/event.js
var IdentifyOperation2, SpecialEventType;
var init_event = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/types/event/event.js"() {
    "use strict";
    (function(IdentifyOperation4) {
      IdentifyOperation4["SET"] = "$set";
      IdentifyOperation4["SET_ONCE"] = "$setOnce";
      IdentifyOperation4["ADD"] = "$add";
      IdentifyOperation4["APPEND"] = "$append";
      IdentifyOperation4["PREPEND"] = "$prepend";
      IdentifyOperation4["REMOVE"] = "$remove";
      IdentifyOperation4["PREINSERT"] = "$preInsert";
      IdentifyOperation4["POSTINSERT"] = "$postInsert";
      IdentifyOperation4["UNSET"] = "$unset";
      IdentifyOperation4["CLEAR_ALL"] = "$clearAll";
    })(IdentifyOperation2 || (IdentifyOperation2 = {}));
    (function(SpecialEventType3) {
      SpecialEventType3["IDENTIFY"] = "$identify";
      SpecialEventType3["GROUP_IDENTIFY"] = "$groupidentify";
      SpecialEventType3["REVENUE"] = "revenue_amount";
    })(SpecialEventType || (SpecialEventType = {}));
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/utils/event-builder.js
var createTrackEvent, createIdentifyEvent, createGroupIdentifyEvent, createGroupEvent, createRevenueEvent;
var init_event_builder = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/utils/event-builder.js"() {
    "use strict";
    init_tslib_es6();
    init_identify();
    init_event();
    createTrackEvent = function(eventInput, eventProperties, eventOptions) {
      var baseEvent = typeof eventInput === "string" ? { event_type: eventInput } : eventInput;
      return __assign(__assign(__assign({}, baseEvent), eventOptions), eventProperties && { event_properties: eventProperties });
    };
    createIdentifyEvent = function(identify2, eventOptions) {
      var identifyEvent = __assign(__assign({}, eventOptions), { event_type: SpecialEventType.IDENTIFY, user_properties: identify2.getUserProperties() });
      return identifyEvent;
    };
    createGroupIdentifyEvent = function(groupType, groupName, identify2, eventOptions) {
      var _a;
      var groupIdentify2 = __assign(__assign({}, eventOptions), { event_type: SpecialEventType.GROUP_IDENTIFY, group_properties: identify2.getUserProperties(), groups: (_a = {}, _a[groupType] = groupName, _a) });
      return groupIdentify2;
    };
    createGroupEvent = function(groupType, groupName, eventOptions) {
      var _a;
      var identify2 = new Identify();
      identify2.set(groupType, groupName);
      var groupEvent = __assign(__assign({}, eventOptions), { event_type: SpecialEventType.IDENTIFY, user_properties: identify2.getUserProperties(), groups: (_a = {}, _a[groupType] = groupName, _a) });
      return groupEvent;
    };
    createRevenueEvent = function(revenue2, eventOptions) {
      return __assign(__assign({}, eventOptions), { event_type: SpecialEventType.REVENUE, event_properties: revenue2.getEventProperties() });
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/utils/return-wrapper.js
var returnWrapper;
var init_return_wrapper = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/utils/return-wrapper.js"() {
    "use strict";
    returnWrapper = function(awaitable) {
      return {
        promise: awaitable || Promise.resolve()
      };
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/core-client.js
var AmplitudeCore;
var init_core_client = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/core-client.js"() {
    "use strict";
    init_tslib_es6();
    init_messages();
    init_timeline();
    init_event_builder();
    init_result_builder();
    init_return_wrapper();
    AmplitudeCore = /** @class */
    function() {
      function AmplitudeCore2(name) {
        if (name === void 0) {
          name = "$default";
        }
        this.initializing = false;
        this.isReady = false;
        this.q = [];
        this.dispatchQ = [];
        this.logEvent = this.track.bind(this);
        this.timeline = new Timeline(this);
        this.name = name;
      }
      AmplitudeCore2.prototype._init = function(config2) {
        return __awaiter(this, void 0, void 0, function() {
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                this.config = config2;
                this.timeline.reset(this);
                return [4, this.runQueuedFunctions("q")];
              case 1:
                _a.sent();
                this.isReady = true;
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      AmplitudeCore2.prototype.runQueuedFunctions = function(queueName) {
        return __awaiter(this, void 0, void 0, function() {
          var queuedFunctions, queuedFunctions_1, queuedFunctions_1_1, queuedFunction, val, e_1_1;
          var e_1, _a;
          return __generator(this, function(_b) {
            switch (_b.label) {
              case 0:
                queuedFunctions = this[queueName];
                this[queueName] = [];
                _b.label = 1;
              case 1:
                _b.trys.push([1, 8, 9, 10]);
                queuedFunctions_1 = __values(queuedFunctions), queuedFunctions_1_1 = queuedFunctions_1.next();
                _b.label = 2;
              case 2:
                if (!!queuedFunctions_1_1.done) return [3, 7];
                queuedFunction = queuedFunctions_1_1.value;
                val = queuedFunction();
                if (!(val && "promise" in val)) return [3, 4];
                return [4, val.promise];
              case 3:
                _b.sent();
                return [3, 6];
              case 4:
                return [4, val];
              case 5:
                _b.sent();
                _b.label = 6;
              case 6:
                queuedFunctions_1_1 = queuedFunctions_1.next();
                return [3, 2];
              case 7:
                return [3, 10];
              case 8:
                e_1_1 = _b.sent();
                e_1 = { error: e_1_1 };
                return [3, 10];
              case 9:
                try {
                  if (queuedFunctions_1_1 && !queuedFunctions_1_1.done && (_a = queuedFunctions_1.return)) _a.call(queuedFunctions_1);
                } finally {
                  if (e_1) throw e_1.error;
                }
                return [
                  7
                  /*endfinally*/
                ];
              case 10:
                if (!this[queueName].length) return [3, 12];
                return [4, this.runQueuedFunctions(queueName)];
              case 11:
                _b.sent();
                _b.label = 12;
              case 12:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      AmplitudeCore2.prototype.track = function(eventInput, eventProperties, eventOptions) {
        var event = createTrackEvent(eventInput, eventProperties, eventOptions);
        return returnWrapper(this.dispatch(event));
      };
      AmplitudeCore2.prototype.identify = function(identify2, eventOptions) {
        var event = createIdentifyEvent(identify2, eventOptions);
        return returnWrapper(this.dispatch(event));
      };
      AmplitudeCore2.prototype.groupIdentify = function(groupType, groupName, identify2, eventOptions) {
        var event = createGroupIdentifyEvent(groupType, groupName, identify2, eventOptions);
        return returnWrapper(this.dispatch(event));
      };
      AmplitudeCore2.prototype.setGroup = function(groupType, groupName, eventOptions) {
        var event = createGroupEvent(groupType, groupName, eventOptions);
        return returnWrapper(this.dispatch(event));
      };
      AmplitudeCore2.prototype.revenue = function(revenue2, eventOptions) {
        var event = createRevenueEvent(revenue2, eventOptions);
        return returnWrapper(this.dispatch(event));
      };
      AmplitudeCore2.prototype.add = function(plugin) {
        if (!this.isReady) {
          this.q.push(this._addPlugin.bind(this, plugin));
          return returnWrapper();
        }
        return this._addPlugin(plugin);
      };
      AmplitudeCore2.prototype._addPlugin = function(plugin) {
        return returnWrapper(this.timeline.register(plugin, this.config));
      };
      AmplitudeCore2.prototype.remove = function(pluginName) {
        if (!this.isReady) {
          this.q.push(this._removePlugin.bind(this, pluginName));
          return returnWrapper();
        }
        return this._removePlugin(pluginName);
      };
      AmplitudeCore2.prototype._removePlugin = function(pluginName) {
        return returnWrapper(this.timeline.deregister(pluginName, this.config));
      };
      AmplitudeCore2.prototype.dispatchWithCallback = function(event, callback) {
        if (!this.isReady) {
          return callback(buildResult(event, 0, CLIENT_NOT_INITIALIZED));
        }
        void this.process(event).then(callback);
      };
      AmplitudeCore2.prototype.dispatch = function(event) {
        return __awaiter(this, void 0, void 0, function() {
          var _this = this;
          return __generator(this, function(_a) {
            if (!this.isReady) {
              return [2, new Promise(function(resolve) {
                _this.dispatchQ.push(_this.dispatchWithCallback.bind(_this, event, resolve));
              })];
            }
            return [2, this.process(event)];
          });
        });
      };
      AmplitudeCore2.prototype.process = function(event) {
        return __awaiter(this, void 0, void 0, function() {
          var result, e_2, message, result;
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                _a.trys.push([0, 2, , 3]);
                if (this.config.optOut) {
                  return [2, buildResult(event, 0, OPT_OUT_MESSAGE)];
                }
                return [4, this.timeline.push(event)];
              case 1:
                result = _a.sent();
                result.code === 200 ? this.config.loggerProvider.log(result.message) : result.code === 100 ? this.config.loggerProvider.warn(result.message) : this.config.loggerProvider.error(result.message);
                return [2, result];
              case 2:
                e_2 = _a.sent();
                message = String(e_2);
                this.config.loggerProvider.error(message);
                result = buildResult(event, 0, message);
                return [2, result];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      AmplitudeCore2.prototype.setOptOut = function(optOut) {
        if (!this.isReady) {
          this.q.push(this._setOptOut.bind(this, Boolean(optOut)));
          return;
        }
        this._setOptOut(optOut);
      };
      AmplitudeCore2.prototype._setOptOut = function(optOut) {
        this.config.optOut = Boolean(optOut);
      };
      AmplitudeCore2.prototype.flush = function() {
        return returnWrapper(this.timeline.flush());
      };
      return AmplitudeCore2;
    }();
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/revenue.js
var Revenue, RevenueProperty;
var init_revenue = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/revenue.js"() {
    "use strict";
    init_tslib_es6();
    init_valid_properties();
    Revenue = /** @class */
    function() {
      function Revenue2() {
        this.productId = "";
        this.quantity = 1;
        this.price = 0;
      }
      Revenue2.prototype.setProductId = function(productId) {
        this.productId = productId;
        return this;
      };
      Revenue2.prototype.setQuantity = function(quantity) {
        if (quantity > 0) {
          this.quantity = quantity;
        }
        return this;
      };
      Revenue2.prototype.setPrice = function(price) {
        this.price = price;
        return this;
      };
      Revenue2.prototype.setRevenueType = function(revenueType) {
        this.revenueType = revenueType;
        return this;
      };
      Revenue2.prototype.setCurrency = function(currency) {
        this.currency = currency;
        return this;
      };
      Revenue2.prototype.setRevenue = function(revenue2) {
        this.revenue = revenue2;
        return this;
      };
      Revenue2.prototype.setReceipt = function(receipt) {
        this.receipt = receipt;
        return this;
      };
      Revenue2.prototype.setReceiptSig = function(receiptSig) {
        this.receiptSig = receiptSig;
        return this;
      };
      Revenue2.prototype.setEventProperties = function(properties) {
        if (isValidObject(properties)) {
          this.properties = properties;
        }
        return this;
      };
      Revenue2.prototype.getEventProperties = function() {
        var eventProperties = this.properties ? __assign({}, this.properties) : {};
        eventProperties[RevenueProperty.REVENUE_PRODUCT_ID] = this.productId;
        eventProperties[RevenueProperty.REVENUE_QUANTITY] = this.quantity;
        eventProperties[RevenueProperty.REVENUE_PRICE] = this.price;
        eventProperties[RevenueProperty.REVENUE_TYPE] = this.revenueType;
        eventProperties[RevenueProperty.REVENUE_CURRENCY] = this.currency;
        eventProperties[RevenueProperty.REVENUE] = this.revenue;
        eventProperties[RevenueProperty.RECEIPT] = this.receipt;
        eventProperties[RevenueProperty.RECEIPT_SIG] = this.receiptSig;
        return eventProperties;
      };
      return Revenue2;
    }();
    (function(RevenueProperty3) {
      RevenueProperty3["REVENUE_PRODUCT_ID"] = "$productId";
      RevenueProperty3["REVENUE_QUANTITY"] = "$quantity";
      RevenueProperty3["REVENUE_PRICE"] = "$price";
      RevenueProperty3["REVENUE_TYPE"] = "$revenueType";
      RevenueProperty3["REVENUE_CURRENCY"] = "$currency";
      RevenueProperty3["REVENUE"] = "$revenue";
      RevenueProperty3["RECEIPT"] = "$receipt";
      RevenueProperty3["RECEIPT_SIG"] = "$receiptSig";
    })(RevenueProperty || (RevenueProperty = {}));
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/utils/chunk.js
var chunk;
var init_chunk = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/utils/chunk.js"() {
    "use strict";
    chunk = function(arr, size) {
      var chunkSize = Math.max(size, 1);
      return arr.reduce(function(chunks, element, index2) {
        var chunkIndex = Math.floor(index2 / chunkSize);
        if (!chunks[chunkIndex]) {
          chunks[chunkIndex] = [];
        }
        chunks[chunkIndex].push(element);
        return chunks;
      }, []);
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/types/loglevel.js
var LogLevel;
var init_loglevel = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/types/loglevel.js"() {
    "use strict";
    (function(LogLevel3) {
      LogLevel3[LogLevel3["None"] = 0] = "None";
      LogLevel3[LogLevel3["Error"] = 1] = "Error";
      LogLevel3[LogLevel3["Warn"] = 2] = "Warn";
      LogLevel3[LogLevel3["Verbose"] = 3] = "Verbose";
      LogLevel3[LogLevel3["Debug"] = 4] = "Debug";
    })(LogLevel || (LogLevel = {}));
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/logger.js
var PREFIX, Logger;
var init_logger = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/logger.js"() {
    "use strict";
    init_loglevel();
    PREFIX = "Amplitude Logger ";
    Logger = /** @class */
    function() {
      function Logger2() {
        this.logLevel = LogLevel.None;
      }
      Logger2.prototype.disable = function() {
        this.logLevel = LogLevel.None;
      };
      Logger2.prototype.enable = function(logLevel) {
        if (logLevel === void 0) {
          logLevel = LogLevel.Warn;
        }
        this.logLevel = logLevel;
      };
      Logger2.prototype.log = function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (this.logLevel < LogLevel.Verbose) {
          return;
        }
        console.log("".concat(PREFIX, "[Log]: ").concat(args.join(" ")));
      };
      Logger2.prototype.warn = function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (this.logLevel < LogLevel.Warn) {
          return;
        }
        console.warn("".concat(PREFIX, "[Warn]: ").concat(args.join(" ")));
      };
      Logger2.prototype.error = function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (this.logLevel < LogLevel.Error) {
          return;
        }
        console.error("".concat(PREFIX, "[Error]: ").concat(args.join(" ")));
      };
      Logger2.prototype.debug = function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (this.logLevel < LogLevel.Debug) {
          return;
        }
        console.log("".concat(PREFIX, "[Debug]: ").concat(args.join(" ")));
      };
      return Logger2;
    }();
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/config.js
var getDefaultConfig, Config, getServerUrl, createServerConfig, RequestMetadata;
var init_config = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/config.js"() {
    "use strict";
    init_constants();
    init_logger();
    init_loglevel();
    getDefaultConfig = function() {
      return {
        flushMaxRetries: 12,
        flushQueueSize: 200,
        flushIntervalMillis: 1e4,
        instanceName: "$default_instance",
        logLevel: LogLevel.Warn,
        loggerProvider: new Logger(),
        offline: false,
        optOut: false,
        serverUrl: AMPLITUDE_SERVER_URL,
        serverZone: "US",
        useBatch: false
      };
    };
    Config = /** @class */
    function() {
      function Config2(options) {
        var _a, _b, _c, _d;
        this._optOut = false;
        var defaultConfig = getDefaultConfig();
        this.apiKey = options.apiKey;
        this.flushIntervalMillis = (_a = options.flushIntervalMillis) !== null && _a !== void 0 ? _a : defaultConfig.flushIntervalMillis;
        this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
        this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
        this.instanceName = options.instanceName || defaultConfig.instanceName;
        this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
        this.logLevel = (_b = options.logLevel) !== null && _b !== void 0 ? _b : defaultConfig.logLevel;
        this.minIdLength = options.minIdLength;
        this.plan = options.plan;
        this.ingestionMetadata = options.ingestionMetadata;
        this.offline = options.offline !== void 0 ? options.offline : defaultConfig.offline;
        this.optOut = (_c = options.optOut) !== null && _c !== void 0 ? _c : defaultConfig.optOut;
        this.serverUrl = options.serverUrl;
        this.serverZone = options.serverZone || defaultConfig.serverZone;
        this.storageProvider = options.storageProvider;
        this.transportProvider = options.transportProvider;
        this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
        this.loggerProvider.enable(this.logLevel);
        var serverConfig = createServerConfig(options.serverUrl, options.serverZone, options.useBatch);
        this.serverZone = serverConfig.serverZone;
        this.serverUrl = serverConfig.serverUrl;
      }
      Object.defineProperty(Config2.prototype, "optOut", {
        get: function() {
          return this._optOut;
        },
        set: function(optOut) {
          this._optOut = optOut;
        },
        enumerable: false,
        configurable: true
      });
      return Config2;
    }();
    getServerUrl = function(serverZone, useBatch) {
      if (serverZone === "EU") {
        return useBatch ? EU_AMPLITUDE_BATCH_SERVER_URL : EU_AMPLITUDE_SERVER_URL;
      }
      return useBatch ? AMPLITUDE_BATCH_SERVER_URL : AMPLITUDE_SERVER_URL;
    };
    createServerConfig = function(serverUrl, serverZone, useBatch) {
      if (serverUrl === void 0) {
        serverUrl = "";
      }
      if (serverZone === void 0) {
        serverZone = getDefaultConfig().serverZone;
      }
      if (useBatch === void 0) {
        useBatch = getDefaultConfig().useBatch;
      }
      if (serverUrl) {
        return { serverUrl, serverZone: void 0 };
      }
      var _serverZone = ["US", "EU"].includes(serverZone) ? serverZone : getDefaultConfig().serverZone;
      return {
        serverZone: _serverZone,
        serverUrl: getServerUrl(_serverZone, useBatch)
      };
    };
    RequestMetadata = /** @class */
    function() {
      function RequestMetadata2() {
        this.sdk = {
          metrics: {
            histogram: {}
          }
        };
      }
      RequestMetadata2.prototype.recordHistogram = function(key, value) {
        this.sdk.metrics.histogram[key] = value;
      };
      return RequestMetadata2;
    }();
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/plugins/destination.js
function getErrorMessage(error) {
  if (error instanceof Error)
    return error.message;
  return String(error);
}
function getResponseBodyString(res) {
  var responseBodyString = "";
  try {
    if ("body" in res) {
      responseBodyString = JSON.stringify(res.body, null, 2);
    }
  } catch (_a) {
  }
  return responseBodyString;
}
var Destination;
var init_destination = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/plugins/destination.js"() {
    "use strict";
    init_tslib_es6();
    init_status();
    init_messages();
    init_constants();
    init_chunk();
    init_result_builder();
    init_config();
    init_uuid();
    Destination = /** @class */
    function() {
      function Destination2() {
        this.name = "amplitude";
        this.type = "destination";
        this.retryTimeout = 1e3;
        this.throttleTimeout = 3e4;
        this.storageKey = "";
        this.scheduleId = null;
        this.scheduledTimeout = 0;
        this.flushId = null;
        this.queue = [];
      }
      Destination2.prototype.setup = function(config2) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
          var unsent;
          var _this = this;
          return __generator(this, function(_b) {
            switch (_b.label) {
              case 0:
                this.config = config2;
                this.storageKey = "".concat(STORAGE_PREFIX, "_").concat(this.config.apiKey.substring(0, 10));
                return [4, (_a = this.config.storageProvider) === null || _a === void 0 ? void 0 : _a.get(this.storageKey)];
              case 1:
                unsent = _b.sent();
                if (unsent && unsent.length > 0) {
                  void Promise.all(unsent.map(function(event) {
                    return _this.execute(event);
                  })).catch();
                }
                return [2, Promise.resolve(void 0)];
            }
          });
        });
      };
      Destination2.prototype.execute = function(event) {
        var _this = this;
        if (!event.insert_id) {
          event.insert_id = UUID();
        }
        return new Promise(function(resolve) {
          var context = {
            event,
            attempts: 0,
            callback: function(result) {
              return resolve(result);
            },
            timeout: 0
          };
          _this.queue.push(context);
          _this.schedule(_this.config.flushIntervalMillis);
          _this.saveEvents();
        });
      };
      Destination2.prototype.removeEventsExceedFlushMaxRetries = function(list) {
        var _this = this;
        return list.filter(function(context) {
          context.attempts += 1;
          if (context.attempts < _this.config.flushMaxRetries) {
            return true;
          }
          void _this.fulfillRequest([context], 500, MAX_RETRIES_EXCEEDED_MESSAGE);
          return false;
        });
      };
      Destination2.prototype.scheduleEvents = function(list) {
        var _this = this;
        list.forEach(function(context) {
          _this.schedule(context.timeout === 0 ? _this.config.flushIntervalMillis : context.timeout);
        });
      };
      Destination2.prototype.schedule = function(timeout2) {
        var _this = this;
        if (this.config.offline) {
          return;
        }
        if (this.scheduleId === null || this.scheduleId && timeout2 > this.scheduledTimeout) {
          if (this.scheduleId) {
            clearTimeout(this.scheduleId);
          }
          this.scheduledTimeout = timeout2;
          this.scheduleId = setTimeout(function() {
            _this.queue = _this.queue.map(function(context) {
              context.timeout = 0;
              return context;
            });
            void _this.flush(true);
          }, timeout2);
          return;
        }
      };
      Destination2.prototype.resetSchedule = function() {
        this.scheduleId = null;
        this.scheduledTimeout = 0;
      };
      Destination2.prototype.flush = function(useRetry) {
        if (useRetry === void 0) {
          useRetry = false;
        }
        return __awaiter(this, void 0, void 0, function() {
          var list, later, batches;
          var _this = this;
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                if (this.config.offline) {
                  this.resetSchedule();
                  this.config.loggerProvider.debug("Skipping flush while offline.");
                  return [
                    2
                    /*return*/
                  ];
                }
                if (this.flushId) {
                  this.resetSchedule();
                  this.config.loggerProvider.debug("Skipping flush because previous flush has not resolved.");
                  return [
                    2
                    /*return*/
                  ];
                }
                this.flushId = this.scheduleId;
                this.resetSchedule();
                list = [];
                later = [];
                this.queue.forEach(function(context) {
                  return context.timeout === 0 ? list.push(context) : later.push(context);
                });
                batches = chunk(list, this.config.flushQueueSize);
                return [4, batches.reduce(function(promise, batch) {
                  return __awaiter(_this, void 0, void 0, function() {
                    return __generator(this, function(_a2) {
                      switch (_a2.label) {
                        case 0:
                          return [4, promise];
                        case 1:
                          _a2.sent();
                          return [4, this.send(batch, useRetry)];
                        case 2:
                          return [2, _a2.sent()];
                      }
                    });
                  });
                }, Promise.resolve())];
              case 1:
                _a.sent();
                this.flushId = null;
                this.scheduleEvents(this.queue);
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      Destination2.prototype.send = function(list, useRetry) {
        if (useRetry === void 0) {
          useRetry = true;
        }
        return __awaiter(this, void 0, void 0, function() {
          var payload, serverUrl, res, e_1, errorMessage;
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                if (!this.config.apiKey) {
                  return [2, this.fulfillRequest(list, 400, MISSING_API_KEY_MESSAGE)];
                }
                payload = {
                  api_key: this.config.apiKey,
                  events: list.map(function(context) {
                    var _a2 = context.event, extra = _a2.extra, eventWithoutExtra = __rest(_a2, ["extra"]);
                    return eventWithoutExtra;
                  }),
                  options: {
                    min_id_length: this.config.minIdLength
                  },
                  client_upload_time: (/* @__PURE__ */ new Date()).toISOString(),
                  request_metadata: this.config.requestMetadata
                };
                this.config.requestMetadata = new RequestMetadata();
                _a.label = 1;
              case 1:
                _a.trys.push([1, 3, , 4]);
                serverUrl = createServerConfig(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl;
                return [4, this.config.transportProvider.send(serverUrl, payload)];
              case 2:
                res = _a.sent();
                if (res === null) {
                  this.fulfillRequest(list, 0, UNEXPECTED_ERROR_MESSAGE);
                  return [
                    2
                    /*return*/
                  ];
                }
                if (!useRetry) {
                  if ("body" in res) {
                    this.fulfillRequest(list, res.statusCode, "".concat(res.status, ": ").concat(getResponseBodyString(res)));
                  } else {
                    this.fulfillRequest(list, res.statusCode, res.status);
                  }
                  return [
                    2
                    /*return*/
                  ];
                }
                this.handleResponse(res, list);
                return [3, 4];
              case 3:
                e_1 = _a.sent();
                errorMessage = getErrorMessage(e_1);
                this.config.loggerProvider.error(errorMessage);
                this.handleResponse({ status: Status.Failed, statusCode: 0 }, list);
                return [3, 4];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      Destination2.prototype.handleResponse = function(res, list) {
        var status = res.status;
        switch (status) {
          case Status.Success: {
            this.handleSuccessResponse(res, list);
            break;
          }
          case Status.Invalid: {
            this.handleInvalidResponse(res, list);
            break;
          }
          case Status.PayloadTooLarge: {
            this.handlePayloadTooLargeResponse(res, list);
            break;
          }
          case Status.RateLimit: {
            this.handleRateLimitResponse(res, list);
            break;
          }
          default: {
            this.config.loggerProvider.warn(`{code: 0, error: "Status '`.concat(status, "' provided for ").concat(list.length, ' events"}'));
            this.handleOtherResponse(list);
            break;
          }
        }
      };
      Destination2.prototype.handleSuccessResponse = function(res, list) {
        this.fulfillRequest(list, res.statusCode, SUCCESS_MESSAGE);
      };
      Destination2.prototype.handleInvalidResponse = function(res, list) {
        var _this = this;
        if (res.body.missingField || res.body.error.startsWith(INVALID_API_KEY)) {
          this.fulfillRequest(list, res.statusCode, res.body.error);
          return;
        }
        var dropIndex = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(Object.values(res.body.eventsWithInvalidFields)), false), __read(Object.values(res.body.eventsWithMissingFields)), false), __read(Object.values(res.body.eventsWithInvalidIdLengths)), false), __read(res.body.silencedEvents), false).flat();
        var dropIndexSet = new Set(dropIndex);
        var retry = list.filter(function(context, index2) {
          if (dropIndexSet.has(index2)) {
            _this.fulfillRequest([context], res.statusCode, res.body.error);
            return;
          }
          return true;
        });
        if (retry.length > 0) {
          this.config.loggerProvider.warn(getResponseBodyString(res));
        }
        var tryable = this.removeEventsExceedFlushMaxRetries(retry);
        this.scheduleEvents(tryable);
      };
      Destination2.prototype.handlePayloadTooLargeResponse = function(res, list) {
        if (list.length === 1) {
          this.fulfillRequest(list, res.statusCode, res.body.error);
          return;
        }
        this.config.loggerProvider.warn(getResponseBodyString(res));
        this.config.flushQueueSize /= 2;
        var tryable = this.removeEventsExceedFlushMaxRetries(list);
        this.scheduleEvents(tryable);
      };
      Destination2.prototype.handleRateLimitResponse = function(res, list) {
        var _this = this;
        var dropUserIds = Object.keys(res.body.exceededDailyQuotaUsers);
        var dropDeviceIds = Object.keys(res.body.exceededDailyQuotaDevices);
        var throttledIndex = res.body.throttledEvents;
        var dropUserIdsSet = new Set(dropUserIds);
        var dropDeviceIdsSet = new Set(dropDeviceIds);
        var throttledIndexSet = new Set(throttledIndex);
        var retry = list.filter(function(context, index2) {
          if (context.event.user_id && dropUserIdsSet.has(context.event.user_id) || context.event.device_id && dropDeviceIdsSet.has(context.event.device_id)) {
            _this.fulfillRequest([context], res.statusCode, res.body.error);
            return;
          }
          if (throttledIndexSet.has(index2)) {
            context.timeout = _this.throttleTimeout;
          }
          return true;
        });
        if (retry.length > 0) {
          this.config.loggerProvider.warn(getResponseBodyString(res));
        }
        var tryable = this.removeEventsExceedFlushMaxRetries(retry);
        this.scheduleEvents(tryable);
      };
      Destination2.prototype.handleOtherResponse = function(list) {
        var _this = this;
        var later = list.map(function(context) {
          context.timeout = context.attempts * _this.retryTimeout;
          return context;
        });
        var tryable = this.removeEventsExceedFlushMaxRetries(later);
        this.scheduleEvents(tryable);
      };
      Destination2.prototype.fulfillRequest = function(list, code, message) {
        this.removeEvents(list);
        list.forEach(function(context) {
          return context.callback(buildResult(context.event, code, message));
        });
      };
      Destination2.prototype.saveEvents = function() {
        if (!this.config.storageProvider) {
          return;
        }
        var updatedEvents = this.queue.map(function(context) {
          return context.event;
        });
        void this.config.storageProvider.set(this.storageKey, updatedEvents);
      };
      Destination2.prototype.removeEvents = function(eventsToRemove) {
        this.queue = this.queue.filter(function(queuedContext) {
          return !eventsToRemove.some(function(context) {
            return context.event.insert_id === queuedContext.event.insert_id;
          });
        });
        this.saveEvents();
      };
      return Destination2;
    }();
  }
});

// node_modules/@amplitude/analytics-connector/dist/analytics-connector.esm.js
function __values2(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read2(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
var ApplicationContextProviderImpl, getLanguage, EventBridgeImpl, __assign2, isEqual, ID_OP_SET, ID_OP_UNSET, ID_OP_CLEAR_ALL, IdentityStoreImpl, safeGlobal, AnalyticsConnector;
var init_analytics_connector_esm = __esm({
  "node_modules/@amplitude/analytics-connector/dist/analytics-connector.esm.js"() {
    "use strict";
    ApplicationContextProviderImpl = /** @class */
    function() {
      function ApplicationContextProviderImpl2() {
      }
      ApplicationContextProviderImpl2.prototype.getApplicationContext = function() {
        return {
          versionName: this.versionName,
          language: getLanguage(),
          platform: "Web",
          os: void 0,
          deviceModel: void 0
        };
      };
      return ApplicationContextProviderImpl2;
    }();
    getLanguage = function() {
      return typeof navigator !== "undefined" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
    };
    EventBridgeImpl = /** @class */
    function() {
      function EventBridgeImpl2() {
        this.queue = [];
      }
      EventBridgeImpl2.prototype.logEvent = function(event) {
        if (!this.receiver) {
          if (this.queue.length < 512) {
            this.queue.push(event);
          }
        } else {
          this.receiver(event);
        }
      };
      EventBridgeImpl2.prototype.setEventReceiver = function(receiver) {
        this.receiver = receiver;
        if (this.queue.length > 0) {
          this.queue.forEach(function(event) {
            receiver(event);
          });
          this.queue = [];
        }
      };
      return EventBridgeImpl2;
    }();
    __assign2 = function() {
      __assign2 = Object.assign || function __assign8(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign2.apply(this, arguments);
    };
    isEqual = function(obj1, obj2) {
      var e_1, _a;
      var primitive = ["string", "number", "boolean", "undefined"];
      var typeA = typeof obj1;
      var typeB = typeof obj2;
      if (typeA !== typeB) {
        return false;
      }
      try {
        for (var primitive_1 = __values2(primitive), primitive_1_1 = primitive_1.next(); !primitive_1_1.done; primitive_1_1 = primitive_1.next()) {
          var p = primitive_1_1.value;
          if (p === typeA) {
            return obj1 === obj2;
          }
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (primitive_1_1 && !primitive_1_1.done && (_a = primitive_1.return)) _a.call(primitive_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      if (obj1 == null && obj2 == null) {
        return true;
      } else if (obj1 == null || obj2 == null) {
        return false;
      }
      if (obj1.length !== obj2.length) {
        return false;
      }
      var isArrayA = Array.isArray(obj1);
      var isArrayB = Array.isArray(obj2);
      if (isArrayA !== isArrayB) {
        return false;
      }
      if (isArrayA && isArrayB) {
        for (var i = 0; i < obj1.length; i++) {
          if (!isEqual(obj1[i], obj2[i])) {
            return false;
          }
        }
      } else {
        var sorted1 = Object.keys(obj1).sort();
        var sorted2 = Object.keys(obj2).sort();
        if (!isEqual(sorted1, sorted2)) {
          return false;
        }
        var result_1 = true;
        Object.keys(obj1).forEach(function(key) {
          if (!isEqual(obj1[key], obj2[key])) {
            result_1 = false;
          }
        });
        return result_1;
      }
      return true;
    };
    ID_OP_SET = "$set";
    ID_OP_UNSET = "$unset";
    ID_OP_CLEAR_ALL = "$clearAll";
    if (!Object.entries) {
      Object.entries = function(obj) {
        var ownProps = Object.keys(obj);
        var i = ownProps.length;
        var resArray = new Array(i);
        while (i--) {
          resArray[i] = [ownProps[i], obj[ownProps[i]]];
        }
        return resArray;
      };
    }
    IdentityStoreImpl = /** @class */
    function() {
      function IdentityStoreImpl2() {
        this.identity = { userProperties: {} };
        this.listeners = /* @__PURE__ */ new Set();
      }
      IdentityStoreImpl2.prototype.editIdentity = function() {
        var self2 = this;
        var actingUserProperties = __assign2({}, this.identity.userProperties);
        var actingIdentity = __assign2(__assign2({}, this.identity), { userProperties: actingUserProperties });
        return {
          setUserId: function(userId) {
            actingIdentity.userId = userId;
            return this;
          },
          setDeviceId: function(deviceId) {
            actingIdentity.deviceId = deviceId;
            return this;
          },
          setUserProperties: function(userProperties) {
            actingIdentity.userProperties = userProperties;
            return this;
          },
          setOptOut: function(optOut) {
            actingIdentity.optOut = optOut;
            return this;
          },
          updateUserProperties: function(actions) {
            var e_1, _a, e_2, _b, e_3, _c;
            var actingProperties = actingIdentity.userProperties || {};
            try {
              for (var _d = __values2(Object.entries(actions)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var _f = __read2(_e.value, 2), action = _f[0], properties = _f[1];
                switch (action) {
                  case ID_OP_SET:
                    try {
                      for (var _g = (e_2 = void 0, __values2(Object.entries(properties))), _h = _g.next(); !_h.done; _h = _g.next()) {
                        var _j = __read2(_h.value, 2), key = _j[0], value = _j[1];
                        actingProperties[key] = value;
                      }
                    } catch (e_2_1) {
                      e_2 = { error: e_2_1 };
                    } finally {
                      try {
                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                      } finally {
                        if (e_2) throw e_2.error;
                      }
                    }
                    break;
                  case ID_OP_UNSET:
                    try {
                      for (var _k = (e_3 = void 0, __values2(Object.keys(properties))), _l = _k.next(); !_l.done; _l = _k.next()) {
                        var key = _l.value;
                        delete actingProperties[key];
                      }
                    } catch (e_3_1) {
                      e_3 = { error: e_3_1 };
                    } finally {
                      try {
                        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                      } finally {
                        if (e_3) throw e_3.error;
                      }
                    }
                    break;
                  case ID_OP_CLEAR_ALL:
                    actingProperties = {};
                    break;
                }
              }
            } catch (e_1_1) {
              e_1 = { error: e_1_1 };
            } finally {
              try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
            actingIdentity.userProperties = actingProperties;
            return this;
          },
          commit: function() {
            self2.setIdentity(actingIdentity);
            return this;
          }
        };
      };
      IdentityStoreImpl2.prototype.getIdentity = function() {
        return __assign2({}, this.identity);
      };
      IdentityStoreImpl2.prototype.setIdentity = function(identity) {
        var originalIdentity = __assign2({}, this.identity);
        this.identity = __assign2({}, identity);
        if (!isEqual(originalIdentity, this.identity)) {
          this.listeners.forEach(function(listener) {
            listener(identity);
          });
        }
      };
      IdentityStoreImpl2.prototype.addIdentityListener = function(listener) {
        this.listeners.add(listener);
      };
      IdentityStoreImpl2.prototype.removeIdentityListener = function(listener) {
        this.listeners.delete(listener);
      };
      return IdentityStoreImpl2;
    }();
    safeGlobal = typeof globalThis !== "undefined" ? globalThis : typeof global !== "undefined" ? global : self;
    AnalyticsConnector = /** @class */
    function() {
      function AnalyticsConnector2() {
        this.identityStore = new IdentityStoreImpl();
        this.eventBridge = new EventBridgeImpl();
        this.applicationContextProvider = new ApplicationContextProviderImpl();
      }
      AnalyticsConnector2.getInstance = function(instanceName) {
        if (!safeGlobal["analyticsConnectorInstances"]) {
          safeGlobal["analyticsConnectorInstances"] = {};
        }
        if (!safeGlobal["analyticsConnectorInstances"][instanceName]) {
          safeGlobal["analyticsConnectorInstances"][instanceName] = new AnalyticsConnector2();
        }
        return safeGlobal["analyticsConnectorInstances"][instanceName];
      };
      return AnalyticsConnector2;
    }();
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/analytics-connector.js
var getAnalyticsConnector, setConnectorUserId, setConnectorDeviceId;
var init_analytics_connector = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/analytics-connector.js"() {
    "use strict";
    init_analytics_connector_esm();
    getAnalyticsConnector = function(instanceName) {
      if (instanceName === void 0) {
        instanceName = "$default_instance";
      }
      return AnalyticsConnector.getInstance(instanceName);
    };
    setConnectorUserId = function(userId, instanceName) {
      getAnalyticsConnector(instanceName).identityStore.editIdentity().setUserId(userId).commit();
    };
    setConnectorDeviceId = function(deviceId, instanceName) {
      getAnalyticsConnector(instanceName).identityStore.editIdentity().setDeviceId(deviceId).commit();
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/plugins/identity.js
var IdentityEventSender;
var init_identity = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/plugins/identity.js"() {
    "use strict";
    init_tslib_es6();
    init_analytics_connector();
    IdentityEventSender = /** @class */
    function() {
      function IdentityEventSender2() {
        this.name = "identity";
        this.type = "before";
        this.identityStore = getAnalyticsConnector().identityStore;
      }
      IdentityEventSender2.prototype.execute = function(context) {
        return __awaiter(this, void 0, void 0, function() {
          var userProperties;
          return __generator(this, function(_a) {
            userProperties = context.user_properties;
            if (userProperties) {
              this.identityStore.editIdentity().updateUserProperties(userProperties).commit();
            }
            return [2, context];
          });
        });
      };
      IdentityEventSender2.prototype.setup = function(config2) {
        return __awaiter(this, void 0, void 0, function() {
          return __generator(this, function(_a) {
            if (config2.instanceName) {
              this.identityStore = getAnalyticsConnector(config2.instanceName).identityStore;
            }
            return [
              2
              /*return*/
            ];
          });
        });
      };
      return IdentityEventSender2;
    }();
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/global-scope.js
var getGlobalScope;
var init_global_scope = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/global-scope.js"() {
    "use strict";
    getGlobalScope = function() {
      var ampIntegrationContextName = "ampIntegrationContext";
      if (typeof globalThis !== "undefined" && typeof globalThis[ampIntegrationContextName] !== "undefined") {
        return globalThis[ampIntegrationContextName];
      }
      if (typeof globalThis !== "undefined") {
        return globalThis;
      }
      if (typeof window !== "undefined") {
        return window;
      }
      if (typeof self !== "undefined") {
        return self;
      }
      if (typeof global !== "undefined") {
        return global;
      }
      return void 0;
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/session.js
var isNewSession;
var init_session = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/session.js"() {
    "use strict";
    isNewSession = function(sessionTimeout, lastEventTime) {
      if (lastEventTime === void 0) {
        lastEventTime = Date.now();
      }
      var currentTime = Date.now();
      var timeSinceLastEvent = currentTime - lastEventTime;
      return timeSinceLastEvent > sessionTimeout;
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/cookie-name.js
var getCookieName, getOldCookieName;
var init_cookie_name = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/cookie-name.js"() {
    "use strict";
    init_constants();
    getCookieName = function(apiKey, postKey, limit) {
      if (postKey === void 0) {
        postKey = "";
      }
      if (limit === void 0) {
        limit = 10;
      }
      return [AMPLITUDE_PREFIX, postKey, apiKey.substring(0, limit)].filter(Boolean).join("_");
    };
    getOldCookieName = function(apiKey) {
      return "".concat(AMPLITUDE_PREFIX.toLowerCase(), "_").concat(apiKey.substring(0, 6));
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/language.js
var getLanguage2;
var init_language = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/language.js"() {
    "use strict";
    getLanguage2 = function() {
      var _a, _b, _c, _d;
      if (typeof navigator === "undefined")
        return "";
      var userLanguage = navigator.userLanguage;
      return (_d = (_c = (_b = (_a = navigator.languages) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : navigator.language) !== null && _c !== void 0 ? _c : userLanguage) !== null && _d !== void 0 ? _d : "";
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/query-params.js
var getQueryParams, tryDecodeURIComponent;
var init_query_params = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/query-params.js"() {
    "use strict";
    init_global_scope();
    getQueryParams = function() {
      var _a;
      var globalScope = getGlobalScope();
      if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _a === void 0 ? void 0 : _a.search)) {
        return {};
      }
      var pairs = globalScope.location.search.substring(1).split("&").filter(Boolean);
      var params = pairs.reduce(function(acc, curr) {
        var query = curr.split("=", 2);
        var key = tryDecodeURIComponent(query[0]);
        var value = tryDecodeURIComponent(query[1]);
        if (!value) {
          return acc;
        }
        acc[key] = value;
        return acc;
      }, {});
      return params;
    };
    tryDecodeURIComponent = function(value) {
      if (value === void 0) {
        value = "";
      }
      try {
        return decodeURIComponent(value);
      } catch (_a) {
        return "";
      }
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/utils/debug.js
var getStacktrace, getClientLogConfig, getValueByStringPath, getClientStates, debugWrapper;
var init_debug = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/utils/debug.js"() {
    "use strict";
    init_tslib_es6();
    init_loglevel();
    getStacktrace = function(ignoreDepth) {
      if (ignoreDepth === void 0) {
        ignoreDepth = 0;
      }
      var trace = new Error().stack || "";
      return trace.split("\n").slice(2 + ignoreDepth).map(function(text) {
        return text.trim();
      });
    };
    getClientLogConfig = function(client2) {
      return function() {
        var _a = __assign({}, client2.config), logger = _a.loggerProvider, logLevel = _a.logLevel;
        return {
          logger,
          logLevel
        };
      };
    };
    getValueByStringPath = function(obj, path) {
      var e_1, _a;
      path = path.replace(/\[(\w+)\]/g, ".$1");
      path = path.replace(/^\./, "");
      try {
        for (var _b = __values(path.split(".")), _c = _b.next(); !_c.done; _c = _b.next()) {
          var attr2 = _c.value;
          if (attr2 in obj) {
            obj = obj[attr2];
          } else {
            return;
          }
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return obj;
    };
    getClientStates = function(client2, paths) {
      return function() {
        var e_2, _a;
        var res = {};
        try {
          for (var paths_1 = __values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
            var path = paths_1_1.value;
            res[path] = getValueByStringPath(client2, path);
          }
        } catch (e_2_1) {
          e_2 = { error: e_2_1 };
        } finally {
          try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
          } finally {
            if (e_2) throw e_2.error;
          }
        }
        return res;
      };
    };
    debugWrapper = function(fn, fnName, getLogConfig, getStates, fnContext) {
      if (fnContext === void 0) {
        fnContext = null;
      }
      return function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var _a = getLogConfig(), logger = _a.logger, logLevel = _a.logLevel;
        if (logLevel && logLevel < LogLevel.Debug || !logLevel || !logger) {
          return fn.apply(fnContext, args);
        }
        var debugContext = {
          type: "invoke public method",
          name: fnName,
          args,
          stacktrace: getStacktrace(1),
          time: {
            start: (/* @__PURE__ */ new Date()).toISOString()
          },
          states: {}
        };
        if (getStates && debugContext.states) {
          debugContext.states.before = getStates();
        }
        var result = fn.apply(fnContext, args);
        if (result && result.promise) {
          result.promise.then(function() {
            if (getStates && debugContext.states) {
              debugContext.states.after = getStates();
            }
            if (debugContext.time) {
              debugContext.time.end = (/* @__PURE__ */ new Date()).toISOString();
            }
            logger.debug(JSON.stringify(debugContext, null, 2));
          });
        } else {
          if (getStates && debugContext.states) {
            debugContext.states.after = getStates();
          }
          if (debugContext.time) {
            debugContext.time.end = (/* @__PURE__ */ new Date()).toISOString();
          }
          logger.debug(JSON.stringify(debugContext, null, 2));
        }
        return result;
      };
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/storage/memory.js
var MemoryStorage;
var init_memory = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/storage/memory.js"() {
    "use strict";
    init_tslib_es6();
    MemoryStorage = /** @class */
    function() {
      function MemoryStorage2() {
        this.memoryStorage = /* @__PURE__ */ new Map();
      }
      MemoryStorage2.prototype.isEnabled = function() {
        return __awaiter(this, void 0, void 0, function() {
          return __generator(this, function(_a) {
            return [2, true];
          });
        });
      };
      MemoryStorage2.prototype.get = function(key) {
        return __awaiter(this, void 0, void 0, function() {
          return __generator(this, function(_a) {
            return [2, this.memoryStorage.get(key)];
          });
        });
      };
      MemoryStorage2.prototype.getRaw = function(key) {
        return __awaiter(this, void 0, void 0, function() {
          var value;
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                return [4, this.get(key)];
              case 1:
                value = _a.sent();
                return [2, value ? JSON.stringify(value) : void 0];
            }
          });
        });
      };
      MemoryStorage2.prototype.set = function(key, value) {
        return __awaiter(this, void 0, void 0, function() {
          return __generator(this, function(_a) {
            this.memoryStorage.set(key, value);
            return [
              2
              /*return*/
            ];
          });
        });
      };
      MemoryStorage2.prototype.remove = function(key) {
        return __awaiter(this, void 0, void 0, function() {
          return __generator(this, function(_a) {
            this.memoryStorage.delete(key);
            return [
              2
              /*return*/
            ];
          });
        });
      };
      MemoryStorage2.prototype.reset = function() {
        return __awaiter(this, void 0, void 0, function() {
          return __generator(this, function(_a) {
            this.memoryStorage.clear();
            return [
              2
              /*return*/
            ];
          });
        });
      };
      return MemoryStorage2;
    }();
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/storage/cookie.js
var CookieStorage, decodeCookiesAsDefault, decodeCookiesWithDoubleUrlEncoding;
var init_cookie = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/storage/cookie.js"() {
    "use strict";
    init_tslib_es6();
    init_global_scope();
    CookieStorage = /** @class */
    function() {
      function CookieStorage2(options) {
        this.options = __assign({}, options);
      }
      CookieStorage2.prototype.isEnabled = function() {
        return __awaiter(this, void 0, void 0, function() {
          var testStrorage, testKey, value, _a;
          return __generator(this, function(_b) {
            switch (_b.label) {
              case 0:
                if (!getGlobalScope()) {
                  return [2, false];
                }
                CookieStorage2.testValue = String(Date.now());
                testStrorage = new CookieStorage2(this.options);
                testKey = "AMP_TEST";
                _b.label = 1;
              case 1:
                _b.trys.push([1, 4, 5, 7]);
                return [4, testStrorage.set(testKey, CookieStorage2.testValue)];
              case 2:
                _b.sent();
                return [4, testStrorage.get(testKey)];
              case 3:
                value = _b.sent();
                return [2, value === CookieStorage2.testValue];
              case 4:
                _a = _b.sent();
                return [2, false];
              case 5:
                return [4, testStrorage.remove(testKey)];
              case 6:
                _b.sent();
                return [
                  7
                  /*endfinally*/
                ];
              case 7:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      CookieStorage2.prototype.get = function(key) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
          var value, decodedValue;
          return __generator(this, function(_b) {
            switch (_b.label) {
              case 0:
                return [4, this.getRaw(key)];
              case 1:
                value = _b.sent();
                if (!value) {
                  return [2, void 0];
                }
                try {
                  decodedValue = (_a = decodeCookiesAsDefault(value)) !== null && _a !== void 0 ? _a : decodeCookiesWithDoubleUrlEncoding(value);
                  if (decodedValue === void 0) {
                    console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(key, ", value: ").concat(value));
                    return [2, void 0];
                  }
                  return [2, JSON.parse(decodedValue)];
                } catch (_c) {
                  console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(key, ", value: ").concat(value));
                  return [2, void 0];
                }
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      CookieStorage2.prototype.getRaw = function(key) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function() {
          var globalScope, cookie, match;
          return __generator(this, function(_c) {
            globalScope = getGlobalScope();
            cookie = (_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.document) === null || _a === void 0 ? void 0 : _a.cookie.split("; ")) !== null && _b !== void 0 ? _b : [];
            match = cookie.find(function(c) {
              return c.indexOf(key + "=") === 0;
            });
            if (!match) {
              return [2, void 0];
            }
            return [2, match.substring(key.length + 1)];
          });
        });
      };
      CookieStorage2.prototype.set = function(key, value) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
          var expirationDays, expires, expireDate, date, str, globalScope, errorMessage;
          return __generator(this, function(_b) {
            try {
              expirationDays = (_a = this.options.expirationDays) !== null && _a !== void 0 ? _a : 0;
              expires = value !== null ? expirationDays : -1;
              expireDate = void 0;
              if (expires) {
                date = /* @__PURE__ */ new Date();
                date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1e3);
                expireDate = date;
              }
              str = "".concat(key, "=").concat(btoa(encodeURIComponent(JSON.stringify(value))));
              if (expireDate) {
                str += "; expires=".concat(expireDate.toUTCString());
              }
              str += "; path=/";
              if (this.options.domain) {
                str += "; domain=".concat(this.options.domain);
              }
              if (this.options.secure) {
                str += "; Secure";
              }
              if (this.options.sameSite) {
                str += "; SameSite=".concat(this.options.sameSite);
              }
              globalScope = getGlobalScope();
              if (globalScope) {
                globalScope.document.cookie = str;
              }
            } catch (error) {
              errorMessage = error instanceof Error ? error.message : String(error);
              console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(key, ". Error: ").concat(errorMessage));
            }
            return [
              2
              /*return*/
            ];
          });
        });
      };
      CookieStorage2.prototype.remove = function(key) {
        return __awaiter(this, void 0, void 0, function() {
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                return [4, this.set(key, null)];
              case 1:
                _a.sent();
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      CookieStorage2.prototype.reset = function() {
        return __awaiter(this, void 0, void 0, function() {
          return __generator(this, function(_a) {
            return [
              2
              /*return*/
            ];
          });
        });
      };
      return CookieStorage2;
    }();
    decodeCookiesAsDefault = function(value) {
      try {
        return decodeURIComponent(atob(value));
      } catch (_a) {
        return void 0;
      }
    };
    decodeCookiesWithDoubleUrlEncoding = function(value) {
      try {
        return decodeURIComponent(atob(decodeURIComponent(value)));
      } catch (_a) {
        return void 0;
      }
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/storage/helpers.js
var getStorageKey;
var init_helpers = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/storage/helpers.js"() {
    "use strict";
    init_constants();
    getStorageKey = function(apiKey, postKey, limit) {
      if (postKey === void 0) {
        postKey = "";
      }
      if (limit === void 0) {
        limit = 10;
      }
      return [AMPLITUDE_PREFIX, postKey, apiKey.substring(0, limit)].filter(Boolean).join("_");
    };
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/transports/base.js
var BaseTransport;
var init_base = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/transports/base.js"() {
    "use strict";
    init_status();
    BaseTransport = /** @class */
    function() {
      function BaseTransport2() {
      }
      BaseTransport2.prototype.send = function(_serverUrl, _payload) {
        return Promise.resolve(null);
      };
      BaseTransport2.prototype.buildResponse = function(responseJSON) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (typeof responseJSON !== "object") {
          return null;
        }
        var statusCode = responseJSON.code || 0;
        var status = this.buildStatus(statusCode);
        switch (status) {
          case Status.Success:
            return {
              status,
              statusCode,
              body: {
                eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
                payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
                serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
              }
            };
          case Status.Invalid:
            return {
              status,
              statusCode,
              body: {
                error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : "",
                missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : "",
                eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
                eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
                eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
                epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
                exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
                silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
                silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
                throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
                throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
              }
            };
          case Status.PayloadTooLarge:
            return {
              status,
              statusCode,
              body: {
                error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ""
              }
            };
          case Status.RateLimit:
            return {
              status,
              statusCode,
              body: {
                error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : "",
                epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
                throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
                throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
                exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
                exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
                throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
              }
            };
          case Status.Timeout:
          default:
            return {
              status,
              statusCode
            };
        }
      };
      BaseTransport2.prototype.buildStatus = function(code) {
        if (code >= 200 && code < 300) {
          return Status.Success;
        }
        if (code === 429) {
          return Status.RateLimit;
        }
        if (code === 413) {
          return Status.PayloadTooLarge;
        }
        if (code === 408) {
          return Status.Timeout;
        }
        if (code >= 400 && code < 500) {
          return Status.Invalid;
        }
        if (code >= 500) {
          return Status.Failed;
        }
        return Status.Unknown;
      };
      return BaseTransport2;
    }();
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/transports/fetch.js
var FetchTransport;
var init_fetch = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/transports/fetch.js"() {
    "use strict";
    init_tslib_es6();
    init_base();
    FetchTransport = /** @class */
    function(_super) {
      __extends(FetchTransport2, _super);
      function FetchTransport2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      FetchTransport2.prototype.send = function(serverUrl, payload) {
        return __awaiter(this, void 0, void 0, function() {
          var options, response, responseText;
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                if (typeof fetch === "undefined") {
                  throw new Error("FetchTransport is not supported");
                }
                options = {
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "*/*"
                  },
                  body: JSON.stringify(payload),
                  method: "POST"
                };
                return [4, fetch(serverUrl, options)];
              case 1:
                response = _a.sent();
                return [4, response.text()];
              case 2:
                responseText = _a.sent();
                try {
                  return [2, this.buildResponse(JSON.parse(responseText))];
                } catch (_b) {
                  return [2, this.buildResponse({ code: response.status })];
                }
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      return FetchTransport2;
    }(BaseTransport);
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/types/offline.js
var OfflineDisabled;
var init_offline = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/types/offline.js"() {
    "use strict";
    OfflineDisabled = null;
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/types/element-interactions.js
var DEFAULT_CSS_SELECTOR_ALLOWLIST, DEFAULT_DATA_ATTRIBUTE_PREFIX, DEFAULT_ACTION_CLICK_ALLOWLIST;
var init_element_interactions = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/types/element-interactions.js"() {
    "use strict";
    DEFAULT_CSS_SELECTOR_ALLOWLIST = [
      "a",
      "button",
      "input",
      "select",
      "textarea",
      "label",
      "video",
      "audio",
      '[contenteditable="true" i]',
      "[data-amp-default-track]",
      ".amp-default-track"
    ];
    DEFAULT_DATA_ATTRIBUTE_PREFIX = "data-amp-track-";
    DEFAULT_ACTION_CLICK_ALLOWLIST = ["div", "span", "h1", "h2", "h3", "h4", "h5", "h6"];
  }
});

// node_modules/@amplitude/analytics-core/lib/esm/index.js
var init_esm = __esm({
  "node_modules/@amplitude/analytics-core/lib/esm/index.js"() {
    "use strict";
    init_core_client();
    init_identify();
    init_revenue();
    init_destination();
    init_identity();
    init_config();
    init_logger();
    init_global_scope();
    init_analytics_connector();
    init_session();
    init_cookie_name();
    init_language();
    init_query_params();
    init_return_wrapper();
    init_debug();
    init_uuid();
    init_event_builder();
    init_memory();
    init_cookie();
    init_helpers();
    init_base();
    init_fetch();
    init_loglevel();
    init_offline();
    init_element_interactions();
  }
});

// node_modules/@amplitude/analytics-browser/node_modules/tslib/tslib.es6.mjs
function __extends2(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics2(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __rest2(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __awaiter2(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator2(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return { value: op[1], done: false };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read3(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray2(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var extendStatics2, __assign3;
var init_tslib_es62 = __esm({
  "node_modules/@amplitude/analytics-browser/node_modules/tslib/tslib.es6.mjs"() {
    "use strict";
    extendStatics2 = function(d, b) {
      extendStatics2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
      };
      return extendStatics2(d, b);
    };
    __assign3 = function() {
      __assign3 = Object.assign || function __assign8(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign3.apply(this, arguments);
    };
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/default-tracking.js
var isTrackingEnabled, isAttributionTrackingEnabled, isFileDownloadTrackingEnabled, isFormInteractionTrackingEnabled, isPageViewTrackingEnabled, isSessionTrackingEnabled, isElementInteractionsEnabled, getElementInteractionsConfig, getPageViewTrackingConfig, getAttributionTrackingConfig;
var init_default_tracking = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/default-tracking.js"() {
    "use strict";
    init_tslib_es62();
    isTrackingEnabled = function(autocapture, event) {
      if (typeof autocapture === "boolean") {
        return autocapture;
      }
      if ((autocapture === null || autocapture === void 0 ? void 0 : autocapture[event]) === false) {
        return false;
      }
      return true;
    };
    isAttributionTrackingEnabled = function(autocapture) {
      return isTrackingEnabled(autocapture, "attribution");
    };
    isFileDownloadTrackingEnabled = function(autocapture) {
      return isTrackingEnabled(autocapture, "fileDownloads");
    };
    isFormInteractionTrackingEnabled = function(autocapture) {
      return isTrackingEnabled(autocapture, "formInteractions");
    };
    isPageViewTrackingEnabled = function(autocapture) {
      return isTrackingEnabled(autocapture, "pageViews");
    };
    isSessionTrackingEnabled = function(autocapture) {
      return isTrackingEnabled(autocapture, "sessions");
    };
    isElementInteractionsEnabled = function(autocapture) {
      if (typeof autocapture === "boolean") {
        return autocapture;
      }
      if (typeof autocapture === "object" && (autocapture.elementInteractions === true || typeof autocapture.elementInteractions === "object")) {
        return true;
      }
      return false;
    };
    getElementInteractionsConfig = function(config2) {
      if (isElementInteractionsEnabled(config2.autocapture) && typeof config2.autocapture === "object" && typeof config2.autocapture.elementInteractions === "object") {
        return config2.autocapture.elementInteractions;
      }
      return void 0;
    };
    getPageViewTrackingConfig = function(config2) {
      var trackOn = function() {
        return false;
      };
      var trackHistoryChanges = void 0;
      var eventType;
      var pageCounter = config2.pageCounter;
      var isDefaultPageViewTrackingEnabled = isPageViewTrackingEnabled(config2.defaultTracking);
      if (isDefaultPageViewTrackingEnabled) {
        trackOn = void 0;
        eventType = void 0;
        if (config2.defaultTracking && typeof config2.defaultTracking === "object" && config2.defaultTracking.pageViews && typeof config2.defaultTracking.pageViews === "object") {
          if ("trackOn" in config2.defaultTracking.pageViews) {
            trackOn = config2.defaultTracking.pageViews.trackOn;
          }
          if ("trackHistoryChanges" in config2.defaultTracking.pageViews) {
            trackHistoryChanges = config2.defaultTracking.pageViews.trackHistoryChanges;
          }
          if ("eventType" in config2.defaultTracking.pageViews && config2.defaultTracking.pageViews.eventType) {
            eventType = config2.defaultTracking.pageViews.eventType;
          }
        }
      }
      return {
        trackOn,
        trackHistoryChanges,
        eventType,
        pageCounter
      };
    };
    getAttributionTrackingConfig = function(config2) {
      if (isAttributionTrackingEnabled(config2.defaultTracking) && config2.defaultTracking && typeof config2.defaultTracking === "object" && config2.defaultTracking.attribution && typeof config2.defaultTracking.attribution === "object") {
        return __assign3({}, config2.defaultTracking.attribution);
      }
      return {};
    };
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/utils/snippet-helper.js
var runQueuedFunctions, convertProxyObjectToRealObject, isInstanceProxy;
var init_snippet_helper = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/utils/snippet-helper.js"() {
    "use strict";
    runQueuedFunctions = function(instance, queue) {
      convertProxyObjectToRealObject(instance, queue);
    };
    convertProxyObjectToRealObject = function(instance, queue) {
      for (var i = 0; i < queue.length; i++) {
        var _a = queue[i], name_1 = _a.name, args = _a.args, resolve = _a.resolve;
        var fn = instance && instance[name_1];
        if (typeof fn === "function") {
          var result = fn.apply(instance, args);
          if (typeof resolve === "function") {
            resolve(result === null || result === void 0 ? void 0 : result.promise);
          }
        }
      }
      return instance;
    };
    isInstanceProxy = function(instance) {
      var instanceProxy = instance;
      return instanceProxy && instanceProxy._q !== void 0;
    };
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/version.js
var VERSION;
var init_version = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/version.js"() {
    "use strict";
    VERSION = "2.12.0";
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/lib-prefix.js
var LIBPREFIX;
var init_lib_prefix = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/lib-prefix.js"() {
    "use strict";
    LIBPREFIX = "amplitude-ts";
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/plugins/context.js
var BROWSER_PLATFORM, IP_ADDRESS, Context;
var init_context = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/plugins/context.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    init_version();
    init_lib_prefix();
    BROWSER_PLATFORM = "Web";
    IP_ADDRESS = "$remote";
    Context = /** @class */
    function() {
      function Context2() {
        this.name = "@amplitude/plugin-context-browser";
        this.type = "before";
        this.library = "".concat(LIBPREFIX, "/").concat(VERSION);
        if (typeof navigator !== "undefined") {
          this.userAgent = navigator.userAgent;
        }
      }
      Context2.prototype.setup = function(config2) {
        this.config = config2;
        return Promise.resolve(void 0);
      };
      Context2.prototype.execute = function(context) {
        return __awaiter2(this, void 0, void 0, function() {
          var time, lastEventId, nextEventId, event;
          var _a, _b;
          return __generator2(this, function(_c) {
            time = (/* @__PURE__ */ new Date()).getTime();
            lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
            nextEventId = (_b = context.event_id) !== null && _b !== void 0 ? _b : lastEventId + 1;
            this.config.lastEventId = nextEventId;
            if (!context.time) {
              this.config.lastEventTime = time;
            }
            event = __assign3(__assign3(__assign3(__assign3(__assign3(__assign3(__assign3(__assign3({ user_id: this.config.userId, device_id: this.config.deviceId, session_id: this.config.sessionId, time }, this.config.appVersion && { app_version: this.config.appVersion }), this.config.trackingOptions.platform && { platform: BROWSER_PLATFORM }), this.config.trackingOptions.language && { language: getLanguage2() }), this.config.trackingOptions.ipAddress && { ip: IP_ADDRESS }), { insert_id: UUID(), partner_id: this.config.partnerId, plan: this.config.plan }), this.config.ingestionMetadata && {
              ingestion_metadata: {
                source_name: this.config.ingestionMetadata.sourceName,
                source_version: this.config.ingestionMetadata.sourceVersion
              }
            }), context), { event_id: nextEventId, library: this.library, user_agent: this.userAgent });
            return [2, event];
          });
        });
      };
      return Context2;
    }();
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/storage/browser-storage.js
var BrowserStorage;
var init_browser_storage = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/storage/browser-storage.js"() {
    "use strict";
    init_tslib_es62();
    BrowserStorage = /** @class */
    function() {
      function BrowserStorage2(storage) {
        this.storage = storage;
      }
      BrowserStorage2.prototype.isEnabled = function() {
        return __awaiter2(this, void 0, void 0, function() {
          var random, testStorage, testKey, value, _a;
          return __generator2(this, function(_b) {
            switch (_b.label) {
              case 0:
                if (!this.storage) {
                  return [2, false];
                }
                random = String(Date.now());
                testStorage = new BrowserStorage2(this.storage);
                testKey = "AMP_TEST";
                _b.label = 1;
              case 1:
                _b.trys.push([1, 4, 5, 7]);
                return [4, testStorage.set(testKey, random)];
              case 2:
                _b.sent();
                return [4, testStorage.get(testKey)];
              case 3:
                value = _b.sent();
                return [2, value === random];
              case 4:
                _a = _b.sent();
                return [2, false];
              case 5:
                return [4, testStorage.remove(testKey)];
              case 6:
                _b.sent();
                return [
                  7
                  /*endfinally*/
                ];
              case 7:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      BrowserStorage2.prototype.get = function(key) {
        return __awaiter2(this, void 0, void 0, function() {
          var value, _a;
          return __generator2(this, function(_b) {
            switch (_b.label) {
              case 0:
                _b.trys.push([0, 2, , 3]);
                return [4, this.getRaw(key)];
              case 1:
                value = _b.sent();
                if (!value) {
                  return [2, void 0];
                }
                return [2, JSON.parse(value)];
              case 2:
                _a = _b.sent();
                console.error("[Amplitude] Error: Could not get value from storage");
                return [2, void 0];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      BrowserStorage2.prototype.getRaw = function(key) {
        return __awaiter2(this, void 0, void 0, function() {
          var _a;
          return __generator2(this, function(_b) {
            return [2, ((_a = this.storage) === null || _a === void 0 ? void 0 : _a.getItem(key)) || void 0];
          });
        });
      };
      BrowserStorage2.prototype.set = function(key, value) {
        return __awaiter2(this, void 0, void 0, function() {
          var _a;
          return __generator2(this, function(_b) {
            try {
              (_a = this.storage) === null || _a === void 0 ? void 0 : _a.setItem(key, JSON.stringify(value));
            } catch (_c) {
            }
            return [
              2
              /*return*/
            ];
          });
        });
      };
      BrowserStorage2.prototype.remove = function(key) {
        return __awaiter2(this, void 0, void 0, function() {
          var _a;
          return __generator2(this, function(_b) {
            try {
              (_a = this.storage) === null || _a === void 0 ? void 0 : _a.removeItem(key);
            } catch (_c) {
            }
            return [
              2
              /*return*/
            ];
          });
        });
      };
      BrowserStorage2.prototype.reset = function() {
        return __awaiter2(this, void 0, void 0, function() {
          var _a;
          return __generator2(this, function(_b) {
            try {
              (_a = this.storage) === null || _a === void 0 ? void 0 : _a.clear();
            } catch (_c) {
            }
            return [
              2
              /*return*/
            ];
          });
        });
      };
      return BrowserStorage2;
    }();
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/storage/local-storage.js
var MAX_ARRAY_LENGTH, LocalStorage;
var init_local_storage = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/storage/local-storage.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    init_browser_storage();
    MAX_ARRAY_LENGTH = 1e3;
    LocalStorage = /** @class */
    function(_super) {
      __extends2(LocalStorage2, _super);
      function LocalStorage2(config2) {
        var _a;
        var _this = _super.call(this, (_a = getGlobalScope()) === null || _a === void 0 ? void 0 : _a.localStorage) || this;
        _this.loggerProvider = config2 === null || config2 === void 0 ? void 0 : config2.loggerProvider;
        return _this;
      }
      LocalStorage2.prototype.set = function(key, value) {
        return __awaiter2(this, void 0, void 0, function() {
          var droppedEventsCount;
          var _a;
          return __generator2(this, function(_b) {
            switch (_b.label) {
              case 0:
                if (!(Array.isArray(value) && value.length > MAX_ARRAY_LENGTH)) return [3, 2];
                droppedEventsCount = value.length - MAX_ARRAY_LENGTH;
                return [4, _super.prototype.set.call(this, key, value.slice(0, MAX_ARRAY_LENGTH))];
              case 1:
                _b.sent();
                (_a = this.loggerProvider) === null || _a === void 0 ? void 0 : _a.error("Failed to save ".concat(droppedEventsCount, " events because the queue length exceeded ").concat(MAX_ARRAY_LENGTH, "."));
                return [3, 4];
              case 2:
                return [4, _super.prototype.set.call(this, key, value)];
              case 3:
                _b.sent();
                _b.label = 4;
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      return LocalStorage2;
    }(BrowserStorage);
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/storage/session-storage.js
var SessionStorage;
var init_session_storage = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/storage/session-storage.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    init_browser_storage();
    SessionStorage = /** @class */
    function(_super) {
      __extends2(SessionStorage2, _super);
      function SessionStorage2() {
        var _a;
        return _super.call(this, (_a = getGlobalScope()) === null || _a === void 0 ? void 0 : _a.sessionStorage) || this;
      }
      return SessionStorage2;
    }(BrowserStorage);
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/transports/xhr.js
var XHRTransport;
var init_xhr = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/transports/xhr.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    XHRTransport = /** @class */
    function(_super) {
      __extends2(XHRTransport2, _super);
      function XHRTransport2() {
        var _this = _super.apply(this, __spreadArray2([], __read3(arguments), false)) || this;
        _this.state = {
          done: 4
        };
        return _this;
      }
      XHRTransport2.prototype.send = function(serverUrl, payload) {
        return __awaiter2(this, void 0, void 0, function() {
          var _this = this;
          return __generator2(this, function(_a) {
            return [2, new Promise(function(resolve, reject) {
              if (typeof XMLHttpRequest === "undefined") {
                reject(new Error("XHRTransport is not supported."));
              }
              var xhr = new XMLHttpRequest();
              xhr.open("POST", serverUrl, true);
              xhr.onreadystatechange = function() {
                if (xhr.readyState === _this.state.done) {
                  var responseText = xhr.responseText;
                  try {
                    resolve(_this.buildResponse(JSON.parse(responseText)));
                  } catch (_a2) {
                    resolve(_this.buildResponse({ code: xhr.status }));
                  }
                }
              };
              xhr.setRequestHeader("Content-Type", "application/json");
              xhr.setRequestHeader("Accept", "*/*");
              xhr.send(JSON.stringify(payload));
            })];
          });
        });
      };
      return XHRTransport2;
    }(BaseTransport);
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/transports/send-beacon.js
var SendBeaconTransport;
var init_send_beacon = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/transports/send-beacon.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    SendBeaconTransport = /** @class */
    function(_super) {
      __extends2(SendBeaconTransport2, _super);
      function SendBeaconTransport2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      SendBeaconTransport2.prototype.send = function(serverUrl, payload) {
        return __awaiter2(this, void 0, void 0, function() {
          var _this = this;
          return __generator2(this, function(_a) {
            return [2, new Promise(function(resolve, reject) {
              var globalScope = getGlobalScope();
              if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator.sendBeacon)) {
                throw new Error("SendBeaconTransport is not supported");
              }
              try {
                var data = JSON.stringify(payload);
                var success = globalScope.navigator.sendBeacon(serverUrl, JSON.stringify(payload));
                if (success) {
                  return resolve(_this.buildResponse({
                    code: 200,
                    events_ingested: payload.events.length,
                    payload_size_bytes: data.length,
                    server_upload_time: Date.now()
                  }));
                }
                return resolve(_this.buildResponse({ code: 500 }));
              } catch (e) {
                reject(e);
              }
            })];
          });
        });
      };
      return SendBeaconTransport2;
    }(BaseTransport);
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/cookie-migration/index.js
var parseLegacyCookies, parseTime, decode2;
var init_cookie_migration = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/cookie-migration/index.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    parseLegacyCookies = function(apiKey_1, cookieStorage_1) {
      var args_1 = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
      }
      return __awaiter2(void 0, __spreadArray2([apiKey_1, cookieStorage_1], __read3(args_1), false), void 0, function(apiKey, cookieStorage, deleteLegacyCookies) {
        var cookieName, cookies, _a, deviceId, userId, optOut, sessionId, lastEventTime, lastEventId;
        if (deleteLegacyCookies === void 0) {
          deleteLegacyCookies = true;
        }
        return __generator2(this, function(_b) {
          switch (_b.label) {
            case 0:
              cookieName = getOldCookieName(apiKey);
              return [4, cookieStorage.getRaw(cookieName)];
            case 1:
              cookies = _b.sent();
              if (!cookies) {
                return [2, {
                  optOut: false
                }];
              }
              if (!deleteLegacyCookies) return [3, 3];
              return [4, cookieStorage.remove(cookieName)];
            case 2:
              _b.sent();
              _b.label = 3;
            case 3:
              _a = __read3(cookies.split("."), 6), deviceId = _a[0], userId = _a[1], optOut = _a[2], sessionId = _a[3], lastEventTime = _a[4], lastEventId = _a[5];
              return [2, {
                deviceId,
                userId: decode2(userId),
                sessionId: parseTime(sessionId),
                lastEventId: parseTime(lastEventId),
                lastEventTime: parseTime(lastEventTime),
                optOut: Boolean(optOut)
              }];
          }
        });
      });
    };
    parseTime = function(num) {
      var integer = parseInt(num, 32);
      if (isNaN(integer)) {
        return void 0;
      }
      return integer;
    };
    decode2 = function(value) {
      if (!atob || !escape || !value) {
        return void 0;
      }
      try {
        return decodeURIComponent(escape(atob(value)));
      } catch (_a) {
        return void 0;
      }
    };
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/constants.js
var DEFAULT_EVENT_PREFIX, DEFAULT_PAGE_VIEW_EVENT, DEFAULT_FORM_START_EVENT, DEFAULT_FORM_SUBMIT_EVENT, DEFAULT_FILE_DOWNLOAD_EVENT, DEFAULT_SESSION_START_EVENT, DEFAULT_SESSION_END_EVENT, FILE_EXTENSION, FILE_NAME, LINK_ID, LINK_TEXT, LINK_URL, FORM_ID, FORM_NAME, FORM_DESTINATION, DEFAULT_IDENTITY_STORAGE, DEFAULT_SERVER_ZONE;
var init_constants2 = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/constants.js"() {
    "use strict";
    DEFAULT_EVENT_PREFIX = "[Amplitude]";
    DEFAULT_PAGE_VIEW_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Page Viewed");
    DEFAULT_FORM_START_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Started");
    DEFAULT_FORM_SUBMIT_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Submitted");
    DEFAULT_FILE_DOWNLOAD_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " File Downloaded");
    DEFAULT_SESSION_START_EVENT = "session_start";
    DEFAULT_SESSION_END_EVENT = "session_end";
    FILE_EXTENSION = "".concat(DEFAULT_EVENT_PREFIX, " File Extension");
    FILE_NAME = "".concat(DEFAULT_EVENT_PREFIX, " File Name");
    LINK_ID = "".concat(DEFAULT_EVENT_PREFIX, " Link ID");
    LINK_TEXT = "".concat(DEFAULT_EVENT_PREFIX, " Link Text");
    LINK_URL = "".concat(DEFAULT_EVENT_PREFIX, " Link URL");
    FORM_ID = "".concat(DEFAULT_EVENT_PREFIX, " Form ID");
    FORM_NAME = "".concat(DEFAULT_EVENT_PREFIX, " Form Name");
    FORM_DESTINATION = "".concat(DEFAULT_EVENT_PREFIX, " Form Destination");
    DEFAULT_IDENTITY_STORAGE = "cookie";
    DEFAULT_SERVER_ZONE = "US";
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/config.js
var BrowserConfig, useBrowserConfig, createCookieStorage, createTransport, getTopLevelDomain;
var init_config2 = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/config.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    init_local_storage();
    init_session_storage();
    init_xhr();
    init_send_beacon();
    init_cookie_migration();
    init_constants2();
    BrowserConfig = /** @class */
    function(_super) {
      __extends2(BrowserConfig2, _super);
      function BrowserConfig2(apiKey, appVersion, cookieStorage, cookieOptions, defaultTracking, autocapture, deviceId, flushIntervalMillis, flushMaxRetries, flushQueueSize, identityStorage, ingestionMetadata, instanceName, lastEventId, lastEventTime, loggerProvider, logLevel, minIdLength, offline, optOut, partnerId, plan, serverUrl, serverZone, sessionId, sessionTimeout, storageProvider, trackingOptions, transport, useBatch, fetchRemoteConfig, userId, pageCounter, debugLogsEnabled) {
        if (cookieStorage === void 0) {
          cookieStorage = new MemoryStorage();
        }
        if (cookieOptions === void 0) {
          cookieOptions = {
            domain: "",
            expiration: 365,
            sameSite: "Lax",
            secure: false,
            upgrade: true
          };
        }
        if (flushIntervalMillis === void 0) {
          flushIntervalMillis = 1e3;
        }
        if (flushMaxRetries === void 0) {
          flushMaxRetries = 5;
        }
        if (flushQueueSize === void 0) {
          flushQueueSize = 30;
        }
        if (identityStorage === void 0) {
          identityStorage = DEFAULT_IDENTITY_STORAGE;
        }
        if (loggerProvider === void 0) {
          loggerProvider = new Logger();
        }
        if (logLevel === void 0) {
          logLevel = LogLevel.Warn;
        }
        if (offline === void 0) {
          offline = false;
        }
        if (optOut === void 0) {
          optOut = false;
        }
        if (serverUrl === void 0) {
          serverUrl = "";
        }
        if (serverZone === void 0) {
          serverZone = DEFAULT_SERVER_ZONE;
        }
        if (sessionTimeout === void 0) {
          sessionTimeout = 30 * 60 * 1e3;
        }
        if (storageProvider === void 0) {
          storageProvider = new LocalStorage({ loggerProvider });
        }
        if (trackingOptions === void 0) {
          trackingOptions = {
            ipAddress: true,
            language: true,
            platform: true
          };
        }
        if (transport === void 0) {
          transport = "fetch";
        }
        if (useBatch === void 0) {
          useBatch = false;
        }
        if (fetchRemoteConfig === void 0) {
          fetchRemoteConfig = false;
        }
        var _this = _super.call(this, { apiKey, storageProvider, transportProvider: createTransport(transport) }) || this;
        _this.apiKey = apiKey;
        _this.appVersion = appVersion;
        _this.cookieOptions = cookieOptions;
        _this.defaultTracking = defaultTracking;
        _this.autocapture = autocapture;
        _this.flushIntervalMillis = flushIntervalMillis;
        _this.flushMaxRetries = flushMaxRetries;
        _this.flushQueueSize = flushQueueSize;
        _this.identityStorage = identityStorage;
        _this.ingestionMetadata = ingestionMetadata;
        _this.instanceName = instanceName;
        _this.loggerProvider = loggerProvider;
        _this.logLevel = logLevel;
        _this.minIdLength = minIdLength;
        _this.offline = offline;
        _this.partnerId = partnerId;
        _this.plan = plan;
        _this.serverUrl = serverUrl;
        _this.serverZone = serverZone;
        _this.sessionTimeout = sessionTimeout;
        _this.storageProvider = storageProvider;
        _this.trackingOptions = trackingOptions;
        _this.transport = transport;
        _this.useBatch = useBatch;
        _this.fetchRemoteConfig = fetchRemoteConfig;
        _this._optOut = false;
        _this._cookieStorage = cookieStorage;
        _this.deviceId = deviceId;
        _this.lastEventId = lastEventId;
        _this.lastEventTime = lastEventTime;
        _this.optOut = optOut;
        _this.sessionId = sessionId;
        _this.pageCounter = pageCounter;
        _this.userId = userId;
        _this.debugLogsEnabled = debugLogsEnabled;
        _this.loggerProvider.enable(debugLogsEnabled ? LogLevel.Debug : _this.logLevel);
        return _this;
      }
      Object.defineProperty(BrowserConfig2.prototype, "cookieStorage", {
        get: function() {
          return this._cookieStorage;
        },
        set: function(cookieStorage) {
          if (this._cookieStorage !== cookieStorage) {
            this._cookieStorage = cookieStorage;
            this.updateStorage();
          }
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(BrowserConfig2.prototype, "deviceId", {
        get: function() {
          return this._deviceId;
        },
        set: function(deviceId) {
          if (this._deviceId !== deviceId) {
            this._deviceId = deviceId;
            this.updateStorage();
          }
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(BrowserConfig2.prototype, "userId", {
        get: function() {
          return this._userId;
        },
        set: function(userId) {
          if (this._userId !== userId) {
            this._userId = userId;
            this.updateStorage();
          }
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(BrowserConfig2.prototype, "sessionId", {
        get: function() {
          return this._sessionId;
        },
        set: function(sessionId) {
          if (this._sessionId !== sessionId) {
            this._sessionId = sessionId;
            this.updateStorage();
          }
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(BrowserConfig2.prototype, "optOut", {
        get: function() {
          return this._optOut;
        },
        set: function(optOut) {
          if (this._optOut !== optOut) {
            this._optOut = optOut;
            this.updateStorage();
          }
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(BrowserConfig2.prototype, "lastEventTime", {
        get: function() {
          return this._lastEventTime;
        },
        set: function(lastEventTime) {
          if (this._lastEventTime !== lastEventTime) {
            this._lastEventTime = lastEventTime;
            this.updateStorage();
          }
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(BrowserConfig2.prototype, "lastEventId", {
        get: function() {
          return this._lastEventId;
        },
        set: function(lastEventId) {
          if (this._lastEventId !== lastEventId) {
            this._lastEventId = lastEventId;
            this.updateStorage();
          }
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(BrowserConfig2.prototype, "pageCounter", {
        get: function() {
          return this._pageCounter;
        },
        set: function(pageCounter) {
          if (this._pageCounter !== pageCounter) {
            this._pageCounter = pageCounter;
            this.updateStorage();
          }
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(BrowserConfig2.prototype, "debugLogsEnabled", {
        set: function(debugLogsEnabled) {
          if (this._debugLogsEnabled !== debugLogsEnabled) {
            this._debugLogsEnabled = debugLogsEnabled;
            this.updateStorage();
          }
        },
        enumerable: false,
        configurable: true
      });
      BrowserConfig2.prototype.updateStorage = function() {
        var cache = {
          deviceId: this._deviceId,
          userId: this._userId,
          sessionId: this._sessionId,
          optOut: this._optOut,
          lastEventTime: this._lastEventTime,
          lastEventId: this._lastEventId,
          pageCounter: this._pageCounter,
          debugLogsEnabled: this._debugLogsEnabled
        };
        void this.cookieStorage.set(getCookieName(this.apiKey), cache);
      };
      return BrowserConfig2;
    }(Config);
    useBrowserConfig = function(apiKey_1) {
      var args_1 = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
      }
      return __awaiter2(void 0, __spreadArray2([apiKey_1], __read3(args_1), false), void 0, function(apiKey, options, amplitudeInstance) {
        var identityStorage, cookieOptions, _a, _b, cookieStorage, legacyCookies, previousCookies, queryParams, deviceId, lastEventId, lastEventTime, optOut, sessionId, userId, trackingOptions, pageCounter, debugLogsEnabled, browserConfig;
        var _c;
        var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
        if (options === void 0) {
          options = {};
        }
        return __generator2(this, function(_3) {
          switch (_3.label) {
            case 0:
              identityStorage = options.identityStorage || DEFAULT_IDENTITY_STORAGE;
              _c = {};
              if (!(identityStorage !== DEFAULT_IDENTITY_STORAGE)) return [3, 1];
              _a = "";
              return [3, 5];
            case 1:
              if (!((_e = (_d = options.cookieOptions) === null || _d === void 0 ? void 0 : _d.domain) !== null && _e !== void 0)) return [3, 2];
              _b = _e;
              return [3, 4];
            case 2:
              return [4, getTopLevelDomain()];
            case 3:
              _b = _3.sent();
              _3.label = 4;
            case 4:
              _a = _b;
              _3.label = 5;
            case 5:
              cookieOptions = __assign3.apply(void 0, [(_c.domain = _a, _c.expiration = 365, _c.sameSite = "Lax", _c.secure = false, _c.upgrade = true, _c), options.cookieOptions]);
              cookieStorage = createCookieStorage(options.identityStorage, cookieOptions);
              return [4, parseLegacyCookies(apiKey, cookieStorage, (_g = (_f = options.cookieOptions) === null || _f === void 0 ? void 0 : _f.upgrade) !== null && _g !== void 0 ? _g : true)];
            case 6:
              legacyCookies = _3.sent();
              return [4, cookieStorage.get(getCookieName(apiKey))];
            case 7:
              previousCookies = _3.sent();
              queryParams = getQueryParams();
              deviceId = (_m = (_l = (_k = (_j = (_h = options.deviceId) !== null && _h !== void 0 ? _h : queryParams.ampDeviceId) !== null && _j !== void 0 ? _j : queryParams.deviceId) !== null && _k !== void 0 ? _k : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _l !== void 0 ? _l : legacyCookies.deviceId) !== null && _m !== void 0 ? _m : UUID();
              lastEventId = (_o = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventId) !== null && _o !== void 0 ? _o : legacyCookies.lastEventId;
              lastEventTime = (_p = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventTime) !== null && _p !== void 0 ? _p : legacyCookies.lastEventTime;
              optOut = (_r = (_q = options.optOut) !== null && _q !== void 0 ? _q : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.optOut) !== null && _r !== void 0 ? _r : legacyCookies.optOut;
              sessionId = (_s = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.sessionId) !== null && _s !== void 0 ? _s : legacyCookies.sessionId;
              userId = (_u = (_t = options.userId) !== null && _t !== void 0 ? _t : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _u !== void 0 ? _u : legacyCookies.userId;
              amplitudeInstance.previousSessionDeviceId = (_v = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _v !== void 0 ? _v : legacyCookies.deviceId;
              amplitudeInstance.previousSessionUserId = (_w = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _w !== void 0 ? _w : legacyCookies.userId;
              trackingOptions = {
                ipAddress: (_y = (_x = options.trackingOptions) === null || _x === void 0 ? void 0 : _x.ipAddress) !== null && _y !== void 0 ? _y : true,
                language: (_0 = (_z = options.trackingOptions) === null || _z === void 0 ? void 0 : _z.language) !== null && _0 !== void 0 ? _0 : true,
                platform: (_2 = (_1 = options.trackingOptions) === null || _1 === void 0 ? void 0 : _1.platform) !== null && _2 !== void 0 ? _2 : true
              };
              pageCounter = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.pageCounter;
              debugLogsEnabled = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.debugLogsEnabled;
              if (options.autocapture !== void 0) {
                options.defaultTracking = options.autocapture;
              }
              browserConfig = new BrowserConfig(apiKey, options.appVersion, cookieStorage, cookieOptions, options.defaultTracking, options.autocapture, deviceId, options.flushIntervalMillis, options.flushMaxRetries, options.flushQueueSize, identityStorage, options.ingestionMetadata, options.instanceName, lastEventId, lastEventTime, options.loggerProvider, options.logLevel, options.minIdLength, options.offline, optOut, options.partnerId, options.plan, options.serverUrl, options.serverZone, sessionId, options.sessionTimeout, options.storageProvider, trackingOptions, options.transport, options.useBatch, options.fetchRemoteConfig, userId, pageCounter, debugLogsEnabled);
              return [4, browserConfig.storageProvider.isEnabled()];
            case 8:
              if (!_3.sent()) {
                browserConfig.loggerProvider.warn("Storage provider ".concat(browserConfig.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage."));
                browserConfig.storageProvider = new MemoryStorage();
              }
              return [2, browserConfig];
          }
        });
      });
    };
    createCookieStorage = function(identityStorage, cookieOptions) {
      if (identityStorage === void 0) {
        identityStorage = DEFAULT_IDENTITY_STORAGE;
      }
      if (cookieOptions === void 0) {
        cookieOptions = {};
      }
      switch (identityStorage) {
        case "localStorage":
          return new LocalStorage();
        case "sessionStorage":
          return new SessionStorage();
        case "none":
          return new MemoryStorage();
        case "cookie":
        default:
          return new CookieStorage(__assign3(__assign3({}, cookieOptions), { expirationDays: cookieOptions.expiration }));
      }
    };
    createTransport = function(transport) {
      if (transport === "xhr") {
        return new XHRTransport();
      }
      if (transport === "beacon") {
        return new SendBeaconTransport();
      }
      return new FetchTransport();
    };
    getTopLevelDomain = function(url) {
      return __awaiter2(void 0, void 0, void 0, function() {
        var host, parts, levels, storageKey, i, i, domain, options, storage, value;
        return __generator2(this, function(_a) {
          switch (_a.label) {
            case 0:
              return [4, new CookieStorage().isEnabled()];
            case 1:
              if (!_a.sent() || !url && (typeof location === "undefined" || !location.hostname)) {
                return [2, ""];
              }
              host = url !== null && url !== void 0 ? url : location.hostname;
              parts = host.split(".");
              levels = [];
              storageKey = "AMP_TLDTEST";
              for (i = parts.length - 2; i >= 0; --i) {
                levels.push(parts.slice(i).join("."));
              }
              i = 0;
              _a.label = 2;
            case 2:
              if (!(i < levels.length)) return [3, 7];
              domain = levels[i];
              options = { domain: "." + domain };
              storage = new CookieStorage(options);
              return [4, storage.set(storageKey, 1)];
            case 3:
              _a.sent();
              return [4, storage.get(storageKey)];
            case 4:
              value = _a.sent();
              if (!value) return [3, 6];
              return [4, storage.remove(storageKey)];
            case 5:
              _a.sent();
              return [2, "." + domain];
            case 6:
              i++;
              return [3, 2];
            case 7:
              return [2, ""];
          }
        });
      });
    };
  }
});

// node_modules/@amplitude/plugin-page-view-tracking-browser/node_modules/tslib/tslib.es6.mjs
function __awaiter3(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator3(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return { value: op[1], done: false };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read4(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray3(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var __assign4;
var init_tslib_es63 = __esm({
  "node_modules/@amplitude/plugin-page-view-tracking-browser/node_modules/tslib/tslib.es6.mjs"() {
    "use strict";
    __assign4 = function() {
      __assign4 = Object.assign || function __assign8(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign4.apply(this, arguments);
    };
  }
});

// node_modules/@amplitude/analytics-client-common/node_modules/tslib/tslib.es6.mjs
function __awaiter4(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator4(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return { value: op[1], done: false };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
var __assign5;
var init_tslib_es64 = __esm({
  "node_modules/@amplitude/analytics-client-common/node_modules/tslib/tslib.es6.mjs"() {
    "use strict";
    __assign5 = function() {
      __assign5 = Object.assign || function __assign8(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign5.apply(this, arguments);
    };
  }
});

// node_modules/@amplitude/analytics-client-common/lib/esm/global-scope.js
var getGlobalScope2;
var init_global_scope2 = __esm({
  "node_modules/@amplitude/analytics-client-common/lib/esm/global-scope.js"() {
    "use strict";
    getGlobalScope2 = function() {
      var ampIntegrationContextName = "ampIntegrationContext";
      if (typeof globalThis !== "undefined" && typeof globalThis[ampIntegrationContextName] !== "undefined") {
        return globalThis[ampIntegrationContextName];
      }
      if (typeof globalThis !== "undefined") {
        return globalThis;
      }
      if (typeof window !== "undefined") {
        return window;
      }
      if (typeof self !== "undefined") {
        return self;
      }
      if (typeof global !== "undefined") {
        return global;
      }
      return void 0;
    };
  }
});

// node_modules/@amplitude/analytics-client-common/lib/esm/query-params.js
var getQueryParams2, tryDecodeURIComponent2;
var init_query_params2 = __esm({
  "node_modules/@amplitude/analytics-client-common/lib/esm/query-params.js"() {
    "use strict";
    init_global_scope2();
    getQueryParams2 = function() {
      var _a;
      var globalScope = getGlobalScope2();
      if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _a === void 0 ? void 0 : _a.search)) {
        return {};
      }
      var pairs = globalScope.location.search.substring(1).split("&").filter(Boolean);
      var params = pairs.reduce(function(acc, curr) {
        var query = curr.split("=", 2);
        var key = tryDecodeURIComponent2(query[0]);
        var value = tryDecodeURIComponent2(query[1]);
        if (!value) {
          return acc;
        }
        acc[key] = value;
        return acc;
      }, {});
      return params;
    };
    tryDecodeURIComponent2 = function(value) {
      if (value === void 0) {
        value = "";
      }
      try {
        return decodeURIComponent(value);
      } catch (_a) {
        return "";
      }
    };
  }
});

// node_modules/@amplitude/analytics-client-common/lib/esm/attribution/constants.js
var UTM_CAMPAIGN, UTM_CONTENT, UTM_ID, UTM_MEDIUM, UTM_SOURCE, UTM_TERM, DCLID, FBCLID, GBRAID, GCLID, KO_CLICK_ID, LI_FAT_ID, MSCLKID, RDT_CID, TTCLID, TWCLID, WBRAID, BASE_CAMPAIGN;
var init_constants3 = __esm({
  "node_modules/@amplitude/analytics-client-common/lib/esm/attribution/constants.js"() {
    "use strict";
    UTM_CAMPAIGN = "utm_campaign";
    UTM_CONTENT = "utm_content";
    UTM_ID = "utm_id";
    UTM_MEDIUM = "utm_medium";
    UTM_SOURCE = "utm_source";
    UTM_TERM = "utm_term";
    DCLID = "dclid";
    FBCLID = "fbclid";
    GBRAID = "gbraid";
    GCLID = "gclid";
    KO_CLICK_ID = "ko_click_id";
    LI_FAT_ID = "li_fat_id";
    MSCLKID = "msclkid";
    RDT_CID = "rtd_cid";
    TTCLID = "ttclid";
    TWCLID = "twclid";
    WBRAID = "wbraid";
    BASE_CAMPAIGN = {
      utm_campaign: void 0,
      utm_content: void 0,
      utm_id: void 0,
      utm_medium: void 0,
      utm_source: void 0,
      utm_term: void 0,
      referrer: void 0,
      referring_domain: void 0,
      dclid: void 0,
      gbraid: void 0,
      gclid: void 0,
      fbclid: void 0,
      ko_click_id: void 0,
      li_fat_id: void 0,
      msclkid: void 0,
      rtd_cid: void 0,
      ttclid: void 0,
      twclid: void 0,
      wbraid: void 0
    };
  }
});

// node_modules/@amplitude/analytics-client-common/lib/esm/attribution/campaign-parser.js
var CampaignParser;
var init_campaign_parser = __esm({
  "node_modules/@amplitude/analytics-client-common/lib/esm/attribution/campaign-parser.js"() {
    "use strict";
    init_tslib_es64();
    init_query_params2();
    init_constants3();
    CampaignParser = /** @class */
    function() {
      function CampaignParser3() {
      }
      CampaignParser3.prototype.parse = function() {
        return __awaiter4(this, void 0, void 0, function() {
          return __generator4(this, function(_a) {
            return [2, __assign5(__assign5(__assign5(__assign5({}, BASE_CAMPAIGN), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
          });
        });
      };
      CampaignParser3.prototype.getUtmParam = function() {
        var params = getQueryParams2();
        var utmCampaign = params[UTM_CAMPAIGN];
        var utmContent = params[UTM_CONTENT];
        var utmId = params[UTM_ID];
        var utmMedium = params[UTM_MEDIUM];
        var utmSource = params[UTM_SOURCE];
        var utmTerm = params[UTM_TERM];
        return {
          utm_campaign: utmCampaign,
          utm_content: utmContent,
          utm_id: utmId,
          utm_medium: utmMedium,
          utm_source: utmSource,
          utm_term: utmTerm
        };
      };
      CampaignParser3.prototype.getReferrer = function() {
        var _a, _b;
        var data = {
          referrer: void 0,
          referring_domain: void 0
        };
        try {
          data.referrer = document.referrer || void 0;
          data.referring_domain = (_b = (_a = data.referrer) === null || _a === void 0 ? void 0 : _a.split("/")[2]) !== null && _b !== void 0 ? _b : void 0;
        } catch (_c) {
        }
        return data;
      };
      CampaignParser3.prototype.getClickIds = function() {
        var _a;
        var params = getQueryParams2();
        return _a = {}, _a[DCLID] = params[DCLID], _a[FBCLID] = params[FBCLID], _a[GBRAID] = params[GBRAID], _a[GCLID] = params[GCLID], _a[KO_CLICK_ID] = params[KO_CLICK_ID], _a[LI_FAT_ID] = params[LI_FAT_ID], _a[MSCLKID] = params[MSCLKID], _a[RDT_CID] = params[RDT_CID], _a[TTCLID] = params[TTCLID], _a[TWCLID] = params[TWCLID], _a[WBRAID] = params[WBRAID], _a;
      };
      return CampaignParser3;
    }();
  }
});

// node_modules/@amplitude/analytics-client-common/lib/esm/index.js
var init_esm2 = __esm({
  "node_modules/@amplitude/analytics-client-common/lib/esm/index.js"() {
    "use strict";
    init_campaign_parser();
    init_constants3();
    init_global_scope2();
  }
});

// node_modules/@amplitude/analytics-types/lib/esm/event.js
var IdentifyOperation3, RevenueProperty2, SpecialEventType2;
var init_event2 = __esm({
  "node_modules/@amplitude/analytics-types/lib/esm/event.js"() {
    "use strict";
    (function(IdentifyOperation4) {
      IdentifyOperation4["SET"] = "$set";
      IdentifyOperation4["SET_ONCE"] = "$setOnce";
      IdentifyOperation4["ADD"] = "$add";
      IdentifyOperation4["APPEND"] = "$append";
      IdentifyOperation4["PREPEND"] = "$prepend";
      IdentifyOperation4["REMOVE"] = "$remove";
      IdentifyOperation4["PREINSERT"] = "$preInsert";
      IdentifyOperation4["POSTINSERT"] = "$postInsert";
      IdentifyOperation4["UNSET"] = "$unset";
      IdentifyOperation4["CLEAR_ALL"] = "$clearAll";
    })(IdentifyOperation3 || (IdentifyOperation3 = {}));
    (function(RevenueProperty3) {
      RevenueProperty3["REVENUE_PRODUCT_ID"] = "$productId";
      RevenueProperty3["REVENUE_QUANTITY"] = "$quantity";
      RevenueProperty3["REVENUE_PRICE"] = "$price";
      RevenueProperty3["REVENUE_TYPE"] = "$revenueType";
      RevenueProperty3["REVENUE_CURRENCY"] = "$currency";
      RevenueProperty3["REVENUE"] = "$revenue";
    })(RevenueProperty2 || (RevenueProperty2 = {}));
    (function(SpecialEventType3) {
      SpecialEventType3["IDENTIFY"] = "$identify";
      SpecialEventType3["GROUP_IDENTIFY"] = "$groupidentify";
      SpecialEventType3["REVENUE"] = "revenue_amount";
    })(SpecialEventType2 || (SpecialEventType2 = {}));
  }
});

// node_modules/@amplitude/analytics-types/lib/esm/logger.js
var LogLevel2;
var init_logger2 = __esm({
  "node_modules/@amplitude/analytics-types/lib/esm/logger.js"() {
    "use strict";
    (function(LogLevel3) {
      LogLevel3[LogLevel3["None"] = 0] = "None";
      LogLevel3[LogLevel3["Error"] = 1] = "Error";
      LogLevel3[LogLevel3["Warn"] = 2] = "Warn";
      LogLevel3[LogLevel3["Verbose"] = 3] = "Verbose";
      LogLevel3[LogLevel3["Debug"] = 4] = "Debug";
    })(LogLevel2 || (LogLevel2 = {}));
  }
});

// node_modules/@amplitude/analytics-types/lib/esm/server-zone.js
var ServerZone;
var init_server_zone = __esm({
  "node_modules/@amplitude/analytics-types/lib/esm/server-zone.js"() {
    "use strict";
    (function(ServerZone2) {
      ServerZone2["US"] = "US";
      ServerZone2["EU"] = "EU";
    })(ServerZone || (ServerZone = {}));
  }
});

// node_modules/@amplitude/analytics-types/lib/esm/status.js
var Status2;
var init_status2 = __esm({
  "node_modules/@amplitude/analytics-types/lib/esm/status.js"() {
    "use strict";
    (function(Status3) {
      Status3["Unknown"] = "unknown";
      Status3["Skipped"] = "skipped";
      Status3["Success"] = "success";
      Status3["RateLimit"] = "rate_limit";
      Status3["PayloadTooLarge"] = "payload_too_large";
      Status3["Invalid"] = "invalid";
      Status3["Failed"] = "failed";
      Status3["Timeout"] = "Timeout";
      Status3["SystemError"] = "SystemError";
    })(Status2 || (Status2 = {}));
  }
});

// node_modules/@amplitude/analytics-types/lib/esm/offline.js
var OfflineDisabled2;
var init_offline2 = __esm({
  "node_modules/@amplitude/analytics-types/lib/esm/offline.js"() {
    "use strict";
    OfflineDisabled2 = null;
  }
});

// node_modules/@amplitude/analytics-types/lib/esm/element-interactions.js
var DEFAULT_CSS_SELECTOR_ALLOWLIST2, DEFAULT_DATA_ATTRIBUTE_PREFIX2, DEFAULT_ACTION_CLICK_ALLOWLIST2;
var init_element_interactions2 = __esm({
  "node_modules/@amplitude/analytics-types/lib/esm/element-interactions.js"() {
    "use strict";
    DEFAULT_CSS_SELECTOR_ALLOWLIST2 = [
      "a",
      "button",
      "input",
      "select",
      "textarea",
      "label",
      "video",
      "audio",
      '[contenteditable="true" i]',
      "[data-amp-default-track]",
      ".amp-default-track"
    ];
    DEFAULT_DATA_ATTRIBUTE_PREFIX2 = "data-amp-track-";
    DEFAULT_ACTION_CLICK_ALLOWLIST2 = ["div", "span", "h1", "h2", "h3", "h4", "h5", "h6"];
  }
});

// node_modules/@amplitude/analytics-types/lib/esm/index.js
var esm_exports = {};
__export(esm_exports, {
  DEFAULT_ACTION_CLICK_ALLOWLIST: () => DEFAULT_ACTION_CLICK_ALLOWLIST2,
  DEFAULT_CSS_SELECTOR_ALLOWLIST: () => DEFAULT_CSS_SELECTOR_ALLOWLIST2,
  DEFAULT_DATA_ATTRIBUTE_PREFIX: () => DEFAULT_DATA_ATTRIBUTE_PREFIX2,
  IdentifyOperation: () => IdentifyOperation3,
  LogLevel: () => LogLevel2,
  OfflineDisabled: () => OfflineDisabled2,
  RevenueProperty: () => RevenueProperty2,
  ServerZone: () => ServerZone,
  SpecialEventType: () => SpecialEventType2,
  Status: () => Status2
});
var init_esm3 = __esm({
  "node_modules/@amplitude/analytics-types/lib/esm/index.js"() {
    "use strict";
    init_event2();
    init_logger2();
    init_server_zone();
    init_status2();
    init_offline2();
    init_element_interactions2();
  }
});

// node_modules/@amplitude/plugin-page-view-tracking-browser/lib/esm/utils.js
var omitUndefined;
var init_utils = __esm({
  "node_modules/@amplitude/plugin-page-view-tracking-browser/lib/esm/utils.js"() {
    "use strict";
    omitUndefined = function(input) {
      var obj = {};
      for (var key in input) {
        var val = input[key];
        if (val) {
          obj[key] = val;
        }
      }
      return obj;
    };
  }
});

// node_modules/@amplitude/plugin-page-view-tracking-browser/lib/esm/page-view-tracking.js
var defaultPageViewEvent, pageViewTrackingPlugin, getCampaignParams, isCampaignEvent, shouldTrackHistoryPageView;
var init_page_view_tracking = __esm({
  "node_modules/@amplitude/plugin-page-view-tracking-browser/lib/esm/page-view-tracking.js"() {
    "use strict";
    init_tslib_es63();
    init_esm2();
    init_esm3();
    init_esm2();
    init_utils();
    defaultPageViewEvent = "[Amplitude] Page Viewed";
    pageViewTrackingPlugin = function(options) {
      if (options === void 0) {
        options = {};
      }
      var amplitude;
      var globalScope = getGlobalScope2();
      var loggerProvider = void 0;
      var pushState;
      var localConfig;
      var trackOn = options.trackOn, trackHistoryChanges = options.trackHistoryChanges, _a = options.eventType, eventType = _a === void 0 ? defaultPageViewEvent : _a;
      var getDecodeURI = function(locationStr) {
        var decodedLocationStr = locationStr;
        try {
          decodedLocationStr = decodeURI(locationStr);
        } catch (e) {
          loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.error("Malformed URI sequence: ", e);
        }
        return decodedLocationStr;
      };
      var createPageViewEvent = function() {
        return __awaiter3(void 0, void 0, void 0, function() {
          var locationHREF, _a2;
          var _b;
          return __generator3(this, function(_c) {
            switch (_c.label) {
              case 0:
                locationHREF = getDecodeURI(typeof location !== "undefined" && location.href || "");
                _b = {
                  event_type: eventType
                };
                _a2 = [{}];
                return [4, getCampaignParams()];
              case 1:
                return [2, (_b.event_properties = __assign4.apply(void 0, [__assign4.apply(void 0, _a2.concat([_c.sent()])), { "[Amplitude] Page Domain": (
                  /* istanbul ignore next */
                  typeof location !== "undefined" && location.hostname || ""
                ), "[Amplitude] Page Location": locationHREF, "[Amplitude] Page Path": (
                  /* istanbul ignore next */
                  typeof location !== "undefined" && getDecodeURI(location.pathname) || ""
                ), "[Amplitude] Page Title": (
                  /* istanbul ignore next */
                  typeof document !== "undefined" && document.title || ""
                ), "[Amplitude] Page URL": locationHREF.split("?")[0] }]), _b)];
            }
          });
        });
      };
      var shouldTrackOnPageLoad = function() {
        return typeof trackOn === "undefined" || typeof trackOn === "function" && trackOn();
      };
      var previousURL = typeof location !== "undefined" ? location.href : null;
      var trackHistoryPageView = function() {
        return __awaiter3(void 0, void 0, void 0, function() {
          var newURL, shouldTrackPageView, _a2, _b, _c;
          return __generator3(this, function(_d) {
            switch (_d.label) {
              case 0:
                newURL = location.href;
                shouldTrackPageView = shouldTrackHistoryPageView(trackHistoryChanges, newURL, previousURL || "") && shouldTrackOnPageLoad();
                previousURL = newURL;
                if (!shouldTrackPageView) return [3, 4];
                loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.log("Tracking page view event");
                if (!(amplitude === null || amplitude === void 0)) return [3, 1];
                _a2 = void 0;
                return [3, 3];
              case 1:
                _c = (_b = amplitude).track;
                return [4, createPageViewEvent()];
              case 2:
                _a2 = _c.apply(_b, [_d.sent()]);
                _d.label = 3;
              case 3:
                _a2;
                _d.label = 4;
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      var trackHistoryPageViewWrapper = function() {
        void trackHistoryPageView();
      };
      var plugin = {
        name: "@amplitude/plugin-page-view-tracking-browser",
        type: "enrichment",
        setup: function(config2, client2) {
          return __awaiter3(void 0, void 0, void 0, function() {
            var _a2, _b;
            return __generator3(this, function(_c) {
              switch (_c.label) {
                case 0:
                  amplitude = client2;
                  localConfig = config2;
                  loggerProvider = config2.loggerProvider;
                  loggerProvider.log("Installing @amplitude/plugin-page-view-tracking-browser");
                  if (globalScope) {
                    globalScope.addEventListener("popstate", trackHistoryPageViewWrapper);
                    pushState = globalScope.history.pushState;
                    globalScope.history.pushState = new Proxy(globalScope.history.pushState, {
                      apply: function(target, thisArg, _a3) {
                        var _b2 = __read4(_a3, 3), state = _b2[0], unused = _b2[1], url = _b2[2];
                        target.apply(thisArg, [state, unused, url]);
                        void trackHistoryPageView();
                      }
                    });
                  }
                  if (!shouldTrackOnPageLoad()) return [3, 2];
                  loggerProvider.log("Tracking page view event");
                  _b = (_a2 = amplitude).track;
                  return [4, createPageViewEvent()];
                case 1:
                  _b.apply(_a2, [_c.sent()]);
                  _c.label = 2;
                case 2:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        },
        execute: function(event) {
          return __awaiter3(void 0, void 0, void 0, function() {
            var pageViewEvent;
            return __generator3(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  if (!(trackOn === "attribution" && isCampaignEvent(event))) return [3, 2];
                  loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.log("Enriching campaign event to page view event with campaign parameters");
                  return [4, createPageViewEvent()];
                case 1:
                  pageViewEvent = _a2.sent();
                  event.event_type = pageViewEvent.event_type;
                  event.event_properties = __assign4(__assign4({}, event.event_properties), pageViewEvent.event_properties);
                  _a2.label = 2;
                case 2:
                  if (localConfig && event.event_type === eventType) {
                    localConfig.pageCounter = !localConfig.pageCounter ? 1 : localConfig.pageCounter + 1;
                    event.event_properties = __assign4(__assign4({}, event.event_properties), { "[Amplitude] Page Counter": localConfig.pageCounter });
                  }
                  return [2, event];
              }
            });
          });
        },
        teardown: function() {
          return __awaiter3(void 0, void 0, void 0, function() {
            return __generator3(this, function(_a2) {
              if (globalScope) {
                globalScope.removeEventListener("popstate", trackHistoryPageViewWrapper);
                if (pushState) {
                  globalScope.history.pushState = pushState;
                }
              }
              return [
                2
                /*return*/
              ];
            });
          });
        }
      };
      return plugin;
    };
    getCampaignParams = function() {
      return __awaiter3(void 0, void 0, void 0, function() {
        var _a;
        return __generator3(this, function(_b) {
          switch (_b.label) {
            case 0:
              _a = omitUndefined;
              return [4, new CampaignParser().parse()];
            case 1:
              return [2, _a.apply(void 0, [_b.sent()])];
          }
        });
      });
    };
    isCampaignEvent = function(event) {
      if (event.event_type === "$identify" && event.user_properties) {
        var properties = event.user_properties;
        var $set = properties[IdentifyOperation3.SET] || {};
        var $unset = properties[IdentifyOperation3.UNSET] || {};
        var userProperties_1 = __spreadArray3(__spreadArray3([], __read4(Object.keys($set)), false), __read4(Object.keys($unset)), false);
        return Object.keys(BASE_CAMPAIGN).every(function(value) {
          return userProperties_1.includes(value);
        });
      }
      return false;
    };
    shouldTrackHistoryPageView = function(trackingOption, newURLStr, oldURLStr) {
      switch (trackingOption) {
        case "pathOnly": {
          if (oldURLStr == "")
            return true;
          var newURL = new URL(newURLStr);
          var oldURL = new URL(oldURLStr);
          var newBaseStr = newURL.origin + newURL.pathname;
          var oldBaseStr = oldURL.origin + oldURL.pathname;
          return newBaseStr !== oldBaseStr;
        }
        default:
          return newURLStr !== oldURLStr;
      }
    };
  }
});

// node_modules/@amplitude/plugin-page-view-tracking-browser/lib/esm/index.js
var init_esm4 = __esm({
  "node_modules/@amplitude/plugin-page-view-tracking-browser/lib/esm/index.js"() {
    "use strict";
    init_page_view_tracking();
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/plugins/form-interaction-tracking.js
var formInteractionTracking, stringOrUndefined, extractFormAction;
var init_form_interaction_tracking = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/plugins/form-interaction-tracking.js"() {
    "use strict";
    init_tslib_es62();
    init_constants2();
    init_esm();
    formInteractionTracking = function() {
      var observer;
      var eventListeners = [];
      var addEventListener = function(element, type2, handler) {
        element.addEventListener(type2, handler);
        eventListeners.push({
          element,
          type: type2,
          handler
        });
      };
      var removeClickListeners = function() {
        eventListeners.forEach(function(_a) {
          var element = _a.element, type2 = _a.type, handler = _a.handler;
          element === null || element === void 0 ? void 0 : element.removeEventListener(type2, handler);
        });
        eventListeners = [];
      };
      var name = "@amplitude/plugin-form-interaction-tracking-browser";
      var type = "enrichment";
      var setup = function(config2, amplitude) {
        return __awaiter2(void 0, void 0, void 0, function() {
          var _a;
          return __generator2(this, function(_b) {
            (_a = getGlobalScope()) === null || _a === void 0 ? void 0 : _a.addEventListener("load", function() {
              if (!amplitude) {
                config2.loggerProvider.warn("Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.");
                return;
              }
              if (typeof document === "undefined") {
                return;
              }
              var addFormInteractionListener = function(form) {
                var hasFormChanged = false;
                addEventListener(form, "change", function() {
                  var _a2;
                  var formDestination = extractFormAction(form);
                  if (!hasFormChanged) {
                    amplitude.track(DEFAULT_FORM_START_EVENT, (_a2 = {}, _a2[FORM_ID] = stringOrUndefined(form.id), _a2[FORM_NAME] = stringOrUndefined(form.name), _a2[FORM_DESTINATION] = formDestination, _a2));
                  }
                  hasFormChanged = true;
                });
                addEventListener(form, "submit", function() {
                  var _a2, _b2;
                  var formDestination = extractFormAction(form);
                  if (!hasFormChanged) {
                    amplitude.track(DEFAULT_FORM_START_EVENT, (_a2 = {}, _a2[FORM_ID] = stringOrUndefined(form.id), _a2[FORM_NAME] = stringOrUndefined(form.name), _a2[FORM_DESTINATION] = formDestination, _a2));
                  }
                  amplitude.track(DEFAULT_FORM_SUBMIT_EVENT, (_b2 = {}, _b2[FORM_ID] = stringOrUndefined(form.id), _b2[FORM_NAME] = stringOrUndefined(form.name), _b2[FORM_DESTINATION] = formDestination, _b2));
                  hasFormChanged = false;
                });
              };
              var forms = Array.from(document.getElementsByTagName("form"));
              forms.forEach(addFormInteractionListener);
              if (typeof MutationObserver !== "undefined") {
                observer = new MutationObserver(function(mutations) {
                  mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                      if (node.nodeName === "FORM") {
                        addFormInteractionListener(node);
                      }
                      if ("querySelectorAll" in node && typeof node.querySelectorAll === "function") {
                        Array.from(node.querySelectorAll("form")).map(addFormInteractionListener);
                      }
                    });
                  });
                });
                observer.observe(document.body, {
                  subtree: true,
                  childList: true
                });
              }
            });
            return [
              2
              /*return*/
            ];
          });
        });
      };
      var execute = function(event) {
        return __awaiter2(void 0, void 0, void 0, function() {
          return __generator2(this, function(_a) {
            return [2, event];
          });
        });
      };
      var teardown = function() {
        return __awaiter2(void 0, void 0, void 0, function() {
          return __generator2(this, function(_a) {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            removeClickListeners();
            return [
              2
              /*return*/
            ];
          });
        });
      };
      return {
        name,
        type,
        setup,
        execute,
        teardown
      };
    };
    stringOrUndefined = function(name) {
      if (typeof name !== "string") {
        return void 0;
      }
      return name;
    };
    extractFormAction = function(form) {
      var formDestination = form.getAttribute("action");
      try {
        formDestination = new URL(encodeURI(formDestination !== null && formDestination !== void 0 ? formDestination : ""), window.location.href).href;
      } catch (_a) {
      }
      return formDestination;
    };
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/plugins/file-download-tracking.js
var fileDownloadTracking;
var init_file_download_tracking = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/plugins/file-download-tracking.js"() {
    "use strict";
    init_tslib_es62();
    init_constants2();
    init_esm();
    fileDownloadTracking = function() {
      var observer;
      var eventListeners = [];
      var addEventListener = function(element, type2, handler) {
        element.addEventListener(type2, handler);
        eventListeners.push({
          element,
          type: type2,
          handler
        });
      };
      var removeClickListeners = function() {
        eventListeners.forEach(function(_a) {
          var element = _a.element, type2 = _a.type, handler = _a.handler;
          element === null || element === void 0 ? void 0 : element.removeEventListener(type2, handler);
        });
        eventListeners = [];
      };
      var name = "@amplitude/plugin-file-download-tracking-browser";
      var type = "enrichment";
      var setup = function(config2, amplitude) {
        return __awaiter2(void 0, void 0, void 0, function() {
          var _a;
          return __generator2(this, function(_b) {
            (_a = getGlobalScope()) === null || _a === void 0 ? void 0 : _a.addEventListener("load", function() {
              if (!amplitude) {
                config2.loggerProvider.warn("File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.");
                return;
              }
              if (typeof document === "undefined") {
                return;
              }
              var addFileDownloadListener = function(a) {
                var url;
                try {
                  url = new URL(a.href, window.location.href);
                } catch (_a2) {
                  return;
                }
                var result = ext.exec(url.href);
                var fileExtension = result === null || result === void 0 ? void 0 : result[1];
                if (fileExtension) {
                  addEventListener(a, "click", function() {
                    var _a2;
                    if (fileExtension) {
                      amplitude.track(DEFAULT_FILE_DOWNLOAD_EVENT, (_a2 = {}, _a2[FILE_EXTENSION] = fileExtension, _a2[FILE_NAME] = url.pathname, _a2[LINK_ID] = a.id, _a2[LINK_TEXT] = a.text, _a2[LINK_URL] = a.href, _a2));
                    }
                  });
                }
              };
              var ext = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)(\?.+)?$/;
              var links = Array.from(document.getElementsByTagName("a"));
              links.forEach(addFileDownloadListener);
              if (typeof MutationObserver !== "undefined") {
                observer = new MutationObserver(function(mutations) {
                  mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                      if (node.nodeName === "A") {
                        addFileDownloadListener(node);
                      }
                      if ("querySelectorAll" in node && typeof node.querySelectorAll === "function") {
                        Array.from(node.querySelectorAll("a")).map(addFileDownloadListener);
                      }
                    });
                  });
                });
                observer.observe(document.body, {
                  subtree: true,
                  childList: true
                });
              }
            });
            return [
              2
              /*return*/
            ];
          });
        });
      };
      var execute = function(event) {
        return __awaiter2(void 0, void 0, void 0, function() {
          return __generator2(this, function(_a) {
            return [2, event];
          });
        });
      };
      var teardown = function() {
        return __awaiter2(void 0, void 0, void 0, function() {
          return __generator2(this, function(_a) {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            removeClickListeners();
            return [
              2
              /*return*/
            ];
          });
        });
      };
      return {
        name,
        type,
        setup,
        execute,
        teardown
      };
    };
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/det-notification.js
var notified, detNotify;
var init_det_notification = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/det-notification.js"() {
    "use strict";
    notified = false;
    detNotify = function(config2) {
      if (notified || config2.defaultTracking !== void 0) {
        return;
      }
      var message = "`options.defaultTracking` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to `options.defaultTracking`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:\n\namplitude.init(<YOUR_API_KEY>, {\n  defaultTracking: true,\n});\n\nVisit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.";
      config2.loggerProvider.warn(message);
      notified = true;
    };
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/plugins/network-connectivity-checker.js
var networkConnectivityCheckerPlugin;
var init_network_connectivity_checker = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/plugins/network-connectivity-checker.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    networkConnectivityCheckerPlugin = function() {
      var name = "@amplitude/plugin-network-checker-browser";
      var type = "before";
      var globalScope = getGlobalScope();
      var eventListeners = [];
      var addNetworkListener = function(type2, handler) {
        if (globalScope) {
          globalScope.addEventListener(type2, handler);
          eventListeners.push({
            type: type2,
            handler
          });
        }
      };
      var removeNetworkListeners = function() {
        eventListeners.forEach(function(_a) {
          var type2 = _a.type, handler = _a.handler;
          if (globalScope) {
            globalScope.removeEventListener(type2, handler);
          }
        });
        eventListeners = [];
      };
      var setup = function(config2, amplitude) {
        return __awaiter2(void 0, void 0, void 0, function() {
          return __generator2(this, function(_a) {
            if (typeof navigator === "undefined") {
              config2.loggerProvider.debug("Network connectivity checker plugin is disabled because navigator is not available.");
              config2.offline = false;
              return [
                2
                /*return*/
              ];
            }
            config2.offline = !navigator.onLine;
            addNetworkListener("online", function() {
              config2.loggerProvider.debug("Network connectivity changed to online.");
              config2.offline = false;
              setTimeout(function() {
                amplitude.flush();
              }, config2.flushIntervalMillis);
            });
            addNetworkListener("offline", function() {
              config2.loggerProvider.debug("Network connectivity changed to offline.");
              config2.offline = true;
            });
            return [
              2
              /*return*/
            ];
          });
        });
      };
      var teardown = function() {
        return __awaiter2(void 0, void 0, void 0, function() {
          return __generator2(this, function(_a) {
            removeNetworkListeners();
            return [
              2
              /*return*/
            ];
          });
        });
      };
      return {
        name,
        type,
        setup,
        teardown
      };
    };
  }
});

// node_modules/@amplitude/analytics-remote-config/node_modules/tslib/tslib.es6.mjs
function __awaiter5(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator5(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return { value: op[1], done: false };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __values3(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return { value: o && o[i++], done: !o };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var __assign6;
var init_tslib_es65 = __esm({
  "node_modules/@amplitude/analytics-remote-config/node_modules/tslib/tslib.es6.mjs"() {
    "use strict";
    __assign6 = function() {
      __assign6 = Object.assign || function __assign8(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign6.apply(this, arguments);
    };
  }
});

// node_modules/@amplitude/analytics-remote-config/lib/esm/remote-config.js
var UNEXPECTED_NETWORK_ERROR_MESSAGE, SUCCESS_REMOTE_CONFIG, MAX_RETRIES_EXCEEDED_MESSAGE2, TIMEOUT_MESSAGE, UNEXPECTED_ERROR_MESSAGE2, REMOTE_CONFIG_SERVER_URL, REMOTE_CONFIG_SERVER_URL_STAGING, REMOTE_CONFIG_SERVER_URL_EU, RemoteConfigFetch, createRemoteConfigFetch;
var init_remote_config = __esm({
  "node_modules/@amplitude/analytics-remote-config/lib/esm/remote-config.js"() {
    "use strict";
    init_tslib_es65();
    init_esm();
    init_esm3();
    UNEXPECTED_NETWORK_ERROR_MESSAGE = "Network error occurred, remote config fetch failed";
    SUCCESS_REMOTE_CONFIG = "Remote config successfully fetched";
    MAX_RETRIES_EXCEEDED_MESSAGE2 = "Remote config fetch rejected due to exceeded retry count";
    TIMEOUT_MESSAGE = "Remote config fetch rejected due to timeout after 5 seconds";
    UNEXPECTED_ERROR_MESSAGE2 = "Unexpected error occurred";
    REMOTE_CONFIG_SERVER_URL = "https://sr-client-cfg.amplitude.com/config";
    REMOTE_CONFIG_SERVER_URL_STAGING = "https://sr-client-cfg.stag2.amplitude.com/config";
    REMOTE_CONFIG_SERVER_URL_EU = "https://sr-client-cfg.eu.amplitude.com/config";
    RemoteConfigFetch = /** @class */
    function() {
      function RemoteConfigFetch2(_a) {
        var localConfig = _a.localConfig, configKeys = _a.configKeys;
        var _this = this;
        this.retryTimeout = 1e3;
        this.attempts = 0;
        this.sessionTargetingMatch = false;
        this.metrics = {};
        this.getRemoteConfig = function(configNamespace, key, sessionId) {
          return __awaiter5(_this, void 0, void 0, function() {
            var fetchStartTime, configAPIResponse, remoteConfig;
            return __generator5(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  fetchStartTime = Date.now();
                  return [4, this.fetchWithTimeout(sessionId)];
                case 1:
                  configAPIResponse = _a2.sent();
                  if (configAPIResponse) {
                    remoteConfig = configAPIResponse.configs && configAPIResponse.configs[configNamespace];
                    if (remoteConfig) {
                      this.metrics.fetchTimeAPISuccess = Date.now() - fetchStartTime;
                      return [2, remoteConfig[key]];
                    }
                  }
                  this.metrics.fetchTimeAPIFail = Date.now() - fetchStartTime;
                  return [2, void 0];
              }
            });
          });
        };
        this.fetchWithTimeout = function(sessionId) {
          return __awaiter5(_this, void 0, void 0, function() {
            var controller, timeoutId, remoteConfig;
            return __generator5(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  controller = new AbortController();
                  timeoutId = setTimeout(function() {
                    return controller.abort();
                  }, 5e3);
                  return [4, this.fetchRemoteConfig(controller.signal, sessionId)];
                case 1:
                  remoteConfig = _a2.sent();
                  clearTimeout(timeoutId);
                  return [2, remoteConfig];
              }
            });
          });
        };
        this.fetchRemoteConfig = function(signal, sessionId) {
          return __awaiter5(_this, void 0, void 0, function() {
            var urlParams, _a2, _b, configKey, options, serverUrl, res, parsedStatus, e_1, knownError;
            var e_2, _c;
            var _d;
            return __generator5(this, function(_e) {
              switch (_e.label) {
                case 0:
                  if (sessionId === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries) {
                    return [2, this.completeRequest({ err: MAX_RETRIES_EXCEEDED_MESSAGE2 })];
                  } else if (signal.aborted) {
                    return [2, this.completeRequest({ err: TIMEOUT_MESSAGE })];
                  } else if (sessionId !== this.lastFetchedSessionId) {
                    this.lastFetchedSessionId = sessionId;
                    this.attempts = 0;
                  }
                  _e.label = 1;
                case 1:
                  _e.trys.push([1, 3, , 4]);
                  urlParams = new URLSearchParams({
                    api_key: this.localConfig.apiKey
                  });
                  try {
                    for (_a2 = __values3(this.configKeys), _b = _a2.next(); !_b.done; _b = _a2.next()) {
                      configKey = _b.value;
                      urlParams.append("config_keys", configKey);
                    }
                  } catch (e_2_1) {
                    e_2 = { error: e_2_1 };
                  } finally {
                    try {
                      if (_b && !_b.done && (_c = _a2.return)) _c.call(_a2);
                    } finally {
                      if (e_2) throw e_2.error;
                    }
                  }
                  if (sessionId) {
                    urlParams.set("session_id", String(sessionId));
                  }
                  options = {
                    headers: {
                      Accept: "*/*"
                    },
                    method: "GET"
                  };
                  serverUrl = "".concat(this.getServerUrl(), "?").concat(urlParams.toString());
                  this.attempts += 1;
                  return [4, fetch(serverUrl, __assign6(__assign6({}, options), { signal }))];
                case 2:
                  res = _e.sent();
                  if (res === null) {
                    return [2, this.completeRequest({ err: UNEXPECTED_ERROR_MESSAGE2 })];
                  }
                  parsedStatus = new BaseTransport().buildStatus(res.status);
                  switch (parsedStatus) {
                    case Status2.Success:
                      this.attempts = 0;
                      return [2, this.parseAndStoreConfig(res)];
                    case Status2.Failed:
                      return [2, this.retryFetch(signal, sessionId)];
                    default:
                      return [2, this.completeRequest({ err: UNEXPECTED_NETWORK_ERROR_MESSAGE })];
                  }
                  return [3, 4];
                case 3:
                  e_1 = _e.sent();
                  knownError = e_1;
                  if (signal.aborted) {
                    return [2, this.completeRequest({ err: TIMEOUT_MESSAGE })];
                  }
                  return [2, this.completeRequest({ err: (_d = knownError.message) !== null && _d !== void 0 ? _d : UNEXPECTED_ERROR_MESSAGE2 })];
                case 4:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        };
        this.retryFetch = function(signal, sessionId) {
          return __awaiter5(_this, void 0, void 0, function() {
            var _this2 = this;
            return __generator5(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  return [4, new Promise(function(resolve) {
                    return setTimeout(resolve, _this2.attempts * _this2.retryTimeout);
                  })];
                case 1:
                  _a2.sent();
                  return [2, this.fetchRemoteConfig(signal, sessionId)];
              }
            });
          });
        };
        this.parseAndStoreConfig = function(res) {
          return __awaiter5(_this, void 0, void 0, function() {
            var remoteConfig;
            return __generator5(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  return [4, res.json()];
                case 1:
                  remoteConfig = _a2.sent();
                  this.completeRequest({ success: SUCCESS_REMOTE_CONFIG });
                  return [2, remoteConfig];
              }
            });
          });
        };
        this.localConfig = localConfig;
        this.configKeys = configKeys;
      }
      RemoteConfigFetch2.prototype.getServerUrl = function() {
        if (this.localConfig.serverZone === ServerZone.STAGING) {
          return REMOTE_CONFIG_SERVER_URL_STAGING;
        }
        if (this.localConfig.serverZone === ServerZone.EU) {
          return REMOTE_CONFIG_SERVER_URL_EU;
        }
        return REMOTE_CONFIG_SERVER_URL;
      };
      RemoteConfigFetch2.prototype.completeRequest = function(_a) {
        var err = _a.err, success = _a.success;
        if (err) {
          throw new Error(err);
        } else if (success) {
          this.localConfig.loggerProvider.log(success);
        }
      };
      return RemoteConfigFetch2;
    }();
    createRemoteConfigFetch = function(_a) {
      var localConfig = _a.localConfig, configKeys = _a.configKeys;
      return __awaiter5(void 0, void 0, void 0, function() {
        return __generator5(this, function(_b) {
          return [2, new RemoteConfigFetch({ localConfig, configKeys })];
        });
      });
    };
  }
});

// node_modules/@amplitude/analytics-remote-config/lib/esm/index.js
var createRemoteConfigFetch2;
var init_esm5 = __esm({
  "node_modules/@amplitude/analytics-remote-config/lib/esm/index.js"() {
    "use strict";
    init_remote_config();
    createRemoteConfigFetch2 = createRemoteConfigFetch;
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/config/joined-config.js
var BrowserJoinedConfigGenerator, createBrowserJoinedConfigGenerator;
var init_joined_config = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/config/joined-config.js"() {
    "use strict";
    init_tslib_es62();
    init_esm5();
    init_esm();
    BrowserJoinedConfigGenerator = /** @class */
    function() {
      function BrowserJoinedConfigGenerator2(localConfig) {
        this.config = localConfig;
        this.config.loggerProvider.debug("Local configuration before merging with remote config", JSON.stringify(this.config, null, 2));
      }
      BrowserJoinedConfigGenerator2.prototype.initialize = function() {
        return __awaiter2(this, void 0, void 0, function() {
          var _a;
          return __generator2(this, function(_b) {
            switch (_b.label) {
              case 0:
                _a = this;
                return [4, createRemoteConfigFetch2({
                  localConfig: this.config,
                  configKeys: ["analyticsSDK"]
                })];
              case 1:
                _a.remoteConfigFetch = _b.sent();
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      BrowserJoinedConfigGenerator2.prototype.generateJoinedConfig = function() {
        return __awaiter2(this, void 0, void 0, function() {
          var remoteConfig, _a, e_1;
          var _b, _c, _d;
          var _e;
          return __generator2(this, function(_f) {
            switch (_f.label) {
              case 0:
                _f.trys.push([0, 3, , 4]);
                _a = this.remoteConfigFetch;
                if (!_a) return [3, 2];
                return [4, this.remoteConfigFetch.getRemoteConfig("analyticsSDK", "browserSDK", this.config.sessionId)];
              case 1:
                _a = _f.sent();
                _f.label = 2;
              case 2:
                remoteConfig = _a;
                this.config.loggerProvider.debug("Remote configuration:", JSON.stringify(remoteConfig, null, 2));
                if (remoteConfig && "autocapture" in remoteConfig) {
                  if (typeof remoteConfig.autocapture === "boolean") {
                    this.config.autocapture = remoteConfig.autocapture;
                  }
                  if (typeof remoteConfig.autocapture === "object") {
                    if (this.config.autocapture === void 0) {
                      this.config.autocapture = remoteConfig.autocapture;
                    }
                    if (typeof this.config.autocapture === "boolean") {
                      this.config.autocapture = __assign3({ attribution: this.config.autocapture, fileDownloads: this.config.autocapture, formInteractions: this.config.autocapture, pageViews: this.config.autocapture, sessions: this.config.autocapture, elementInteractions: this.config.autocapture }, remoteConfig.autocapture);
                    }
                    if (typeof this.config.autocapture === "object") {
                      this.config.autocapture = __assign3(__assign3({}, this.config.autocapture), remoteConfig.autocapture);
                    }
                  }
                  this.config.defaultTracking = this.config.autocapture;
                }
                this.config.loggerProvider.debug("Joined configuration: ", JSON.stringify(this.config, null, 2));
                (_b = (_e = this.config).requestMetadata) !== null && _b !== void 0 ? _b : _e.requestMetadata = new RequestMetadata();
                if ((_c = this.remoteConfigFetch) === null || _c === void 0 ? void 0 : _c.metrics.fetchTimeAPISuccess) {
                  this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_success", this.remoteConfigFetch.metrics.fetchTimeAPISuccess);
                }
                if ((_d = this.remoteConfigFetch) === null || _d === void 0 ? void 0 : _d.metrics.fetchTimeAPIFail) {
                  this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_fail", this.remoteConfigFetch.metrics.fetchTimeAPIFail);
                }
                return [3, 4];
              case 3:
                e_1 = _f.sent();
                this.config.loggerProvider.error("Failed to fetch remote configuration because of error: ", e_1);
                return [3, 4];
              case 4:
                return [2, this.config];
            }
          });
        });
      };
      return BrowserJoinedConfigGenerator2;
    }();
    createBrowserJoinedConfigGenerator = function(localConfig) {
      return __awaiter2(void 0, void 0, void 0, function() {
        var joinedConfigGenerator;
        return __generator2(this, function(_a) {
          switch (_a.label) {
            case 0:
              joinedConfigGenerator = new BrowserJoinedConfigGenerator(localConfig);
              return [4, joinedConfigGenerator.initialize()];
            case 1:
              _a.sent();
              return [2, joinedConfigGenerator];
          }
        });
      });
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/tslib/tslib.es6.mjs
function __awaiter6(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator6(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return { value: op[1], done: false };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __values4(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return { value: o && o[i++], done: !o };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read5(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray4(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var __assign7;
var init_tslib_es66 = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/tslib/tslib.es6.mjs"() {
    "use strict";
    __assign7 = function() {
      __assign7 = Object.assign || function __assign8(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign7.apply(this, arguments);
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/lib/esm/constants.js
var PLUGIN_NAME, AMPLITUDE_ELEMENT_CLICKED_EVENT, AMPLITUDE_ELEMENT_CHANGED_EVENT, AMPLITUDE_EVENT_PROP_ELEMENT_ID, AMPLITUDE_EVENT_PROP_ELEMENT_CLASS, AMPLITUDE_EVENT_PROP_ELEMENT_TAG, AMPLITUDE_EVENT_PROP_ELEMENT_TEXT, AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY, AMPLITUDE_EVENT_PROP_ELEMENT_HREF, AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT, AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP, AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL, AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES, AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR, AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL, AMPLITUDE_EVENT_PROP_PAGE_URL, AMPLITUDE_EVENT_PROP_PAGE_TITLE, AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT, AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH, AMPLITUDE_ORIGIN, AMPLITUDE_ORIGIN_EU, AMPLITUDE_ORIGIN_STAGING, AMPLITUDE_ORIGINS_MAP, AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL, AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
var init_constants4 = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/lib/esm/constants.js"() {
    "use strict";
    PLUGIN_NAME = "@amplitude/plugin-autocapture-browser";
    AMPLITUDE_ELEMENT_CLICKED_EVENT = "[Amplitude] Element Clicked";
    AMPLITUDE_ELEMENT_CHANGED_EVENT = "[Amplitude] Element Changed";
    AMPLITUDE_EVENT_PROP_ELEMENT_ID = "[Amplitude] Element ID";
    AMPLITUDE_EVENT_PROP_ELEMENT_CLASS = "[Amplitude] Element Class";
    AMPLITUDE_EVENT_PROP_ELEMENT_TAG = "[Amplitude] Element Tag";
    AMPLITUDE_EVENT_PROP_ELEMENT_TEXT = "[Amplitude] Element Text";
    AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY = "[Amplitude] Element Hierarchy";
    AMPLITUDE_EVENT_PROP_ELEMENT_HREF = "[Amplitude] Element Href";
    AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT = "[Amplitude] Element Position Left";
    AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP = "[Amplitude] Element Position Top";
    AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL = "[Amplitude] Element Aria Label";
    AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES = "[Amplitude] Element Attributes";
    AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR = "[Amplitude] Element Selector";
    AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL = "[Amplitude] Element Parent Label";
    AMPLITUDE_EVENT_PROP_PAGE_URL = "[Amplitude] Page URL";
    AMPLITUDE_EVENT_PROP_PAGE_TITLE = "[Amplitude] Page Title";
    AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT = "[Amplitude] Viewport Height";
    AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH = "[Amplitude] Viewport Width";
    AMPLITUDE_ORIGIN = "https://app.amplitude.com";
    AMPLITUDE_ORIGIN_EU = "https://app.eu.amplitude.com";
    AMPLITUDE_ORIGIN_STAGING = "https://apps.stag2.amplitude.com";
    AMPLITUDE_ORIGINS_MAP = {
      US: AMPLITUDE_ORIGIN,
      EU: AMPLITUDE_ORIGIN_EU,
      STAGING: AMPLITUDE_ORIGIN_STAGING
    };
    AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL = "https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz";
    AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS = "amp-visual-tagging-selector-highlight";
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isFunction.js
var require_isFunction = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isFunction.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isFunction = void 0;
    function isFunction(value) {
      return typeof value === "function";
    }
    exports2.isFunction = isFunction;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/createErrorClass.js
var require_createErrorClass = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/createErrorClass.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createErrorClass = void 0;
    function createErrorClass(createImpl) {
      var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
      };
      var ctorFunc = createImpl(_super);
      ctorFunc.prototype = Object.create(Error.prototype);
      ctorFunc.prototype.constructor = ctorFunc;
      return ctorFunc;
    }
    exports2.createErrorClass = createErrorClass;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/UnsubscriptionError.js
var require_UnsubscriptionError = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/UnsubscriptionError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.UnsubscriptionError = void 0;
    var createErrorClass_1 = require_createErrorClass();
    exports2.UnsubscriptionError = createErrorClass_1.createErrorClass(function(_super) {
      return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
          return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
      };
    });
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/arrRemove.js
var require_arrRemove = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/arrRemove.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.arrRemove = void 0;
    function arrRemove(arr, item) {
      if (arr) {
        var index2 = arr.indexOf(item);
        0 <= index2 && arr.splice(index2, 1);
      }
    }
    exports2.arrRemove = arrRemove;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Subscription.js
var require_Subscription = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Subscription.js"(exports2) {
    "use strict";
    var __values5 = exports2 && exports2.__values || function(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
        next: function() {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
        }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isSubscription = exports2.EMPTY_SUBSCRIPTION = exports2.Subscription = void 0;
    var isFunction_1 = require_isFunction();
    var UnsubscriptionError_1 = require_UnsubscriptionError();
    var arrRemove_1 = require_arrRemove();
    var Subscription = function() {
      function Subscription2(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
      }
      Subscription2.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
          this.closed = true;
          var _parentage = this._parentage;
          if (_parentage) {
            this._parentage = null;
            if (Array.isArray(_parentage)) {
              try {
                for (var _parentage_1 = __values5(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
                  var parent_1 = _parentage_1_1.value;
                  parent_1.remove(this);
                }
              } catch (e_1_1) {
                e_1 = { error: e_1_1 };
              } finally {
                try {
                  if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                } finally {
                  if (e_1) throw e_1.error;
                }
              }
            } else {
              _parentage.remove(this);
            }
          }
          var initialFinalizer = this.initialTeardown;
          if (isFunction_1.isFunction(initialFinalizer)) {
            try {
              initialFinalizer();
            } catch (e) {
              errors = e instanceof UnsubscriptionError_1.UnsubscriptionError ? e.errors : [e];
            }
          }
          var _finalizers = this._finalizers;
          if (_finalizers) {
            this._finalizers = null;
            try {
              for (var _finalizers_1 = __values5(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
                var finalizer = _finalizers_1_1.value;
                try {
                  execFinalizer(finalizer);
                } catch (err) {
                  errors = errors !== null && errors !== void 0 ? errors : [];
                  if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                    errors = __spreadArray5(__spreadArray5([], __read6(errors)), __read6(err.errors));
                  } else {
                    errors.push(err);
                  }
                }
              }
            } catch (e_2_1) {
              e_2 = { error: e_2_1 };
            } finally {
              try {
                if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
              } finally {
                if (e_2) throw e_2.error;
              }
            }
          }
          if (errors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
          }
        }
      };
      Subscription2.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
          if (this.closed) {
            execFinalizer(teardown);
          } else {
            if (teardown instanceof Subscription2) {
              if (teardown.closed || teardown._hasParent(this)) {
                return;
              }
              teardown._addParent(this);
            }
            (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
          }
        }
      };
      Subscription2.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
      };
      Subscription2.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
      };
      Subscription2.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) {
          this._parentage = null;
        } else if (Array.isArray(_parentage)) {
          arrRemove_1.arrRemove(_parentage, parent);
        }
      };
      Subscription2.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && arrRemove_1.arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription2) {
          teardown._removeParent(this);
        }
      };
      Subscription2.EMPTY = function() {
        var empty = new Subscription2();
        empty.closed = true;
        return empty;
      }();
      return Subscription2;
    }();
    exports2.Subscription = Subscription;
    exports2.EMPTY_SUBSCRIPTION = Subscription.EMPTY;
    function isSubscription(value) {
      return value instanceof Subscription || value && "closed" in value && isFunction_1.isFunction(value.remove) && isFunction_1.isFunction(value.add) && isFunction_1.isFunction(value.unsubscribe);
    }
    exports2.isSubscription = isSubscription;
    function execFinalizer(finalizer) {
      if (isFunction_1.isFunction(finalizer)) {
        finalizer();
      } else {
        finalizer.unsubscribe();
      }
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/config.js
var require_config = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/config.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.config = void 0;
    exports2.config = {
      onUnhandledError: null,
      onStoppedNotification: null,
      Promise: void 0,
      useDeprecatedSynchronousErrorHandling: false,
      useDeprecatedNextContext: false
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/timeoutProvider.js
var require_timeoutProvider = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/timeoutProvider.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.timeoutProvider = void 0;
    exports2.timeoutProvider = {
      setTimeout: function(handler, timeout2) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
          args[_i - 2] = arguments[_i];
        }
        var delegate = exports2.timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
          return delegate.setTimeout.apply(delegate, __spreadArray5([handler, timeout2], __read6(args)));
        }
        return setTimeout.apply(void 0, __spreadArray5([handler, timeout2], __read6(args)));
      },
      clearTimeout: function(handle) {
        var delegate = exports2.timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
      },
      delegate: void 0
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/reportUnhandledError.js
var require_reportUnhandledError = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/reportUnhandledError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.reportUnhandledError = void 0;
    var config_1 = require_config();
    var timeoutProvider_1 = require_timeoutProvider();
    function reportUnhandledError(err) {
      timeoutProvider_1.timeoutProvider.setTimeout(function() {
        var onUnhandledError = config_1.config.onUnhandledError;
        if (onUnhandledError) {
          onUnhandledError(err);
        } else {
          throw err;
        }
      });
    }
    exports2.reportUnhandledError = reportUnhandledError;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/noop.js
var require_noop = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/noop.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.noop = void 0;
    function noop() {
    }
    exports2.noop = noop;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/NotificationFactories.js
var require_NotificationFactories = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/NotificationFactories.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createNotification = exports2.nextNotification = exports2.errorNotification = exports2.COMPLETE_NOTIFICATION = void 0;
    exports2.COMPLETE_NOTIFICATION = function() {
      return createNotification("C", void 0, void 0);
    }();
    function errorNotification(error) {
      return createNotification("E", void 0, error);
    }
    exports2.errorNotification = errorNotification;
    function nextNotification(value) {
      return createNotification("N", value, void 0);
    }
    exports2.nextNotification = nextNotification;
    function createNotification(kind, value, error) {
      return {
        kind,
        value,
        error
      };
    }
    exports2.createNotification = createNotification;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/errorContext.js
var require_errorContext = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/errorContext.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.captureError = exports2.errorContext = void 0;
    var config_1 = require_config();
    var context = null;
    function errorContext(cb) {
      if (config_1.config.useDeprecatedSynchronousErrorHandling) {
        var isRoot = !context;
        if (isRoot) {
          context = { errorThrown: false, error: null };
        }
        cb();
        if (isRoot) {
          var _a = context, errorThrown = _a.errorThrown, error = _a.error;
          context = null;
          if (errorThrown) {
            throw error;
          }
        }
      } else {
        cb();
      }
    }
    exports2.errorContext = errorContext;
    function captureError(err) {
      if (config_1.config.useDeprecatedSynchronousErrorHandling && context) {
        context.errorThrown = true;
        context.error = err;
      }
    }
    exports2.captureError = captureError;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Subscriber.js
var require_Subscriber = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Subscriber.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.EMPTY_OBSERVER = exports2.SafeSubscriber = exports2.Subscriber = void 0;
    var isFunction_1 = require_isFunction();
    var Subscription_1 = require_Subscription();
    var config_1 = require_config();
    var reportUnhandledError_1 = require_reportUnhandledError();
    var noop_1 = require_noop();
    var NotificationFactories_1 = require_NotificationFactories();
    var timeoutProvider_1 = require_timeoutProvider();
    var errorContext_1 = require_errorContext();
    var Subscriber = function(_super) {
      __extends3(Subscriber2, _super);
      function Subscriber2(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
          _this.destination = destination;
          if (Subscription_1.isSubscription(destination)) {
            destination.add(_this);
          }
        } else {
          _this.destination = exports2.EMPTY_OBSERVER;
        }
        return _this;
      }
      Subscriber2.create = function(next, error, complete) {
        return new SafeSubscriber(next, error, complete);
      };
      Subscriber2.prototype.next = function(value) {
        if (this.isStopped) {
          handleStoppedNotification(NotificationFactories_1.nextNotification(value), this);
        } else {
          this._next(value);
        }
      };
      Subscriber2.prototype.error = function(err) {
        if (this.isStopped) {
          handleStoppedNotification(NotificationFactories_1.errorNotification(err), this);
        } else {
          this.isStopped = true;
          this._error(err);
        }
      };
      Subscriber2.prototype.complete = function() {
        if (this.isStopped) {
          handleStoppedNotification(NotificationFactories_1.COMPLETE_NOTIFICATION, this);
        } else {
          this.isStopped = true;
          this._complete();
        }
      };
      Subscriber2.prototype.unsubscribe = function() {
        if (!this.closed) {
          this.isStopped = true;
          _super.prototype.unsubscribe.call(this);
          this.destination = null;
        }
      };
      Subscriber2.prototype._next = function(value) {
        this.destination.next(value);
      };
      Subscriber2.prototype._error = function(err) {
        try {
          this.destination.error(err);
        } finally {
          this.unsubscribe();
        }
      };
      Subscriber2.prototype._complete = function() {
        try {
          this.destination.complete();
        } finally {
          this.unsubscribe();
        }
      };
      return Subscriber2;
    }(Subscription_1.Subscription);
    exports2.Subscriber = Subscriber;
    var _bind = Function.prototype.bind;
    function bind(fn, thisArg) {
      return _bind.call(fn, thisArg);
    }
    var ConsumerObserver = function() {
      function ConsumerObserver2(partialObserver) {
        this.partialObserver = partialObserver;
      }
      ConsumerObserver2.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) {
          try {
            partialObserver.next(value);
          } catch (error) {
            handleUnhandledError(error);
          }
        }
      };
      ConsumerObserver2.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) {
          try {
            partialObserver.error(err);
          } catch (error) {
            handleUnhandledError(error);
          }
        } else {
          handleUnhandledError(err);
        }
      };
      ConsumerObserver2.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) {
          try {
            partialObserver.complete();
          } catch (error) {
            handleUnhandledError(error);
          }
        }
      };
      return ConsumerObserver2;
    }();
    var SafeSubscriber = function(_super) {
      __extends3(SafeSubscriber2, _super);
      function SafeSubscriber2(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if (isFunction_1.isFunction(observerOrNext) || !observerOrNext) {
          partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : void 0,
            error: error !== null && error !== void 0 ? error : void 0,
            complete: complete !== null && complete !== void 0 ? complete : void 0
          };
        } else {
          var context_1;
          if (_this && config_1.config.useDeprecatedNextContext) {
            context_1 = Object.create(observerOrNext);
            context_1.unsubscribe = function() {
              return _this.unsubscribe();
            };
            partialObserver = {
              next: observerOrNext.next && bind(observerOrNext.next, context_1),
              error: observerOrNext.error && bind(observerOrNext.error, context_1),
              complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
            };
          } else {
            partialObserver = observerOrNext;
          }
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
      }
      return SafeSubscriber2;
    }(Subscriber);
    exports2.SafeSubscriber = SafeSubscriber;
    function handleUnhandledError(error) {
      if (config_1.config.useDeprecatedSynchronousErrorHandling) {
        errorContext_1.captureError(error);
      } else {
        reportUnhandledError_1.reportUnhandledError(error);
      }
    }
    function defaultErrorHandler(err) {
      throw err;
    }
    function handleStoppedNotification(notification, subscriber) {
      var onStoppedNotification = config_1.config.onStoppedNotification;
      onStoppedNotification && timeoutProvider_1.timeoutProvider.setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
      });
    }
    exports2.EMPTY_OBSERVER = {
      closed: true,
      next: noop_1.noop,
      error: defaultErrorHandler,
      complete: noop_1.noop
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/symbol/observable.js
var require_observable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/symbol/observable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.observable = void 0;
    exports2.observable = function() {
      return typeof Symbol === "function" && Symbol.observable || "@@observable";
    }();
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/identity.js
var require_identity = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/identity.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.identity = void 0;
    function identity(x) {
      return x;
    }
    exports2.identity = identity;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/pipe.js
var require_pipe = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/pipe.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.pipeFromArray = exports2.pipe = void 0;
    var identity_1 = require_identity();
    function pipe() {
      var fns = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
      }
      return pipeFromArray(fns);
    }
    exports2.pipe = pipe;
    function pipeFromArray(fns) {
      if (fns.length === 0) {
        return identity_1.identity;
      }
      if (fns.length === 1) {
        return fns[0];
      }
      return function piped(input) {
        return fns.reduce(function(prev, fn) {
          return fn(prev);
        }, input);
      };
    }
    exports2.pipeFromArray = pipeFromArray;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Observable.js
var require_Observable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Observable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.Observable = void 0;
    var Subscriber_1 = require_Subscriber();
    var Subscription_1 = require_Subscription();
    var observable_1 = require_observable();
    var pipe_1 = require_pipe();
    var config_1 = require_config();
    var isFunction_1 = require_isFunction();
    var errorContext_1 = require_errorContext();
    var Observable2 = function() {
      function Observable3(subscribe) {
        if (subscribe) {
          this._subscribe = subscribe;
        }
      }
      Observable3.prototype.lift = function(operator) {
        var observable = new Observable3();
        observable.source = this;
        observable.operator = operator;
        return observable;
      };
      Observable3.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new Subscriber_1.SafeSubscriber(observerOrNext, error, complete);
        errorContext_1.errorContext(function() {
          var _a = _this, operator = _a.operator, source = _a.source;
          subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
      };
      Observable3.prototype._trySubscribe = function(sink) {
        try {
          return this._subscribe(sink);
        } catch (err) {
          sink.error(err);
        }
      };
      Observable3.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
          var subscriber = new Subscriber_1.SafeSubscriber({
            next: function(value) {
              try {
                next(value);
              } catch (err) {
                reject(err);
                subscriber.unsubscribe();
              }
            },
            error: reject,
            complete: resolve
          });
          _this.subscribe(subscriber);
        });
      };
      Observable3.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
      };
      Observable3.prototype[observable_1.observable] = function() {
        return this;
      };
      Observable3.prototype.pipe = function() {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          operations[_i] = arguments[_i];
        }
        return pipe_1.pipeFromArray(operations)(this);
      };
      Observable3.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
          var value;
          _this.subscribe(function(x) {
            return value = x;
          }, function(err) {
            return reject(err);
          }, function() {
            return resolve(value);
          });
        });
      };
      Observable3.create = function(subscribe) {
        return new Observable3(subscribe);
      };
      return Observable3;
    }();
    exports2.Observable = Observable2;
    function getPromiseCtor(promiseCtor) {
      var _a;
      return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config_1.config.Promise) !== null && _a !== void 0 ? _a : Promise;
    }
    function isObserver(value) {
      return value && isFunction_1.isFunction(value.next) && isFunction_1.isFunction(value.error) && isFunction_1.isFunction(value.complete);
    }
    function isSubscriber(value) {
      return value && value instanceof Subscriber_1.Subscriber || isObserver(value) && Subscription_1.isSubscription(value);
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/lift.js
var require_lift = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/lift.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.operate = exports2.hasLift = void 0;
    var isFunction_1 = require_isFunction();
    function hasLift(source) {
      return isFunction_1.isFunction(source === null || source === void 0 ? void 0 : source.lift);
    }
    exports2.hasLift = hasLift;
    function operate(init2) {
      return function(source) {
        if (hasLift(source)) {
          return source.lift(function(liftedSource) {
            try {
              return init2(liftedSource, this);
            } catch (err) {
              this.error(err);
            }
          });
        }
        throw new TypeError("Unable to lift unknown Observable type");
      };
    }
    exports2.operate = operate;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/OperatorSubscriber.js
var require_OperatorSubscriber = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/OperatorSubscriber.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.OperatorSubscriber = exports2.createOperatorSubscriber = void 0;
    var Subscriber_1 = require_Subscriber();
    function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
      return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
    }
    exports2.createOperatorSubscriber = createOperatorSubscriber;
    var OperatorSubscriber = function(_super) {
      __extends3(OperatorSubscriber2, _super);
      function OperatorSubscriber2(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
          try {
            onNext(value);
          } catch (err) {
            destination.error(err);
          }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
          try {
            onError(err);
          } catch (err2) {
            destination.error(err2);
          } finally {
            this.unsubscribe();
          }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
          try {
            onComplete();
          } catch (err) {
            destination.error(err);
          } finally {
            this.unsubscribe();
          }
        } : _super.prototype._complete;
        return _this;
      }
      OperatorSubscriber2.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
          var closed_1 = this.closed;
          _super.prototype.unsubscribe.call(this);
          !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
        }
      };
      return OperatorSubscriber2;
    }(Subscriber_1.Subscriber);
    exports2.OperatorSubscriber = OperatorSubscriber;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/refCount.js
var require_refCount = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/refCount.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.refCount = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function refCount() {
      return lift_1.operate(function(source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = OperatorSubscriber_1.createOperatorSubscriber(subscriber, void 0, void 0, void 0, function() {
          if (!source || source._refCount <= 0 || 0 < --source._refCount) {
            connection = null;
            return;
          }
          var sharedConnection = source._connection;
          var conn = connection;
          connection = null;
          if (sharedConnection && (!conn || sharedConnection === conn)) {
            sharedConnection.unsubscribe();
          }
          subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) {
          connection = source.connect();
        }
      });
    }
    exports2.refCount = refCount;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/ConnectableObservable.js
var require_ConnectableObservable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/ConnectableObservable.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.ConnectableObservable = void 0;
    var Observable_1 = require_Observable();
    var Subscription_1 = require_Subscription();
    var refCount_1 = require_refCount();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var lift_1 = require_lift();
    var ConnectableObservable = function(_super) {
      __extends3(ConnectableObservable2, _super);
      function ConnectableObservable2(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if (lift_1.hasLift(source)) {
          _this.lift = source.lift;
        }
        return _this;
      }
      ConnectableObservable2.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
      };
      ConnectableObservable2.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
          this._subject = this.subjectFactory();
        }
        return this._subject;
      };
      ConnectableObservable2.prototype._teardown = function() {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 ? void 0 : _connection.unsubscribe();
      };
      ConnectableObservable2.prototype.connect = function() {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
          connection = this._connection = new Subscription_1.Subscription();
          var subject_1 = this.getSubject();
          connection.add(this.source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subject_1, void 0, function() {
            _this._teardown();
            subject_1.complete();
          }, function(err) {
            _this._teardown();
            subject_1.error(err);
          }, function() {
            return _this._teardown();
          })));
          if (connection.closed) {
            this._connection = null;
            connection = Subscription_1.Subscription.EMPTY;
          }
        }
        return connection;
      };
      ConnectableObservable2.prototype.refCount = function() {
        return refCount_1.refCount()(this);
      };
      return ConnectableObservable2;
    }(Observable_1.Observable);
    exports2.ConnectableObservable = ConnectableObservable;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/performanceTimestampProvider.js
var require_performanceTimestampProvider = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/performanceTimestampProvider.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.performanceTimestampProvider = void 0;
    exports2.performanceTimestampProvider = {
      now: function() {
        return (exports2.performanceTimestampProvider.delegate || performance).now();
      },
      delegate: void 0
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/animationFrameProvider.js
var require_animationFrameProvider = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/animationFrameProvider.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.animationFrameProvider = void 0;
    var Subscription_1 = require_Subscription();
    exports2.animationFrameProvider = {
      schedule: function(callback) {
        var request = requestAnimationFrame;
        var cancel = cancelAnimationFrame;
        var delegate = exports2.animationFrameProvider.delegate;
        if (delegate) {
          request = delegate.requestAnimationFrame;
          cancel = delegate.cancelAnimationFrame;
        }
        var handle = request(function(timestamp) {
          cancel = void 0;
          callback(timestamp);
        });
        return new Subscription_1.Subscription(function() {
          return cancel === null || cancel === void 0 ? void 0 : cancel(handle);
        });
      },
      requestAnimationFrame: function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var delegate = exports2.animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, __spreadArray5([], __read6(args)));
      },
      cancelAnimationFrame: function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var delegate = exports2.animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, __spreadArray5([], __read6(args)));
      },
      delegate: void 0
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/dom/animationFrames.js
var require_animationFrames = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/dom/animationFrames.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.animationFrames = void 0;
    var Observable_1 = require_Observable();
    var performanceTimestampProvider_1 = require_performanceTimestampProvider();
    var animationFrameProvider_1 = require_animationFrameProvider();
    function animationFrames(timestampProvider) {
      return timestampProvider ? animationFramesFactory(timestampProvider) : DEFAULT_ANIMATION_FRAMES;
    }
    exports2.animationFrames = animationFrames;
    function animationFramesFactory(timestampProvider) {
      return new Observable_1.Observable(function(subscriber) {
        var provider = timestampProvider || performanceTimestampProvider_1.performanceTimestampProvider;
        var start = provider.now();
        var id2 = 0;
        var run = function() {
          if (!subscriber.closed) {
            id2 = animationFrameProvider_1.animationFrameProvider.requestAnimationFrame(function(timestamp) {
              id2 = 0;
              var now = provider.now();
              subscriber.next({
                timestamp: timestampProvider ? now : timestamp,
                elapsed: now - start
              });
              run();
            });
          }
        };
        run();
        return function() {
          if (id2) {
            animationFrameProvider_1.animationFrameProvider.cancelAnimationFrame(id2);
          }
        };
      });
    }
    var DEFAULT_ANIMATION_FRAMES = animationFramesFactory();
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/ObjectUnsubscribedError.js
var require_ObjectUnsubscribedError = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/ObjectUnsubscribedError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.ObjectUnsubscribedError = void 0;
    var createErrorClass_1 = require_createErrorClass();
    exports2.ObjectUnsubscribedError = createErrorClass_1.createErrorClass(function(_super) {
      return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
      };
    });
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Subject.js
var require_Subject = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Subject.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    var __values5 = exports2 && exports2.__values || function(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
        next: function() {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
        }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.AnonymousSubject = exports2.Subject = void 0;
    var Observable_1 = require_Observable();
    var Subscription_1 = require_Subscription();
    var ObjectUnsubscribedError_1 = require_ObjectUnsubscribedError();
    var arrRemove_1 = require_arrRemove();
    var errorContext_1 = require_errorContext();
    var Subject = function(_super) {
      __extends3(Subject2, _super);
      function Subject2() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
      }
      Subject2.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
      };
      Subject2.prototype._throwIfClosed = function() {
        if (this.closed) {
          throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
      };
      Subject2.prototype.next = function(value) {
        var _this = this;
        errorContext_1.errorContext(function() {
          var e_1, _a;
          _this._throwIfClosed();
          if (!_this.isStopped) {
            if (!_this.currentObservers) {
              _this.currentObservers = Array.from(_this.observers);
            }
            try {
              for (var _b = __values5(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var observer = _c.value;
                observer.next(value);
              }
            } catch (e_1_1) {
              e_1 = { error: e_1_1 };
            } finally {
              try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
          }
        });
      };
      Subject2.prototype.error = function(err) {
        var _this = this;
        errorContext_1.errorContext(function() {
          _this._throwIfClosed();
          if (!_this.isStopped) {
            _this.hasError = _this.isStopped = true;
            _this.thrownError = err;
            var observers = _this.observers;
            while (observers.length) {
              observers.shift().error(err);
            }
          }
        });
      };
      Subject2.prototype.complete = function() {
        var _this = this;
        errorContext_1.errorContext(function() {
          _this._throwIfClosed();
          if (!_this.isStopped) {
            _this.isStopped = true;
            var observers = _this.observers;
            while (observers.length) {
              observers.shift().complete();
            }
          }
        });
      };
      Subject2.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
      };
      Object.defineProperty(Subject2.prototype, "observed", {
        get: function() {
          var _a;
          return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
      });
      Subject2.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
      };
      Subject2.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
      };
      Subject2.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) {
          return Subscription_1.EMPTY_SUBSCRIPTION;
        }
        this.currentObservers = null;
        observers.push(subscriber);
        return new Subscription_1.Subscription(function() {
          _this.currentObservers = null;
          arrRemove_1.arrRemove(observers, subscriber);
        });
      };
      Subject2.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) {
          subscriber.error(thrownError);
        } else if (isStopped) {
          subscriber.complete();
        }
      };
      Subject2.prototype.asObservable = function() {
        var observable = new Observable_1.Observable();
        observable.source = this;
        return observable;
      };
      Subject2.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
      };
      return Subject2;
    }(Observable_1.Observable);
    exports2.Subject = Subject;
    var AnonymousSubject = function(_super) {
      __extends3(AnonymousSubject2, _super);
      function AnonymousSubject2(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
      }
      AnonymousSubject2.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
      };
      AnonymousSubject2.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
      };
      AnonymousSubject2.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
      };
      AnonymousSubject2.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : Subscription_1.EMPTY_SUBSCRIPTION;
      };
      return AnonymousSubject2;
    }(Subject);
    exports2.AnonymousSubject = AnonymousSubject;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/BehaviorSubject.js
var require_BehaviorSubject = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/BehaviorSubject.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.BehaviorSubject = void 0;
    var Subject_1 = require_Subject();
    var BehaviorSubject = function(_super) {
      __extends3(BehaviorSubject2, _super);
      function BehaviorSubject2(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
      }
      Object.defineProperty(BehaviorSubject2.prototype, "value", {
        get: function() {
          return this.getValue();
        },
        enumerable: false,
        configurable: true
      });
      BehaviorSubject2.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
      };
      BehaviorSubject2.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) {
          throw thrownError;
        }
        this._throwIfClosed();
        return _value;
      };
      BehaviorSubject2.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
      };
      return BehaviorSubject2;
    }(Subject_1.Subject);
    exports2.BehaviorSubject = BehaviorSubject;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/dateTimestampProvider.js
var require_dateTimestampProvider = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/dateTimestampProvider.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.dateTimestampProvider = void 0;
    exports2.dateTimestampProvider = {
      now: function() {
        return (exports2.dateTimestampProvider.delegate || Date).now();
      },
      delegate: void 0
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/ReplaySubject.js
var require_ReplaySubject = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/ReplaySubject.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.ReplaySubject = void 0;
    var Subject_1 = require_Subject();
    var dateTimestampProvider_1 = require_dateTimestampProvider();
    var ReplaySubject = function(_super) {
      __extends3(ReplaySubject2, _super);
      function ReplaySubject2(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) {
          _bufferSize = Infinity;
        }
        if (_windowTime === void 0) {
          _windowTime = Infinity;
        }
        if (_timestampProvider === void 0) {
          _timestampProvider = dateTimestampProvider_1.dateTimestampProvider;
        }
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
      }
      ReplaySubject2.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
          _buffer.push(value);
          !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
      };
      ReplaySubject2.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for (var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2) {
          subscriber.next(copy[i]);
        }
        this._checkFinalizedStatuses(subscriber);
        return subscription;
      };
      ReplaySubject2.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
          var now = _timestampProvider.now();
          var last = 0;
          for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
            last = i;
          }
          last && _buffer.splice(0, last + 1);
        }
      };
      return ReplaySubject2;
    }(Subject_1.Subject);
    exports2.ReplaySubject = ReplaySubject;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/AsyncSubject.js
var require_AsyncSubject = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/AsyncSubject.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.AsyncSubject = void 0;
    var Subject_1 = require_Subject();
    var AsyncSubject = function(_super) {
      __extends3(AsyncSubject2, _super);
      function AsyncSubject2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = null;
        _this._hasValue = false;
        _this._isComplete = false;
        return _this;
      }
      AsyncSubject2.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, _hasValue = _a._hasValue, _value = _a._value, thrownError = _a.thrownError, isStopped = _a.isStopped, _isComplete = _a._isComplete;
        if (hasError) {
          subscriber.error(thrownError);
        } else if (isStopped || _isComplete) {
          _hasValue && subscriber.next(_value);
          subscriber.complete();
        }
      };
      AsyncSubject2.prototype.next = function(value) {
        if (!this.isStopped) {
          this._value = value;
          this._hasValue = true;
        }
      };
      AsyncSubject2.prototype.complete = function() {
        var _a = this, _hasValue = _a._hasValue, _value = _a._value, _isComplete = _a._isComplete;
        if (!_isComplete) {
          this._isComplete = true;
          _hasValue && _super.prototype.next.call(this, _value);
          _super.prototype.complete.call(this);
        }
      };
      return AsyncSubject2;
    }(Subject_1.Subject);
    exports2.AsyncSubject = AsyncSubject;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/Action.js
var require_Action = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/Action.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.Action = void 0;
    var Subscription_1 = require_Subscription();
    var Action = function(_super) {
      __extends3(Action2, _super);
      function Action2(scheduler, work) {
        return _super.call(this) || this;
      }
      Action2.prototype.schedule = function(state, delay2) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        return this;
      };
      return Action2;
    }(Subscription_1.Subscription);
    exports2.Action = Action;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/intervalProvider.js
var require_intervalProvider = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/intervalProvider.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.intervalProvider = void 0;
    exports2.intervalProvider = {
      setInterval: function(handler, timeout2) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
          args[_i - 2] = arguments[_i];
        }
        var delegate = exports2.intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) {
          return delegate.setInterval.apply(delegate, __spreadArray5([handler, timeout2], __read6(args)));
        }
        return setInterval.apply(void 0, __spreadArray5([handler, timeout2], __read6(args)));
      },
      clearInterval: function(handle) {
        var delegate = exports2.intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
      },
      delegate: void 0
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AsyncAction.js
var require_AsyncAction = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AsyncAction.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.AsyncAction = void 0;
    var Action_1 = require_Action();
    var intervalProvider_1 = require_intervalProvider();
    var arrRemove_1 = require_arrRemove();
    var AsyncAction = function(_super) {
      __extends3(AsyncAction2, _super);
      function AsyncAction2(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
      }
      AsyncAction2.prototype.schedule = function(state, delay2) {
        var _a;
        if (delay2 === void 0) {
          delay2 = 0;
        }
        if (this.closed) {
          return this;
        }
        this.state = state;
        var id2 = this.id;
        var scheduler = this.scheduler;
        if (id2 != null) {
          this.id = this.recycleAsyncId(scheduler, id2, delay2);
        }
        this.pending = true;
        this.delay = delay2;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay2);
        return this;
      };
      AsyncAction2.prototype.requestAsyncId = function(scheduler, _id, delay2) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        return intervalProvider_1.intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay2);
      };
      AsyncAction2.prototype.recycleAsyncId = function(_scheduler, id2, delay2) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        if (delay2 != null && this.delay === delay2 && this.pending === false) {
          return id2;
        }
        if (id2 != null) {
          intervalProvider_1.intervalProvider.clearInterval(id2);
        }
        return void 0;
      };
      AsyncAction2.prototype.execute = function(state, delay2) {
        if (this.closed) {
          return new Error("executing a cancelled action");
        }
        this.pending = false;
        var error = this._execute(state, delay2);
        if (error) {
          return error;
        } else if (this.pending === false && this.id != null) {
          this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
      };
      AsyncAction2.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
          this.work(state);
        } catch (e) {
          errored = true;
          errorValue = e ? e : new Error("Scheduled action threw falsy error");
        }
        if (errored) {
          this.unsubscribe();
          return errorValue;
        }
      };
      AsyncAction2.prototype.unsubscribe = function() {
        if (!this.closed) {
          var _a = this, id2 = _a.id, scheduler = _a.scheduler;
          var actions = scheduler.actions;
          this.work = this.state = this.scheduler = null;
          this.pending = false;
          arrRemove_1.arrRemove(actions, this);
          if (id2 != null) {
            this.id = this.recycleAsyncId(scheduler, id2, null);
          }
          this.delay = null;
          _super.prototype.unsubscribe.call(this);
        }
      };
      return AsyncAction2;
    }(Action_1.Action);
    exports2.AsyncAction = AsyncAction;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/Immediate.js
var require_Immediate = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/Immediate.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.TestTools = exports2.Immediate = void 0;
    var nextHandle = 1;
    var resolved;
    var activeHandles = {};
    function findAndClearHandle(handle) {
      if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
      }
      return false;
    }
    exports2.Immediate = {
      setImmediate: function(cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        if (!resolved) {
          resolved = Promise.resolve();
        }
        resolved.then(function() {
          return findAndClearHandle(handle) && cb();
        });
        return handle;
      },
      clearImmediate: function(handle) {
        findAndClearHandle(handle);
      }
    };
    exports2.TestTools = {
      pending: function() {
        return Object.keys(activeHandles).length;
      }
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/immediateProvider.js
var require_immediateProvider = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/immediateProvider.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.immediateProvider = void 0;
    var Immediate_1 = require_Immediate();
    var setImmediate = Immediate_1.Immediate.setImmediate;
    var clearImmediate = Immediate_1.Immediate.clearImmediate;
    exports2.immediateProvider = {
      setImmediate: function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var delegate = exports2.immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || setImmediate).apply(void 0, __spreadArray5([], __read6(args)));
      },
      clearImmediate: function(handle) {
        var delegate = exports2.immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || clearImmediate)(handle);
      },
      delegate: void 0
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AsapAction.js
var require_AsapAction = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AsapAction.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.AsapAction = void 0;
    var AsyncAction_1 = require_AsyncAction();
    var immediateProvider_1 = require_immediateProvider();
    var AsapAction = function(_super) {
      __extends3(AsapAction2, _super);
      function AsapAction2(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
      }
      AsapAction2.prototype.requestAsyncId = function(scheduler, id2, delay2) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        if (delay2 !== null && delay2 > 0) {
          return _super.prototype.requestAsyncId.call(this, scheduler, id2, delay2);
        }
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = immediateProvider_1.immediateProvider.setImmediate(scheduler.flush.bind(scheduler, void 0)));
      };
      AsapAction2.prototype.recycleAsyncId = function(scheduler, id2, delay2) {
        var _a;
        if (delay2 === void 0) {
          delay2 = 0;
        }
        if (delay2 != null ? delay2 > 0 : this.delay > 0) {
          return _super.prototype.recycleAsyncId.call(this, scheduler, id2, delay2);
        }
        var actions = scheduler.actions;
        if (id2 != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id2) {
          immediateProvider_1.immediateProvider.clearImmediate(id2);
          if (scheduler._scheduled === id2) {
            scheduler._scheduled = void 0;
          }
        }
        return void 0;
      };
      return AsapAction2;
    }(AsyncAction_1.AsyncAction);
    exports2.AsapAction = AsapAction;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Scheduler.js
var require_Scheduler = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Scheduler.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.Scheduler = void 0;
    var dateTimestampProvider_1 = require_dateTimestampProvider();
    var Scheduler = function() {
      function Scheduler2(schedulerActionCtor, now) {
        if (now === void 0) {
          now = Scheduler2.now;
        }
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
      }
      Scheduler2.prototype.schedule = function(work, delay2, state) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        return new this.schedulerActionCtor(this, work).schedule(state, delay2);
      };
      Scheduler2.now = dateTimestampProvider_1.dateTimestampProvider.now;
      return Scheduler2;
    }();
    exports2.Scheduler = Scheduler;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AsyncScheduler.js
var require_AsyncScheduler = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AsyncScheduler.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.AsyncScheduler = void 0;
    var Scheduler_1 = require_Scheduler();
    var AsyncScheduler = function(_super) {
      __extends3(AsyncScheduler2, _super);
      function AsyncScheduler2(SchedulerAction, now) {
        if (now === void 0) {
          now = Scheduler_1.Scheduler.now;
        }
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
      }
      AsyncScheduler2.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
          actions.push(action);
          return;
        }
        var error;
        this._active = true;
        do {
          if (error = action.execute(action.state, action.delay)) {
            break;
          }
        } while (action = actions.shift());
        this._active = false;
        if (error) {
          while (action = actions.shift()) {
            action.unsubscribe();
          }
          throw error;
        }
      };
      return AsyncScheduler2;
    }(Scheduler_1.Scheduler);
    exports2.AsyncScheduler = AsyncScheduler;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AsapScheduler.js
var require_AsapScheduler = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AsapScheduler.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.AsapScheduler = void 0;
    var AsyncScheduler_1 = require_AsyncScheduler();
    var AsapScheduler = function(_super) {
      __extends3(AsapScheduler2, _super);
      function AsapScheduler2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      AsapScheduler2.prototype.flush = function(action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = void 0;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
          if (error = action.execute(action.state, action.delay)) {
            break;
          }
        } while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
          while ((action = actions[0]) && action.id === flushId && actions.shift()) {
            action.unsubscribe();
          }
          throw error;
        }
      };
      return AsapScheduler2;
    }(AsyncScheduler_1.AsyncScheduler);
    exports2.AsapScheduler = AsapScheduler;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/asap.js
var require_asap = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/asap.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.asap = exports2.asapScheduler = void 0;
    var AsapAction_1 = require_AsapAction();
    var AsapScheduler_1 = require_AsapScheduler();
    exports2.asapScheduler = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
    exports2.asap = exports2.asapScheduler;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/async.js
var require_async = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/async.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.async = exports2.asyncScheduler = void 0;
    var AsyncAction_1 = require_AsyncAction();
    var AsyncScheduler_1 = require_AsyncScheduler();
    exports2.asyncScheduler = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
    exports2.async = exports2.asyncScheduler;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/QueueAction.js
var require_QueueAction = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/QueueAction.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.QueueAction = void 0;
    var AsyncAction_1 = require_AsyncAction();
    var QueueAction = function(_super) {
      __extends3(QueueAction2, _super);
      function QueueAction2(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
      }
      QueueAction2.prototype.schedule = function(state, delay2) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        if (delay2 > 0) {
          return _super.prototype.schedule.call(this, state, delay2);
        }
        this.delay = delay2;
        this.state = state;
        this.scheduler.flush(this);
        return this;
      };
      QueueAction2.prototype.execute = function(state, delay2) {
        return delay2 > 0 || this.closed ? _super.prototype.execute.call(this, state, delay2) : this._execute(state, delay2);
      };
      QueueAction2.prototype.requestAsyncId = function(scheduler, id2, delay2) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        if (delay2 != null && delay2 > 0 || delay2 == null && this.delay > 0) {
          return _super.prototype.requestAsyncId.call(this, scheduler, id2, delay2);
        }
        scheduler.flush(this);
        return 0;
      };
      return QueueAction2;
    }(AsyncAction_1.AsyncAction);
    exports2.QueueAction = QueueAction;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/QueueScheduler.js
var require_QueueScheduler = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/QueueScheduler.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.QueueScheduler = void 0;
    var AsyncScheduler_1 = require_AsyncScheduler();
    var QueueScheduler = function(_super) {
      __extends3(QueueScheduler2, _super);
      function QueueScheduler2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      return QueueScheduler2;
    }(AsyncScheduler_1.AsyncScheduler);
    exports2.QueueScheduler = QueueScheduler;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/queue.js
var require_queue = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/queue.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.queue = exports2.queueScheduler = void 0;
    var QueueAction_1 = require_QueueAction();
    var QueueScheduler_1 = require_QueueScheduler();
    exports2.queueScheduler = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
    exports2.queue = exports2.queueScheduler;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AnimationFrameAction.js
var require_AnimationFrameAction = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AnimationFrameAction.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.AnimationFrameAction = void 0;
    var AsyncAction_1 = require_AsyncAction();
    var animationFrameProvider_1 = require_animationFrameProvider();
    var AnimationFrameAction = function(_super) {
      __extends3(AnimationFrameAction2, _super);
      function AnimationFrameAction2(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
      }
      AnimationFrameAction2.prototype.requestAsyncId = function(scheduler, id2, delay2) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        if (delay2 !== null && delay2 > 0) {
          return _super.prototype.requestAsyncId.call(this, scheduler, id2, delay2);
        }
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = animationFrameProvider_1.animationFrameProvider.requestAnimationFrame(function() {
          return scheduler.flush(void 0);
        }));
      };
      AnimationFrameAction2.prototype.recycleAsyncId = function(scheduler, id2, delay2) {
        var _a;
        if (delay2 === void 0) {
          delay2 = 0;
        }
        if (delay2 != null ? delay2 > 0 : this.delay > 0) {
          return _super.prototype.recycleAsyncId.call(this, scheduler, id2, delay2);
        }
        var actions = scheduler.actions;
        if (id2 != null && id2 === scheduler._scheduled && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id2) {
          animationFrameProvider_1.animationFrameProvider.cancelAnimationFrame(id2);
          scheduler._scheduled = void 0;
        }
        return void 0;
      };
      return AnimationFrameAction2;
    }(AsyncAction_1.AsyncAction);
    exports2.AnimationFrameAction = AnimationFrameAction;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AnimationFrameScheduler.js
var require_AnimationFrameScheduler = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/AnimationFrameScheduler.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.AnimationFrameScheduler = void 0;
    var AsyncScheduler_1 = require_AsyncScheduler();
    var AnimationFrameScheduler = function(_super) {
      __extends3(AnimationFrameScheduler2, _super);
      function AnimationFrameScheduler2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      AnimationFrameScheduler2.prototype.flush = function(action) {
        this._active = true;
        var flushId;
        if (action) {
          flushId = action.id;
        } else {
          flushId = this._scheduled;
          this._scheduled = void 0;
        }
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
          if (error = action.execute(action.state, action.delay)) {
            break;
          }
        } while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
          while ((action = actions[0]) && action.id === flushId && actions.shift()) {
            action.unsubscribe();
          }
          throw error;
        }
      };
      return AnimationFrameScheduler2;
    }(AsyncScheduler_1.AsyncScheduler);
    exports2.AnimationFrameScheduler = AnimationFrameScheduler;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/animationFrame.js
var require_animationFrame = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/animationFrame.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.animationFrame = exports2.animationFrameScheduler = void 0;
    var AnimationFrameAction_1 = require_AnimationFrameAction();
    var AnimationFrameScheduler_1 = require_AnimationFrameScheduler();
    exports2.animationFrameScheduler = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
    exports2.animationFrame = exports2.animationFrameScheduler;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/VirtualTimeScheduler.js
var require_VirtualTimeScheduler = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduler/VirtualTimeScheduler.js"(exports2) {
    "use strict";
    var __extends3 = exports2 && exports2.__extends || /* @__PURE__ */ function() {
      var extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics3(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.VirtualAction = exports2.VirtualTimeScheduler = void 0;
    var AsyncAction_1 = require_AsyncAction();
    var Subscription_1 = require_Subscription();
    var AsyncScheduler_1 = require_AsyncScheduler();
    var VirtualTimeScheduler = function(_super) {
      __extends3(VirtualTimeScheduler2, _super);
      function VirtualTimeScheduler2(schedulerActionCtor, maxFrames) {
        if (schedulerActionCtor === void 0) {
          schedulerActionCtor = VirtualAction;
        }
        if (maxFrames === void 0) {
          maxFrames = Infinity;
        }
        var _this = _super.call(this, schedulerActionCtor, function() {
          return _this.frame;
        }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
      }
      VirtualTimeScheduler2.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error;
        var action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
          actions.shift();
          this.frame = action.delay;
          if (error = action.execute(action.state, action.delay)) {
            break;
          }
        }
        if (error) {
          while (action = actions.shift()) {
            action.unsubscribe();
          }
          throw error;
        }
      };
      VirtualTimeScheduler2.frameTimeFactor = 10;
      return VirtualTimeScheduler2;
    }(AsyncScheduler_1.AsyncScheduler);
    exports2.VirtualTimeScheduler = VirtualTimeScheduler;
    var VirtualAction = function(_super) {
      __extends3(VirtualAction2, _super);
      function VirtualAction2(scheduler, work, index2) {
        if (index2 === void 0) {
          index2 = scheduler.index += 1;
        }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index2;
        _this.active = true;
        _this.index = scheduler.index = index2;
        return _this;
      }
      VirtualAction2.prototype.schedule = function(state, delay2) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        if (Number.isFinite(delay2)) {
          if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay2);
          }
          this.active = false;
          var action = new VirtualAction2(this.scheduler, this.work);
          this.add(action);
          return action.schedule(state, delay2);
        } else {
          return Subscription_1.Subscription.EMPTY;
        }
      };
      VirtualAction2.prototype.requestAsyncId = function(scheduler, id2, delay2) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        this.delay = scheduler.frame + delay2;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction2.sortActions);
        return 1;
      };
      VirtualAction2.prototype.recycleAsyncId = function(scheduler, id2, delay2) {
        if (delay2 === void 0) {
          delay2 = 0;
        }
        return void 0;
      };
      VirtualAction2.prototype._execute = function(state, delay2) {
        if (this.active === true) {
          return _super.prototype._execute.call(this, state, delay2);
        }
      };
      VirtualAction2.sortActions = function(a, b) {
        if (a.delay === b.delay) {
          if (a.index === b.index) {
            return 0;
          } else if (a.index > b.index) {
            return 1;
          } else {
            return -1;
          }
        } else if (a.delay > b.delay) {
          return 1;
        } else {
          return -1;
        }
      };
      return VirtualAction2;
    }(AsyncAction_1.AsyncAction);
    exports2.VirtualAction = VirtualAction;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/empty.js
var require_empty = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/empty.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.empty = exports2.EMPTY = void 0;
    var Observable_1 = require_Observable();
    exports2.EMPTY = new Observable_1.Observable(function(subscriber) {
      return subscriber.complete();
    });
    function empty(scheduler) {
      return scheduler ? emptyScheduled(scheduler) : exports2.EMPTY;
    }
    exports2.empty = empty;
    function emptyScheduled(scheduler) {
      return new Observable_1.Observable(function(subscriber) {
        return scheduler.schedule(function() {
          return subscriber.complete();
        });
      });
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isScheduler.js
var require_isScheduler = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isScheduler.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isScheduler = void 0;
    var isFunction_1 = require_isFunction();
    function isScheduler(value) {
      return value && isFunction_1.isFunction(value.schedule);
    }
    exports2.isScheduler = isScheduler;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/args.js
var require_args = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/args.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.popNumber = exports2.popScheduler = exports2.popResultSelector = void 0;
    var isFunction_1 = require_isFunction();
    var isScheduler_1 = require_isScheduler();
    function last(arr) {
      return arr[arr.length - 1];
    }
    function popResultSelector(args) {
      return isFunction_1.isFunction(last(args)) ? args.pop() : void 0;
    }
    exports2.popResultSelector = popResultSelector;
    function popScheduler(args) {
      return isScheduler_1.isScheduler(last(args)) ? args.pop() : void 0;
    }
    exports2.popScheduler = popScheduler;
    function popNumber(args, defaultValue) {
      return typeof last(args) === "number" ? args.pop() : defaultValue;
    }
    exports2.popNumber = popNumber;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isArrayLike.js
var require_isArrayLike = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isArrayLike.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isArrayLike = void 0;
    exports2.isArrayLike = function(x) {
      return x && typeof x.length === "number" && typeof x !== "function";
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isPromise.js
var require_isPromise = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isPromise.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isPromise = void 0;
    var isFunction_1 = require_isFunction();
    function isPromise(value) {
      return isFunction_1.isFunction(value === null || value === void 0 ? void 0 : value.then);
    }
    exports2.isPromise = isPromise;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isInteropObservable.js
var require_isInteropObservable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isInteropObservable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isInteropObservable = void 0;
    var observable_1 = require_observable();
    var isFunction_1 = require_isFunction();
    function isInteropObservable(input) {
      return isFunction_1.isFunction(input[observable_1.observable]);
    }
    exports2.isInteropObservable = isInteropObservable;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isAsyncIterable.js
var require_isAsyncIterable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isAsyncIterable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isAsyncIterable = void 0;
    var isFunction_1 = require_isFunction();
    function isAsyncIterable(obj) {
      return Symbol.asyncIterator && isFunction_1.isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
    }
    exports2.isAsyncIterable = isAsyncIterable;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/throwUnobservableError.js
var require_throwUnobservableError = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/throwUnobservableError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createInvalidObservableTypeError = void 0;
    function createInvalidObservableTypeError(input) {
      return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
    }
    exports2.createInvalidObservableTypeError = createInvalidObservableTypeError;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/symbol/iterator.js
var require_iterator = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/symbol/iterator.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.iterator = exports2.getSymbolIterator = void 0;
    function getSymbolIterator() {
      if (typeof Symbol !== "function" || !Symbol.iterator) {
        return "@@iterator";
      }
      return Symbol.iterator;
    }
    exports2.getSymbolIterator = getSymbolIterator;
    exports2.iterator = getSymbolIterator();
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isIterable.js
var require_isIterable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isIterable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isIterable = void 0;
    var iterator_1 = require_iterator();
    var isFunction_1 = require_isFunction();
    function isIterable(input) {
      return isFunction_1.isFunction(input === null || input === void 0 ? void 0 : input[iterator_1.iterator]);
    }
    exports2.isIterable = isIterable;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isReadableStreamLike.js
var require_isReadableStreamLike = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isReadableStreamLike.js"(exports2) {
    "use strict";
    var __generator7 = exports2 && exports2.__generator || function(thisArg, body) {
      var _ = { label: 0, sent: function() {
        if (t[0] & 1) throw t[1];
        return t[1];
      }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
      }), g;
      function verb(n) {
        return function(v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return { value: op[1], done: false };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2]) _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    var __await = exports2 && exports2.__await || function(v) {
      return this instanceof __await ? (this.v = v, this) : new __await(v);
    };
    var __asyncGenerator = exports2 && exports2.__asyncGenerator || function(thisArg, _arguments, generator) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var g = generator.apply(thisArg, _arguments || []), i, q = [];
      return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
      }, i;
      function verb(n) {
        if (g[n]) i[n] = function(v) {
          return new Promise(function(a, b) {
            q.push([n, v, a, b]) > 1 || resume(n, v);
          });
        };
      }
      function resume(n, v) {
        try {
          step(g[n](v));
        } catch (e) {
          settle(q[0][3], e);
        }
      }
      function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
      }
      function fulfill(value) {
        resume("next", value);
      }
      function reject(value) {
        resume("throw", value);
      }
      function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
      }
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isReadableStreamLike = exports2.readableStreamLikeToAsyncGenerator = void 0;
    var isFunction_1 = require_isFunction();
    function readableStreamLikeToAsyncGenerator(readableStream) {
      return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return __generator7(this, function(_b) {
          switch (_b.label) {
            case 0:
              reader = readableStream.getReader();
              _b.label = 1;
            case 1:
              _b.trys.push([1, , 9, 10]);
              _b.label = 2;
            case 2:
              if (false) return [3, 8];
              return [4, __await(reader.read())];
            case 3:
              _a = _b.sent(), value = _a.value, done = _a.done;
              if (!done) return [3, 5];
              return [4, __await(void 0)];
            case 4:
              return [2, _b.sent()];
            case 5:
              return [4, __await(value)];
            case 6:
              return [4, _b.sent()];
            case 7:
              _b.sent();
              return [3, 2];
            case 8:
              return [3, 10];
            case 9:
              reader.releaseLock();
              return [7];
            case 10:
              return [2];
          }
        });
      });
    }
    exports2.readableStreamLikeToAsyncGenerator = readableStreamLikeToAsyncGenerator;
    function isReadableStreamLike(obj) {
      return isFunction_1.isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
    }
    exports2.isReadableStreamLike = isReadableStreamLike;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/innerFrom.js
var require_innerFrom = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/innerFrom.js"(exports2) {
    "use strict";
    var __awaiter7 = exports2 && exports2.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    var __generator7 = exports2 && exports2.__generator || function(thisArg, body) {
      var _ = { label: 0, sent: function() {
        if (t[0] & 1) throw t[1];
        return t[1];
      }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
      }), g;
      function verb(n) {
        return function(v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return { value: op[1], done: false };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2]) _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    var __asyncValues = exports2 && exports2.__asyncValues || function(o) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var m = o[Symbol.asyncIterator], i;
      return m ? m.call(o) : (o = typeof __values5 === "function" ? __values5(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
      }, i);
      function verb(n) {
        i[n] = o[n] && function(v) {
          return new Promise(function(resolve, reject) {
            v = o[n](v), settle(resolve, reject, v.done, v.value);
          });
        };
      }
      function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v2) {
          resolve({ value: v2, done: d });
        }, reject);
      }
    };
    var __values5 = exports2 && exports2.__values || function(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
        next: function() {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
        }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.fromReadableStreamLike = exports2.fromAsyncIterable = exports2.fromIterable = exports2.fromPromise = exports2.fromArrayLike = exports2.fromInteropObservable = exports2.innerFrom = void 0;
    var isArrayLike_1 = require_isArrayLike();
    var isPromise_1 = require_isPromise();
    var Observable_1 = require_Observable();
    var isInteropObservable_1 = require_isInteropObservable();
    var isAsyncIterable_1 = require_isAsyncIterable();
    var throwUnobservableError_1 = require_throwUnobservableError();
    var isIterable_1 = require_isIterable();
    var isReadableStreamLike_1 = require_isReadableStreamLike();
    var isFunction_1 = require_isFunction();
    var reportUnhandledError_1 = require_reportUnhandledError();
    var observable_1 = require_observable();
    function innerFrom(input) {
      if (input instanceof Observable_1.Observable) {
        return input;
      }
      if (input != null) {
        if (isInteropObservable_1.isInteropObservable(input)) {
          return fromInteropObservable(input);
        }
        if (isArrayLike_1.isArrayLike(input)) {
          return fromArrayLike(input);
        }
        if (isPromise_1.isPromise(input)) {
          return fromPromise(input);
        }
        if (isAsyncIterable_1.isAsyncIterable(input)) {
          return fromAsyncIterable(input);
        }
        if (isIterable_1.isIterable(input)) {
          return fromIterable(input);
        }
        if (isReadableStreamLike_1.isReadableStreamLike(input)) {
          return fromReadableStreamLike(input);
        }
      }
      throw throwUnobservableError_1.createInvalidObservableTypeError(input);
    }
    exports2.innerFrom = innerFrom;
    function fromInteropObservable(obj) {
      return new Observable_1.Observable(function(subscriber) {
        var obs = obj[observable_1.observable]();
        if (isFunction_1.isFunction(obs.subscribe)) {
          return obs.subscribe(subscriber);
        }
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
      });
    }
    exports2.fromInteropObservable = fromInteropObservable;
    function fromArrayLike(array) {
      return new Observable_1.Observable(function(subscriber) {
        for (var i = 0; i < array.length && !subscriber.closed; i++) {
          subscriber.next(array[i]);
        }
        subscriber.complete();
      });
    }
    exports2.fromArrayLike = fromArrayLike;
    function fromPromise(promise) {
      return new Observable_1.Observable(function(subscriber) {
        promise.then(function(value) {
          if (!subscriber.closed) {
            subscriber.next(value);
            subscriber.complete();
          }
        }, function(err) {
          return subscriber.error(err);
        }).then(null, reportUnhandledError_1.reportUnhandledError);
      });
    }
    exports2.fromPromise = fromPromise;
    function fromIterable(iterable) {
      return new Observable_1.Observable(function(subscriber) {
        var e_1, _a;
        try {
          for (var iterable_1 = __values5(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
            var value = iterable_1_1.value;
            subscriber.next(value);
            if (subscriber.closed) {
              return;
            }
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        subscriber.complete();
      });
    }
    exports2.fromIterable = fromIterable;
    function fromAsyncIterable(asyncIterable) {
      return new Observable_1.Observable(function(subscriber) {
        process2(asyncIterable, subscriber).catch(function(err) {
          return subscriber.error(err);
        });
      });
    }
    exports2.fromAsyncIterable = fromAsyncIterable;
    function fromReadableStreamLike(readableStream) {
      return fromAsyncIterable(isReadableStreamLike_1.readableStreamLikeToAsyncGenerator(readableStream));
    }
    exports2.fromReadableStreamLike = fromReadableStreamLike;
    function process2(asyncIterable, subscriber) {
      var asyncIterable_1, asyncIterable_1_1;
      var e_2, _a;
      return __awaiter7(this, void 0, void 0, function() {
        var value, e_2_1;
        return __generator7(this, function(_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 5, 6, 11]);
              asyncIterable_1 = __asyncValues(asyncIterable);
              _b.label = 1;
            case 1:
              return [4, asyncIterable_1.next()];
            case 2:
              if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
              value = asyncIterable_1_1.value;
              subscriber.next(value);
              if (subscriber.closed) {
                return [2];
              }
              _b.label = 3;
            case 3:
              return [3, 1];
            case 4:
              return [3, 11];
            case 5:
              e_2_1 = _b.sent();
              e_2 = { error: e_2_1 };
              return [3, 11];
            case 6:
              _b.trys.push([6, , 9, 10]);
              if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
              return [4, _a.call(asyncIterable_1)];
            case 7:
              _b.sent();
              _b.label = 8;
            case 8:
              return [3, 10];
            case 9:
              if (e_2) throw e_2.error;
              return [7];
            case 10:
              return [7];
            case 11:
              subscriber.complete();
              return [2];
          }
        });
      });
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/executeSchedule.js
var require_executeSchedule = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/executeSchedule.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.executeSchedule = void 0;
    function executeSchedule(parentSubscription, scheduler, work, delay2, repeat) {
      if (delay2 === void 0) {
        delay2 = 0;
      }
      if (repeat === void 0) {
        repeat = false;
      }
      var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) {
          parentSubscription.add(this.schedule(null, delay2));
        } else {
          this.unsubscribe();
        }
      }, delay2);
      parentSubscription.add(scheduleSubscription);
      if (!repeat) {
        return scheduleSubscription;
      }
    }
    exports2.executeSchedule = executeSchedule;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/observeOn.js
var require_observeOn = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/observeOn.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.observeOn = void 0;
    var executeSchedule_1 = require_executeSchedule();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function observeOn(scheduler, delay2) {
      if (delay2 === void 0) {
        delay2 = 0;
      }
      return lift_1.operate(function(source, subscriber) {
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          return executeSchedule_1.executeSchedule(subscriber, scheduler, function() {
            return subscriber.next(value);
          }, delay2);
        }, function() {
          return executeSchedule_1.executeSchedule(subscriber, scheduler, function() {
            return subscriber.complete();
          }, delay2);
        }, function(err) {
          return executeSchedule_1.executeSchedule(subscriber, scheduler, function() {
            return subscriber.error(err);
          }, delay2);
        }));
      });
    }
    exports2.observeOn = observeOn;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/subscribeOn.js
var require_subscribeOn = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/subscribeOn.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.subscribeOn = void 0;
    var lift_1 = require_lift();
    function subscribeOn(scheduler, delay2) {
      if (delay2 === void 0) {
        delay2 = 0;
      }
      return lift_1.operate(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
          return source.subscribe(subscriber);
        }, delay2));
      });
    }
    exports2.subscribeOn = subscribeOn;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduleObservable.js
var require_scheduleObservable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduleObservable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.scheduleObservable = void 0;
    var innerFrom_1 = require_innerFrom();
    var observeOn_1 = require_observeOn();
    var subscribeOn_1 = require_subscribeOn();
    function scheduleObservable(input, scheduler) {
      return innerFrom_1.innerFrom(input).pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
    }
    exports2.scheduleObservable = scheduleObservable;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/schedulePromise.js
var require_schedulePromise = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/schedulePromise.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.schedulePromise = void 0;
    var innerFrom_1 = require_innerFrom();
    var observeOn_1 = require_observeOn();
    var subscribeOn_1 = require_subscribeOn();
    function schedulePromise(input, scheduler) {
      return innerFrom_1.innerFrom(input).pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
    }
    exports2.schedulePromise = schedulePromise;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduleArray.js
var require_scheduleArray = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduleArray.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.scheduleArray = void 0;
    var Observable_1 = require_Observable();
    function scheduleArray(input, scheduler) {
      return new Observable_1.Observable(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
          if (i === input.length) {
            subscriber.complete();
          } else {
            subscriber.next(input[i++]);
            if (!subscriber.closed) {
              this.schedule();
            }
          }
        });
      });
    }
    exports2.scheduleArray = scheduleArray;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduleIterable.js
var require_scheduleIterable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduleIterable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.scheduleIterable = void 0;
    var Observable_1 = require_Observable();
    var iterator_1 = require_iterator();
    var isFunction_1 = require_isFunction();
    var executeSchedule_1 = require_executeSchedule();
    function scheduleIterable(input, scheduler) {
      return new Observable_1.Observable(function(subscriber) {
        var iterator;
        executeSchedule_1.executeSchedule(subscriber, scheduler, function() {
          iterator = input[iterator_1.iterator]();
          executeSchedule_1.executeSchedule(subscriber, scheduler, function() {
            var _a;
            var value;
            var done;
            try {
              _a = iterator.next(), value = _a.value, done = _a.done;
            } catch (err) {
              subscriber.error(err);
              return;
            }
            if (done) {
              subscriber.complete();
            } else {
              subscriber.next(value);
            }
          }, 0, true);
        });
        return function() {
          return isFunction_1.isFunction(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
      });
    }
    exports2.scheduleIterable = scheduleIterable;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduleAsyncIterable.js
var require_scheduleAsyncIterable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduleAsyncIterable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.scheduleAsyncIterable = void 0;
    var Observable_1 = require_Observable();
    var executeSchedule_1 = require_executeSchedule();
    function scheduleAsyncIterable(input, scheduler) {
      if (!input) {
        throw new Error("Iterable cannot be null");
      }
      return new Observable_1.Observable(function(subscriber) {
        executeSchedule_1.executeSchedule(subscriber, scheduler, function() {
          var iterator = input[Symbol.asyncIterator]();
          executeSchedule_1.executeSchedule(subscriber, scheduler, function() {
            iterator.next().then(function(result) {
              if (result.done) {
                subscriber.complete();
              } else {
                subscriber.next(result.value);
              }
            });
          }, 0, true);
        });
      });
    }
    exports2.scheduleAsyncIterable = scheduleAsyncIterable;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduleReadableStreamLike.js
var require_scheduleReadableStreamLike = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduleReadableStreamLike.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.scheduleReadableStreamLike = void 0;
    var scheduleAsyncIterable_1 = require_scheduleAsyncIterable();
    var isReadableStreamLike_1 = require_isReadableStreamLike();
    function scheduleReadableStreamLike(input, scheduler) {
      return scheduleAsyncIterable_1.scheduleAsyncIterable(isReadableStreamLike_1.readableStreamLikeToAsyncGenerator(input), scheduler);
    }
    exports2.scheduleReadableStreamLike = scheduleReadableStreamLike;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduled.js
var require_scheduled = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/scheduled/scheduled.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.scheduled = void 0;
    var scheduleObservable_1 = require_scheduleObservable();
    var schedulePromise_1 = require_schedulePromise();
    var scheduleArray_1 = require_scheduleArray();
    var scheduleIterable_1 = require_scheduleIterable();
    var scheduleAsyncIterable_1 = require_scheduleAsyncIterable();
    var isInteropObservable_1 = require_isInteropObservable();
    var isPromise_1 = require_isPromise();
    var isArrayLike_1 = require_isArrayLike();
    var isIterable_1 = require_isIterable();
    var isAsyncIterable_1 = require_isAsyncIterable();
    var throwUnobservableError_1 = require_throwUnobservableError();
    var isReadableStreamLike_1 = require_isReadableStreamLike();
    var scheduleReadableStreamLike_1 = require_scheduleReadableStreamLike();
    function scheduled(input, scheduler) {
      if (input != null) {
        if (isInteropObservable_1.isInteropObservable(input)) {
          return scheduleObservable_1.scheduleObservable(input, scheduler);
        }
        if (isArrayLike_1.isArrayLike(input)) {
          return scheduleArray_1.scheduleArray(input, scheduler);
        }
        if (isPromise_1.isPromise(input)) {
          return schedulePromise_1.schedulePromise(input, scheduler);
        }
        if (isAsyncIterable_1.isAsyncIterable(input)) {
          return scheduleAsyncIterable_1.scheduleAsyncIterable(input, scheduler);
        }
        if (isIterable_1.isIterable(input)) {
          return scheduleIterable_1.scheduleIterable(input, scheduler);
        }
        if (isReadableStreamLike_1.isReadableStreamLike(input)) {
          return scheduleReadableStreamLike_1.scheduleReadableStreamLike(input, scheduler);
        }
      }
      throw throwUnobservableError_1.createInvalidObservableTypeError(input);
    }
    exports2.scheduled = scheduled;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/from.js
var require_from = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/from.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.from = void 0;
    var scheduled_1 = require_scheduled();
    var innerFrom_1 = require_innerFrom();
    function from(input, scheduler) {
      return scheduler ? scheduled_1.scheduled(input, scheduler) : innerFrom_1.innerFrom(input);
    }
    exports2.from = from;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/of.js
var require_of = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/of.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.of = void 0;
    var args_1 = require_args();
    var from_1 = require_from();
    function of() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var scheduler = args_1.popScheduler(args);
      return from_1.from(args, scheduler);
    }
    exports2.of = of;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/throwError.js
var require_throwError = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/throwError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.throwError = void 0;
    var Observable_1 = require_Observable();
    var isFunction_1 = require_isFunction();
    function throwError(errorOrErrorFactory, scheduler) {
      var errorFactory = isFunction_1.isFunction(errorOrErrorFactory) ? errorOrErrorFactory : function() {
        return errorOrErrorFactory;
      };
      var init2 = function(subscriber) {
        return subscriber.error(errorFactory());
      };
      return new Observable_1.Observable(scheduler ? function(subscriber) {
        return scheduler.schedule(init2, 0, subscriber);
      } : init2);
    }
    exports2.throwError = throwError;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Notification.js
var require_Notification = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/Notification.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.observeNotification = exports2.Notification = exports2.NotificationKind = void 0;
    var empty_1 = require_empty();
    var of_1 = require_of();
    var throwError_1 = require_throwError();
    var isFunction_1 = require_isFunction();
    var NotificationKind;
    (function(NotificationKind2) {
      NotificationKind2["NEXT"] = "N";
      NotificationKind2["ERROR"] = "E";
      NotificationKind2["COMPLETE"] = "C";
    })(NotificationKind = exports2.NotificationKind || (exports2.NotificationKind = {}));
    var Notification = function() {
      function Notification2(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
      }
      Notification2.prototype.observe = function(observer) {
        return observeNotification(this, observer);
      };
      Notification2.prototype.do = function(nextHandler, errorHandler, completeHandler) {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        return kind === "N" ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === "E" ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
      };
      Notification2.prototype.accept = function(nextOrObserver, error, complete) {
        var _a;
        return isFunction_1.isFunction((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next) ? this.observe(nextOrObserver) : this.do(nextOrObserver, error, complete);
      };
      Notification2.prototype.toObservable = function() {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        var result = kind === "N" ? of_1.of(value) : kind === "E" ? throwError_1.throwError(function() {
          return error;
        }) : kind === "C" ? empty_1.EMPTY : 0;
        if (!result) {
          throw new TypeError("Unexpected notification kind " + kind);
        }
        return result;
      };
      Notification2.createNext = function(value) {
        return new Notification2("N", value);
      };
      Notification2.createError = function(err) {
        return new Notification2("E", void 0, err);
      };
      Notification2.createComplete = function() {
        return Notification2.completeNotification;
      };
      Notification2.completeNotification = new Notification2("C");
      return Notification2;
    }();
    exports2.Notification = Notification;
    function observeNotification(notification, observer) {
      var _a, _b, _c;
      var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
      if (typeof kind !== "string") {
        throw new TypeError('Invalid notification, missing "kind"');
      }
      kind === "N" ? (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, value) : kind === "E" ? (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
    }
    exports2.observeNotification = observeNotification;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isObservable.js
var require_isObservable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isObservable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isObservable = void 0;
    var Observable_1 = require_Observable();
    var isFunction_1 = require_isFunction();
    function isObservable(obj) {
      return !!obj && (obj instanceof Observable_1.Observable || isFunction_1.isFunction(obj.lift) && isFunction_1.isFunction(obj.subscribe));
    }
    exports2.isObservable = isObservable;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/EmptyError.js
var require_EmptyError = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/EmptyError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.EmptyError = void 0;
    var createErrorClass_1 = require_createErrorClass();
    exports2.EmptyError = createErrorClass_1.createErrorClass(function(_super) {
      return function EmptyErrorImpl() {
        _super(this);
        this.name = "EmptyError";
        this.message = "no elements in sequence";
      };
    });
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/lastValueFrom.js
var require_lastValueFrom = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/lastValueFrom.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.lastValueFrom = void 0;
    var EmptyError_1 = require_EmptyError();
    function lastValueFrom(source, config2) {
      var hasConfig = typeof config2 === "object";
      return new Promise(function(resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
          next: function(value) {
            _value = value;
            _hasValue = true;
          },
          error: reject,
          complete: function() {
            if (_hasValue) {
              resolve(_value);
            } else if (hasConfig) {
              resolve(config2.defaultValue);
            } else {
              reject(new EmptyError_1.EmptyError());
            }
          }
        });
      });
    }
    exports2.lastValueFrom = lastValueFrom;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/firstValueFrom.js
var require_firstValueFrom = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/firstValueFrom.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.firstValueFrom = void 0;
    var EmptyError_1 = require_EmptyError();
    var Subscriber_1 = require_Subscriber();
    function firstValueFrom(source, config2) {
      var hasConfig = typeof config2 === "object";
      return new Promise(function(resolve, reject) {
        var subscriber = new Subscriber_1.SafeSubscriber({
          next: function(value) {
            resolve(value);
            subscriber.unsubscribe();
          },
          error: reject,
          complete: function() {
            if (hasConfig) {
              resolve(config2.defaultValue);
            } else {
              reject(new EmptyError_1.EmptyError());
            }
          }
        });
        source.subscribe(subscriber);
      });
    }
    exports2.firstValueFrom = firstValueFrom;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/ArgumentOutOfRangeError.js
var require_ArgumentOutOfRangeError = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/ArgumentOutOfRangeError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.ArgumentOutOfRangeError = void 0;
    var createErrorClass_1 = require_createErrorClass();
    exports2.ArgumentOutOfRangeError = createErrorClass_1.createErrorClass(function(_super) {
      return function ArgumentOutOfRangeErrorImpl() {
        _super(this);
        this.name = "ArgumentOutOfRangeError";
        this.message = "argument out of range";
      };
    });
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/NotFoundError.js
var require_NotFoundError = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/NotFoundError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.NotFoundError = void 0;
    var createErrorClass_1 = require_createErrorClass();
    exports2.NotFoundError = createErrorClass_1.createErrorClass(function(_super) {
      return function NotFoundErrorImpl(message) {
        _super(this);
        this.name = "NotFoundError";
        this.message = message;
      };
    });
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/SequenceError.js
var require_SequenceError = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/SequenceError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.SequenceError = void 0;
    var createErrorClass_1 = require_createErrorClass();
    exports2.SequenceError = createErrorClass_1.createErrorClass(function(_super) {
      return function SequenceErrorImpl(message) {
        _super(this);
        this.name = "SequenceError";
        this.message = message;
      };
    });
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isDate.js
var require_isDate = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/isDate.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isValidDate = void 0;
    function isValidDate(value) {
      return value instanceof Date && !isNaN(value);
    }
    exports2.isValidDate = isValidDate;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/timeout.js
var require_timeout = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/timeout.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.timeout = exports2.TimeoutError = void 0;
    var async_1 = require_async();
    var isDate_1 = require_isDate();
    var lift_1 = require_lift();
    var innerFrom_1 = require_innerFrom();
    var createErrorClass_1 = require_createErrorClass();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var executeSchedule_1 = require_executeSchedule();
    exports2.TimeoutError = createErrorClass_1.createErrorClass(function(_super) {
      return function TimeoutErrorImpl(info) {
        if (info === void 0) {
          info = null;
        }
        _super(this);
        this.message = "Timeout has occurred";
        this.name = "TimeoutError";
        this.info = info;
      };
    });
    function timeout2(config2, schedulerArg) {
      var _a = isDate_1.isValidDate(config2) ? { first: config2 } : typeof config2 === "number" ? { each: config2 } : config2, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : async_1.asyncScheduler : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
      if (first == null && each == null) {
        throw new TypeError("No timeout provided.");
      }
      return lift_1.operate(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function(delay2) {
          timerSubscription = executeSchedule_1.executeSchedule(subscriber, scheduler, function() {
            try {
              originalSourceSubscription.unsubscribe();
              innerFrom_1.innerFrom(_with({
                meta,
                lastValue,
                seen
              })).subscribe(subscriber);
            } catch (err) {
              subscriber.error(err);
            }
          }, delay2);
        };
        originalSourceSubscription = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
          seen++;
          subscriber.next(lastValue = value);
          each > 0 && startTimer(each);
        }, void 0, void 0, function() {
          if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) {
            timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
          }
          lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === "number" ? first : +first - scheduler.now() : each);
      });
    }
    exports2.timeout = timeout2;
    function timeoutErrorFactory(info) {
      throw new exports2.TimeoutError(info);
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/map.js
var require_map = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/map.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.map = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function map4(project, thisArg) {
      return lift_1.operate(function(source, subscriber) {
        var index2 = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          subscriber.next(project.call(thisArg, value, index2++));
        }));
      });
    }
    exports2.map = map4;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/mapOneOrManyArgs.js
var require_mapOneOrManyArgs = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/mapOneOrManyArgs.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.mapOneOrManyArgs = void 0;
    var map_1 = require_map();
    var isArray = Array.isArray;
    function callOrApply(fn, args) {
      return isArray(args) ? fn.apply(void 0, __spreadArray5([], __read6(args))) : fn(args);
    }
    function mapOneOrManyArgs(fn) {
      return map_1.map(function(args) {
        return callOrApply(fn, args);
      });
    }
    exports2.mapOneOrManyArgs = mapOneOrManyArgs;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/bindCallbackInternals.js
var require_bindCallbackInternals = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/bindCallbackInternals.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.bindCallbackInternals = void 0;
    var isScheduler_1 = require_isScheduler();
    var Observable_1 = require_Observable();
    var subscribeOn_1 = require_subscribeOn();
    var mapOneOrManyArgs_1 = require_mapOneOrManyArgs();
    var observeOn_1 = require_observeOn();
    var AsyncSubject_1 = require_AsyncSubject();
    function bindCallbackInternals(isNodeStyle, callbackFunc, resultSelector, scheduler) {
      if (resultSelector) {
        if (isScheduler_1.isScheduler(resultSelector)) {
          scheduler = resultSelector;
        } else {
          return function() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return bindCallbackInternals(isNodeStyle, callbackFunc, scheduler).apply(this, args).pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
          };
        }
      }
      if (scheduler) {
        return function() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return bindCallbackInternals(isNodeStyle, callbackFunc).apply(this, args).pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
        };
      }
      return function() {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var subject = new AsyncSubject_1.AsyncSubject();
        var uninitialized = true;
        return new Observable_1.Observable(function(subscriber) {
          var subs = subject.subscribe(subscriber);
          if (uninitialized) {
            uninitialized = false;
            var isAsync_1 = false;
            var isComplete_1 = false;
            callbackFunc.apply(_this, __spreadArray5(__spreadArray5([], __read6(args)), [
              function() {
                var results = [];
                for (var _i2 = 0; _i2 < arguments.length; _i2++) {
                  results[_i2] = arguments[_i2];
                }
                if (isNodeStyle) {
                  var err = results.shift();
                  if (err != null) {
                    subject.error(err);
                    return;
                  }
                }
                subject.next(1 < results.length ? results : results[0]);
                isComplete_1 = true;
                if (isAsync_1) {
                  subject.complete();
                }
              }
            ]));
            if (isComplete_1) {
              subject.complete();
            }
            isAsync_1 = true;
          }
          return subs;
        });
      };
    }
    exports2.bindCallbackInternals = bindCallbackInternals;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/bindCallback.js
var require_bindCallback = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/bindCallback.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.bindCallback = void 0;
    var bindCallbackInternals_1 = require_bindCallbackInternals();
    function bindCallback(callbackFunc, resultSelector, scheduler) {
      return bindCallbackInternals_1.bindCallbackInternals(false, callbackFunc, resultSelector, scheduler);
    }
    exports2.bindCallback = bindCallback;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/bindNodeCallback.js
var require_bindNodeCallback = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/bindNodeCallback.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.bindNodeCallback = void 0;
    var bindCallbackInternals_1 = require_bindCallbackInternals();
    function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
      return bindCallbackInternals_1.bindCallbackInternals(true, callbackFunc, resultSelector, scheduler);
    }
    exports2.bindNodeCallback = bindNodeCallback;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/argsArgArrayOrObject.js
var require_argsArgArrayOrObject = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/argsArgArrayOrObject.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.argsArgArrayOrObject = void 0;
    var isArray = Array.isArray;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectProto = Object.prototype;
    var getKeys = Object.keys;
    function argsArgArrayOrObject(args) {
      if (args.length === 1) {
        var first_1 = args[0];
        if (isArray(first_1)) {
          return { args: first_1, keys: null };
        }
        if (isPOJO(first_1)) {
          var keys = getKeys(first_1);
          return {
            args: keys.map(function(key) {
              return first_1[key];
            }),
            keys
          };
        }
      }
      return { args, keys: null };
    }
    exports2.argsArgArrayOrObject = argsArgArrayOrObject;
    function isPOJO(obj) {
      return obj && typeof obj === "object" && getPrototypeOf(obj) === objectProto;
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/createObject.js
var require_createObject = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/createObject.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createObject = void 0;
    function createObject(keys, values) {
      return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
      }, {});
    }
    exports2.createObject = createObject;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/combineLatest.js
var require_combineLatest = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/combineLatest.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.combineLatestInit = exports2.combineLatest = void 0;
    var Observable_1 = require_Observable();
    var argsArgArrayOrObject_1 = require_argsArgArrayOrObject();
    var from_1 = require_from();
    var identity_1 = require_identity();
    var mapOneOrManyArgs_1 = require_mapOneOrManyArgs();
    var args_1 = require_args();
    var createObject_1 = require_createObject();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var executeSchedule_1 = require_executeSchedule();
    function combineLatest() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var scheduler = args_1.popScheduler(args);
      var resultSelector = args_1.popResultSelector(args);
      var _a = argsArgArrayOrObject_1.argsArgArrayOrObject(args), observables = _a.args, keys = _a.keys;
      if (observables.length === 0) {
        return from_1.from([], scheduler);
      }
      var result = new Observable_1.Observable(combineLatestInit(observables, scheduler, keys ? function(values) {
        return createObject_1.createObject(keys, values);
      } : identity_1.identity));
      return resultSelector ? result.pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector)) : result;
    }
    exports2.combineLatest = combineLatest;
    function combineLatestInit(observables, scheduler, valueTransform) {
      if (valueTransform === void 0) {
        valueTransform = identity_1.identity;
      }
      return function(subscriber) {
        maybeSchedule(scheduler, function() {
          var length = observables.length;
          var values = new Array(length);
          var active = length;
          var remainingFirstValues = length;
          var _loop_1 = function(i2) {
            maybeSchedule(scheduler, function() {
              var source = from_1.from(observables[i2], scheduler);
              var hasFirstValue = false;
              source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
                values[i2] = value;
                if (!hasFirstValue) {
                  hasFirstValue = true;
                  remainingFirstValues--;
                }
                if (!remainingFirstValues) {
                  subscriber.next(valueTransform(values.slice()));
                }
              }, function() {
                if (!--active) {
                  subscriber.complete();
                }
              }));
            }, subscriber);
          };
          for (var i = 0; i < length; i++) {
            _loop_1(i);
          }
        }, subscriber);
      };
    }
    exports2.combineLatestInit = combineLatestInit;
    function maybeSchedule(scheduler, execute, subscription) {
      if (scheduler) {
        executeSchedule_1.executeSchedule(subscription, scheduler, execute);
      } else {
        execute();
      }
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeInternals.js
var require_mergeInternals = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeInternals.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.mergeInternals = void 0;
    var innerFrom_1 = require_innerFrom();
    var executeSchedule_1 = require_executeSchedule();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
      var buffer2 = [];
      var active = 0;
      var index2 = 0;
      var isComplete = false;
      var checkComplete = function() {
        if (isComplete && !buffer2.length && !active) {
          subscriber.complete();
        }
      };
      var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer2.push(value);
      };
      var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        innerFrom_1.innerFrom(project(value, index2++)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(innerValue) {
          onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
          if (expand) {
            outerNext(innerValue);
          } else {
            subscriber.next(innerValue);
          }
        }, function() {
          innerComplete = true;
        }, void 0, function() {
          if (innerComplete) {
            try {
              active--;
              var _loop_1 = function() {
                var bufferedValue = buffer2.shift();
                if (innerSubScheduler) {
                  executeSchedule_1.executeSchedule(subscriber, innerSubScheduler, function() {
                    return doInnerSub(bufferedValue);
                  });
                } else {
                  doInnerSub(bufferedValue);
                }
              };
              while (buffer2.length && active < concurrent) {
                _loop_1();
              }
              checkComplete();
            } catch (err) {
              subscriber.error(err);
            }
          }
        }));
      };
      source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
      }));
      return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
      };
    }
    exports2.mergeInternals = mergeInternals;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeMap.js
var require_mergeMap = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeMap.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.mergeMap = void 0;
    var map_1 = require_map();
    var innerFrom_1 = require_innerFrom();
    var lift_1 = require_lift();
    var mergeInternals_1 = require_mergeInternals();
    var isFunction_1 = require_isFunction();
    function mergeMap(project, resultSelector, concurrent) {
      if (concurrent === void 0) {
        concurrent = Infinity;
      }
      if (isFunction_1.isFunction(resultSelector)) {
        return mergeMap(function(a, i) {
          return map_1.map(function(b, ii) {
            return resultSelector(a, b, i, ii);
          })(innerFrom_1.innerFrom(project(a, i)));
        }, concurrent);
      } else if (typeof resultSelector === "number") {
        concurrent = resultSelector;
      }
      return lift_1.operate(function(source, subscriber) {
        return mergeInternals_1.mergeInternals(source, subscriber, project, concurrent);
      });
    }
    exports2.mergeMap = mergeMap;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeAll.js
var require_mergeAll = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeAll.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.mergeAll = void 0;
    var mergeMap_1 = require_mergeMap();
    var identity_1 = require_identity();
    function mergeAll(concurrent) {
      if (concurrent === void 0) {
        concurrent = Infinity;
      }
      return mergeMap_1.mergeMap(identity_1.identity, concurrent);
    }
    exports2.mergeAll = mergeAll;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/concatAll.js
var require_concatAll = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/concatAll.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.concatAll = void 0;
    var mergeAll_1 = require_mergeAll();
    function concatAll() {
      return mergeAll_1.mergeAll(1);
    }
    exports2.concatAll = concatAll;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/concat.js
var require_concat = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/concat.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.concat = void 0;
    var concatAll_1 = require_concatAll();
    var args_1 = require_args();
    var from_1 = require_from();
    function concat() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return concatAll_1.concatAll()(from_1.from(args, args_1.popScheduler(args)));
    }
    exports2.concat = concat;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/defer.js
var require_defer = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/defer.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.defer = void 0;
    var Observable_1 = require_Observable();
    var innerFrom_1 = require_innerFrom();
    function defer(observableFactory) {
      return new Observable_1.Observable(function(subscriber) {
        innerFrom_1.innerFrom(observableFactory()).subscribe(subscriber);
      });
    }
    exports2.defer = defer;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/connectable.js
var require_connectable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/connectable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.connectable = void 0;
    var Subject_1 = require_Subject();
    var Observable_1 = require_Observable();
    var defer_1 = require_defer();
    var DEFAULT_CONFIG = {
      connector: function() {
        return new Subject_1.Subject();
      },
      resetOnDisconnect: true
    };
    function connectable(source, config2) {
      if (config2 === void 0) {
        config2 = DEFAULT_CONFIG;
      }
      var connection = null;
      var connector = config2.connector, _a = config2.resetOnDisconnect, resetOnDisconnect = _a === void 0 ? true : _a;
      var subject = connector();
      var result = new Observable_1.Observable(function(subscriber) {
        return subject.subscribe(subscriber);
      });
      result.connect = function() {
        if (!connection || connection.closed) {
          connection = defer_1.defer(function() {
            return source;
          }).subscribe(subject);
          if (resetOnDisconnect) {
            connection.add(function() {
              return subject = connector();
            });
          }
        }
        return connection;
      };
      return result;
    }
    exports2.connectable = connectable;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/forkJoin.js
var require_forkJoin = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/forkJoin.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.forkJoin = void 0;
    var Observable_1 = require_Observable();
    var argsArgArrayOrObject_1 = require_argsArgArrayOrObject();
    var innerFrom_1 = require_innerFrom();
    var args_1 = require_args();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var mapOneOrManyArgs_1 = require_mapOneOrManyArgs();
    var createObject_1 = require_createObject();
    function forkJoin() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var resultSelector = args_1.popResultSelector(args);
      var _a = argsArgArrayOrObject_1.argsArgArrayOrObject(args), sources = _a.args, keys = _a.keys;
      var result = new Observable_1.Observable(function(subscriber) {
        var length = sources.length;
        if (!length) {
          subscriber.complete();
          return;
        }
        var values = new Array(length);
        var remainingCompletions = length;
        var remainingEmissions = length;
        var _loop_1 = function(sourceIndex2) {
          var hasValue = false;
          innerFrom_1.innerFrom(sources[sourceIndex2]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
            if (!hasValue) {
              hasValue = true;
              remainingEmissions--;
            }
            values[sourceIndex2] = value;
          }, function() {
            return remainingCompletions--;
          }, void 0, function() {
            if (!remainingCompletions || !hasValue) {
              if (!remainingEmissions) {
                subscriber.next(keys ? createObject_1.createObject(keys, values) : values);
              }
              subscriber.complete();
            }
          }));
        };
        for (var sourceIndex = 0; sourceIndex < length; sourceIndex++) {
          _loop_1(sourceIndex);
        }
      });
      return resultSelector ? result.pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector)) : result;
    }
    exports2.forkJoin = forkJoin;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/fromEvent.js
var require_fromEvent = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/fromEvent.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.fromEvent = void 0;
    var innerFrom_1 = require_innerFrom();
    var Observable_1 = require_Observable();
    var mergeMap_1 = require_mergeMap();
    var isArrayLike_1 = require_isArrayLike();
    var isFunction_1 = require_isFunction();
    var mapOneOrManyArgs_1 = require_mapOneOrManyArgs();
    var nodeEventEmitterMethods = ["addListener", "removeListener"];
    var eventTargetMethods = ["addEventListener", "removeEventListener"];
    var jqueryMethods = ["on", "off"];
    function fromEvent2(target, eventName, options, resultSelector) {
      if (isFunction_1.isFunction(options)) {
        resultSelector = options;
        options = void 0;
      }
      if (resultSelector) {
        return fromEvent2(target, eventName, options).pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
      }
      var _a = __read6(isEventTarget(target) ? eventTargetMethods.map(function(methodName) {
        return function(handler) {
          return target[methodName](eventName, handler, options);
        };
      }) : isNodeStyleEventEmitter(target) ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName)) : isJQueryStyleEventEmitter(target) ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName)) : [], 2), add2 = _a[0], remove2 = _a[1];
      if (!add2) {
        if (isArrayLike_1.isArrayLike(target)) {
          return mergeMap_1.mergeMap(function(subTarget) {
            return fromEvent2(subTarget, eventName, options);
          })(innerFrom_1.innerFrom(target));
        }
      }
      if (!add2) {
        throw new TypeError("Invalid event target");
      }
      return new Observable_1.Observable(function(subscriber) {
        var handler = function() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return subscriber.next(1 < args.length ? args : args[0]);
        };
        add2(handler);
        return function() {
          return remove2(handler);
        };
      });
    }
    exports2.fromEvent = fromEvent2;
    function toCommonHandlerRegistry(target, eventName) {
      return function(methodName) {
        return function(handler) {
          return target[methodName](eventName, handler);
        };
      };
    }
    function isNodeStyleEventEmitter(target) {
      return isFunction_1.isFunction(target.addListener) && isFunction_1.isFunction(target.removeListener);
    }
    function isJQueryStyleEventEmitter(target) {
      return isFunction_1.isFunction(target.on) && isFunction_1.isFunction(target.off);
    }
    function isEventTarget(target) {
      return isFunction_1.isFunction(target.addEventListener) && isFunction_1.isFunction(target.removeEventListener);
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/fromEventPattern.js
var require_fromEventPattern = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/fromEventPattern.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.fromEventPattern = void 0;
    var Observable_1 = require_Observable();
    var isFunction_1 = require_isFunction();
    var mapOneOrManyArgs_1 = require_mapOneOrManyArgs();
    function fromEventPattern(addHandler, removeHandler, resultSelector) {
      if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
      }
      return new Observable_1.Observable(function(subscriber) {
        var handler = function() {
          var e = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            e[_i] = arguments[_i];
          }
          return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return isFunction_1.isFunction(removeHandler) ? function() {
          return removeHandler(handler, retValue);
        } : void 0;
      });
    }
    exports2.fromEventPattern = fromEventPattern;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/generate.js
var require_generate = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/generate.js"(exports2) {
    "use strict";
    var __generator7 = exports2 && exports2.__generator || function(thisArg, body) {
      var _ = { label: 0, sent: function() {
        if (t[0] & 1) throw t[1];
        return t[1];
      }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
      }), g;
      function verb(n) {
        return function(v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return { value: op[1], done: false };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2]) _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.generate = void 0;
    var identity_1 = require_identity();
    var isScheduler_1 = require_isScheduler();
    var defer_1 = require_defer();
    var scheduleIterable_1 = require_scheduleIterable();
    function generate(initialStateOrOptions, condition, iterate, resultSelectorOrScheduler, scheduler) {
      var _a, _b;
      var resultSelector;
      var initialState;
      if (arguments.length === 1) {
        _a = initialStateOrOptions, initialState = _a.initialState, condition = _a.condition, iterate = _a.iterate, _b = _a.resultSelector, resultSelector = _b === void 0 ? identity_1.identity : _b, scheduler = _a.scheduler;
      } else {
        initialState = initialStateOrOptions;
        if (!resultSelectorOrScheduler || isScheduler_1.isScheduler(resultSelectorOrScheduler)) {
          resultSelector = identity_1.identity;
          scheduler = resultSelectorOrScheduler;
        } else {
          resultSelector = resultSelectorOrScheduler;
        }
      }
      function gen() {
        var state;
        return __generator7(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              state = initialState;
              _a2.label = 1;
            case 1:
              if (!(!condition || condition(state))) return [3, 4];
              return [4, resultSelector(state)];
            case 2:
              _a2.sent();
              _a2.label = 3;
            case 3:
              state = iterate(state);
              return [3, 1];
            case 4:
              return [2];
          }
        });
      }
      return defer_1.defer(scheduler ? function() {
        return scheduleIterable_1.scheduleIterable(gen(), scheduler);
      } : gen);
    }
    exports2.generate = generate;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/iif.js
var require_iif = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/iif.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.iif = void 0;
    var defer_1 = require_defer();
    function iif(condition, trueResult, falseResult) {
      return defer_1.defer(function() {
        return condition() ? trueResult : falseResult;
      });
    }
    exports2.iif = iif;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/timer.js
var require_timer = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/timer.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.timer = void 0;
    var Observable_1 = require_Observable();
    var async_1 = require_async();
    var isScheduler_1 = require_isScheduler();
    var isDate_1 = require_isDate();
    function timer(dueTime, intervalOrScheduler, scheduler) {
      if (dueTime === void 0) {
        dueTime = 0;
      }
      if (scheduler === void 0) {
        scheduler = async_1.async;
      }
      var intervalDuration = -1;
      if (intervalOrScheduler != null) {
        if (isScheduler_1.isScheduler(intervalOrScheduler)) {
          scheduler = intervalOrScheduler;
        } else {
          intervalDuration = intervalOrScheduler;
        }
      }
      return new Observable_1.Observable(function(subscriber) {
        var due = isDate_1.isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) {
          due = 0;
        }
        var n = 0;
        return scheduler.schedule(function() {
          if (!subscriber.closed) {
            subscriber.next(n++);
            if (0 <= intervalDuration) {
              this.schedule(void 0, intervalDuration);
            } else {
              subscriber.complete();
            }
          }
        }, due);
      });
    }
    exports2.timer = timer;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/interval.js
var require_interval = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/interval.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.interval = void 0;
    var async_1 = require_async();
    var timer_1 = require_timer();
    function interval(period, scheduler) {
      if (period === void 0) {
        period = 0;
      }
      if (scheduler === void 0) {
        scheduler = async_1.asyncScheduler;
      }
      if (period < 0) {
        period = 0;
      }
      return timer_1.timer(period, period, scheduler);
    }
    exports2.interval = interval;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/merge.js
var require_merge = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/merge.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.merge = void 0;
    var mergeAll_1 = require_mergeAll();
    var innerFrom_1 = require_innerFrom();
    var empty_1 = require_empty();
    var args_1 = require_args();
    var from_1 = require_from();
    function merge3() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var scheduler = args_1.popScheduler(args);
      var concurrent = args_1.popNumber(args, Infinity);
      var sources = args;
      return !sources.length ? empty_1.EMPTY : sources.length === 1 ? innerFrom_1.innerFrom(sources[0]) : mergeAll_1.mergeAll(concurrent)(from_1.from(sources, scheduler));
    }
    exports2.merge = merge3;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/never.js
var require_never = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/never.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.never = exports2.NEVER = void 0;
    var Observable_1 = require_Observable();
    var noop_1 = require_noop();
    exports2.NEVER = new Observable_1.Observable(noop_1.noop);
    function never() {
      return exports2.NEVER;
    }
    exports2.never = never;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/argsOrArgArray.js
var require_argsOrArgArray = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/argsOrArgArray.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.argsOrArgArray = void 0;
    var isArray = Array.isArray;
    function argsOrArgArray(args) {
      return args.length === 1 && isArray(args[0]) ? args[0] : args;
    }
    exports2.argsOrArgArray = argsOrArgArray;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/onErrorResumeNext.js
var require_onErrorResumeNext = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/onErrorResumeNext.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.onErrorResumeNext = void 0;
    var Observable_1 = require_Observable();
    var argsOrArgArray_1 = require_argsOrArgArray();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var noop_1 = require_noop();
    var innerFrom_1 = require_innerFrom();
    function onErrorResumeNext() {
      var sources = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
      }
      var nextSources = argsOrArgArray_1.argsOrArgArray(sources);
      return new Observable_1.Observable(function(subscriber) {
        var sourceIndex = 0;
        var subscribeNext = function() {
          if (sourceIndex < nextSources.length) {
            var nextSource = void 0;
            try {
              nextSource = innerFrom_1.innerFrom(nextSources[sourceIndex++]);
            } catch (err) {
              subscribeNext();
              return;
            }
            var innerSubscriber = new OperatorSubscriber_1.OperatorSubscriber(subscriber, void 0, noop_1.noop, noop_1.noop);
            nextSource.subscribe(innerSubscriber);
            innerSubscriber.add(subscribeNext);
          } else {
            subscriber.complete();
          }
        };
        subscribeNext();
      });
    }
    exports2.onErrorResumeNext = onErrorResumeNext;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/pairs.js
var require_pairs = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/pairs.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.pairs = void 0;
    var from_1 = require_from();
    function pairs(obj, scheduler) {
      return from_1.from(Object.entries(obj), scheduler);
    }
    exports2.pairs = pairs;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/not.js
var require_not = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/util/not.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.not = void 0;
    function not(pred, thisArg) {
      return function(value, index2) {
        return !pred.call(thisArg, value, index2);
      };
    }
    exports2.not = not;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/filter.js
var require_filter = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/filter.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.filter = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function filter4(predicate, thisArg) {
      return lift_1.operate(function(source, subscriber) {
        var index2 = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          return predicate.call(thisArg, value, index2++) && subscriber.next(value);
        }));
      });
    }
    exports2.filter = filter4;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/partition.js
var require_partition = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/partition.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.partition = void 0;
    var not_1 = require_not();
    var filter_1 = require_filter();
    var innerFrom_1 = require_innerFrom();
    function partition(source, predicate, thisArg) {
      return [filter_1.filter(predicate, thisArg)(innerFrom_1.innerFrom(source)), filter_1.filter(not_1.not(predicate, thisArg))(innerFrom_1.innerFrom(source))];
    }
    exports2.partition = partition;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/race.js
var require_race = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/race.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.raceInit = exports2.race = void 0;
    var Observable_1 = require_Observable();
    var innerFrom_1 = require_innerFrom();
    var argsOrArgArray_1 = require_argsOrArgArray();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function race() {
      var sources = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
      }
      sources = argsOrArgArray_1.argsOrArgArray(sources);
      return sources.length === 1 ? innerFrom_1.innerFrom(sources[0]) : new Observable_1.Observable(raceInit(sources));
    }
    exports2.race = race;
    function raceInit(sources) {
      return function(subscriber) {
        var subscriptions = [];
        var _loop_1 = function(i2) {
          subscriptions.push(innerFrom_1.innerFrom(sources[i2]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
            if (subscriptions) {
              for (var s = 0; s < subscriptions.length; s++) {
                s !== i2 && subscriptions[s].unsubscribe();
              }
              subscriptions = null;
            }
            subscriber.next(value);
          })));
        };
        for (var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++) {
          _loop_1(i);
        }
      };
    }
    exports2.raceInit = raceInit;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/range.js
var require_range = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/range.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.range = void 0;
    var Observable_1 = require_Observable();
    var empty_1 = require_empty();
    function range(start, count, scheduler) {
      if (count == null) {
        count = start;
        start = 0;
      }
      if (count <= 0) {
        return empty_1.EMPTY;
      }
      var end = count + start;
      return new Observable_1.Observable(scheduler ? function(subscriber) {
        var n = start;
        return scheduler.schedule(function() {
          if (n < end) {
            subscriber.next(n++);
            this.schedule();
          } else {
            subscriber.complete();
          }
        });
      } : function(subscriber) {
        var n = start;
        while (n < end && !subscriber.closed) {
          subscriber.next(n++);
        }
        subscriber.complete();
      });
    }
    exports2.range = range;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/using.js
var require_using = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/using.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.using = void 0;
    var Observable_1 = require_Observable();
    var innerFrom_1 = require_innerFrom();
    var empty_1 = require_empty();
    function using(resourceFactory, observableFactory) {
      return new Observable_1.Observable(function(subscriber) {
        var resource = resourceFactory();
        var result = observableFactory(resource);
        var source = result ? innerFrom_1.innerFrom(result) : empty_1.EMPTY;
        source.subscribe(subscriber);
        return function() {
          if (resource) {
            resource.unsubscribe();
          }
        };
      });
    }
    exports2.using = using;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/zip.js
var require_zip = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/zip.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.zip = void 0;
    var Observable_1 = require_Observable();
    var innerFrom_1 = require_innerFrom();
    var argsOrArgArray_1 = require_argsOrArgArray();
    var empty_1 = require_empty();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var args_1 = require_args();
    function zip() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var resultSelector = args_1.popResultSelector(args);
      var sources = argsOrArgArray_1.argsOrArgArray(args);
      return sources.length ? new Observable_1.Observable(function(subscriber) {
        var buffers = sources.map(function() {
          return [];
        });
        var completed = sources.map(function() {
          return false;
        });
        subscriber.add(function() {
          buffers = completed = null;
        });
        var _loop_1 = function(sourceIndex2) {
          innerFrom_1.innerFrom(sources[sourceIndex2]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
            buffers[sourceIndex2].push(value);
            if (buffers.every(function(buffer2) {
              return buffer2.length;
            })) {
              var result = buffers.map(function(buffer2) {
                return buffer2.shift();
              });
              subscriber.next(resultSelector ? resultSelector.apply(void 0, __spreadArray5([], __read6(result))) : result);
              if (buffers.some(function(buffer2, i) {
                return !buffer2.length && completed[i];
              })) {
                subscriber.complete();
              }
            }
          }, function() {
            completed[sourceIndex2] = true;
            !buffers[sourceIndex2].length && subscriber.complete();
          }));
        };
        for (var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++) {
          _loop_1(sourceIndex);
        }
        return function() {
          buffers = completed = null;
        };
      }) : empty_1.EMPTY;
    }
    exports2.zip = zip;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/types.js
var require_types = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/types.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/audit.js
var require_audit = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/audit.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.audit = void 0;
    var lift_1 = require_lift();
    var innerFrom_1 = require_innerFrom();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function audit(durationSelector) {
      return lift_1.operate(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var isComplete = false;
        var endDuration = function() {
          durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
          durationSubscriber = null;
          if (hasValue) {
            hasValue = false;
            var value = lastValue;
            lastValue = null;
            subscriber.next(value);
          }
          isComplete && subscriber.complete();
        };
        var cleanupDuration = function() {
          durationSubscriber = null;
          isComplete && subscriber.complete();
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          hasValue = true;
          lastValue = value;
          if (!durationSubscriber) {
            innerFrom_1.innerFrom(durationSelector(value)).subscribe(durationSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, endDuration, cleanupDuration));
          }
        }, function() {
          isComplete = true;
          (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
        }));
      });
    }
    exports2.audit = audit;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/auditTime.js
var require_auditTime = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/auditTime.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.auditTime = void 0;
    var async_1 = require_async();
    var audit_1 = require_audit();
    var timer_1 = require_timer();
    function auditTime(duration, scheduler) {
      if (scheduler === void 0) {
        scheduler = async_1.asyncScheduler;
      }
      return audit_1.audit(function() {
        return timer_1.timer(duration, scheduler);
      });
    }
    exports2.auditTime = auditTime;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/buffer.js
var require_buffer = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/buffer.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.buffer = void 0;
    var lift_1 = require_lift();
    var noop_1 = require_noop();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var innerFrom_1 = require_innerFrom();
    function buffer2(closingNotifier) {
      return lift_1.operate(function(source, subscriber) {
        var currentBuffer = [];
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          return currentBuffer.push(value);
        }, function() {
          subscriber.next(currentBuffer);
          subscriber.complete();
        }));
        innerFrom_1.innerFrom(closingNotifier).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
          var b = currentBuffer;
          currentBuffer = [];
          subscriber.next(b);
        }, noop_1.noop));
        return function() {
          currentBuffer = null;
        };
      });
    }
    exports2.buffer = buffer2;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/bufferCount.js
var require_bufferCount = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/bufferCount.js"(exports2) {
    "use strict";
    var __values5 = exports2 && exports2.__values || function(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
        next: function() {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
        }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.bufferCount = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var arrRemove_1 = require_arrRemove();
    function bufferCount(bufferSize, startBufferEvery) {
      if (startBufferEvery === void 0) {
        startBufferEvery = null;
      }
      startBufferEvery = startBufferEvery !== null && startBufferEvery !== void 0 ? startBufferEvery : bufferSize;
      return lift_1.operate(function(source, subscriber) {
        var buffers = [];
        var count = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var e_1, _a, e_2, _b;
          var toEmit = null;
          if (count++ % startBufferEvery === 0) {
            buffers.push([]);
          }
          try {
            for (var buffers_1 = __values5(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
              var buffer2 = buffers_1_1.value;
              buffer2.push(value);
              if (bufferSize <= buffer2.length) {
                toEmit = toEmit !== null && toEmit !== void 0 ? toEmit : [];
                toEmit.push(buffer2);
              }
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          if (toEmit) {
            try {
              for (var toEmit_1 = __values5(toEmit), toEmit_1_1 = toEmit_1.next(); !toEmit_1_1.done; toEmit_1_1 = toEmit_1.next()) {
                var buffer2 = toEmit_1_1.value;
                arrRemove_1.arrRemove(buffers, buffer2);
                subscriber.next(buffer2);
              }
            } catch (e_2_1) {
              e_2 = { error: e_2_1 };
            } finally {
              try {
                if (toEmit_1_1 && !toEmit_1_1.done && (_b = toEmit_1.return)) _b.call(toEmit_1);
              } finally {
                if (e_2) throw e_2.error;
              }
            }
          }
        }, function() {
          var e_3, _a;
          try {
            for (var buffers_2 = __values5(buffers), buffers_2_1 = buffers_2.next(); !buffers_2_1.done; buffers_2_1 = buffers_2.next()) {
              var buffer2 = buffers_2_1.value;
              subscriber.next(buffer2);
            }
          } catch (e_3_1) {
            e_3 = { error: e_3_1 };
          } finally {
            try {
              if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
          subscriber.complete();
        }, void 0, function() {
          buffers = null;
        }));
      });
    }
    exports2.bufferCount = bufferCount;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/bufferTime.js
var require_bufferTime = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/bufferTime.js"(exports2) {
    "use strict";
    var __values5 = exports2 && exports2.__values || function(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
        next: function() {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
        }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.bufferTime = void 0;
    var Subscription_1 = require_Subscription();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var arrRemove_1 = require_arrRemove();
    var async_1 = require_async();
    var args_1 = require_args();
    var executeSchedule_1 = require_executeSchedule();
    function bufferTime(bufferTimeSpan) {
      var _a, _b;
      var otherArgs = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        otherArgs[_i - 1] = arguments[_i];
      }
      var scheduler = (_a = args_1.popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : async_1.asyncScheduler;
      var bufferCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
      var maxBufferSize = otherArgs[1] || Infinity;
      return lift_1.operate(function(source, subscriber) {
        var bufferRecords = [];
        var restartOnEmit = false;
        var emit = function(record) {
          var buffer2 = record.buffer, subs = record.subs;
          subs.unsubscribe();
          arrRemove_1.arrRemove(bufferRecords, record);
          subscriber.next(buffer2);
          restartOnEmit && startBuffer();
        };
        var startBuffer = function() {
          if (bufferRecords) {
            var subs = new Subscription_1.Subscription();
            subscriber.add(subs);
            var buffer2 = [];
            var record_1 = {
              buffer: buffer2,
              subs
            };
            bufferRecords.push(record_1);
            executeSchedule_1.executeSchedule(subs, scheduler, function() {
              return emit(record_1);
            }, bufferTimeSpan);
          }
        };
        if (bufferCreationInterval !== null && bufferCreationInterval >= 0) {
          executeSchedule_1.executeSchedule(subscriber, scheduler, startBuffer, bufferCreationInterval, true);
        } else {
          restartOnEmit = true;
        }
        startBuffer();
        var bufferTimeSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var e_1, _a2;
          var recordsCopy = bufferRecords.slice();
          try {
            for (var recordsCopy_1 = __values5(recordsCopy), recordsCopy_1_1 = recordsCopy_1.next(); !recordsCopy_1_1.done; recordsCopy_1_1 = recordsCopy_1.next()) {
              var record = recordsCopy_1_1.value;
              var buffer2 = record.buffer;
              buffer2.push(value);
              maxBufferSize <= buffer2.length && emit(record);
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (recordsCopy_1_1 && !recordsCopy_1_1.done && (_a2 = recordsCopy_1.return)) _a2.call(recordsCopy_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        }, function() {
          while (bufferRecords === null || bufferRecords === void 0 ? void 0 : bufferRecords.length) {
            subscriber.next(bufferRecords.shift().buffer);
          }
          bufferTimeSubscriber === null || bufferTimeSubscriber === void 0 ? void 0 : bufferTimeSubscriber.unsubscribe();
          subscriber.complete();
          subscriber.unsubscribe();
        }, void 0, function() {
          return bufferRecords = null;
        });
        source.subscribe(bufferTimeSubscriber);
      });
    }
    exports2.bufferTime = bufferTime;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/bufferToggle.js
var require_bufferToggle = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/bufferToggle.js"(exports2) {
    "use strict";
    var __values5 = exports2 && exports2.__values || function(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
        next: function() {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
        }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.bufferToggle = void 0;
    var Subscription_1 = require_Subscription();
    var lift_1 = require_lift();
    var innerFrom_1 = require_innerFrom();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var noop_1 = require_noop();
    var arrRemove_1 = require_arrRemove();
    function bufferToggle(openings, closingSelector) {
      return lift_1.operate(function(source, subscriber) {
        var buffers = [];
        innerFrom_1.innerFrom(openings).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(openValue) {
          var buffer2 = [];
          buffers.push(buffer2);
          var closingSubscription = new Subscription_1.Subscription();
          var emitBuffer = function() {
            arrRemove_1.arrRemove(buffers, buffer2);
            subscriber.next(buffer2);
            closingSubscription.unsubscribe();
          };
          closingSubscription.add(innerFrom_1.innerFrom(closingSelector(openValue)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, emitBuffer, noop_1.noop)));
        }, noop_1.noop));
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var e_1, _a;
          try {
            for (var buffers_1 = __values5(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
              var buffer2 = buffers_1_1.value;
              buffer2.push(value);
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        }, function() {
          while (buffers.length > 0) {
            subscriber.next(buffers.shift());
          }
          subscriber.complete();
        }));
      });
    }
    exports2.bufferToggle = bufferToggle;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/bufferWhen.js
var require_bufferWhen = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/bufferWhen.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.bufferWhen = void 0;
    var lift_1 = require_lift();
    var noop_1 = require_noop();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var innerFrom_1 = require_innerFrom();
    function bufferWhen(closingSelector) {
      return lift_1.operate(function(source, subscriber) {
        var buffer2 = null;
        var closingSubscriber = null;
        var openBuffer = function() {
          closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
          var b = buffer2;
          buffer2 = [];
          b && subscriber.next(b);
          innerFrom_1.innerFrom(closingSelector()).subscribe(closingSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, openBuffer, noop_1.noop));
        };
        openBuffer();
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          return buffer2 === null || buffer2 === void 0 ? void 0 : buffer2.push(value);
        }, function() {
          buffer2 && subscriber.next(buffer2);
          subscriber.complete();
        }, void 0, function() {
          return buffer2 = closingSubscriber = null;
        }));
      });
    }
    exports2.bufferWhen = bufferWhen;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/catchError.js
var require_catchError = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/catchError.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.catchError = void 0;
    var innerFrom_1 = require_innerFrom();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var lift_1 = require_lift();
    function catchError(selector2) {
      return lift_1.operate(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, void 0, void 0, function(err) {
          handledResult = innerFrom_1.innerFrom(selector2(err, catchError(selector2)(source)));
          if (innerSub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
          } else {
            syncUnsub = true;
          }
        }));
        if (syncUnsub) {
          innerSub.unsubscribe();
          innerSub = null;
          handledResult.subscribe(subscriber);
        }
      });
    }
    exports2.catchError = catchError;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/scanInternals.js
var require_scanInternals = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/scanInternals.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.scanInternals = void 0;
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
      return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index2 = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var i = index2++;
          state = hasState ? accumulator(state, value, i) : (hasState = true, value);
          emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
          hasState && subscriber.next(state);
          subscriber.complete();
        }));
      };
    }
    exports2.scanInternals = scanInternals;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/reduce.js
var require_reduce = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/reduce.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.reduce = void 0;
    var scanInternals_1 = require_scanInternals();
    var lift_1 = require_lift();
    function reduce(accumulator, seed) {
      return lift_1.operate(scanInternals_1.scanInternals(accumulator, seed, arguments.length >= 2, false, true));
    }
    exports2.reduce = reduce;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/toArray.js
var require_toArray = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/toArray.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.toArray = void 0;
    var reduce_1 = require_reduce();
    var lift_1 = require_lift();
    var arrReducer = function(arr, value) {
      return arr.push(value), arr;
    };
    function toArray() {
      return lift_1.operate(function(source, subscriber) {
        reduce_1.reduce(arrReducer, [])(source).subscribe(subscriber);
      });
    }
    exports2.toArray = toArray;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/joinAllInternals.js
var require_joinAllInternals = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/joinAllInternals.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.joinAllInternals = void 0;
    var identity_1 = require_identity();
    var mapOneOrManyArgs_1 = require_mapOneOrManyArgs();
    var pipe_1 = require_pipe();
    var mergeMap_1 = require_mergeMap();
    var toArray_1 = require_toArray();
    function joinAllInternals(joinFn, project) {
      return pipe_1.pipe(toArray_1.toArray(), mergeMap_1.mergeMap(function(sources) {
        return joinFn(sources);
      }), project ? mapOneOrManyArgs_1.mapOneOrManyArgs(project) : identity_1.identity);
    }
    exports2.joinAllInternals = joinAllInternals;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/combineLatestAll.js
var require_combineLatestAll = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/combineLatestAll.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.combineLatestAll = void 0;
    var combineLatest_1 = require_combineLatest();
    var joinAllInternals_1 = require_joinAllInternals();
    function combineLatestAll(project) {
      return joinAllInternals_1.joinAllInternals(combineLatest_1.combineLatest, project);
    }
    exports2.combineLatestAll = combineLatestAll;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/combineAll.js
var require_combineAll = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/combineAll.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.combineAll = void 0;
    var combineLatestAll_1 = require_combineLatestAll();
    exports2.combineAll = combineLatestAll_1.combineLatestAll;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/combineLatest.js
var require_combineLatest2 = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/combineLatest.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.combineLatest = void 0;
    var combineLatest_1 = require_combineLatest();
    var lift_1 = require_lift();
    var argsOrArgArray_1 = require_argsOrArgArray();
    var mapOneOrManyArgs_1 = require_mapOneOrManyArgs();
    var pipe_1 = require_pipe();
    var args_1 = require_args();
    function combineLatest() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var resultSelector = args_1.popResultSelector(args);
      return resultSelector ? pipe_1.pipe(combineLatest.apply(void 0, __spreadArray5([], __read6(args))), mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector)) : lift_1.operate(function(source, subscriber) {
        combineLatest_1.combineLatestInit(__spreadArray5([source], __read6(argsOrArgArray_1.argsOrArgArray(args))))(subscriber);
      });
    }
    exports2.combineLatest = combineLatest;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/combineLatestWith.js
var require_combineLatestWith = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/combineLatestWith.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.combineLatestWith = void 0;
    var combineLatest_1 = require_combineLatest2();
    function combineLatestWith() {
      var otherSources = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
      }
      return combineLatest_1.combineLatest.apply(void 0, __spreadArray5([], __read6(otherSources)));
    }
    exports2.combineLatestWith = combineLatestWith;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/concatMap.js
var require_concatMap = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/concatMap.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.concatMap = void 0;
    var mergeMap_1 = require_mergeMap();
    var isFunction_1 = require_isFunction();
    function concatMap(project, resultSelector) {
      return isFunction_1.isFunction(resultSelector) ? mergeMap_1.mergeMap(project, resultSelector, 1) : mergeMap_1.mergeMap(project, 1);
    }
    exports2.concatMap = concatMap;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/concatMapTo.js
var require_concatMapTo = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/concatMapTo.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.concatMapTo = void 0;
    var concatMap_1 = require_concatMap();
    var isFunction_1 = require_isFunction();
    function concatMapTo(innerObservable, resultSelector) {
      return isFunction_1.isFunction(resultSelector) ? concatMap_1.concatMap(function() {
        return innerObservable;
      }, resultSelector) : concatMap_1.concatMap(function() {
        return innerObservable;
      });
    }
    exports2.concatMapTo = concatMapTo;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/concat.js
var require_concat2 = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/concat.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.concat = void 0;
    var lift_1 = require_lift();
    var concatAll_1 = require_concatAll();
    var args_1 = require_args();
    var from_1 = require_from();
    function concat() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var scheduler = args_1.popScheduler(args);
      return lift_1.operate(function(source, subscriber) {
        concatAll_1.concatAll()(from_1.from(__spreadArray5([source], __read6(args)), scheduler)).subscribe(subscriber);
      });
    }
    exports2.concat = concat;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/concatWith.js
var require_concatWith = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/concatWith.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.concatWith = void 0;
    var concat_1 = require_concat2();
    function concatWith() {
      var otherSources = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
      }
      return concat_1.concat.apply(void 0, __spreadArray5([], __read6(otherSources)));
    }
    exports2.concatWith = concatWith;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/fromSubscribable.js
var require_fromSubscribable = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/observable/fromSubscribable.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.fromSubscribable = void 0;
    var Observable_1 = require_Observable();
    function fromSubscribable(subscribable) {
      return new Observable_1.Observable(function(subscriber) {
        return subscribable.subscribe(subscriber);
      });
    }
    exports2.fromSubscribable = fromSubscribable;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/connect.js
var require_connect = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/connect.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.connect = void 0;
    var Subject_1 = require_Subject();
    var innerFrom_1 = require_innerFrom();
    var lift_1 = require_lift();
    var fromSubscribable_1 = require_fromSubscribable();
    var DEFAULT_CONFIG = {
      connector: function() {
        return new Subject_1.Subject();
      }
    };
    function connect(selector2, config2) {
      if (config2 === void 0) {
        config2 = DEFAULT_CONFIG;
      }
      var connector = config2.connector;
      return lift_1.operate(function(source, subscriber) {
        var subject = connector();
        innerFrom_1.innerFrom(selector2(fromSubscribable_1.fromSubscribable(subject))).subscribe(subscriber);
        subscriber.add(source.subscribe(subject));
      });
    }
    exports2.connect = connect;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/count.js
var require_count = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/count.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.count = void 0;
    var reduce_1 = require_reduce();
    function count(predicate) {
      return reduce_1.reduce(function(total, value, i) {
        return !predicate || predicate(value, i) ? total + 1 : total;
      }, 0);
    }
    exports2.count = count;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/debounce.js
var require_debounce = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/debounce.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.debounce = void 0;
    var lift_1 = require_lift();
    var noop_1 = require_noop();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var innerFrom_1 = require_innerFrom();
    function debounce2(durationSelector) {
      return lift_1.operate(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var emit = function() {
          durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
          durationSubscriber = null;
          if (hasValue) {
            hasValue = false;
            var value = lastValue;
            lastValue = null;
            subscriber.next(value);
          }
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
          hasValue = true;
          lastValue = value;
          durationSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, emit, noop_1.noop);
          innerFrom_1.innerFrom(durationSelector(value)).subscribe(durationSubscriber);
        }, function() {
          emit();
          subscriber.complete();
        }, void 0, function() {
          lastValue = durationSubscriber = null;
        }));
      });
    }
    exports2.debounce = debounce2;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/debounceTime.js
var require_debounceTime = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/debounceTime.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.debounceTime = void 0;
    var async_1 = require_async();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function debounceTime2(dueTime, scheduler) {
      if (scheduler === void 0) {
        scheduler = async_1.asyncScheduler;
      }
      return lift_1.operate(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
          if (activeTask) {
            activeTask.unsubscribe();
            activeTask = null;
            var value = lastValue;
            lastValue = null;
            subscriber.next(value);
          }
        };
        function emitWhenIdle() {
          var targetTime = lastTime + dueTime;
          var now = scheduler.now();
          if (now < targetTime) {
            activeTask = this.schedule(void 0, targetTime - now);
            subscriber.add(activeTask);
            return;
          }
          emit();
        }
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          lastValue = value;
          lastTime = scheduler.now();
          if (!activeTask) {
            activeTask = scheduler.schedule(emitWhenIdle, dueTime);
            subscriber.add(activeTask);
          }
        }, function() {
          emit();
          subscriber.complete();
        }, void 0, function() {
          lastValue = activeTask = null;
        }));
      });
    }
    exports2.debounceTime = debounceTime2;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/defaultIfEmpty.js
var require_defaultIfEmpty = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/defaultIfEmpty.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.defaultIfEmpty = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function defaultIfEmpty(defaultValue) {
      return lift_1.operate(function(source, subscriber) {
        var hasValue = false;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          hasValue = true;
          subscriber.next(value);
        }, function() {
          if (!hasValue) {
            subscriber.next(defaultValue);
          }
          subscriber.complete();
        }));
      });
    }
    exports2.defaultIfEmpty = defaultIfEmpty;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/take.js
var require_take = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/take.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.take = void 0;
    var empty_1 = require_empty();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function take2(count) {
      return count <= 0 ? function() {
        return empty_1.EMPTY;
      } : lift_1.operate(function(source, subscriber) {
        var seen = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          if (++seen <= count) {
            subscriber.next(value);
            if (count <= seen) {
              subscriber.complete();
            }
          }
        }));
      });
    }
    exports2.take = take2;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/ignoreElements.js
var require_ignoreElements = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/ignoreElements.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.ignoreElements = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var noop_1 = require_noop();
    function ignoreElements() {
      return lift_1.operate(function(source, subscriber) {
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, noop_1.noop));
      });
    }
    exports2.ignoreElements = ignoreElements;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mapTo.js
var require_mapTo = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mapTo.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.mapTo = void 0;
    var map_1 = require_map();
    function mapTo(value) {
      return map_1.map(function() {
        return value;
      });
    }
    exports2.mapTo = mapTo;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/delayWhen.js
var require_delayWhen = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/delayWhen.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.delayWhen = void 0;
    var concat_1 = require_concat();
    var take_1 = require_take();
    var ignoreElements_1 = require_ignoreElements();
    var mapTo_1 = require_mapTo();
    var mergeMap_1 = require_mergeMap();
    var innerFrom_1 = require_innerFrom();
    function delayWhen(delayDurationSelector, subscriptionDelay) {
      if (subscriptionDelay) {
        return function(source) {
          return concat_1.concat(subscriptionDelay.pipe(take_1.take(1), ignoreElements_1.ignoreElements()), source.pipe(delayWhen(delayDurationSelector)));
        };
      }
      return mergeMap_1.mergeMap(function(value, index2) {
        return innerFrom_1.innerFrom(delayDurationSelector(value, index2)).pipe(take_1.take(1), mapTo_1.mapTo(value));
      });
    }
    exports2.delayWhen = delayWhen;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/delay.js
var require_delay = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/delay.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.delay = void 0;
    var async_1 = require_async();
    var delayWhen_1 = require_delayWhen();
    var timer_1 = require_timer();
    function delay2(due, scheduler) {
      if (scheduler === void 0) {
        scheduler = async_1.asyncScheduler;
      }
      var duration = timer_1.timer(due, scheduler);
      return delayWhen_1.delayWhen(function() {
        return duration;
      });
    }
    exports2.delay = delay2;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/dematerialize.js
var require_dematerialize = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/dematerialize.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.dematerialize = void 0;
    var Notification_1 = require_Notification();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function dematerialize() {
      return lift_1.operate(function(source, subscriber) {
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(notification) {
          return Notification_1.observeNotification(notification, subscriber);
        }));
      });
    }
    exports2.dematerialize = dematerialize;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/distinct.js
var require_distinct = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/distinct.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.distinct = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var noop_1 = require_noop();
    var innerFrom_1 = require_innerFrom();
    function distinct(keySelector, flushes) {
      return lift_1.operate(function(source, subscriber) {
        var distinctKeys = /* @__PURE__ */ new Set();
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var key = keySelector ? keySelector(value) : value;
          if (!distinctKeys.has(key)) {
            distinctKeys.add(key);
            subscriber.next(value);
          }
        }));
        flushes && innerFrom_1.innerFrom(flushes).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
          return distinctKeys.clear();
        }, noop_1.noop));
      });
    }
    exports2.distinct = distinct;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/distinctUntilChanged.js
var require_distinctUntilChanged = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/distinctUntilChanged.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.distinctUntilChanged = void 0;
    var identity_1 = require_identity();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function distinctUntilChanged(comparator, keySelector) {
      if (keySelector === void 0) {
        keySelector = identity_1.identity;
      }
      comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
      return lift_1.operate(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var currentKey = keySelector(value);
          if (first || !comparator(previousKey, currentKey)) {
            first = false;
            previousKey = currentKey;
            subscriber.next(value);
          }
        }));
      });
    }
    exports2.distinctUntilChanged = distinctUntilChanged;
    function defaultCompare(a, b) {
      return a === b;
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/distinctUntilKeyChanged.js
var require_distinctUntilKeyChanged = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/distinctUntilKeyChanged.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.distinctUntilKeyChanged = void 0;
    var distinctUntilChanged_1 = require_distinctUntilChanged();
    function distinctUntilKeyChanged(key, compare) {
      return distinctUntilChanged_1.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
      });
    }
    exports2.distinctUntilKeyChanged = distinctUntilKeyChanged;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/throwIfEmpty.js
var require_throwIfEmpty = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/throwIfEmpty.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.throwIfEmpty = void 0;
    var EmptyError_1 = require_EmptyError();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function throwIfEmpty(errorFactory) {
      if (errorFactory === void 0) {
        errorFactory = defaultErrorFactory;
      }
      return lift_1.operate(function(source, subscriber) {
        var hasValue = false;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          hasValue = true;
          subscriber.next(value);
        }, function() {
          return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
      });
    }
    exports2.throwIfEmpty = throwIfEmpty;
    function defaultErrorFactory() {
      return new EmptyError_1.EmptyError();
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/elementAt.js
var require_elementAt = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/elementAt.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.elementAt = void 0;
    var ArgumentOutOfRangeError_1 = require_ArgumentOutOfRangeError();
    var filter_1 = require_filter();
    var throwIfEmpty_1 = require_throwIfEmpty();
    var defaultIfEmpty_1 = require_defaultIfEmpty();
    var take_1 = require_take();
    function elementAt(index2, defaultValue) {
      if (index2 < 0) {
        throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError();
      }
      var hasDefaultValue = arguments.length >= 2;
      return function(source) {
        return source.pipe(filter_1.filter(function(v, i) {
          return i === index2;
        }), take_1.take(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function() {
          return new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError();
        }));
      };
    }
    exports2.elementAt = elementAt;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/endWith.js
var require_endWith = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/endWith.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.endWith = void 0;
    var concat_1 = require_concat();
    var of_1 = require_of();
    function endWith() {
      var values = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
      }
      return function(source) {
        return concat_1.concat(source, of_1.of.apply(void 0, __spreadArray5([], __read6(values))));
      };
    }
    exports2.endWith = endWith;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/every.js
var require_every = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/every.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.every = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function every(predicate, thisArg) {
      return lift_1.operate(function(source, subscriber) {
        var index2 = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          if (!predicate.call(thisArg, value, index2++, source)) {
            subscriber.next(false);
            subscriber.complete();
          }
        }, function() {
          subscriber.next(true);
          subscriber.complete();
        }));
      });
    }
    exports2.every = every;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/exhaustMap.js
var require_exhaustMap = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/exhaustMap.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.exhaustMap = void 0;
    var map_1 = require_map();
    var innerFrom_1 = require_innerFrom();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function exhaustMap(project, resultSelector) {
      if (resultSelector) {
        return function(source) {
          return source.pipe(exhaustMap(function(a, i) {
            return innerFrom_1.innerFrom(project(a, i)).pipe(map_1.map(function(b, ii) {
              return resultSelector(a, b, i, ii);
            }));
          }));
        };
      }
      return lift_1.operate(function(source, subscriber) {
        var index2 = 0;
        var innerSub = null;
        var isComplete = false;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(outerValue) {
          if (!innerSub) {
            innerSub = OperatorSubscriber_1.createOperatorSubscriber(subscriber, void 0, function() {
              innerSub = null;
              isComplete && subscriber.complete();
            });
            innerFrom_1.innerFrom(project(outerValue, index2++)).subscribe(innerSub);
          }
        }, function() {
          isComplete = true;
          !innerSub && subscriber.complete();
        }));
      });
    }
    exports2.exhaustMap = exhaustMap;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/exhaustAll.js
var require_exhaustAll = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/exhaustAll.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.exhaustAll = void 0;
    var exhaustMap_1 = require_exhaustMap();
    var identity_1 = require_identity();
    function exhaustAll() {
      return exhaustMap_1.exhaustMap(identity_1.identity);
    }
    exports2.exhaustAll = exhaustAll;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/exhaust.js
var require_exhaust = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/exhaust.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.exhaust = void 0;
    var exhaustAll_1 = require_exhaustAll();
    exports2.exhaust = exhaustAll_1.exhaustAll;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/expand.js
var require_expand = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/expand.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.expand = void 0;
    var lift_1 = require_lift();
    var mergeInternals_1 = require_mergeInternals();
    function expand(project, concurrent, scheduler) {
      if (concurrent === void 0) {
        concurrent = Infinity;
      }
      concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
      return lift_1.operate(function(source, subscriber) {
        return mergeInternals_1.mergeInternals(source, subscriber, project, concurrent, void 0, true, scheduler);
      });
    }
    exports2.expand = expand;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/finalize.js
var require_finalize = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/finalize.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.finalize = void 0;
    var lift_1 = require_lift();
    function finalize(callback) {
      return lift_1.operate(function(source, subscriber) {
        try {
          source.subscribe(subscriber);
        } finally {
          subscriber.add(callback);
        }
      });
    }
    exports2.finalize = finalize;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/find.js
var require_find = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/find.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createFind = exports2.find = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function find(predicate, thisArg) {
      return lift_1.operate(createFind(predicate, thisArg, "value"));
    }
    exports2.find = find;
    function createFind(predicate, thisArg, emit) {
      var findIndex = emit === "index";
      return function(source, subscriber) {
        var index2 = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var i = index2++;
          if (predicate.call(thisArg, value, i, source)) {
            subscriber.next(findIndex ? i : value);
            subscriber.complete();
          }
        }, function() {
          subscriber.next(findIndex ? -1 : void 0);
          subscriber.complete();
        }));
      };
    }
    exports2.createFind = createFind;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/findIndex.js
var require_findIndex = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/findIndex.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.findIndex = void 0;
    var lift_1 = require_lift();
    var find_1 = require_find();
    function findIndex(predicate, thisArg) {
      return lift_1.operate(find_1.createFind(predicate, thisArg, "index"));
    }
    exports2.findIndex = findIndex;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/first.js
var require_first = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/first.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.first = void 0;
    var EmptyError_1 = require_EmptyError();
    var filter_1 = require_filter();
    var take_1 = require_take();
    var defaultIfEmpty_1 = require_defaultIfEmpty();
    var throwIfEmpty_1 = require_throwIfEmpty();
    var identity_1 = require_identity();
    function first(predicate, defaultValue) {
      var hasDefaultValue = arguments.length >= 2;
      return function(source) {
        return source.pipe(predicate ? filter_1.filter(function(v, i) {
          return predicate(v, i, source);
        }) : identity_1.identity, take_1.take(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function() {
          return new EmptyError_1.EmptyError();
        }));
      };
    }
    exports2.first = first;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/groupBy.js
var require_groupBy = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/groupBy.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.groupBy = void 0;
    var Observable_1 = require_Observable();
    var innerFrom_1 = require_innerFrom();
    var Subject_1 = require_Subject();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function groupBy(keySelector, elementOrOptions, duration, connector) {
      return lift_1.operate(function(source, subscriber) {
        var element;
        if (!elementOrOptions || typeof elementOrOptions === "function") {
          element = elementOrOptions;
        } else {
          duration = elementOrOptions.duration, element = elementOrOptions.element, connector = elementOrOptions.connector;
        }
        var groups = /* @__PURE__ */ new Map();
        var notify = function(cb) {
          groups.forEach(cb);
          cb(subscriber);
        };
        var handleError = function(err) {
          return notify(function(consumer) {
            return consumer.error(err);
          });
        };
        var activeGroups = 0;
        var teardownAttempted = false;
        var groupBySourceSubscriber = new OperatorSubscriber_1.OperatorSubscriber(subscriber, function(value) {
          try {
            var key_1 = keySelector(value);
            var group_1 = groups.get(key_1);
            if (!group_1) {
              groups.set(key_1, group_1 = connector ? connector() : new Subject_1.Subject());
              var grouped = createGroupedObservable(key_1, group_1);
              subscriber.next(grouped);
              if (duration) {
                var durationSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(group_1, function() {
                  group_1.complete();
                  durationSubscriber_1 === null || durationSubscriber_1 === void 0 ? void 0 : durationSubscriber_1.unsubscribe();
                }, void 0, void 0, function() {
                  return groups.delete(key_1);
                });
                groupBySourceSubscriber.add(innerFrom_1.innerFrom(duration(grouped)).subscribe(durationSubscriber_1));
              }
            }
            group_1.next(element ? element(value) : value);
          } catch (err) {
            handleError(err);
          }
        }, function() {
          return notify(function(consumer) {
            return consumer.complete();
          });
        }, handleError, function() {
          return groups.clear();
        }, function() {
          teardownAttempted = true;
          return activeGroups === 0;
        });
        source.subscribe(groupBySourceSubscriber);
        function createGroupedObservable(key, groupSubject) {
          var result = new Observable_1.Observable(function(groupSubscriber) {
            activeGroups++;
            var innerSub = groupSubject.subscribe(groupSubscriber);
            return function() {
              innerSub.unsubscribe();
              --activeGroups === 0 && teardownAttempted && groupBySourceSubscriber.unsubscribe();
            };
          });
          result.key = key;
          return result;
        }
      });
    }
    exports2.groupBy = groupBy;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/isEmpty.js
var require_isEmpty = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/isEmpty.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.isEmpty = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function isEmpty2() {
      return lift_1.operate(function(source, subscriber) {
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
          subscriber.next(false);
          subscriber.complete();
        }, function() {
          subscriber.next(true);
          subscriber.complete();
        }));
      });
    }
    exports2.isEmpty = isEmpty2;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/takeLast.js
var require_takeLast = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/takeLast.js"(exports2) {
    "use strict";
    var __values5 = exports2 && exports2.__values || function(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
        next: function() {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
        }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.takeLast = void 0;
    var empty_1 = require_empty();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function takeLast(count) {
      return count <= 0 ? function() {
        return empty_1.EMPTY;
      } : lift_1.operate(function(source, subscriber) {
        var buffer2 = [];
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          buffer2.push(value);
          count < buffer2.length && buffer2.shift();
        }, function() {
          var e_1, _a;
          try {
            for (var buffer_1 = __values5(buffer2), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()) {
              var value = buffer_1_1.value;
              subscriber.next(value);
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          subscriber.complete();
        }, void 0, function() {
          buffer2 = null;
        }));
      });
    }
    exports2.takeLast = takeLast;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/last.js
var require_last = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/last.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.last = void 0;
    var EmptyError_1 = require_EmptyError();
    var filter_1 = require_filter();
    var takeLast_1 = require_takeLast();
    var throwIfEmpty_1 = require_throwIfEmpty();
    var defaultIfEmpty_1 = require_defaultIfEmpty();
    var identity_1 = require_identity();
    function last(predicate, defaultValue) {
      var hasDefaultValue = arguments.length >= 2;
      return function(source) {
        return source.pipe(predicate ? filter_1.filter(function(v, i) {
          return predicate(v, i, source);
        }) : identity_1.identity, takeLast_1.takeLast(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function() {
          return new EmptyError_1.EmptyError();
        }));
      };
    }
    exports2.last = last;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/materialize.js
var require_materialize = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/materialize.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.materialize = void 0;
    var Notification_1 = require_Notification();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function materialize() {
      return lift_1.operate(function(source, subscriber) {
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          subscriber.next(Notification_1.Notification.createNext(value));
        }, function() {
          subscriber.next(Notification_1.Notification.createComplete());
          subscriber.complete();
        }, function(err) {
          subscriber.next(Notification_1.Notification.createError(err));
          subscriber.complete();
        }));
      });
    }
    exports2.materialize = materialize;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/max.js
var require_max = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/max.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.max = void 0;
    var reduce_1 = require_reduce();
    var isFunction_1 = require_isFunction();
    function max(comparer) {
      return reduce_1.reduce(isFunction_1.isFunction(comparer) ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
      } : function(x, y) {
        return x > y ? x : y;
      });
    }
    exports2.max = max;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/flatMap.js
var require_flatMap = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/flatMap.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.flatMap = void 0;
    var mergeMap_1 = require_mergeMap();
    exports2.flatMap = mergeMap_1.mergeMap;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeMapTo.js
var require_mergeMapTo = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeMapTo.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.mergeMapTo = void 0;
    var mergeMap_1 = require_mergeMap();
    var isFunction_1 = require_isFunction();
    function mergeMapTo(innerObservable, resultSelector, concurrent) {
      if (concurrent === void 0) {
        concurrent = Infinity;
      }
      if (isFunction_1.isFunction(resultSelector)) {
        return mergeMap_1.mergeMap(function() {
          return innerObservable;
        }, resultSelector, concurrent);
      }
      if (typeof resultSelector === "number") {
        concurrent = resultSelector;
      }
      return mergeMap_1.mergeMap(function() {
        return innerObservable;
      }, concurrent);
    }
    exports2.mergeMapTo = mergeMapTo;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeScan.js
var require_mergeScan = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeScan.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.mergeScan = void 0;
    var lift_1 = require_lift();
    var mergeInternals_1 = require_mergeInternals();
    function mergeScan(accumulator, seed, concurrent) {
      if (concurrent === void 0) {
        concurrent = Infinity;
      }
      return lift_1.operate(function(source, subscriber) {
        var state = seed;
        return mergeInternals_1.mergeInternals(source, subscriber, function(value, index2) {
          return accumulator(state, value, index2);
        }, concurrent, function(value) {
          state = value;
        }, false, void 0, function() {
          return state = null;
        });
      });
    }
    exports2.mergeScan = mergeScan;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/merge.js
var require_merge2 = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/merge.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.merge = void 0;
    var lift_1 = require_lift();
    var mergeAll_1 = require_mergeAll();
    var args_1 = require_args();
    var from_1 = require_from();
    function merge3() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var scheduler = args_1.popScheduler(args);
      var concurrent = args_1.popNumber(args, Infinity);
      return lift_1.operate(function(source, subscriber) {
        mergeAll_1.mergeAll(concurrent)(from_1.from(__spreadArray5([source], __read6(args)), scheduler)).subscribe(subscriber);
      });
    }
    exports2.merge = merge3;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeWith.js
var require_mergeWith = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/mergeWith.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.mergeWith = void 0;
    var merge_1 = require_merge2();
    function mergeWith() {
      var otherSources = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
      }
      return merge_1.merge.apply(void 0, __spreadArray5([], __read6(otherSources)));
    }
    exports2.mergeWith = mergeWith;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/min.js
var require_min = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/min.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.min = void 0;
    var reduce_1 = require_reduce();
    var isFunction_1 = require_isFunction();
    function min(comparer) {
      return reduce_1.reduce(isFunction_1.isFunction(comparer) ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
      } : function(x, y) {
        return x < y ? x : y;
      });
    }
    exports2.min = min;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/multicast.js
var require_multicast = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/multicast.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.multicast = void 0;
    var ConnectableObservable_1 = require_ConnectableObservable();
    var isFunction_1 = require_isFunction();
    var connect_1 = require_connect();
    function multicast(subjectOrSubjectFactory, selector2) {
      var subjectFactory = isFunction_1.isFunction(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function() {
        return subjectOrSubjectFactory;
      };
      if (isFunction_1.isFunction(selector2)) {
        return connect_1.connect(selector2, {
          connector: subjectFactory
        });
      }
      return function(source) {
        return new ConnectableObservable_1.ConnectableObservable(source, subjectFactory);
      };
    }
    exports2.multicast = multicast;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/onErrorResumeNextWith.js
var require_onErrorResumeNextWith = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/onErrorResumeNextWith.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.onErrorResumeNext = exports2.onErrorResumeNextWith = void 0;
    var argsOrArgArray_1 = require_argsOrArgArray();
    var onErrorResumeNext_1 = require_onErrorResumeNext();
    function onErrorResumeNextWith() {
      var sources = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
      }
      var nextSources = argsOrArgArray_1.argsOrArgArray(sources);
      return function(source) {
        return onErrorResumeNext_1.onErrorResumeNext.apply(void 0, __spreadArray5([source], __read6(nextSources)));
      };
    }
    exports2.onErrorResumeNextWith = onErrorResumeNextWith;
    exports2.onErrorResumeNext = onErrorResumeNextWith;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/pairwise.js
var require_pairwise = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/pairwise.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.pairwise = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function pairwise2() {
      return lift_1.operate(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var p = prev;
          prev = value;
          hasPrev && subscriber.next([p, value]);
          hasPrev = true;
        }));
      });
    }
    exports2.pairwise = pairwise2;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/pluck.js
var require_pluck = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/pluck.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.pluck = void 0;
    var map_1 = require_map();
    function pluck() {
      var properties = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
      }
      var length = properties.length;
      if (length === 0) {
        throw new Error("list of properties cannot be empty.");
      }
      return map_1.map(function(x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
          var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
          if (typeof p !== "undefined") {
            currentProp = p;
          } else {
            return void 0;
          }
        }
        return currentProp;
      });
    }
    exports2.pluck = pluck;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/publish.js
var require_publish = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/publish.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.publish = void 0;
    var Subject_1 = require_Subject();
    var multicast_1 = require_multicast();
    var connect_1 = require_connect();
    function publish(selector2) {
      return selector2 ? function(source) {
        return connect_1.connect(selector2)(source);
      } : function(source) {
        return multicast_1.multicast(new Subject_1.Subject())(source);
      };
    }
    exports2.publish = publish;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/publishBehavior.js
var require_publishBehavior = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/publishBehavior.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.publishBehavior = void 0;
    var BehaviorSubject_1 = require_BehaviorSubject();
    var ConnectableObservable_1 = require_ConnectableObservable();
    function publishBehavior(initialValue) {
      return function(source) {
        var subject = new BehaviorSubject_1.BehaviorSubject(initialValue);
        return new ConnectableObservable_1.ConnectableObservable(source, function() {
          return subject;
        });
      };
    }
    exports2.publishBehavior = publishBehavior;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/publishLast.js
var require_publishLast = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/publishLast.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.publishLast = void 0;
    var AsyncSubject_1 = require_AsyncSubject();
    var ConnectableObservable_1 = require_ConnectableObservable();
    function publishLast() {
      return function(source) {
        var subject = new AsyncSubject_1.AsyncSubject();
        return new ConnectableObservable_1.ConnectableObservable(source, function() {
          return subject;
        });
      };
    }
    exports2.publishLast = publishLast;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/publishReplay.js
var require_publishReplay = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/publishReplay.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.publishReplay = void 0;
    var ReplaySubject_1 = require_ReplaySubject();
    var multicast_1 = require_multicast();
    var isFunction_1 = require_isFunction();
    function publishReplay(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
      if (selectorOrScheduler && !isFunction_1.isFunction(selectorOrScheduler)) {
        timestampProvider = selectorOrScheduler;
      }
      var selector2 = isFunction_1.isFunction(selectorOrScheduler) ? selectorOrScheduler : void 0;
      return function(source) {
        return multicast_1.multicast(new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, timestampProvider), selector2)(source);
      };
    }
    exports2.publishReplay = publishReplay;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/raceWith.js
var require_raceWith = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/raceWith.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.raceWith = void 0;
    var race_1 = require_race();
    var lift_1 = require_lift();
    var identity_1 = require_identity();
    function raceWith() {
      var otherSources = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
      }
      return !otherSources.length ? identity_1.identity : lift_1.operate(function(source, subscriber) {
        race_1.raceInit(__spreadArray5([source], __read6(otherSources)))(subscriber);
      });
    }
    exports2.raceWith = raceWith;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/repeat.js
var require_repeat = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/repeat.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.repeat = void 0;
    var empty_1 = require_empty();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var innerFrom_1 = require_innerFrom();
    var timer_1 = require_timer();
    function repeat(countOrConfig) {
      var _a;
      var count = Infinity;
      var delay2;
      if (countOrConfig != null) {
        if (typeof countOrConfig === "object") {
          _a = countOrConfig.count, count = _a === void 0 ? Infinity : _a, delay2 = countOrConfig.delay;
        } else {
          count = countOrConfig;
        }
      }
      return count <= 0 ? function() {
        return empty_1.EMPTY;
      } : lift_1.operate(function(source, subscriber) {
        var soFar = 0;
        var sourceSub;
        var resubscribe = function() {
          sourceSub === null || sourceSub === void 0 ? void 0 : sourceSub.unsubscribe();
          sourceSub = null;
          if (delay2 != null) {
            var notifier = typeof delay2 === "number" ? timer_1.timer(delay2) : innerFrom_1.innerFrom(delay2(soFar));
            var notifierSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
              notifierSubscriber_1.unsubscribe();
              subscribeToSource();
            });
            notifier.subscribe(notifierSubscriber_1);
          } else {
            subscribeToSource();
          }
        };
        var subscribeToSource = function() {
          var syncUnsub = false;
          sourceSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, void 0, function() {
            if (++soFar < count) {
              if (sourceSub) {
                resubscribe();
              } else {
                syncUnsub = true;
              }
            } else {
              subscriber.complete();
            }
          }));
          if (syncUnsub) {
            resubscribe();
          }
        };
        subscribeToSource();
      });
    }
    exports2.repeat = repeat;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/repeatWhen.js
var require_repeatWhen = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/repeatWhen.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.repeatWhen = void 0;
    var innerFrom_1 = require_innerFrom();
    var Subject_1 = require_Subject();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function repeatWhen(notifier) {
      return lift_1.operate(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var completions$;
        var isNotifierComplete = false;
        var isMainComplete = false;
        var checkComplete = function() {
          return isMainComplete && isNotifierComplete && (subscriber.complete(), true);
        };
        var getCompletionSubject = function() {
          if (!completions$) {
            completions$ = new Subject_1.Subject();
            innerFrom_1.innerFrom(notifier(completions$)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
              if (innerSub) {
                subscribeForRepeatWhen();
              } else {
                syncResub = true;
              }
            }, function() {
              isNotifierComplete = true;
              checkComplete();
            }));
          }
          return completions$;
        };
        var subscribeForRepeatWhen = function() {
          isMainComplete = false;
          innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, void 0, function() {
            isMainComplete = true;
            !checkComplete() && getCompletionSubject().next();
          }));
          if (syncResub) {
            innerSub.unsubscribe();
            innerSub = null;
            syncResub = false;
            subscribeForRepeatWhen();
          }
        };
        subscribeForRepeatWhen();
      });
    }
    exports2.repeatWhen = repeatWhen;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/retry.js
var require_retry = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/retry.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.retry = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var identity_1 = require_identity();
    var timer_1 = require_timer();
    var innerFrom_1 = require_innerFrom();
    function retry(configOrCount) {
      if (configOrCount === void 0) {
        configOrCount = Infinity;
      }
      var config2;
      if (configOrCount && typeof configOrCount === "object") {
        config2 = configOrCount;
      } else {
        config2 = {
          count: configOrCount
        };
      }
      var _a = config2.count, count = _a === void 0 ? Infinity : _a, delay2 = config2.delay, _b = config2.resetOnSuccess, resetOnSuccess = _b === void 0 ? false : _b;
      return count <= 0 ? identity_1.identity : lift_1.operate(function(source, subscriber) {
        var soFar = 0;
        var innerSub;
        var subscribeForRetry = function() {
          var syncUnsub = false;
          innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
            if (resetOnSuccess) {
              soFar = 0;
            }
            subscriber.next(value);
          }, void 0, function(err) {
            if (soFar++ < count) {
              var resub_1 = function() {
                if (innerSub) {
                  innerSub.unsubscribe();
                  innerSub = null;
                  subscribeForRetry();
                } else {
                  syncUnsub = true;
                }
              };
              if (delay2 != null) {
                var notifier = typeof delay2 === "number" ? timer_1.timer(delay2) : innerFrom_1.innerFrom(delay2(err, soFar));
                var notifierSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
                  notifierSubscriber_1.unsubscribe();
                  resub_1();
                }, function() {
                  subscriber.complete();
                });
                notifier.subscribe(notifierSubscriber_1);
              } else {
                resub_1();
              }
            } else {
              subscriber.error(err);
            }
          }));
          if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            subscribeForRetry();
          }
        };
        subscribeForRetry();
      });
    }
    exports2.retry = retry;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/retryWhen.js
var require_retryWhen = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/retryWhen.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.retryWhen = void 0;
    var innerFrom_1 = require_innerFrom();
    var Subject_1 = require_Subject();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function retryWhen(notifier) {
      return lift_1.operate(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var errors$;
        var subscribeForRetryWhen = function() {
          innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, void 0, void 0, function(err) {
            if (!errors$) {
              errors$ = new Subject_1.Subject();
              innerFrom_1.innerFrom(notifier(errors$)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
                return innerSub ? subscribeForRetryWhen() : syncResub = true;
              }));
            }
            if (errors$) {
              errors$.next(err);
            }
          }));
          if (syncResub) {
            innerSub.unsubscribe();
            innerSub = null;
            syncResub = false;
            subscribeForRetryWhen();
          }
        };
        subscribeForRetryWhen();
      });
    }
    exports2.retryWhen = retryWhen;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/sample.js
var require_sample = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/sample.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.sample = void 0;
    var innerFrom_1 = require_innerFrom();
    var lift_1 = require_lift();
    var noop_1 = require_noop();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function sample(notifier) {
      return lift_1.operate(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          hasValue = true;
          lastValue = value;
        }));
        innerFrom_1.innerFrom(notifier).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
          if (hasValue) {
            hasValue = false;
            var value = lastValue;
            lastValue = null;
            subscriber.next(value);
          }
        }, noop_1.noop));
      });
    }
    exports2.sample = sample;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/sampleTime.js
var require_sampleTime = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/sampleTime.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.sampleTime = void 0;
    var async_1 = require_async();
    var sample_1 = require_sample();
    var interval_1 = require_interval();
    function sampleTime(period, scheduler) {
      if (scheduler === void 0) {
        scheduler = async_1.asyncScheduler;
      }
      return sample_1.sample(interval_1.interval(period, scheduler));
    }
    exports2.sampleTime = sampleTime;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/scan.js
var require_scan = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/scan.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.scan = void 0;
    var lift_1 = require_lift();
    var scanInternals_1 = require_scanInternals();
    function scan(accumulator, seed) {
      return lift_1.operate(scanInternals_1.scanInternals(accumulator, seed, arguments.length >= 2, true));
    }
    exports2.scan = scan;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/sequenceEqual.js
var require_sequenceEqual = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/sequenceEqual.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.sequenceEqual = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var innerFrom_1 = require_innerFrom();
    function sequenceEqual(compareTo, comparator) {
      if (comparator === void 0) {
        comparator = function(a, b) {
          return a === b;
        };
      }
      return lift_1.operate(function(source, subscriber) {
        var aState = createState();
        var bState = createState();
        var emit = function(isEqual2) {
          subscriber.next(isEqual2);
          subscriber.complete();
        };
        var createSubscriber = function(selfState, otherState) {
          var sequenceEqualSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(a) {
            var buffer2 = otherState.buffer, complete = otherState.complete;
            if (buffer2.length === 0) {
              complete ? emit(false) : selfState.buffer.push(a);
            } else {
              !comparator(a, buffer2.shift()) && emit(false);
            }
          }, function() {
            selfState.complete = true;
            var complete = otherState.complete, buffer2 = otherState.buffer;
            complete && emit(buffer2.length === 0);
            sequenceEqualSubscriber === null || sequenceEqualSubscriber === void 0 ? void 0 : sequenceEqualSubscriber.unsubscribe();
          });
          return sequenceEqualSubscriber;
        };
        source.subscribe(createSubscriber(aState, bState));
        innerFrom_1.innerFrom(compareTo).subscribe(createSubscriber(bState, aState));
      });
    }
    exports2.sequenceEqual = sequenceEqual;
    function createState() {
      return {
        buffer: [],
        complete: false
      };
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/share.js
var require_share = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/share.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.share = void 0;
    var innerFrom_1 = require_innerFrom();
    var Subject_1 = require_Subject();
    var Subscriber_1 = require_Subscriber();
    var lift_1 = require_lift();
    function share(options) {
      if (options === void 0) {
        options = {};
      }
      var _a = options.connector, connector = _a === void 0 ? function() {
        return new Subject_1.Subject();
      } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
      return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
          resetConnection === null || resetConnection === void 0 ? void 0 : resetConnection.unsubscribe();
          resetConnection = void 0;
        };
        var reset2 = function() {
          cancelReset();
          connection = subject = void 0;
          hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
          var conn = connection;
          reset2();
          conn === null || conn === void 0 ? void 0 : conn.unsubscribe();
        };
        return lift_1.operate(function(source, subscriber) {
          refCount++;
          if (!hasErrored && !hasCompleted) {
            cancelReset();
          }
          var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
          subscriber.add(function() {
            refCount--;
            if (refCount === 0 && !hasErrored && !hasCompleted) {
              resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            }
          });
          dest.subscribe(subscriber);
          if (!connection && refCount > 0) {
            connection = new Subscriber_1.SafeSubscriber({
              next: function(value) {
                return dest.next(value);
              },
              error: function(err) {
                hasErrored = true;
                cancelReset();
                resetConnection = handleReset(reset2, resetOnError, err);
                dest.error(err);
              },
              complete: function() {
                hasCompleted = true;
                cancelReset();
                resetConnection = handleReset(reset2, resetOnComplete);
                dest.complete();
              }
            });
            innerFrom_1.innerFrom(source).subscribe(connection);
          }
        })(wrapperSource);
      };
    }
    exports2.share = share;
    function handleReset(reset2, on) {
      var args = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
      }
      if (on === true) {
        reset2();
        return;
      }
      if (on === false) {
        return;
      }
      var onSubscriber = new Subscriber_1.SafeSubscriber({
        next: function() {
          onSubscriber.unsubscribe();
          reset2();
        }
      });
      return innerFrom_1.innerFrom(on.apply(void 0, __spreadArray5([], __read6(args)))).subscribe(onSubscriber);
    }
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/shareReplay.js
var require_shareReplay = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/shareReplay.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.shareReplay = void 0;
    var ReplaySubject_1 = require_ReplaySubject();
    var share_1 = require_share();
    function shareReplay(configOrBufferSize, windowTime, scheduler) {
      var _a, _b, _c;
      var bufferSize;
      var refCount = false;
      if (configOrBufferSize && typeof configOrBufferSize === "object") {
        _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
      } else {
        bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
      }
      return share_1.share({
        connector: function() {
          return new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
      });
    }
    exports2.shareReplay = shareReplay;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/single.js
var require_single = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/single.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.single = void 0;
    var EmptyError_1 = require_EmptyError();
    var SequenceError_1 = require_SequenceError();
    var NotFoundError_1 = require_NotFoundError();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function single(predicate) {
      return lift_1.operate(function(source, subscriber) {
        var hasValue = false;
        var singleValue;
        var seenValue = false;
        var index2 = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          seenValue = true;
          if (!predicate || predicate(value, index2++, source)) {
            hasValue && subscriber.error(new SequenceError_1.SequenceError("Too many matching values"));
            hasValue = true;
            singleValue = value;
          }
        }, function() {
          if (hasValue) {
            subscriber.next(singleValue);
            subscriber.complete();
          } else {
            subscriber.error(seenValue ? new NotFoundError_1.NotFoundError("No matching values") : new EmptyError_1.EmptyError());
          }
        }));
      });
    }
    exports2.single = single;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/skip.js
var require_skip = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/skip.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.skip = void 0;
    var filter_1 = require_filter();
    function skip(count) {
      return filter_1.filter(function(_, index2) {
        return count <= index2;
      });
    }
    exports2.skip = skip;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/skipLast.js
var require_skipLast = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/skipLast.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.skipLast = void 0;
    var identity_1 = require_identity();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function skipLast(skipCount) {
      return skipCount <= 0 ? identity_1.identity : lift_1.operate(function(source, subscriber) {
        var ring = new Array(skipCount);
        var seen = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var valueIndex = seen++;
          if (valueIndex < skipCount) {
            ring[valueIndex] = value;
          } else {
            var index2 = valueIndex % skipCount;
            var oldValue = ring[index2];
            ring[index2] = value;
            subscriber.next(oldValue);
          }
        }));
        return function() {
          ring = null;
        };
      });
    }
    exports2.skipLast = skipLast;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/skipUntil.js
var require_skipUntil = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/skipUntil.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.skipUntil = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var innerFrom_1 = require_innerFrom();
    var noop_1 = require_noop();
    function skipUntil(notifier) {
      return lift_1.operate(function(source, subscriber) {
        var taking = false;
        var skipSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
          skipSubscriber === null || skipSubscriber === void 0 ? void 0 : skipSubscriber.unsubscribe();
          taking = true;
        }, noop_1.noop);
        innerFrom_1.innerFrom(notifier).subscribe(skipSubscriber);
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          return taking && subscriber.next(value);
        }));
      });
    }
    exports2.skipUntil = skipUntil;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/skipWhile.js
var require_skipWhile = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/skipWhile.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.skipWhile = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function skipWhile(predicate) {
      return lift_1.operate(function(source, subscriber) {
        var taking = false;
        var index2 = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          return (taking || (taking = !predicate(value, index2++))) && subscriber.next(value);
        }));
      });
    }
    exports2.skipWhile = skipWhile;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/startWith.js
var require_startWith = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/startWith.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.startWith = void 0;
    var concat_1 = require_concat();
    var args_1 = require_args();
    var lift_1 = require_lift();
    function startWith() {
      var values = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
      }
      var scheduler = args_1.popScheduler(values);
      return lift_1.operate(function(source, subscriber) {
        (scheduler ? concat_1.concat(values, source, scheduler) : concat_1.concat(values, source)).subscribe(subscriber);
      });
    }
    exports2.startWith = startWith;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/switchMap.js
var require_switchMap = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/switchMap.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.switchMap = void 0;
    var innerFrom_1 = require_innerFrom();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function switchMap2(project, resultSelector) {
      return lift_1.operate(function(source, subscriber) {
        var innerSubscriber = null;
        var index2 = 0;
        var isComplete = false;
        var checkComplete = function() {
          return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
          var innerIndex = 0;
          var outerIndex = index2++;
          innerFrom_1.innerFrom(project(value, outerIndex)).subscribe(innerSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(innerValue) {
            return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
          }, function() {
            innerSubscriber = null;
            checkComplete();
          }));
        }, function() {
          isComplete = true;
          checkComplete();
        }));
      });
    }
    exports2.switchMap = switchMap2;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/switchAll.js
var require_switchAll = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/switchAll.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.switchAll = void 0;
    var switchMap_1 = require_switchMap();
    var identity_1 = require_identity();
    function switchAll() {
      return switchMap_1.switchMap(identity_1.identity);
    }
    exports2.switchAll = switchAll;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/switchMapTo.js
var require_switchMapTo = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/switchMapTo.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.switchMapTo = void 0;
    var switchMap_1 = require_switchMap();
    var isFunction_1 = require_isFunction();
    function switchMapTo(innerObservable, resultSelector) {
      return isFunction_1.isFunction(resultSelector) ? switchMap_1.switchMap(function() {
        return innerObservable;
      }, resultSelector) : switchMap_1.switchMap(function() {
        return innerObservable;
      });
    }
    exports2.switchMapTo = switchMapTo;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/switchScan.js
var require_switchScan = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/switchScan.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.switchScan = void 0;
    var switchMap_1 = require_switchMap();
    var lift_1 = require_lift();
    function switchScan(accumulator, seed) {
      return lift_1.operate(function(source, subscriber) {
        var state = seed;
        switchMap_1.switchMap(function(value, index2) {
          return accumulator(state, value, index2);
        }, function(_, innerValue) {
          return state = innerValue, innerValue;
        })(source).subscribe(subscriber);
        return function() {
          state = null;
        };
      });
    }
    exports2.switchScan = switchScan;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/takeUntil.js
var require_takeUntil = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/takeUntil.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.takeUntil = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var innerFrom_1 = require_innerFrom();
    var noop_1 = require_noop();
    function takeUntil(notifier) {
      return lift_1.operate(function(source, subscriber) {
        innerFrom_1.innerFrom(notifier).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
          return subscriber.complete();
        }, noop_1.noop));
        !subscriber.closed && source.subscribe(subscriber);
      });
    }
    exports2.takeUntil = takeUntil;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/takeWhile.js
var require_takeWhile = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/takeWhile.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.takeWhile = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function takeWhile(predicate, inclusive) {
      if (inclusive === void 0) {
        inclusive = false;
      }
      return lift_1.operate(function(source, subscriber) {
        var index2 = 0;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var result = predicate(value, index2++);
          (result || inclusive) && subscriber.next(value);
          !result && subscriber.complete();
        }));
      });
    }
    exports2.takeWhile = takeWhile;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/tap.js
var require_tap = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/tap.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.tap = void 0;
    var isFunction_1 = require_isFunction();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var identity_1 = require_identity();
    function tap(observerOrNext, error, complete) {
      var tapObserver = isFunction_1.isFunction(observerOrNext) || error || complete ? { next: observerOrNext, error, complete } : observerOrNext;
      return tapObserver ? lift_1.operate(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var _a2;
          (_a2 = tapObserver.next) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver, value);
          subscriber.next(value);
        }, function() {
          var _a2;
          isUnsub = false;
          (_a2 = tapObserver.complete) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver);
          subscriber.complete();
        }, function(err) {
          var _a2;
          isUnsub = false;
          (_a2 = tapObserver.error) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver, err);
          subscriber.error(err);
        }, function() {
          var _a2, _b;
          if (isUnsub) {
            (_a2 = tapObserver.unsubscribe) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver);
          }
          (_b = tapObserver.finalize) === null || _b === void 0 ? void 0 : _b.call(tapObserver);
        }));
      }) : identity_1.identity;
    }
    exports2.tap = tap;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/throttle.js
var require_throttle = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/throttle.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.throttle = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var innerFrom_1 = require_innerFrom();
    function throttle(durationSelector, config2) {
      return lift_1.operate(function(source, subscriber) {
        var _a = config2 !== null && config2 !== void 0 ? config2 : {}, _b = _a.leading, leading = _b === void 0 ? true : _b, _c = _a.trailing, trailing = _c === void 0 ? false : _c;
        var hasValue = false;
        var sendValue = null;
        var throttled = null;
        var isComplete = false;
        var endThrottling = function() {
          throttled === null || throttled === void 0 ? void 0 : throttled.unsubscribe();
          throttled = null;
          if (trailing) {
            send();
            isComplete && subscriber.complete();
          }
        };
        var cleanupThrottling = function() {
          throttled = null;
          isComplete && subscriber.complete();
        };
        var startThrottle = function(value) {
          return throttled = innerFrom_1.innerFrom(durationSelector(value)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, endThrottling, cleanupThrottling));
        };
        var send = function() {
          if (hasValue) {
            hasValue = false;
            var value = sendValue;
            sendValue = null;
            subscriber.next(value);
            !isComplete && startThrottle(value);
          }
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          hasValue = true;
          sendValue = value;
          !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
        }, function() {
          isComplete = true;
          !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
        }));
      });
    }
    exports2.throttle = throttle;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/throttleTime.js
var require_throttleTime = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/throttleTime.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.throttleTime = void 0;
    var async_1 = require_async();
    var throttle_1 = require_throttle();
    var timer_1 = require_timer();
    function throttleTime(duration, scheduler, config2) {
      if (scheduler === void 0) {
        scheduler = async_1.asyncScheduler;
      }
      var duration$ = timer_1.timer(duration, scheduler);
      return throttle_1.throttle(function() {
        return duration$;
      }, config2);
    }
    exports2.throttleTime = throttleTime;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/timeInterval.js
var require_timeInterval = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/timeInterval.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.TimeInterval = exports2.timeInterval = void 0;
    var async_1 = require_async();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function timeInterval(scheduler) {
      if (scheduler === void 0) {
        scheduler = async_1.asyncScheduler;
      }
      return lift_1.operate(function(source, subscriber) {
        var last = scheduler.now();
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var now = scheduler.now();
          var interval = now - last;
          last = now;
          subscriber.next(new TimeInterval(value, interval));
        }));
      });
    }
    exports2.timeInterval = timeInterval;
    var TimeInterval = /* @__PURE__ */ function() {
      function TimeInterval2(value, interval) {
        this.value = value;
        this.interval = interval;
      }
      return TimeInterval2;
    }();
    exports2.TimeInterval = TimeInterval;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/timeoutWith.js
var require_timeoutWith = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/timeoutWith.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.timeoutWith = void 0;
    var async_1 = require_async();
    var isDate_1 = require_isDate();
    var timeout_1 = require_timeout();
    function timeoutWith(due, withObservable, scheduler) {
      var first;
      var each;
      var _with;
      scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : async_1.async;
      if (isDate_1.isValidDate(due)) {
        first = due;
      } else if (typeof due === "number") {
        each = due;
      }
      if (withObservable) {
        _with = function() {
          return withObservable;
        };
      } else {
        throw new TypeError("No observable provided to switch to");
      }
      if (first == null && each == null) {
        throw new TypeError("No timeout provided.");
      }
      return timeout_1.timeout({
        first,
        each,
        scheduler,
        with: _with
      });
    }
    exports2.timeoutWith = timeoutWith;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/timestamp.js
var require_timestamp = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/timestamp.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.timestamp = void 0;
    var dateTimestampProvider_1 = require_dateTimestampProvider();
    var map_1 = require_map();
    function timestamp(timestampProvider) {
      if (timestampProvider === void 0) {
        timestampProvider = dateTimestampProvider_1.dateTimestampProvider;
      }
      return map_1.map(function(value) {
        return { value, timestamp: timestampProvider.now() };
      });
    }
    exports2.timestamp = timestamp;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/window.js
var require_window = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/window.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.window = void 0;
    var Subject_1 = require_Subject();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var noop_1 = require_noop();
    var innerFrom_1 = require_innerFrom();
    function window2(windowBoundaries) {
      return lift_1.operate(function(source, subscriber) {
        var windowSubject = new Subject_1.Subject();
        subscriber.next(windowSubject.asObservable());
        var errorHandler = function(err) {
          windowSubject.error(err);
          subscriber.error(err);
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          return windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.next(value);
        }, function() {
          windowSubject.complete();
          subscriber.complete();
        }, errorHandler));
        innerFrom_1.innerFrom(windowBoundaries).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function() {
          windowSubject.complete();
          subscriber.next(windowSubject = new Subject_1.Subject());
        }, noop_1.noop, errorHandler));
        return function() {
          windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.unsubscribe();
          windowSubject = null;
        };
      });
    }
    exports2.window = window2;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/windowCount.js
var require_windowCount = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/windowCount.js"(exports2) {
    "use strict";
    var __values5 = exports2 && exports2.__values || function(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
        next: function() {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
        }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.windowCount = void 0;
    var Subject_1 = require_Subject();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    function windowCount(windowSize, startWindowEvery) {
      if (startWindowEvery === void 0) {
        startWindowEvery = 0;
      }
      var startEvery = startWindowEvery > 0 ? startWindowEvery : windowSize;
      return lift_1.operate(function(source, subscriber) {
        var windows = [new Subject_1.Subject()];
        var starts = [];
        var count = 0;
        subscriber.next(windows[0].asObservable());
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var e_1, _a;
          try {
            for (var windows_1 = __values5(windows), windows_1_1 = windows_1.next(); !windows_1_1.done; windows_1_1 = windows_1.next()) {
              var window_1 = windows_1_1.value;
              window_1.next(value);
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (windows_1_1 && !windows_1_1.done && (_a = windows_1.return)) _a.call(windows_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          var c = count - windowSize + 1;
          if (c >= 0 && c % startEvery === 0) {
            windows.shift().complete();
          }
          if (++count % startEvery === 0) {
            var window_2 = new Subject_1.Subject();
            windows.push(window_2);
            subscriber.next(window_2.asObservable());
          }
        }, function() {
          while (windows.length > 0) {
            windows.shift().complete();
          }
          subscriber.complete();
        }, function(err) {
          while (windows.length > 0) {
            windows.shift().error(err);
          }
          subscriber.error(err);
        }, function() {
          starts = null;
          windows = null;
        }));
      });
    }
    exports2.windowCount = windowCount;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/windowTime.js
var require_windowTime = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/windowTime.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.windowTime = void 0;
    var Subject_1 = require_Subject();
    var async_1 = require_async();
    var Subscription_1 = require_Subscription();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var arrRemove_1 = require_arrRemove();
    var args_1 = require_args();
    var executeSchedule_1 = require_executeSchedule();
    function windowTime(windowTimeSpan) {
      var _a, _b;
      var otherArgs = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        otherArgs[_i - 1] = arguments[_i];
      }
      var scheduler = (_a = args_1.popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : async_1.asyncScheduler;
      var windowCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
      var maxWindowSize = otherArgs[1] || Infinity;
      return lift_1.operate(function(source, subscriber) {
        var windowRecords = [];
        var restartOnClose = false;
        var closeWindow = function(record) {
          var window2 = record.window, subs = record.subs;
          window2.complete();
          subs.unsubscribe();
          arrRemove_1.arrRemove(windowRecords, record);
          restartOnClose && startWindow();
        };
        var startWindow = function() {
          if (windowRecords) {
            var subs = new Subscription_1.Subscription();
            subscriber.add(subs);
            var window_1 = new Subject_1.Subject();
            var record_1 = {
              window: window_1,
              subs,
              seen: 0
            };
            windowRecords.push(record_1);
            subscriber.next(window_1.asObservable());
            executeSchedule_1.executeSchedule(subs, scheduler, function() {
              return closeWindow(record_1);
            }, windowTimeSpan);
          }
        };
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
          executeSchedule_1.executeSchedule(subscriber, scheduler, startWindow, windowCreationInterval, true);
        } else {
          restartOnClose = true;
        }
        startWindow();
        var loop = function(cb) {
          return windowRecords.slice().forEach(cb);
        };
        var terminate = function(cb) {
          loop(function(_a2) {
            var window2 = _a2.window;
            return cb(window2);
          });
          cb(subscriber);
          subscriber.unsubscribe();
        };
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          loop(function(record) {
            record.window.next(value);
            maxWindowSize <= ++record.seen && closeWindow(record);
          });
        }, function() {
          return terminate(function(consumer) {
            return consumer.complete();
          });
        }, function(err) {
          return terminate(function(consumer) {
            return consumer.error(err);
          });
        }));
        return function() {
          windowRecords = null;
        };
      });
    }
    exports2.windowTime = windowTime;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/windowToggle.js
var require_windowToggle = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/windowToggle.js"(exports2) {
    "use strict";
    var __values5 = exports2 && exports2.__values || function(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
        next: function() {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
        }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.windowToggle = void 0;
    var Subject_1 = require_Subject();
    var Subscription_1 = require_Subscription();
    var lift_1 = require_lift();
    var innerFrom_1 = require_innerFrom();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var noop_1 = require_noop();
    var arrRemove_1 = require_arrRemove();
    function windowToggle(openings, closingSelector) {
      return lift_1.operate(function(source, subscriber) {
        var windows = [];
        var handleError = function(err) {
          while (0 < windows.length) {
            windows.shift().error(err);
          }
          subscriber.error(err);
        };
        innerFrom_1.innerFrom(openings).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(openValue) {
          var window2 = new Subject_1.Subject();
          windows.push(window2);
          var closingSubscription = new Subscription_1.Subscription();
          var closeWindow = function() {
            arrRemove_1.arrRemove(windows, window2);
            window2.complete();
            closingSubscription.unsubscribe();
          };
          var closingNotifier;
          try {
            closingNotifier = innerFrom_1.innerFrom(closingSelector(openValue));
          } catch (err) {
            handleError(err);
            return;
          }
          subscriber.next(window2.asObservable());
          closingSubscription.add(closingNotifier.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, closeWindow, noop_1.noop, handleError)));
        }, noop_1.noop));
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          var e_1, _a;
          var windowsCopy = windows.slice();
          try {
            for (var windowsCopy_1 = __values5(windowsCopy), windowsCopy_1_1 = windowsCopy_1.next(); !windowsCopy_1_1.done; windowsCopy_1_1 = windowsCopy_1.next()) {
              var window_1 = windowsCopy_1_1.value;
              window_1.next(value);
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (windowsCopy_1_1 && !windowsCopy_1_1.done && (_a = windowsCopy_1.return)) _a.call(windowsCopy_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        }, function() {
          while (0 < windows.length) {
            windows.shift().complete();
          }
          subscriber.complete();
        }, handleError, function() {
          while (0 < windows.length) {
            windows.shift().unsubscribe();
          }
        }));
      });
    }
    exports2.windowToggle = windowToggle;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/windowWhen.js
var require_windowWhen = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/windowWhen.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.windowWhen = void 0;
    var Subject_1 = require_Subject();
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var innerFrom_1 = require_innerFrom();
    function windowWhen(closingSelector) {
      return lift_1.operate(function(source, subscriber) {
        var window2;
        var closingSubscriber;
        var handleError = function(err) {
          window2.error(err);
          subscriber.error(err);
        };
        var openWindow = function() {
          closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
          window2 === null || window2 === void 0 ? void 0 : window2.complete();
          window2 = new Subject_1.Subject();
          subscriber.next(window2.asObservable());
          var closingNotifier;
          try {
            closingNotifier = innerFrom_1.innerFrom(closingSelector());
          } catch (err) {
            handleError(err);
            return;
          }
          closingNotifier.subscribe(closingSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, openWindow, openWindow, handleError));
        };
        openWindow();
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          return window2.next(value);
        }, function() {
          window2.complete();
          subscriber.complete();
        }, handleError, function() {
          closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
          window2 = null;
        }));
      });
    }
    exports2.windowWhen = windowWhen;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/withLatestFrom.js
var require_withLatestFrom = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/withLatestFrom.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.withLatestFrom = void 0;
    var lift_1 = require_lift();
    var OperatorSubscriber_1 = require_OperatorSubscriber();
    var innerFrom_1 = require_innerFrom();
    var identity_1 = require_identity();
    var noop_1 = require_noop();
    var args_1 = require_args();
    function withLatestFrom() {
      var inputs = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
      }
      var project = args_1.popResultSelector(inputs);
      return lift_1.operate(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
          return false;
        });
        var ready = false;
        var _loop_1 = function(i2) {
          innerFrom_1.innerFrom(inputs[i2]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
            otherValues[i2] = value;
            if (!ready && !hasValue[i2]) {
              hasValue[i2] = true;
              (ready = hasValue.every(identity_1.identity)) && (hasValue = null);
            }
          }, noop_1.noop));
        };
        for (var i = 0; i < len; i++) {
          _loop_1(i);
        }
        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function(value) {
          if (ready) {
            var values = __spreadArray5([value], __read6(otherValues));
            subscriber.next(project ? project.apply(void 0, __spreadArray5([], __read6(values))) : values);
          }
        }));
      });
    }
    exports2.withLatestFrom = withLatestFrom;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/zipAll.js
var require_zipAll = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/zipAll.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.zipAll = void 0;
    var zip_1 = require_zip();
    var joinAllInternals_1 = require_joinAllInternals();
    function zipAll(project) {
      return joinAllInternals_1.joinAllInternals(zip_1.zip, project);
    }
    exports2.zipAll = zipAll;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/zip.js
var require_zip2 = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/zip.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.zip = void 0;
    var zip_1 = require_zip();
    var lift_1 = require_lift();
    function zip() {
      var sources = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
      }
      return lift_1.operate(function(source, subscriber) {
        zip_1.zip.apply(void 0, __spreadArray5([source], __read6(sources))).subscribe(subscriber);
      });
    }
    exports2.zip = zip;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/zipWith.js
var require_zipWith = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/internal/operators/zipWith.js"(exports2) {
    "use strict";
    var __read6 = exports2 && exports2.__read || function(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = { error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    };
    var __spreadArray5 = exports2 && exports2.__spreadArray || function(to, from) {
      for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
      return to;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.zipWith = void 0;
    var zip_1 = require_zip2();
    function zipWith() {
      var otherInputs = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        otherInputs[_i] = arguments[_i];
      }
      return zip_1.zip.apply(void 0, __spreadArray5([], __read6(otherInputs)));
    }
    exports2.zipWith = zipWith;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/index.js
var require_cjs = __commonJS({
  "node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/cjs/index.js"(exports2) {
    "use strict";
    var __createBinding = exports2 && exports2.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      Object.defineProperty(o, k2, { enumerable: true, get: function() {
        return m[k];
      } });
    } : function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    });
    var __exportStar = exports2 && exports2.__exportStar || function(m, exports3) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p)) __createBinding(exports3, m, p);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.interval = exports2.iif = exports2.generate = exports2.fromEventPattern = exports2.fromEvent = exports2.from = exports2.forkJoin = exports2.empty = exports2.defer = exports2.connectable = exports2.concat = exports2.combineLatest = exports2.bindNodeCallback = exports2.bindCallback = exports2.UnsubscriptionError = exports2.TimeoutError = exports2.SequenceError = exports2.ObjectUnsubscribedError = exports2.NotFoundError = exports2.EmptyError = exports2.ArgumentOutOfRangeError = exports2.firstValueFrom = exports2.lastValueFrom = exports2.isObservable = exports2.identity = exports2.noop = exports2.pipe = exports2.NotificationKind = exports2.Notification = exports2.Subscriber = exports2.Subscription = exports2.Scheduler = exports2.VirtualAction = exports2.VirtualTimeScheduler = exports2.animationFrameScheduler = exports2.animationFrame = exports2.queueScheduler = exports2.queue = exports2.asyncScheduler = exports2.async = exports2.asapScheduler = exports2.asap = exports2.AsyncSubject = exports2.ReplaySubject = exports2.BehaviorSubject = exports2.Subject = exports2.animationFrames = exports2.observable = exports2.ConnectableObservable = exports2.Observable = void 0;
    exports2.filter = exports2.expand = exports2.exhaustMap = exports2.exhaustAll = exports2.exhaust = exports2.every = exports2.endWith = exports2.elementAt = exports2.distinctUntilKeyChanged = exports2.distinctUntilChanged = exports2.distinct = exports2.dematerialize = exports2.delayWhen = exports2.delay = exports2.defaultIfEmpty = exports2.debounceTime = exports2.debounce = exports2.count = exports2.connect = exports2.concatWith = exports2.concatMapTo = exports2.concatMap = exports2.concatAll = exports2.combineLatestWith = exports2.combineLatestAll = exports2.combineAll = exports2.catchError = exports2.bufferWhen = exports2.bufferToggle = exports2.bufferTime = exports2.bufferCount = exports2.buffer = exports2.auditTime = exports2.audit = exports2.config = exports2.NEVER = exports2.EMPTY = exports2.scheduled = exports2.zip = exports2.using = exports2.timer = exports2.throwError = exports2.range = exports2.race = exports2.partition = exports2.pairs = exports2.onErrorResumeNext = exports2.of = exports2.never = exports2.merge = void 0;
    exports2.switchMap = exports2.switchAll = exports2.subscribeOn = exports2.startWith = exports2.skipWhile = exports2.skipUntil = exports2.skipLast = exports2.skip = exports2.single = exports2.shareReplay = exports2.share = exports2.sequenceEqual = exports2.scan = exports2.sampleTime = exports2.sample = exports2.refCount = exports2.retryWhen = exports2.retry = exports2.repeatWhen = exports2.repeat = exports2.reduce = exports2.raceWith = exports2.publishReplay = exports2.publishLast = exports2.publishBehavior = exports2.publish = exports2.pluck = exports2.pairwise = exports2.onErrorResumeNextWith = exports2.observeOn = exports2.multicast = exports2.min = exports2.mergeWith = exports2.mergeScan = exports2.mergeMapTo = exports2.mergeMap = exports2.flatMap = exports2.mergeAll = exports2.max = exports2.materialize = exports2.mapTo = exports2.map = exports2.last = exports2.isEmpty = exports2.ignoreElements = exports2.groupBy = exports2.first = exports2.findIndex = exports2.find = exports2.finalize = void 0;
    exports2.zipWith = exports2.zipAll = exports2.withLatestFrom = exports2.windowWhen = exports2.windowToggle = exports2.windowTime = exports2.windowCount = exports2.window = exports2.toArray = exports2.timestamp = exports2.timeoutWith = exports2.timeout = exports2.timeInterval = exports2.throwIfEmpty = exports2.throttleTime = exports2.throttle = exports2.tap = exports2.takeWhile = exports2.takeUntil = exports2.takeLast = exports2.take = exports2.switchScan = exports2.switchMapTo = void 0;
    var Observable_1 = require_Observable();
    Object.defineProperty(exports2, "Observable", { enumerable: true, get: function() {
      return Observable_1.Observable;
    } });
    var ConnectableObservable_1 = require_ConnectableObservable();
    Object.defineProperty(exports2, "ConnectableObservable", { enumerable: true, get: function() {
      return ConnectableObservable_1.ConnectableObservable;
    } });
    var observable_1 = require_observable();
    Object.defineProperty(exports2, "observable", { enumerable: true, get: function() {
      return observable_1.observable;
    } });
    var animationFrames_1 = require_animationFrames();
    Object.defineProperty(exports2, "animationFrames", { enumerable: true, get: function() {
      return animationFrames_1.animationFrames;
    } });
    var Subject_1 = require_Subject();
    Object.defineProperty(exports2, "Subject", { enumerable: true, get: function() {
      return Subject_1.Subject;
    } });
    var BehaviorSubject_1 = require_BehaviorSubject();
    Object.defineProperty(exports2, "BehaviorSubject", { enumerable: true, get: function() {
      return BehaviorSubject_1.BehaviorSubject;
    } });
    var ReplaySubject_1 = require_ReplaySubject();
    Object.defineProperty(exports2, "ReplaySubject", { enumerable: true, get: function() {
      return ReplaySubject_1.ReplaySubject;
    } });
    var AsyncSubject_1 = require_AsyncSubject();
    Object.defineProperty(exports2, "AsyncSubject", { enumerable: true, get: function() {
      return AsyncSubject_1.AsyncSubject;
    } });
    var asap_1 = require_asap();
    Object.defineProperty(exports2, "asap", { enumerable: true, get: function() {
      return asap_1.asap;
    } });
    Object.defineProperty(exports2, "asapScheduler", { enumerable: true, get: function() {
      return asap_1.asapScheduler;
    } });
    var async_1 = require_async();
    Object.defineProperty(exports2, "async", { enumerable: true, get: function() {
      return async_1.async;
    } });
    Object.defineProperty(exports2, "asyncScheduler", { enumerable: true, get: function() {
      return async_1.asyncScheduler;
    } });
    var queue_1 = require_queue();
    Object.defineProperty(exports2, "queue", { enumerable: true, get: function() {
      return queue_1.queue;
    } });
    Object.defineProperty(exports2, "queueScheduler", { enumerable: true, get: function() {
      return queue_1.queueScheduler;
    } });
    var animationFrame_1 = require_animationFrame();
    Object.defineProperty(exports2, "animationFrame", { enumerable: true, get: function() {
      return animationFrame_1.animationFrame;
    } });
    Object.defineProperty(exports2, "animationFrameScheduler", { enumerable: true, get: function() {
      return animationFrame_1.animationFrameScheduler;
    } });
    var VirtualTimeScheduler_1 = require_VirtualTimeScheduler();
    Object.defineProperty(exports2, "VirtualTimeScheduler", { enumerable: true, get: function() {
      return VirtualTimeScheduler_1.VirtualTimeScheduler;
    } });
    Object.defineProperty(exports2, "VirtualAction", { enumerable: true, get: function() {
      return VirtualTimeScheduler_1.VirtualAction;
    } });
    var Scheduler_1 = require_Scheduler();
    Object.defineProperty(exports2, "Scheduler", { enumerable: true, get: function() {
      return Scheduler_1.Scheduler;
    } });
    var Subscription_1 = require_Subscription();
    Object.defineProperty(exports2, "Subscription", { enumerable: true, get: function() {
      return Subscription_1.Subscription;
    } });
    var Subscriber_1 = require_Subscriber();
    Object.defineProperty(exports2, "Subscriber", { enumerable: true, get: function() {
      return Subscriber_1.Subscriber;
    } });
    var Notification_1 = require_Notification();
    Object.defineProperty(exports2, "Notification", { enumerable: true, get: function() {
      return Notification_1.Notification;
    } });
    Object.defineProperty(exports2, "NotificationKind", { enumerable: true, get: function() {
      return Notification_1.NotificationKind;
    } });
    var pipe_1 = require_pipe();
    Object.defineProperty(exports2, "pipe", { enumerable: true, get: function() {
      return pipe_1.pipe;
    } });
    var noop_1 = require_noop();
    Object.defineProperty(exports2, "noop", { enumerable: true, get: function() {
      return noop_1.noop;
    } });
    var identity_1 = require_identity();
    Object.defineProperty(exports2, "identity", { enumerable: true, get: function() {
      return identity_1.identity;
    } });
    var isObservable_1 = require_isObservable();
    Object.defineProperty(exports2, "isObservable", { enumerable: true, get: function() {
      return isObservable_1.isObservable;
    } });
    var lastValueFrom_1 = require_lastValueFrom();
    Object.defineProperty(exports2, "lastValueFrom", { enumerable: true, get: function() {
      return lastValueFrom_1.lastValueFrom;
    } });
    var firstValueFrom_1 = require_firstValueFrom();
    Object.defineProperty(exports2, "firstValueFrom", { enumerable: true, get: function() {
      return firstValueFrom_1.firstValueFrom;
    } });
    var ArgumentOutOfRangeError_1 = require_ArgumentOutOfRangeError();
    Object.defineProperty(exports2, "ArgumentOutOfRangeError", { enumerable: true, get: function() {
      return ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
    } });
    var EmptyError_1 = require_EmptyError();
    Object.defineProperty(exports2, "EmptyError", { enumerable: true, get: function() {
      return EmptyError_1.EmptyError;
    } });
    var NotFoundError_1 = require_NotFoundError();
    Object.defineProperty(exports2, "NotFoundError", { enumerable: true, get: function() {
      return NotFoundError_1.NotFoundError;
    } });
    var ObjectUnsubscribedError_1 = require_ObjectUnsubscribedError();
    Object.defineProperty(exports2, "ObjectUnsubscribedError", { enumerable: true, get: function() {
      return ObjectUnsubscribedError_1.ObjectUnsubscribedError;
    } });
    var SequenceError_1 = require_SequenceError();
    Object.defineProperty(exports2, "SequenceError", { enumerable: true, get: function() {
      return SequenceError_1.SequenceError;
    } });
    var timeout_1 = require_timeout();
    Object.defineProperty(exports2, "TimeoutError", { enumerable: true, get: function() {
      return timeout_1.TimeoutError;
    } });
    var UnsubscriptionError_1 = require_UnsubscriptionError();
    Object.defineProperty(exports2, "UnsubscriptionError", { enumerable: true, get: function() {
      return UnsubscriptionError_1.UnsubscriptionError;
    } });
    var bindCallback_1 = require_bindCallback();
    Object.defineProperty(exports2, "bindCallback", { enumerable: true, get: function() {
      return bindCallback_1.bindCallback;
    } });
    var bindNodeCallback_1 = require_bindNodeCallback();
    Object.defineProperty(exports2, "bindNodeCallback", { enumerable: true, get: function() {
      return bindNodeCallback_1.bindNodeCallback;
    } });
    var combineLatest_1 = require_combineLatest();
    Object.defineProperty(exports2, "combineLatest", { enumerable: true, get: function() {
      return combineLatest_1.combineLatest;
    } });
    var concat_1 = require_concat();
    Object.defineProperty(exports2, "concat", { enumerable: true, get: function() {
      return concat_1.concat;
    } });
    var connectable_1 = require_connectable();
    Object.defineProperty(exports2, "connectable", { enumerable: true, get: function() {
      return connectable_1.connectable;
    } });
    var defer_1 = require_defer();
    Object.defineProperty(exports2, "defer", { enumerable: true, get: function() {
      return defer_1.defer;
    } });
    var empty_1 = require_empty();
    Object.defineProperty(exports2, "empty", { enumerable: true, get: function() {
      return empty_1.empty;
    } });
    var forkJoin_1 = require_forkJoin();
    Object.defineProperty(exports2, "forkJoin", { enumerable: true, get: function() {
      return forkJoin_1.forkJoin;
    } });
    var from_1 = require_from();
    Object.defineProperty(exports2, "from", { enumerable: true, get: function() {
      return from_1.from;
    } });
    var fromEvent_1 = require_fromEvent();
    Object.defineProperty(exports2, "fromEvent", { enumerable: true, get: function() {
      return fromEvent_1.fromEvent;
    } });
    var fromEventPattern_1 = require_fromEventPattern();
    Object.defineProperty(exports2, "fromEventPattern", { enumerable: true, get: function() {
      return fromEventPattern_1.fromEventPattern;
    } });
    var generate_1 = require_generate();
    Object.defineProperty(exports2, "generate", { enumerable: true, get: function() {
      return generate_1.generate;
    } });
    var iif_1 = require_iif();
    Object.defineProperty(exports2, "iif", { enumerable: true, get: function() {
      return iif_1.iif;
    } });
    var interval_1 = require_interval();
    Object.defineProperty(exports2, "interval", { enumerable: true, get: function() {
      return interval_1.interval;
    } });
    var merge_1 = require_merge();
    Object.defineProperty(exports2, "merge", { enumerable: true, get: function() {
      return merge_1.merge;
    } });
    var never_1 = require_never();
    Object.defineProperty(exports2, "never", { enumerable: true, get: function() {
      return never_1.never;
    } });
    var of_1 = require_of();
    Object.defineProperty(exports2, "of", { enumerable: true, get: function() {
      return of_1.of;
    } });
    var onErrorResumeNext_1 = require_onErrorResumeNext();
    Object.defineProperty(exports2, "onErrorResumeNext", { enumerable: true, get: function() {
      return onErrorResumeNext_1.onErrorResumeNext;
    } });
    var pairs_1 = require_pairs();
    Object.defineProperty(exports2, "pairs", { enumerable: true, get: function() {
      return pairs_1.pairs;
    } });
    var partition_1 = require_partition();
    Object.defineProperty(exports2, "partition", { enumerable: true, get: function() {
      return partition_1.partition;
    } });
    var race_1 = require_race();
    Object.defineProperty(exports2, "race", { enumerable: true, get: function() {
      return race_1.race;
    } });
    var range_1 = require_range();
    Object.defineProperty(exports2, "range", { enumerable: true, get: function() {
      return range_1.range;
    } });
    var throwError_1 = require_throwError();
    Object.defineProperty(exports2, "throwError", { enumerable: true, get: function() {
      return throwError_1.throwError;
    } });
    var timer_1 = require_timer();
    Object.defineProperty(exports2, "timer", { enumerable: true, get: function() {
      return timer_1.timer;
    } });
    var using_1 = require_using();
    Object.defineProperty(exports2, "using", { enumerable: true, get: function() {
      return using_1.using;
    } });
    var zip_1 = require_zip();
    Object.defineProperty(exports2, "zip", { enumerable: true, get: function() {
      return zip_1.zip;
    } });
    var scheduled_1 = require_scheduled();
    Object.defineProperty(exports2, "scheduled", { enumerable: true, get: function() {
      return scheduled_1.scheduled;
    } });
    var empty_2 = require_empty();
    Object.defineProperty(exports2, "EMPTY", { enumerable: true, get: function() {
      return empty_2.EMPTY;
    } });
    var never_2 = require_never();
    Object.defineProperty(exports2, "NEVER", { enumerable: true, get: function() {
      return never_2.NEVER;
    } });
    __exportStar(require_types(), exports2);
    var config_1 = require_config();
    Object.defineProperty(exports2, "config", { enumerable: true, get: function() {
      return config_1.config;
    } });
    var audit_1 = require_audit();
    Object.defineProperty(exports2, "audit", { enumerable: true, get: function() {
      return audit_1.audit;
    } });
    var auditTime_1 = require_auditTime();
    Object.defineProperty(exports2, "auditTime", { enumerable: true, get: function() {
      return auditTime_1.auditTime;
    } });
    var buffer_1 = require_buffer();
    Object.defineProperty(exports2, "buffer", { enumerable: true, get: function() {
      return buffer_1.buffer;
    } });
    var bufferCount_1 = require_bufferCount();
    Object.defineProperty(exports2, "bufferCount", { enumerable: true, get: function() {
      return bufferCount_1.bufferCount;
    } });
    var bufferTime_1 = require_bufferTime();
    Object.defineProperty(exports2, "bufferTime", { enumerable: true, get: function() {
      return bufferTime_1.bufferTime;
    } });
    var bufferToggle_1 = require_bufferToggle();
    Object.defineProperty(exports2, "bufferToggle", { enumerable: true, get: function() {
      return bufferToggle_1.bufferToggle;
    } });
    var bufferWhen_1 = require_bufferWhen();
    Object.defineProperty(exports2, "bufferWhen", { enumerable: true, get: function() {
      return bufferWhen_1.bufferWhen;
    } });
    var catchError_1 = require_catchError();
    Object.defineProperty(exports2, "catchError", { enumerable: true, get: function() {
      return catchError_1.catchError;
    } });
    var combineAll_1 = require_combineAll();
    Object.defineProperty(exports2, "combineAll", { enumerable: true, get: function() {
      return combineAll_1.combineAll;
    } });
    var combineLatestAll_1 = require_combineLatestAll();
    Object.defineProperty(exports2, "combineLatestAll", { enumerable: true, get: function() {
      return combineLatestAll_1.combineLatestAll;
    } });
    var combineLatestWith_1 = require_combineLatestWith();
    Object.defineProperty(exports2, "combineLatestWith", { enumerable: true, get: function() {
      return combineLatestWith_1.combineLatestWith;
    } });
    var concatAll_1 = require_concatAll();
    Object.defineProperty(exports2, "concatAll", { enumerable: true, get: function() {
      return concatAll_1.concatAll;
    } });
    var concatMap_1 = require_concatMap();
    Object.defineProperty(exports2, "concatMap", { enumerable: true, get: function() {
      return concatMap_1.concatMap;
    } });
    var concatMapTo_1 = require_concatMapTo();
    Object.defineProperty(exports2, "concatMapTo", { enumerable: true, get: function() {
      return concatMapTo_1.concatMapTo;
    } });
    var concatWith_1 = require_concatWith();
    Object.defineProperty(exports2, "concatWith", { enumerable: true, get: function() {
      return concatWith_1.concatWith;
    } });
    var connect_1 = require_connect();
    Object.defineProperty(exports2, "connect", { enumerable: true, get: function() {
      return connect_1.connect;
    } });
    var count_1 = require_count();
    Object.defineProperty(exports2, "count", { enumerable: true, get: function() {
      return count_1.count;
    } });
    var debounce_1 = require_debounce();
    Object.defineProperty(exports2, "debounce", { enumerable: true, get: function() {
      return debounce_1.debounce;
    } });
    var debounceTime_1 = require_debounceTime();
    Object.defineProperty(exports2, "debounceTime", { enumerable: true, get: function() {
      return debounceTime_1.debounceTime;
    } });
    var defaultIfEmpty_1 = require_defaultIfEmpty();
    Object.defineProperty(exports2, "defaultIfEmpty", { enumerable: true, get: function() {
      return defaultIfEmpty_1.defaultIfEmpty;
    } });
    var delay_1 = require_delay();
    Object.defineProperty(exports2, "delay", { enumerable: true, get: function() {
      return delay_1.delay;
    } });
    var delayWhen_1 = require_delayWhen();
    Object.defineProperty(exports2, "delayWhen", { enumerable: true, get: function() {
      return delayWhen_1.delayWhen;
    } });
    var dematerialize_1 = require_dematerialize();
    Object.defineProperty(exports2, "dematerialize", { enumerable: true, get: function() {
      return dematerialize_1.dematerialize;
    } });
    var distinct_1 = require_distinct();
    Object.defineProperty(exports2, "distinct", { enumerable: true, get: function() {
      return distinct_1.distinct;
    } });
    var distinctUntilChanged_1 = require_distinctUntilChanged();
    Object.defineProperty(exports2, "distinctUntilChanged", { enumerable: true, get: function() {
      return distinctUntilChanged_1.distinctUntilChanged;
    } });
    var distinctUntilKeyChanged_1 = require_distinctUntilKeyChanged();
    Object.defineProperty(exports2, "distinctUntilKeyChanged", { enumerable: true, get: function() {
      return distinctUntilKeyChanged_1.distinctUntilKeyChanged;
    } });
    var elementAt_1 = require_elementAt();
    Object.defineProperty(exports2, "elementAt", { enumerable: true, get: function() {
      return elementAt_1.elementAt;
    } });
    var endWith_1 = require_endWith();
    Object.defineProperty(exports2, "endWith", { enumerable: true, get: function() {
      return endWith_1.endWith;
    } });
    var every_1 = require_every();
    Object.defineProperty(exports2, "every", { enumerable: true, get: function() {
      return every_1.every;
    } });
    var exhaust_1 = require_exhaust();
    Object.defineProperty(exports2, "exhaust", { enumerable: true, get: function() {
      return exhaust_1.exhaust;
    } });
    var exhaustAll_1 = require_exhaustAll();
    Object.defineProperty(exports2, "exhaustAll", { enumerable: true, get: function() {
      return exhaustAll_1.exhaustAll;
    } });
    var exhaustMap_1 = require_exhaustMap();
    Object.defineProperty(exports2, "exhaustMap", { enumerable: true, get: function() {
      return exhaustMap_1.exhaustMap;
    } });
    var expand_1 = require_expand();
    Object.defineProperty(exports2, "expand", { enumerable: true, get: function() {
      return expand_1.expand;
    } });
    var filter_1 = require_filter();
    Object.defineProperty(exports2, "filter", { enumerable: true, get: function() {
      return filter_1.filter;
    } });
    var finalize_1 = require_finalize();
    Object.defineProperty(exports2, "finalize", { enumerable: true, get: function() {
      return finalize_1.finalize;
    } });
    var find_1 = require_find();
    Object.defineProperty(exports2, "find", { enumerable: true, get: function() {
      return find_1.find;
    } });
    var findIndex_1 = require_findIndex();
    Object.defineProperty(exports2, "findIndex", { enumerable: true, get: function() {
      return findIndex_1.findIndex;
    } });
    var first_1 = require_first();
    Object.defineProperty(exports2, "first", { enumerable: true, get: function() {
      return first_1.first;
    } });
    var groupBy_1 = require_groupBy();
    Object.defineProperty(exports2, "groupBy", { enumerable: true, get: function() {
      return groupBy_1.groupBy;
    } });
    var ignoreElements_1 = require_ignoreElements();
    Object.defineProperty(exports2, "ignoreElements", { enumerable: true, get: function() {
      return ignoreElements_1.ignoreElements;
    } });
    var isEmpty_1 = require_isEmpty();
    Object.defineProperty(exports2, "isEmpty", { enumerable: true, get: function() {
      return isEmpty_1.isEmpty;
    } });
    var last_1 = require_last();
    Object.defineProperty(exports2, "last", { enumerable: true, get: function() {
      return last_1.last;
    } });
    var map_1 = require_map();
    Object.defineProperty(exports2, "map", { enumerable: true, get: function() {
      return map_1.map;
    } });
    var mapTo_1 = require_mapTo();
    Object.defineProperty(exports2, "mapTo", { enumerable: true, get: function() {
      return mapTo_1.mapTo;
    } });
    var materialize_1 = require_materialize();
    Object.defineProperty(exports2, "materialize", { enumerable: true, get: function() {
      return materialize_1.materialize;
    } });
    var max_1 = require_max();
    Object.defineProperty(exports2, "max", { enumerable: true, get: function() {
      return max_1.max;
    } });
    var mergeAll_1 = require_mergeAll();
    Object.defineProperty(exports2, "mergeAll", { enumerable: true, get: function() {
      return mergeAll_1.mergeAll;
    } });
    var flatMap_1 = require_flatMap();
    Object.defineProperty(exports2, "flatMap", { enumerable: true, get: function() {
      return flatMap_1.flatMap;
    } });
    var mergeMap_1 = require_mergeMap();
    Object.defineProperty(exports2, "mergeMap", { enumerable: true, get: function() {
      return mergeMap_1.mergeMap;
    } });
    var mergeMapTo_1 = require_mergeMapTo();
    Object.defineProperty(exports2, "mergeMapTo", { enumerable: true, get: function() {
      return mergeMapTo_1.mergeMapTo;
    } });
    var mergeScan_1 = require_mergeScan();
    Object.defineProperty(exports2, "mergeScan", { enumerable: true, get: function() {
      return mergeScan_1.mergeScan;
    } });
    var mergeWith_1 = require_mergeWith();
    Object.defineProperty(exports2, "mergeWith", { enumerable: true, get: function() {
      return mergeWith_1.mergeWith;
    } });
    var min_1 = require_min();
    Object.defineProperty(exports2, "min", { enumerable: true, get: function() {
      return min_1.min;
    } });
    var multicast_1 = require_multicast();
    Object.defineProperty(exports2, "multicast", { enumerable: true, get: function() {
      return multicast_1.multicast;
    } });
    var observeOn_1 = require_observeOn();
    Object.defineProperty(exports2, "observeOn", { enumerable: true, get: function() {
      return observeOn_1.observeOn;
    } });
    var onErrorResumeNextWith_1 = require_onErrorResumeNextWith();
    Object.defineProperty(exports2, "onErrorResumeNextWith", { enumerable: true, get: function() {
      return onErrorResumeNextWith_1.onErrorResumeNextWith;
    } });
    var pairwise_1 = require_pairwise();
    Object.defineProperty(exports2, "pairwise", { enumerable: true, get: function() {
      return pairwise_1.pairwise;
    } });
    var pluck_1 = require_pluck();
    Object.defineProperty(exports2, "pluck", { enumerable: true, get: function() {
      return pluck_1.pluck;
    } });
    var publish_1 = require_publish();
    Object.defineProperty(exports2, "publish", { enumerable: true, get: function() {
      return publish_1.publish;
    } });
    var publishBehavior_1 = require_publishBehavior();
    Object.defineProperty(exports2, "publishBehavior", { enumerable: true, get: function() {
      return publishBehavior_1.publishBehavior;
    } });
    var publishLast_1 = require_publishLast();
    Object.defineProperty(exports2, "publishLast", { enumerable: true, get: function() {
      return publishLast_1.publishLast;
    } });
    var publishReplay_1 = require_publishReplay();
    Object.defineProperty(exports2, "publishReplay", { enumerable: true, get: function() {
      return publishReplay_1.publishReplay;
    } });
    var raceWith_1 = require_raceWith();
    Object.defineProperty(exports2, "raceWith", { enumerable: true, get: function() {
      return raceWith_1.raceWith;
    } });
    var reduce_1 = require_reduce();
    Object.defineProperty(exports2, "reduce", { enumerable: true, get: function() {
      return reduce_1.reduce;
    } });
    var repeat_1 = require_repeat();
    Object.defineProperty(exports2, "repeat", { enumerable: true, get: function() {
      return repeat_1.repeat;
    } });
    var repeatWhen_1 = require_repeatWhen();
    Object.defineProperty(exports2, "repeatWhen", { enumerable: true, get: function() {
      return repeatWhen_1.repeatWhen;
    } });
    var retry_1 = require_retry();
    Object.defineProperty(exports2, "retry", { enumerable: true, get: function() {
      return retry_1.retry;
    } });
    var retryWhen_1 = require_retryWhen();
    Object.defineProperty(exports2, "retryWhen", { enumerable: true, get: function() {
      return retryWhen_1.retryWhen;
    } });
    var refCount_1 = require_refCount();
    Object.defineProperty(exports2, "refCount", { enumerable: true, get: function() {
      return refCount_1.refCount;
    } });
    var sample_1 = require_sample();
    Object.defineProperty(exports2, "sample", { enumerable: true, get: function() {
      return sample_1.sample;
    } });
    var sampleTime_1 = require_sampleTime();
    Object.defineProperty(exports2, "sampleTime", { enumerable: true, get: function() {
      return sampleTime_1.sampleTime;
    } });
    var scan_1 = require_scan();
    Object.defineProperty(exports2, "scan", { enumerable: true, get: function() {
      return scan_1.scan;
    } });
    var sequenceEqual_1 = require_sequenceEqual();
    Object.defineProperty(exports2, "sequenceEqual", { enumerable: true, get: function() {
      return sequenceEqual_1.sequenceEqual;
    } });
    var share_1 = require_share();
    Object.defineProperty(exports2, "share", { enumerable: true, get: function() {
      return share_1.share;
    } });
    var shareReplay_1 = require_shareReplay();
    Object.defineProperty(exports2, "shareReplay", { enumerable: true, get: function() {
      return shareReplay_1.shareReplay;
    } });
    var single_1 = require_single();
    Object.defineProperty(exports2, "single", { enumerable: true, get: function() {
      return single_1.single;
    } });
    var skip_1 = require_skip();
    Object.defineProperty(exports2, "skip", { enumerable: true, get: function() {
      return skip_1.skip;
    } });
    var skipLast_1 = require_skipLast();
    Object.defineProperty(exports2, "skipLast", { enumerable: true, get: function() {
      return skipLast_1.skipLast;
    } });
    var skipUntil_1 = require_skipUntil();
    Object.defineProperty(exports2, "skipUntil", { enumerable: true, get: function() {
      return skipUntil_1.skipUntil;
    } });
    var skipWhile_1 = require_skipWhile();
    Object.defineProperty(exports2, "skipWhile", { enumerable: true, get: function() {
      return skipWhile_1.skipWhile;
    } });
    var startWith_1 = require_startWith();
    Object.defineProperty(exports2, "startWith", { enumerable: true, get: function() {
      return startWith_1.startWith;
    } });
    var subscribeOn_1 = require_subscribeOn();
    Object.defineProperty(exports2, "subscribeOn", { enumerable: true, get: function() {
      return subscribeOn_1.subscribeOn;
    } });
    var switchAll_1 = require_switchAll();
    Object.defineProperty(exports2, "switchAll", { enumerable: true, get: function() {
      return switchAll_1.switchAll;
    } });
    var switchMap_1 = require_switchMap();
    Object.defineProperty(exports2, "switchMap", { enumerable: true, get: function() {
      return switchMap_1.switchMap;
    } });
    var switchMapTo_1 = require_switchMapTo();
    Object.defineProperty(exports2, "switchMapTo", { enumerable: true, get: function() {
      return switchMapTo_1.switchMapTo;
    } });
    var switchScan_1 = require_switchScan();
    Object.defineProperty(exports2, "switchScan", { enumerable: true, get: function() {
      return switchScan_1.switchScan;
    } });
    var take_1 = require_take();
    Object.defineProperty(exports2, "take", { enumerable: true, get: function() {
      return take_1.take;
    } });
    var takeLast_1 = require_takeLast();
    Object.defineProperty(exports2, "takeLast", { enumerable: true, get: function() {
      return takeLast_1.takeLast;
    } });
    var takeUntil_1 = require_takeUntil();
    Object.defineProperty(exports2, "takeUntil", { enumerable: true, get: function() {
      return takeUntil_1.takeUntil;
    } });
    var takeWhile_1 = require_takeWhile();
    Object.defineProperty(exports2, "takeWhile", { enumerable: true, get: function() {
      return takeWhile_1.takeWhile;
    } });
    var tap_1 = require_tap();
    Object.defineProperty(exports2, "tap", { enumerable: true, get: function() {
      return tap_1.tap;
    } });
    var throttle_1 = require_throttle();
    Object.defineProperty(exports2, "throttle", { enumerable: true, get: function() {
      return throttle_1.throttle;
    } });
    var throttleTime_1 = require_throttleTime();
    Object.defineProperty(exports2, "throttleTime", { enumerable: true, get: function() {
      return throttleTime_1.throttleTime;
    } });
    var throwIfEmpty_1 = require_throwIfEmpty();
    Object.defineProperty(exports2, "throwIfEmpty", { enumerable: true, get: function() {
      return throwIfEmpty_1.throwIfEmpty;
    } });
    var timeInterval_1 = require_timeInterval();
    Object.defineProperty(exports2, "timeInterval", { enumerable: true, get: function() {
      return timeInterval_1.timeInterval;
    } });
    var timeout_2 = require_timeout();
    Object.defineProperty(exports2, "timeout", { enumerable: true, get: function() {
      return timeout_2.timeout;
    } });
    var timeoutWith_1 = require_timeoutWith();
    Object.defineProperty(exports2, "timeoutWith", { enumerable: true, get: function() {
      return timeoutWith_1.timeoutWith;
    } });
    var timestamp_1 = require_timestamp();
    Object.defineProperty(exports2, "timestamp", { enumerable: true, get: function() {
      return timestamp_1.timestamp;
    } });
    var toArray_1 = require_toArray();
    Object.defineProperty(exports2, "toArray", { enumerable: true, get: function() {
      return toArray_1.toArray;
    } });
    var window_1 = require_window();
    Object.defineProperty(exports2, "window", { enumerable: true, get: function() {
      return window_1.window;
    } });
    var windowCount_1 = require_windowCount();
    Object.defineProperty(exports2, "windowCount", { enumerable: true, get: function() {
      return windowCount_1.windowCount;
    } });
    var windowTime_1 = require_windowTime();
    Object.defineProperty(exports2, "windowTime", { enumerable: true, get: function() {
      return windowTime_1.windowTime;
    } });
    var windowToggle_1 = require_windowToggle();
    Object.defineProperty(exports2, "windowToggle", { enumerable: true, get: function() {
      return windowToggle_1.windowToggle;
    } });
    var windowWhen_1 = require_windowWhen();
    Object.defineProperty(exports2, "windowWhen", { enumerable: true, get: function() {
      return windowWhen_1.windowWhen;
    } });
    var withLatestFrom_1 = require_withLatestFrom();
    Object.defineProperty(exports2, "withLatestFrom", { enumerable: true, get: function() {
      return withLatestFrom_1.withLatestFrom;
    } });
    var zipAll_1 = require_zipAll();
    Object.defineProperty(exports2, "zipAll", { enumerable: true, get: function() {
      return zipAll_1.zipAll;
    } });
    var zipWith_1 = require_zipWith();
    Object.defineProperty(exports2, "zipWith", { enumerable: true, get: function() {
      return zipWith_1.zipWith;
    } });
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/lib/esm/libs/finder.js
function finder(input, options) {
  if (input.nodeType !== Node.ELEMENT_NODE) {
    throw new Error("Can't generate CSS selector for non-element node type.");
  }
  if ("html" === input.tagName.toLowerCase()) {
    return "html";
  }
  var defaults = {
    root: document.body,
    idName: function(_name) {
      return true;
    },
    className: function(_name) {
      return true;
    },
    tagName: function(_name) {
      return true;
    },
    attr: function(_name, _value) {
      return false;
    },
    seedMinLength: 1,
    optimizedMinLength: 2,
    threshold: 1e3,
    maxNumberOfTries: 1e4
  };
  config = __assign7(__assign7({}, defaults), options);
  rootDocument = findRootDocument(config.root, defaults);
  var path = bottomUpSearch(input, "all", function() {
    return bottomUpSearch(input, "two", function() {
      return bottomUpSearch(input, "one", function() {
        return bottomUpSearch(input, "none");
      });
    });
  });
  if (path) {
    var optimized = sort(optimize(path, input));
    if (optimized.length > 0) {
      path = optimized[0];
    }
    return selector(path);
  } else {
    throw new Error("Selector was not found.");
  }
}
function findRootDocument(rootNode, defaults) {
  if (rootNode.nodeType === Node.DOCUMENT_NODE) {
    return rootNode;
  }
  if (rootNode === defaults.root) {
    return rootNode.ownerDocument;
  }
  return rootNode;
}
function bottomUpSearch(input, limit, fallback) {
  var path = null;
  var stack = [];
  var current = input;
  var i = 0;
  var _loop_1 = function() {
    var e_1, _a;
    var level = maybe(id(current)) || maybe.apply(void 0, __spreadArray4([], __read5(attr(current)), false)) || maybe.apply(void 0, __spreadArray4([], __read5(classNames(current)), false)) || maybe(tagName(current)) || [any()];
    var nth = index(current);
    if (limit == "all") {
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function(node2) {
          return nthChild(node2, nth);
        }));
      }
    } else if (limit == "two") {
      level = level.slice(0, 1);
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function(node2) {
          return nthChild(node2, nth);
        }));
      }
    } else if (limit == "one") {
      var _b = __read5(level = level.slice(0, 1), 1), node = _b[0];
      if (nth && dispensableNth(node)) {
        level = [nthChild(node, nth)];
      }
    } else if (limit == "none") {
      level = [any()];
      if (nth) {
        level = [nthChild(level[0], nth)];
      }
    }
    try {
      for (var level_1 = (e_1 = void 0, __values4(level)), level_1_1 = level_1.next(); !level_1_1.done; level_1_1 = level_1.next()) {
        var node = level_1_1.value;
        node.level = i;
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (level_1_1 && !level_1_1.done && (_a = level_1.return)) _a.call(level_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    stack.push(level);
    if (stack.length >= config.seedMinLength) {
      path = findUniquePath(stack, fallback);
      if (path) {
        return "break";
      }
    }
    current = current.parentElement;
    i++;
  };
  while (current) {
    var state_1 = _loop_1();
    if (state_1 === "break")
      break;
  }
  if (!path) {
    path = findUniquePath(stack, fallback);
  }
  if (!path && fallback) {
    return fallback();
  }
  return path;
}
function findUniquePath(stack, fallback) {
  var e_2, _a;
  var numCombinations = stack.reduce(function(acc, i) {
    return acc * i.length;
  }, 1);
  if (numCombinations > config.threshold) {
    return fallback ? fallback() : null;
  }
  var paths = sort(combinations(stack));
  try {
    for (var paths_1 = __values4(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
      var candidate = paths_1_1.value;
      if (unique(candidate)) {
        return candidate;
      }
    }
  } catch (e_2_1) {
    e_2 = { error: e_2_1 };
  } finally {
    try {
      if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
  return null;
}
function selector(path) {
  var node = path[0];
  var query = node.name;
  for (var i = 1; i < path.length; i++) {
    var level = path[i].level || 0;
    if (node.level === level - 1) {
      query = "".concat(path[i].name, " > ").concat(query);
    } else {
      query = "".concat(path[i].name, " ").concat(query);
    }
    node = path[i];
  }
  return query;
}
function penalty(path) {
  return path.map(function(node) {
    return node.penalty;
  }).reduce(function(acc, i) {
    return acc + i;
  }, 0);
}
function unique(path) {
  var css = selector(path);
  switch (rootDocument.querySelectorAll(css).length) {
    case 0:
      throw new Error("Can't select any node with this selector: ".concat(css));
    case 1:
      return true;
    default:
      return false;
  }
}
function id(input) {
  var elementId = input.getAttribute("id");
  if (elementId && config.idName(elementId)) {
    return {
      name: "#" + CSS.escape(elementId),
      penalty: 0
    };
  }
  return null;
}
function attr(input) {
  var attrs = Array.from(input.attributes).filter(function(attr2) {
    return config.attr(attr2.name, attr2.value);
  });
  return attrs.map(function(attr2) {
    return {
      name: "[".concat(CSS.escape(attr2.name), '="').concat(CSS.escape(attr2.value), '"]'),
      penalty: 0.5
    };
  });
}
function classNames(input) {
  var names = Array.from(input.classList).filter(config.className);
  return names.map(function(name) {
    return {
      name: "." + CSS.escape(name),
      penalty: 1
    };
  });
}
function tagName(input) {
  var name = input.tagName.toLowerCase();
  if (config.tagName(name)) {
    return {
      name,
      penalty: 2
    };
  }
  return null;
}
function any() {
  return {
    name: "*",
    penalty: 3
  };
}
function index(input) {
  var parent = input.parentNode;
  if (!parent) {
    return null;
  }
  var child = parent.firstChild;
  if (!child) {
    return null;
  }
  var i = 0;
  while (child) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      i++;
    }
    if (child === input) {
      break;
    }
    child = child.nextSibling;
  }
  return i;
}
function nthChild(node, i) {
  return {
    name: node.name + ":nth-child(".concat(i, ")"),
    penalty: node.penalty + 1
  };
}
function dispensableNth(node) {
  return node.name !== "html" && !node.name.startsWith("#");
}
function maybe() {
  var level = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    level[_i] = arguments[_i];
  }
  var list = level.filter(notEmpty);
  if (list.length > 0) {
    return list;
  }
  return null;
}
function notEmpty(value) {
  return value !== null && value !== void 0;
}
function combinations(stack, path) {
  var _a, _b, node, e_3_1;
  var e_3, _c;
  if (path === void 0) {
    path = [];
  }
  return __generator6(this, function(_d) {
    switch (_d.label) {
      case 0:
        if (!(stack.length > 0)) return [3, 9];
        _d.label = 1;
      case 1:
        _d.trys.push([1, 6, 7, 8]);
        _a = __values4(stack[0]), _b = _a.next();
        _d.label = 2;
      case 2:
        if (!!_b.done) return [3, 5];
        node = _b.value;
        return [5, __values4(combinations(stack.slice(1, stack.length), path.concat(node)))];
      case 3:
        _d.sent();
        _d.label = 4;
      case 4:
        _b = _a.next();
        return [3, 2];
      case 5:
        return [3, 8];
      case 6:
        e_3_1 = _d.sent();
        e_3 = { error: e_3_1 };
        return [3, 8];
      case 7:
        try {
          if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
        } finally {
          if (e_3) throw e_3.error;
        }
        return [
          7
          /*endfinally*/
        ];
      case 8:
        return [3, 11];
      case 9:
        return [4, path];
      case 10:
        _d.sent();
        _d.label = 11;
      case 11:
        return [
          2
          /*return*/
        ];
    }
  });
}
function sort(paths) {
  return __spreadArray4([], __read5(paths), false).sort(function(a, b) {
    return penalty(a) - penalty(b);
  });
}
function optimize(path, input, scope) {
  var i, newPath, newPathKey;
  if (scope === void 0) {
    scope = {
      counter: 0,
      visited: /* @__PURE__ */ new Map()
    };
  }
  return __generator6(this, function(_a) {
    switch (_a.label) {
      case 0:
        if (!(path.length > 2 && path.length > config.optimizedMinLength)) return [3, 5];
        i = 1;
        _a.label = 1;
      case 1:
        if (!(i < path.length - 1)) return [3, 5];
        if (scope.counter > config.maxNumberOfTries) {
          return [
            2
            /*return*/
          ];
        }
        scope.counter += 1;
        newPath = __spreadArray4([], __read5(path), false);
        newPath.splice(i, 1);
        newPathKey = selector(newPath);
        if (scope.visited.has(newPathKey)) {
          return [
            2
            /*return*/
          ];
        }
        if (!(unique(newPath) && same(newPath, input))) return [3, 4];
        return [4, newPath];
      case 2:
        _a.sent();
        scope.visited.set(newPathKey, true);
        return [5, __values4(optimize(newPath, input, scope))];
      case 3:
        _a.sent();
        _a.label = 4;
      case 4:
        i++;
        return [3, 1];
      case 5:
        return [
          2
          /*return*/
        ];
    }
  });
}
function same(path, input) {
  return rootDocument.querySelector(selector(path)) === input;
}
var config, rootDocument;
var init_finder = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/lib/esm/libs/finder.js"() {
    "use strict";
    init_tslib_es66();
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/lib/esm/helpers.js
function generateUniqueId() {
  return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var SENSITIVE_TAGS, createShouldTrackEvent, isNonSensitiveString, isTextNode, isNonSensitiveElement, getText, getSelector, isPageUrlAllowed, getAttributesWithPrefix, isEmpty, removeEmptyProperties, getNearestLabel, getClosestElement, getEventTagProps, asyncLoadScript, filterOutNonTrackableEvents;
var init_helpers2 = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/lib/esm/helpers.js"() {
    "use strict";
    init_finder();
    init_constants4();
    SENSITIVE_TAGS = ["input", "select", "textarea"];
    createShouldTrackEvent = function(autocaptureOptions, allowlist) {
      return function(actionType, element) {
        var _a, _b, _c;
        var pageUrlAllowlist = autocaptureOptions.pageUrlAllowlist, shouldTrackEventResolver = autocaptureOptions.shouldTrackEventResolver;
        var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (!tag) {
          return false;
        }
        if (shouldTrackEventResolver) {
          return shouldTrackEventResolver(actionType, element);
        }
        if (!isPageUrlAllowed(window.location.href, pageUrlAllowlist)) {
          return false;
        }
        var elementType = String(element === null || element === void 0 ? void 0 : element.getAttribute("type")) || "";
        if (typeof elementType === "string") {
          switch (elementType.toLowerCase()) {
            case "hidden":
              return false;
            case "password":
              return false;
          }
        }
        if (allowlist) {
          var hasMatchAnyAllowedSelector = allowlist.some(function(selector2) {
            var _a2;
            return !!((_a2 = element === null || element === void 0 ? void 0 : element.matches) === null || _a2 === void 0 ? void 0 : _a2.call(element, selector2));
          });
          if (!hasMatchAnyAllowedSelector) {
            return false;
          }
        }
        switch (tag) {
          case "input":
          case "select":
          case "textarea":
            return actionType === "change" || actionType === "click";
          default: {
            var computedStyle = (_c = window === null || window === void 0 ? void 0 : window.getComputedStyle) === null || _c === void 0 ? void 0 : _c.call(window, element);
            if (computedStyle && computedStyle.getPropertyValue("cursor") === "pointer" && actionType === "click") {
              return true;
            }
            return actionType === "click";
          }
        }
      };
    };
    isNonSensitiveString = function(text) {
      if (text == null) {
        return false;
      }
      if (typeof text === "string") {
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((text || "").replace(/[- ]/g, ""))) {
          return false;
        }
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(text)) {
          return false;
        }
      }
      return true;
    };
    isTextNode = function(node) {
      return !!node && node.nodeType === 3;
    };
    isNonSensitiveElement = function(element) {
      var _a, _b, _c;
      var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
      var isContentEditable = element instanceof HTMLElement ? ((_c = element.getAttribute("contenteditable")) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === "true" : false;
      return !SENSITIVE_TAGS.includes(tag) && !isContentEditable;
    };
    getText = function(element) {
      var text = "";
      if (isNonSensitiveElement(element) && element.childNodes && element.childNodes.length) {
        element.childNodes.forEach(function(child) {
          var childText = "";
          if (isTextNode(child)) {
            if (child.textContent) {
              childText = child.textContent;
            }
          } else {
            childText = getText(child);
          }
          text += childText.split(/(\s+)/).filter(isNonSensitiveString).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
        });
      }
      return text;
    };
    getSelector = function(element, logger) {
      var _a, _b;
      var selector2 = "";
      try {
        selector2 = finder(element, {
          className: function(name) {
            return name !== AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
          },
          maxNumberOfTries: 1e3
        });
        return selector2;
      } catch (error) {
        if (logger) {
          var typedError = error;
          logger.warn("Failed to get selector with finder, use fallback strategy instead: ".concat(typedError.toString()));
        }
      }
      var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
      if (tag) {
        selector2 = tag;
      }
      var id2 = element.getAttribute("id");
      var className = element.getAttribute("class");
      if (id2) {
        selector2 = "#".concat(id2);
      } else if (className) {
        var classes = className.split(" ").filter(function(name) {
          return name !== AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
        }).join(".");
        if (classes) {
          selector2 = "".concat(selector2, ".").concat(classes);
        }
      }
      return selector2;
    };
    isPageUrlAllowed = function(url, pageUrlAllowlist) {
      if (!pageUrlAllowlist || !pageUrlAllowlist.length) {
        return true;
      }
      return pageUrlAllowlist.some(function(allowedUrl) {
        if (typeof allowedUrl === "string") {
          return url === allowedUrl;
        }
        return url.match(allowedUrl);
      });
    };
    getAttributesWithPrefix = function(element, prefix) {
      return element.getAttributeNames().reduce(function(attributes, attributeName) {
        if (attributeName.startsWith(prefix)) {
          var attributeKey = attributeName.replace(prefix, "");
          var attributeValue = element.getAttribute(attributeName);
          if (attributeKey) {
            attributes[attributeKey] = attributeValue || "";
          }
        }
        return attributes;
      }, {});
    };
    isEmpty = function(value) {
      return value === void 0 || value === null || typeof value === "object" && Object.keys(value).length === 0 || typeof value === "string" && value.trim().length === 0;
    };
    removeEmptyProperties = function(properties) {
      return Object.keys(properties).reduce(function(filteredProperties, key) {
        var value = properties[key];
        if (!isEmpty(value)) {
          filteredProperties[key] = value;
        }
        return filteredProperties;
      }, {});
    };
    getNearestLabel = function(element) {
      var parent = element.parentElement;
      if (!parent) {
        return "";
      }
      var labelElement;
      try {
        labelElement = parent.querySelector(":scope>span,h1,h2,h3,h4,h5,h6");
      } catch (error) {
        labelElement = null;
      }
      if (labelElement) {
        var labelText = labelElement.textContent || "";
        return isNonSensitiveString(labelText) ? labelText : "";
      }
      return getNearestLabel(parent);
    };
    getClosestElement = function(element, selectors) {
      if (!element) {
        return null;
      }
      if (selectors.some(function(selector2) {
        var _a;
        return (_a = element === null || element === void 0 ? void 0 : element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector2);
      })) {
        return element;
      }
      return getClosestElement(element === null || element === void 0 ? void 0 : element.parentElement, selectors);
    };
    getEventTagProps = function(element, logger) {
      var _a;
      var _b, _c;
      if (!element) {
        return {};
      }
      var tag = (_c = (_b = element === null || element === void 0 ? void 0 : element.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b);
      var selector2 = getSelector(element, logger);
      var properties = (_a = {}, _a[AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag, _a[AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = getText(element), _a[AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = selector2, _a[AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split("?")[0], _a);
      return removeEmptyProperties(properties);
    };
    asyncLoadScript = function(url) {
      return new Promise(function(resolve, reject) {
        var _a;
        try {
          var scriptElement = document.createElement("script");
          scriptElement.type = "text/javascript";
          scriptElement.async = true;
          scriptElement.src = url;
          scriptElement.addEventListener("load", function() {
            resolve({ status: true });
          }, { once: true });
          scriptElement.addEventListener("error", function() {
            reject({
              status: false,
              message: "Failed to load the script ".concat(url)
            });
          });
          (_a = document.head) === null || _a === void 0 ? void 0 : _a.appendChild(scriptElement);
        } catch (error) {
          reject(error);
        }
      });
    };
    filterOutNonTrackableEvents = function(event) {
      if (event.event.target === null || !event.closestTrackedAncestor) {
        return false;
      }
      return true;
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/lib/esm/libs/messenger.js
var WindowMessenger;
var init_messenger = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/lib/esm/libs/messenger.js"() {
    "use strict";
    init_constants4();
    init_helpers2();
    WindowMessenger = /** @class */
    function() {
      function WindowMessenger2(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.origin, origin = _c === void 0 ? AMPLITUDE_ORIGIN : _c;
        var _this = this;
        this.endpoint = AMPLITUDE_ORIGIN;
        this.requestCallbacks = {};
        this.onSelect = function(data) {
          _this.notify({ action: "element-selected", data });
        };
        this.onTrack = function(type, properties) {
          if (type === "selector-mode-changed") {
            _this.notify({ action: "track-selector-mode-changed", data: properties });
          } else if (type === "selector-moved") {
            _this.notify({ action: "track-selector-moved", data: properties });
          }
        };
        this.endpoint = origin;
      }
      WindowMessenger2.prototype.notify = function(message) {
        var _a, _b, _c, _d;
        (_b = (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 ? void 0 : _b.call(_a, "Message sent: ", JSON.stringify(message));
        (_d = (_c = window.opener) === null || _c === void 0 ? void 0 : _c.postMessage) === null || _d === void 0 ? void 0 : _d.call(_c, message, this.endpoint);
      };
      WindowMessenger2.prototype.sendRequest = function(action, args, options) {
        var _this = this;
        if (options === void 0) {
          options = { timeout: 15e3 };
        }
        var id2 = generateUniqueId();
        var request = {
          id: id2,
          action,
          args
        };
        var promise = new Promise(function(resolve, reject) {
          _this.requestCallbacks[id2] = { resolve, reject };
          _this.notify(request);
          if ((options === null || options === void 0 ? void 0 : options.timeout) > 0) {
            setTimeout(function() {
              reject(new Error("".concat(action, " timed out (id: ").concat(id2, ")")));
              delete _this.requestCallbacks[id2];
            }, options.timeout);
          }
        });
        return promise;
      };
      WindowMessenger2.prototype.handleResponse = function(response) {
        var _a;
        if (!this.requestCallbacks[response.id]) {
          (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn("No callback found for request id: ".concat(response.id));
          return;
        }
        this.requestCallbacks[response.id].resolve(response.responseData);
        delete this.requestCallbacks[response.id];
      };
      WindowMessenger2.prototype.setup = function(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, logger = _b.logger, endpoint = _b.endpoint, isElementSelectable = _b.isElementSelectable, cssSelectorAllowlist = _b.cssSelectorAllowlist, actionClickAllowlist = _b.actionClickAllowlist;
        this.logger = logger;
        if (endpoint && this.endpoint === AMPLITUDE_ORIGIN) {
          this.endpoint = endpoint;
        }
        var amplitudeVisualTaggingSelectorInstance = null;
        window.addEventListener("message", function(event) {
          var _a2, _b2, _c, _d, _e;
          (_b2 = (_a2 = _this.logger) === null || _a2 === void 0 ? void 0 : _a2.debug) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, "Message received: ", JSON.stringify(event));
          if (_this.endpoint !== event.origin) {
            return;
          }
          var eventData = event === null || event === void 0 ? void 0 : event.data;
          var action = eventData === null || eventData === void 0 ? void 0 : eventData.action;
          if (!action) {
            return;
          }
          if ("id" in eventData) {
            (_d = (_c = _this.logger) === null || _c === void 0 ? void 0 : _c.debug) === null || _d === void 0 ? void 0 : _d.call(_c, "Received Response to previous request: ", JSON.stringify(event));
            _this.handleResponse(eventData);
          } else {
            if (action === "ping") {
              _this.notify({ action: "pong" });
            } else if (action === "initialize-visual-tagging-selector") {
              var actionData_1 = eventData === null || eventData === void 0 ? void 0 : eventData.data;
              asyncLoadScript(AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL).then(function() {
                var _a3;
                amplitudeVisualTaggingSelectorInstance = (_a3 = window === null || window === void 0 ? void 0 : window.amplitudeVisualTaggingSelector) === null || _a3 === void 0 ? void 0 : _a3.call(window, {
                  getEventTagProps,
                  isElementSelectable: function(element) {
                    if (isElementSelectable) {
                      return isElementSelectable((actionData_1 === null || actionData_1 === void 0 ? void 0 : actionData_1.actionType) || "click", element);
                    }
                    return true;
                  },
                  onTrack: _this.onTrack,
                  onSelect: _this.onSelect,
                  visualHighlightClass: AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS,
                  messenger: _this,
                  cssSelectorAllowlist,
                  actionClickAllowlist
                });
                _this.notify({ action: "selector-loaded" });
              }).catch(function() {
                var _a3;
                (_a3 = _this.logger) === null || _a3 === void 0 ? void 0 : _a3.warn("Failed to initialize visual tagging selector");
              });
            } else if (action === "close-visual-tagging-selector") {
              (_e = amplitudeVisualTaggingSelectorInstance === null || amplitudeVisualTaggingSelectorInstance === void 0 ? void 0 : amplitudeVisualTaggingSelectorInstance.close) === null || _e === void 0 ? void 0 : _e.call(amplitudeVisualTaggingSelectorInstance);
            }
          }
        });
        this.notify({ action: "page-loaded" });
      };
      return WindowMessenger2;
    }();
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/lib/esm/hierarchy.js
function getElementProperties(element) {
  var e_1, _a;
  var _b, _c, _d, _e;
  if (element === null) {
    return null;
  }
  var tagName2 = String(element.tagName).toLowerCase();
  var properties = {
    tag: tagName2
  };
  var siblings = Array.from((_c = (_b = element.parentElement) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : []);
  if (siblings.length) {
    properties.index = siblings.indexOf(element);
    properties.indexOfType = siblings.filter(function(el) {
      return el.tagName === element.tagName;
    }).indexOf(element);
  }
  var prevSiblingTag = (_e = (_d = element.previousElementSibling) === null || _d === void 0 ? void 0 : _d.tagName) === null || _e === void 0 ? void 0 : _e.toLowerCase();
  if (prevSiblingTag) {
    properties.prevSib = String(prevSiblingTag);
  }
  var id2 = element.getAttribute("id");
  if (id2) {
    properties.id = String(id2);
  }
  var classes = Array.from(element.classList);
  if (classes.length) {
    properties.classes = classes;
  }
  var attributes = {};
  var attributesArray = Array.from(element.attributes);
  var filteredAttributes = attributesArray.filter(function(attr3) {
    return !BLOCKED_ATTRIBUTES.includes(attr3.name);
  });
  var isSensitiveElement = !isNonSensitiveElement(element);
  if (!HIGHLY_SENSITIVE_INPUT_TYPES.includes(String(element.getAttribute("type"))) && !SVG_TAGS.includes(tagName2)) {
    try {
      for (var filteredAttributes_1 = __values4(filteredAttributes), filteredAttributes_1_1 = filteredAttributes_1.next(); !filteredAttributes_1_1.done; filteredAttributes_1_1 = filteredAttributes_1.next()) {
        var attr2 = filteredAttributes_1_1.value;
        if (isSensitiveElement && !SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST.includes(attr2.name)) {
          continue;
        }
        attributes[attr2.name] = String(attr2.value).substring(0, MAX_ATTRIBUTE_LENGTH);
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (filteredAttributes_1_1 && !filteredAttributes_1_1.done && (_a = filteredAttributes_1.return)) _a.call(filteredAttributes_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
  if (Object.keys(attributes).length) {
    properties.attrs = attributes;
  }
  return properties;
}
function getAncestors(targetEl) {
  var ancestors = [];
  if (!targetEl) {
    return ancestors;
  }
  ancestors.push(targetEl);
  var current = targetEl.parentElement;
  while (current && current.tagName !== "HTML") {
    ancestors.push(current);
    current = current.parentElement;
  }
  return ancestors;
}
function ensureListUnderLimit(list, bytesLimit) {
  var numChars = 0;
  for (var i = 0; i < list.length; i++) {
    var node = list[i];
    if (node === null) {
      numChars += 4;
    } else {
      var value = ensureUnicodePythonCompatible(node);
      numChars += value ? Array.from(value).length : 4;
    }
    if (numChars > bytesLimit) {
      return list.slice(0, i);
    }
  }
  return list;
}
function ensureUnicodePythonCompatible(value, nested) {
  if (nested === void 0) {
    nested = false;
  }
  try {
    if (value == null) {
      if (nested) {
        return "None";
      }
      return null;
    } else if (typeof value === "string") {
      if (nested) {
        value = value.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
        if (value.includes('"')) {
          return "'".concat(value, "'");
        }
        if (value.includes("'")) {
          return '"'.concat(value.replace(/'/g, "\\'"), '"');
        }
        return "'".concat(value, "'");
      }
      return value;
    } else if (typeof value === "boolean") {
      return value ? "True" : "False";
    } else if (Array.isArray(value)) {
      var elements = value.map(function(o) {
        return ensureUnicodePythonCompatible(o, true);
      });
      return "[".concat(elements.join(", "), "]");
    } else if (typeof value === "object") {
      var entries = Object.entries(value).filter(function(_a) {
        var _b = __read5(_a, 1), key = _b[0];
        return key != null;
      }).map(function(_a) {
        var _b = __read5(_a, 2), key = _b[0], val = _b[1];
        return "".concat(String(ensureUnicodePythonCompatible(key, true)), ": ").concat(String(ensureUnicodePythonCompatible(val, true)));
      });
      var result = "{".concat(entries.join(", "), "}");
      if (result.includes("\\'")) {
        result = result.replace(/'/g, "'").replace(/'/g, "\\'");
      }
      return result;
    }
    return value.toString();
  } catch (e) {
    return null;
  }
}
var BLOCKED_ATTRIBUTES, SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST, SVG_TAGS, HIGHLY_SENSITIVE_INPUT_TYPES, MAX_ATTRIBUTE_LENGTH, MAX_HIERARCHY_LENGTH, getHierarchy;
var init_hierarchy = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/lib/esm/hierarchy.js"() {
    "use strict";
    init_tslib_es66();
    init_helpers2();
    BLOCKED_ATTRIBUTES = [
      // Already captured elsewhere in the hierarchy object
      "id",
      "class",
      // non-useful and potentially large attribute
      "style",
      // sensitive as prefilled form data may populate this attribute
      "value",
      // DOM events
      "onclick",
      "onchange",
      "oninput",
      "onblur",
      "onsubmit",
      "onfocus",
      "onkeydown",
      "onkeyup",
      "onkeypress",
      // React specific
      "data-reactid",
      "data-react-checksum",
      "data-reactroot"
    ];
    SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST = ["type"];
    SVG_TAGS = ["svg", "path", "g"];
    HIGHLY_SENSITIVE_INPUT_TYPES = ["password", "hidden"];
    MAX_ATTRIBUTE_LENGTH = 128;
    MAX_HIERARCHY_LENGTH = 1024;
    getHierarchy = function(element) {
      var hierarchy = [];
      if (!element) {
        return [];
      }
      var ancestors = getAncestors(element);
      hierarchy = ensureListUnderLimit(ancestors.map(function(el) {
        return getElementProperties(el);
      }), MAX_HIERARCHY_LENGTH);
      return hierarchy;
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-click.js
function trackClicks(_a) {
  var amplitude = _a.amplitude, allObservables = _a.allObservables, options = _a.options, shouldTrackEvent = _a.shouldTrackEvent;
  var clickObservable = allObservables.clickObservable;
  var comparisonTrigger = clickObservable.pipe((0, import_rxjs.pairwise)(), (0, import_rxjs.filter)(function(_a2) {
    var _b = __read5(_a2, 2), prev = _b[0], current = _b[1];
    var targetChanged = prev.event.target !== current.event.target;
    var samePos = Math.abs(current.event.screenX - prev.event.screenX) <= 20 && Math.abs(current.event.screenY - prev.event.screenY) <= 20;
    return targetChanged && !samePos;
  }));
  var timeoutTrigger = clickObservable.pipe((0, import_rxjs.debounceTime)(options.debounceTime), (0, import_rxjs.map)(function() {
    return "timeout";
  }));
  var triggers = (0, import_rxjs.merge)(comparisonTrigger, timeoutTrigger);
  var bufferedClicks = clickObservable.pipe((0, import_rxjs.delay)(0), (0, import_rxjs.filter)(filterOutNonTrackableEvents), (0, import_rxjs.filter)(function(click) {
    return shouldTrackEvent("click", click.closestTrackedAncestor);
  }), (0, import_rxjs.buffer)(triggers));
  return bufferedClicks.subscribe(function(clicks) {
    var e_1, _a2;
    var clickType = clicks.length >= RAGE_CLICK_THRESHOLD ? AMPLITUDE_ELEMENT_CLICKED_EVENT : AMPLITUDE_ELEMENT_CLICKED_EVENT;
    try {
      for (var clicks_1 = __values4(clicks), clicks_1_1 = clicks_1.next(); !clicks_1_1.done; clicks_1_1 = clicks_1.next()) {
        var click = clicks_1_1.value;
        amplitude === null || amplitude === void 0 ? void 0 : amplitude.track(clickType, click.targetElementProperties);
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (clicks_1_1 && !clicks_1_1.done && (_a2 = clicks_1.return)) _a2.call(clicks_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  });
}
var import_rxjs, RAGE_CLICK_THRESHOLD;
var init_track_click = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-click.js"() {
    "use strict";
    init_tslib_es66();
    import_rxjs = __toESM(require_cjs());
    init_helpers2();
    init_constants4();
    RAGE_CLICK_THRESHOLD = 5;
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-change.js
function trackChange(_a) {
  var amplitude = _a.amplitude, allObservables = _a.allObservables, getEventProperties = _a.getEventProperties, shouldTrackEvent = _a.shouldTrackEvent;
  var changeObservable = allObservables.changeObservable;
  var filteredChangeObservable = changeObservable.pipe((0, import_rxjs2.filter)(filterOutNonTrackableEvents), (0, import_rxjs2.filter)(function(changeEvent) {
    return shouldTrackEvent("change", changeEvent.closestTrackedAncestor);
  }));
  return filteredChangeObservable.subscribe(function(changeEvent) {
    amplitude === null || amplitude === void 0 ? void 0 : amplitude.track(AMPLITUDE_ELEMENT_CHANGED_EVENT, getEventProperties("change", changeEvent.closestTrackedAncestor));
  });
}
var import_rxjs2;
var init_track_change = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-change.js"() {
    "use strict";
    import_rxjs2 = __toESM(require_cjs());
    init_helpers2();
    init_constants4();
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-action-click.js
function trackActionClick(_a) {
  var amplitude = _a.amplitude, allObservables = _a.allObservables, options = _a.options, getEventProperties = _a.getEventProperties, shouldTrackEvent = _a.shouldTrackEvent, shouldTrackActionClick = _a.shouldTrackActionClick;
  var clickObservable = allObservables.clickObservable, mutationObservable = allObservables.mutationObservable, navigateObservable = allObservables.navigateObservable;
  var filteredClickObservable = clickObservable.pipe((0, import_rxjs3.filter)(function(click) {
    return !shouldTrackEvent("click", click.closestTrackedAncestor);
  }), (0, import_rxjs3.map)(function(click) {
    var closestActionClickEl = getClosestElement(click.event.target, options.actionClickAllowlist);
    click.closestTrackedAncestor = closestActionClickEl;
    if (click.closestTrackedAncestor !== null) {
      click.targetElementProperties = getEventProperties(click.type, click.closestTrackedAncestor);
    }
    return click;
  }), (0, import_rxjs3.filter)(filterOutNonTrackableEvents), (0, import_rxjs3.filter)(function(clickEvent) {
    return shouldTrackActionClick("click", clickEvent.closestTrackedAncestor);
  }));
  var changeObservables = [mutationObservable];
  if (navigateObservable) {
    changeObservables.push(navigateObservable);
  }
  var mutationOrNavigate = import_rxjs3.merge.apply(void 0, __spreadArray4([], __read5(changeObservables), false));
  var actionClicks = filteredClickObservable.pipe(
    // If a mutation occurs within 0.5 seconds of a click event (timeout({ first: 500 })), it emits the original first click event.
    // take 1 to only limit the action events in case there are multiple
    (0, import_rxjs3.switchMap)(function(click) {
      return mutationOrNavigate.pipe(
        (0, import_rxjs3.take)(1),
        (0, import_rxjs3.timeout)({ first: 500, with: function() {
          return import_rxjs3.EMPTY;
        } }),
        // in case of timeout, map to empty to prevent any click from being emitted
        (0, import_rxjs3.map)(function() {
          return click;
        })
      );
    })
  );
  return actionClicks.subscribe(function(actionClick) {
    amplitude === null || amplitude === void 0 ? void 0 : amplitude.track(AMPLITUDE_ELEMENT_CLICKED_EVENT, getEventProperties("click", actionClick.closestTrackedAncestor));
  });
}
var import_rxjs3;
var init_track_action_click = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-action-click.js"() {
    "use strict";
    init_tslib_es66();
    import_rxjs3 = __toESM(require_cjs());
    init_helpers2();
    init_constants4();
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture-plugin.js
function isElementBasedEvent(event) {
  return event.type === "click" || event.type === "change";
}
var import_rxjs4, ObservablesEnum, autocapturePlugin;
var init_autocapture_plugin = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture-plugin.js"() {
    "use strict";
    init_tslib_es66();
    init_esm();
    init_constants4();
    import_rxjs4 = __toESM(require_cjs());
    init_helpers2();
    init_messenger();
    init_hierarchy();
    init_track_click();
    init_track_change();
    init_track_action_click();
    (function(ObservablesEnum2) {
      ObservablesEnum2["ClickObservable"] = "clickObservable";
      ObservablesEnum2["ChangeObservable"] = "changeObservable";
      ObservablesEnum2["NavigateObservable"] = "navigateObservable";
      ObservablesEnum2["MutationObservable"] = "mutationObservable";
    })(ObservablesEnum || (ObservablesEnum = {}));
    autocapturePlugin = function(options) {
      var _a, _b, _c;
      if (options === void 0) {
        options = {};
      }
      var _d = options.dataAttributePrefix, dataAttributePrefix = _d === void 0 ? DEFAULT_DATA_ATTRIBUTE_PREFIX : _d, _e = options.visualTaggingOptions, visualTaggingOptions = _e === void 0 ? {
        enabled: true,
        messenger: new WindowMessenger()
      } : _e;
      options.cssSelectorAllowlist = (_a = options.cssSelectorAllowlist) !== null && _a !== void 0 ? _a : DEFAULT_CSS_SELECTOR_ALLOWLIST;
      options.actionClickAllowlist = (_b = options.actionClickAllowlist) !== null && _b !== void 0 ? _b : DEFAULT_ACTION_CLICK_ALLOWLIST;
      options.debounceTime = (_c = options.debounceTime) !== null && _c !== void 0 ? _c : 0;
      var name = PLUGIN_NAME;
      var type = "enrichment";
      var subscriptions = [];
      var logger = void 0;
      var createObservables = function() {
        var _a2;
        var clickObservable = (0, import_rxjs4.fromEvent)(document, "click", { capture: true }).pipe((0, import_rxjs4.map)(function(click) {
          return addAdditionalEventProperties(click, "click");
        }));
        var changeObservable = (0, import_rxjs4.fromEvent)(document, "change", { capture: true }).pipe((0, import_rxjs4.map)(function(change) {
          return addAdditionalEventProperties(change, "change");
        }));
        var navigateObservable;
        if (window.navigation) {
          navigateObservable = (0, import_rxjs4.fromEvent)(window.navigation, "navigate").pipe((0, import_rxjs4.map)(function(navigate) {
            return addAdditionalEventProperties(navigate, "navigate");
          }));
        }
        var mutationObservable = new import_rxjs4.Observable(function(observer) {
          var mutationObserver = new MutationObserver(function(mutations) {
            observer.next(mutations);
          });
          mutationObserver.observe(document.body, {
            childList: true,
            attributes: true,
            characterData: true,
            subtree: true
          });
          return function() {
            return mutationObserver.disconnect();
          };
        }).pipe((0, import_rxjs4.map)(function(mutation) {
          return addAdditionalEventProperties(mutation, "mutation");
        }));
        return _a2 = {}, _a2[ObservablesEnum.ClickObservable] = clickObservable, _a2[ObservablesEnum.ChangeObservable] = changeObservable, // [ObservablesEnum.ErrorObservable]: errorObservable,
        _a2[ObservablesEnum.NavigateObservable] = navigateObservable, _a2[ObservablesEnum.MutationObservable] = mutationObservable, _a2;
      };
      var getEventProperties = function(actionType, element) {
        var _a2;
        var _b2, _c2;
        var tag = (_c2 = (_b2 = element === null || element === void 0 ? void 0 : element.tagName) === null || _b2 === void 0 ? void 0 : _b2.toLowerCase) === null || _c2 === void 0 ? void 0 : _c2.call(_b2);
        var rect = typeof element.getBoundingClientRect === "function" ? element.getBoundingClientRect() : { left: null, top: null };
        var ariaLabel = element.getAttribute("aria-label");
        var attributes = getAttributesWithPrefix(element, dataAttributePrefix);
        var nearestLabel = getNearestLabel(element);
        var selector2 = getSelector(element, logger);
        var properties = (_a2 = {}, _a2[AMPLITUDE_EVENT_PROP_ELEMENT_ID] = element.getAttribute("id") || "", _a2[AMPLITUDE_EVENT_PROP_ELEMENT_CLASS] = element.getAttribute("class"), _a2[AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY] = getHierarchy(element), _a2[AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag, _a2[AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = getText(element), _a2[AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT] = rect.left == null ? null : Math.round(rect.left), _a2[AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP] = rect.top == null ? null : Math.round(rect.top), _a2[AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL] = ariaLabel, _a2[AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES] = attributes, _a2[AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = selector2, _a2[AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL] = nearestLabel, _a2[AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split("?")[0], _a2[AMPLITUDE_EVENT_PROP_PAGE_TITLE] = typeof document !== "undefined" && document.title || "", _a2[AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT] = window.innerHeight, _a2[AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH] = window.innerWidth, _a2);
        if (tag === "a" && actionType === "click" && element instanceof HTMLAnchorElement) {
          properties[AMPLITUDE_EVENT_PROP_ELEMENT_HREF] = element.href;
        }
        return removeEmptyProperties(properties);
      };
      var addAdditionalEventProperties = function(event, type2) {
        var baseEvent = {
          event,
          timestamp: Date.now(),
          type: type2
        };
        if (isElementBasedEvent(baseEvent) && baseEvent.event.target !== null) {
          var closestTrackedAncestor = getClosestElement(baseEvent.event.target, options.cssSelectorAllowlist);
          if (closestTrackedAncestor) {
            baseEvent.closestTrackedAncestor = closestTrackedAncestor;
            baseEvent.targetElementProperties = getEventProperties(baseEvent.type, closestTrackedAncestor);
          }
          return baseEvent;
        }
        return baseEvent;
      };
      var setup = function(config2, amplitude) {
        return __awaiter6(void 0, void 0, void 0, function() {
          var shouldTrackEvent, shouldTrackActionClick, allObservables, clickTrackingSubscription, changeSubscription, actionClickSubscription, allowlist, actionClickAllowlist;
          var _a2, _b2;
          return __generator6(this, function(_c2) {
            logger = config2.loggerProvider;
            if (typeof document === "undefined") {
              return [
                2
                /*return*/
              ];
            }
            shouldTrackEvent = createShouldTrackEvent(options, options.cssSelectorAllowlist);
            shouldTrackActionClick = createShouldTrackEvent(options, options.actionClickAllowlist);
            allObservables = createObservables();
            clickTrackingSubscription = trackClicks({
              allObservables,
              options,
              amplitude,
              shouldTrackEvent
            });
            subscriptions.push(clickTrackingSubscription);
            changeSubscription = trackChange({
              allObservables,
              getEventProperties,
              amplitude,
              shouldTrackEvent
            });
            subscriptions.push(changeSubscription);
            actionClickSubscription = trackActionClick({
              allObservables,
              options,
              getEventProperties,
              amplitude,
              shouldTrackEvent,
              shouldTrackActionClick
            });
            subscriptions.push(actionClickSubscription);
            (_a2 = config2 === null || config2 === void 0 ? void 0 : config2.loggerProvider) === null || _a2 === void 0 ? void 0 : _a2.log("".concat(name, " has been successfully added."));
            if (window.opener && visualTaggingOptions.enabled) {
              allowlist = options.cssSelectorAllowlist;
              actionClickAllowlist = options.actionClickAllowlist;
              (_b2 = visualTaggingOptions.messenger) === null || _b2 === void 0 ? void 0 : _b2.setup(__assign7(__assign7({ logger: config2 === null || config2 === void 0 ? void 0 : config2.loggerProvider }, (config2 === null || config2 === void 0 ? void 0 : config2.serverZone) && { endpoint: AMPLITUDE_ORIGINS_MAP[config2.serverZone] }), { isElementSelectable: createShouldTrackEvent(options, __spreadArray4(__spreadArray4([], __read5(allowlist), false), __read5(actionClickAllowlist), false)), cssSelectorAllowlist: allowlist, actionClickAllowlist }));
            }
            return [
              2
              /*return*/
            ];
          });
        });
      };
      var execute = function(event) {
        return __awaiter6(void 0, void 0, void 0, function() {
          return __generator6(this, function(_a2) {
            return [2, event];
          });
        });
      };
      var teardown = function() {
        return __awaiter6(void 0, void 0, void 0, function() {
          var subscriptions_1, subscriptions_1_1, subscription;
          var e_1, _a2;
          return __generator6(this, function(_b2) {
            try {
              for (subscriptions_1 = __values4(subscriptions), subscriptions_1_1 = subscriptions_1.next(); !subscriptions_1_1.done; subscriptions_1_1 = subscriptions_1.next()) {
                subscription = subscriptions_1_1.value;
                subscription.unsubscribe();
              }
            } catch (e_1_1) {
              e_1 = { error: e_1_1 };
            } finally {
              try {
                if (subscriptions_1_1 && !subscriptions_1_1.done && (_a2 = subscriptions_1.return)) _a2.call(subscriptions_1);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
            return [
              2
              /*return*/
            ];
          });
        });
      };
      return {
        name,
        type,
        setup,
        execute,
        teardown
      };
    };
  }
});

// node_modules/@amplitude/plugin-autocapture-browser/lib/esm/index.js
var init_esm6 = __esm({
  "node_modules/@amplitude/plugin-autocapture-browser/lib/esm/index.js"() {
    "use strict";
    init_autocapture_plugin();
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/attribution/constants.js
var UTM_CAMPAIGN2, UTM_CONTENT2, UTM_ID2, UTM_MEDIUM2, UTM_SOURCE2, UTM_TERM2, DCLID2, FBCLID2, GBRAID2, GCLID2, KO_CLICK_ID2, LI_FAT_ID2, MSCLKID2, RDT_CID2, TTCLID2, TWCLID2, WBRAID2, BASE_CAMPAIGN2;
var init_constants5 = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/attribution/constants.js"() {
    "use strict";
    UTM_CAMPAIGN2 = "utm_campaign";
    UTM_CONTENT2 = "utm_content";
    UTM_ID2 = "utm_id";
    UTM_MEDIUM2 = "utm_medium";
    UTM_SOURCE2 = "utm_source";
    UTM_TERM2 = "utm_term";
    DCLID2 = "dclid";
    FBCLID2 = "fbclid";
    GBRAID2 = "gbraid";
    GCLID2 = "gclid";
    KO_CLICK_ID2 = "ko_click_id";
    LI_FAT_ID2 = "li_fat_id";
    MSCLKID2 = "msclkid";
    RDT_CID2 = "rtd_cid";
    TTCLID2 = "ttclid";
    TWCLID2 = "twclid";
    WBRAID2 = "wbraid";
    BASE_CAMPAIGN2 = {
      utm_campaign: void 0,
      utm_content: void 0,
      utm_id: void 0,
      utm_medium: void 0,
      utm_source: void 0,
      utm_term: void 0,
      referrer: void 0,
      referring_domain: void 0,
      dclid: void 0,
      gbraid: void 0,
      gclid: void 0,
      fbclid: void 0,
      ko_click_id: void 0,
      li_fat_id: void 0,
      msclkid: void 0,
      rtd_cid: void 0,
      ttclid: void 0,
      twclid: void 0,
      wbraid: void 0
    };
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/attribution/helpers.js
var domainWithoutSubdomain, isDirectTraffic, isNewCampaign, isExcludedReferrer, createCampaignEvent, getDefaultExcludedReferrers;
var init_helpers3 = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/attribution/helpers.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    init_constants5();
    domainWithoutSubdomain = function(domain) {
      var parts = domain.split(".");
      if (parts.length <= 2) {
        return domain;
      }
      return parts.slice(parts.length - 2, parts.length).join(".");
    };
    isDirectTraffic = function(current) {
      return Object.values(current).every(function(value) {
        return !value;
      });
    };
    isNewCampaign = function(current, previous, options, logger, isNewSession2) {
      if (isNewSession2 === void 0) {
        isNewSession2 = true;
      }
      var referrer = current.referrer, referring_domain = current.referring_domain, currentCampaign = __rest2(current, ["referrer", "referring_domain"]);
      var _a = previous || {}, _previous_referrer = _a.referrer, prevReferringDomain = _a.referring_domain, previousCampaign = __rest2(_a, ["referrer", "referring_domain"]);
      if (isExcludedReferrer(options.excludeReferrers, current.referring_domain)) {
        logger.debug("This is not a new campaign because ".concat(current.referring_domain, " is in the exclude referrer list."));
        return false;
      }
      if (!isNewSession2 && isDirectTraffic(current) && previous) {
        logger.debug("This is not a new campaign because this is a direct traffic in the same session.");
        return false;
      }
      var hasNewCampaign = JSON.stringify(currentCampaign) !== JSON.stringify(previousCampaign);
      var hasNewDomain = domainWithoutSubdomain(referring_domain || "") !== domainWithoutSubdomain(prevReferringDomain || "");
      var result = !previous || hasNewCampaign || hasNewDomain;
      if (!result) {
        logger.debug("This is not a new campaign because it's the same as the previous one.");
      } else {
        logger.debug("This is a new campaign. An $identify event will be sent.");
      }
      return result;
    };
    isExcludedReferrer = function(excludeReferrers, referringDomain) {
      if (excludeReferrers === void 0) {
        excludeReferrers = [];
      }
      if (referringDomain === void 0) {
        referringDomain = "";
      }
      return excludeReferrers.some(function(value) {
        return value instanceof RegExp ? value.test(referringDomain) : value === referringDomain;
      });
    };
    createCampaignEvent = function(campaign, options) {
      var campaignParameters = __assign3(__assign3({}, BASE_CAMPAIGN2), campaign);
      var identifyEvent = Object.entries(campaignParameters).reduce(function(identify2, _a) {
        var _b;
        var _c = __read3(_a, 2), key = _c[0], value = _c[1];
        identify2.setOnce("initial_".concat(key), (_b = value !== null && value !== void 0 ? value : options.initialEmptyValue) !== null && _b !== void 0 ? _b : "EMPTY");
        if (value) {
          return identify2.set(key, value);
        }
        return identify2.unset(key);
      }, new Identify());
      return createIdentifyEvent(identifyEvent);
    };
    getDefaultExcludedReferrers = function(cookieDomain) {
      var domain = cookieDomain;
      if (domain) {
        if (domain.startsWith(".")) {
          domain = domain.substring(1);
        }
        return [new RegExp("".concat(domain.replace(".", "\\."), "$"))];
      }
      return [];
    };
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/attribution/campaign-parser.js
var CampaignParser2;
var init_campaign_parser2 = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/attribution/campaign-parser.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    init_constants5();
    CampaignParser2 = /** @class */
    function() {
      function CampaignParser3() {
      }
      CampaignParser3.prototype.parse = function() {
        return __awaiter2(this, void 0, void 0, function() {
          return __generator2(this, function(_a) {
            return [2, __assign3(__assign3(__assign3(__assign3({}, BASE_CAMPAIGN2), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
          });
        });
      };
      CampaignParser3.prototype.getUtmParam = function() {
        var params = getQueryParams();
        var utmCampaign = params[UTM_CAMPAIGN2];
        var utmContent = params[UTM_CONTENT2];
        var utmId = params[UTM_ID2];
        var utmMedium = params[UTM_MEDIUM2];
        var utmSource = params[UTM_SOURCE2];
        var utmTerm = params[UTM_TERM2];
        return {
          utm_campaign: utmCampaign,
          utm_content: utmContent,
          utm_id: utmId,
          utm_medium: utmMedium,
          utm_source: utmSource,
          utm_term: utmTerm
        };
      };
      CampaignParser3.prototype.getReferrer = function() {
        var _a, _b;
        var data = {
          referrer: void 0,
          referring_domain: void 0
        };
        try {
          data.referrer = document.referrer || void 0;
          data.referring_domain = (_b = (_a = data.referrer) === null || _a === void 0 ? void 0 : _a.split("/")[2]) !== null && _b !== void 0 ? _b : void 0;
        } catch (_c) {
        }
        return data;
      };
      CampaignParser3.prototype.getClickIds = function() {
        var _a;
        var params = getQueryParams();
        return _a = {}, _a[DCLID2] = params[DCLID2], _a[FBCLID2] = params[FBCLID2], _a[GBRAID2] = params[GBRAID2], _a[GCLID2] = params[GCLID2], _a[KO_CLICK_ID2] = params[KO_CLICK_ID2], _a[LI_FAT_ID2] = params[LI_FAT_ID2], _a[MSCLKID2] = params[MSCLKID2], _a[RDT_CID2] = params[RDT_CID2], _a[TTCLID2] = params[TTCLID2], _a[TWCLID2] = params[TWCLID2], _a[WBRAID2] = params[WBRAID2], _a;
      };
      return CampaignParser3;
    }();
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/attribution/web-attribution.js
var WebAttribution;
var init_web_attribution = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/attribution/web-attribution.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    init_helpers3();
    init_campaign_parser2();
    init_constants5();
    WebAttribution = /** @class */
    function() {
      function WebAttribution2(options, config2) {
        var _a;
        this.shouldTrackNewCampaign = false;
        this.options = __assign3({ initialEmptyValue: "EMPTY", resetSessionOnNewCampaign: false, excludeReferrers: getDefaultExcludedReferrers((_a = config2.cookieOptions) === null || _a === void 0 ? void 0 : _a.domain) }, options);
        this.storage = config2.cookieStorage;
        this.storageKey = getStorageKey(config2.apiKey, "MKTG");
        this.currentCampaign = BASE_CAMPAIGN2;
        this.sessionTimeout = config2.sessionTimeout;
        this.lastEventTime = config2.lastEventTime;
        this.logger = config2.loggerProvider;
        config2.loggerProvider.log("Installing web attribution tracking.");
      }
      WebAttribution2.prototype.init = function() {
        return __awaiter2(this, void 0, void 0, function() {
          var isEventInNewSession;
          var _a;
          return __generator2(this, function(_b) {
            switch (_b.label) {
              case 0:
                return [4, this.fetchCampaign()];
              case 1:
                _a = __read3.apply(void 0, [_b.sent(), 2]), this.currentCampaign = _a[0], this.previousCampaign = _a[1];
                isEventInNewSession = !this.lastEventTime ? true : isNewSession(this.sessionTimeout, this.lastEventTime);
                if (!isNewCampaign(this.currentCampaign, this.previousCampaign, this.options, this.logger, isEventInNewSession)) return [3, 3];
                this.shouldTrackNewCampaign = true;
                return [4, this.storage.set(this.storageKey, this.currentCampaign)];
              case 2:
                _b.sent();
                _b.label = 3;
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      WebAttribution2.prototype.fetchCampaign = function() {
        return __awaiter2(this, void 0, void 0, function() {
          return __generator2(this, function(_a) {
            switch (_a.label) {
              case 0:
                return [4, Promise.all([new CampaignParser2().parse(), this.storage.get(this.storageKey)])];
              case 1:
                return [2, _a.sent()];
            }
          });
        });
      };
      WebAttribution2.prototype.generateCampaignEvent = function(event_id) {
        this.shouldTrackNewCampaign = false;
        var campaignEvent = createCampaignEvent(this.currentCampaign, this.options);
        if (event_id) {
          campaignEvent.event_id = event_id;
        }
        return campaignEvent;
      };
      WebAttribution2.prototype.shouldSetSessionIdOnNewCampaign = function() {
        return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
      };
      return WebAttribution2;
    }();
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/browser-client.js
var AmplitudeBrowser;
var init_browser_client = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/browser-client.js"() {
    "use strict";
    init_tslib_es62();
    init_esm();
    init_default_tracking();
    init_snippet_helper();
    init_context();
    init_config2();
    init_esm4();
    init_form_interaction_tracking();
    init_file_download_tracking();
    init_constants2();
    init_det_notification();
    init_network_connectivity_checker();
    init_joined_config();
    init_esm6();
    init_web_attribution();
    AmplitudeBrowser = /** @class */
    function(_super) {
      __extends2(AmplitudeBrowser2, _super);
      function AmplitudeBrowser2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      AmplitudeBrowser2.prototype.init = function(apiKey, userIdOrOptions, maybeOptions) {
        if (apiKey === void 0) {
          apiKey = "";
        }
        var userId;
        var options;
        if (arguments.length > 2) {
          userId = userIdOrOptions;
          options = maybeOptions;
        } else {
          if (typeof userIdOrOptions === "string") {
            userId = userIdOrOptions;
            options = void 0;
          } else {
            userId = userIdOrOptions === null || userIdOrOptions === void 0 ? void 0 : userIdOrOptions.userId;
            options = userIdOrOptions;
          }
        }
        return returnWrapper(this._init(__assign3(__assign3({}, options), { userId, apiKey })));
      };
      AmplitudeBrowser2.prototype._init = function(options) {
        return __awaiter2(this, void 0, void 0, function() {
          var browserOptions, joinedConfigGenerator, attributionTrackingOptions, queryParams, querySessionId, connector;
          var _this = this;
          var _a, _b, _c;
          return __generator2(this, function(_d) {
            switch (_d.label) {
              case 0:
                if (this.initializing) {
                  return [
                    2
                    /*return*/
                  ];
                }
                this.initializing = true;
                return [4, useBrowserConfig(options.apiKey, options, this)];
              case 1:
                browserOptions = _d.sent();
                if (!options.fetchRemoteConfig) return [3, 4];
                return [4, createBrowserJoinedConfigGenerator(browserOptions)];
              case 2:
                joinedConfigGenerator = _d.sent();
                return [4, joinedConfigGenerator.generateJoinedConfig()];
              case 3:
                browserOptions = _d.sent();
                _d.label = 4;
              case 4:
                return [4, _super.prototype._init.call(this, browserOptions)];
              case 5:
                _d.sent();
                this.logBrowserOptions(browserOptions);
                if (!isAttributionTrackingEnabled(this.config.defaultTracking)) return [3, 7];
                attributionTrackingOptions = getAttributionTrackingConfig(this.config);
                this.webAttribution = new WebAttribution(attributionTrackingOptions, this.config);
                return [4, this.webAttribution.init()];
              case 6:
                _d.sent();
                _d.label = 7;
              case 7:
                queryParams = getQueryParams();
                querySessionId = Number.isNaN(Number(queryParams.ampSessionId)) ? void 0 : Number(queryParams.ampSessionId);
                this.setSessionId((_c = (_b = (_a = options.sessionId) !== null && _a !== void 0 ? _a : querySessionId) !== null && _b !== void 0 ? _b : this.config.sessionId) !== null && _c !== void 0 ? _c : Date.now());
                connector = getAnalyticsConnector(options.instanceName);
                connector.identityStore.setIdentity({
                  userId: this.config.userId,
                  deviceId: this.config.deviceId
                });
                if (!(this.config.offline !== OfflineDisabled)) return [3, 9];
                return [4, this.add(networkConnectivityCheckerPlugin()).promise];
              case 8:
                _d.sent();
                _d.label = 9;
              case 9:
                return [4, this.add(new Destination()).promise];
              case 10:
                _d.sent();
                return [4, this.add(new Context()).promise];
              case 11:
                _d.sent();
                return [4, this.add(new IdentityEventSender()).promise];
              case 12:
                _d.sent();
                detNotify(this.config);
                if (!isFileDownloadTrackingEnabled(this.config.defaultTracking)) return [3, 14];
                this.config.loggerProvider.debug("Adding file download tracking plugin");
                return [4, this.add(fileDownloadTracking()).promise];
              case 13:
                _d.sent();
                _d.label = 14;
              case 14:
                if (!isFormInteractionTrackingEnabled(this.config.defaultTracking)) return [3, 16];
                this.config.loggerProvider.debug("Adding form interaction plugin");
                return [4, this.add(formInteractionTracking()).promise];
              case 15:
                _d.sent();
                _d.label = 16;
              case 16:
                if (!isPageViewTrackingEnabled(this.config.defaultTracking)) return [3, 18];
                this.config.loggerProvider.debug("Adding page view tracking plugin");
                return [4, this.add(pageViewTrackingPlugin(getPageViewTrackingConfig(this.config))).promise];
              case 17:
                _d.sent();
                _d.label = 18;
              case 18:
                if (!isElementInteractionsEnabled(this.config.autocapture)) return [3, 20];
                this.config.loggerProvider.debug("Adding user interactions plugin (autocapture plugin)");
                return [4, this.add(autocapturePlugin(getElementInteractionsConfig(this.config))).promise];
              case 19:
                _d.sent();
                _d.label = 20;
              case 20:
                this.initializing = false;
                return [4, this.runQueuedFunctions("dispatchQ")];
              case 21:
                _d.sent();
                connector.eventBridge.setEventReceiver(function(event) {
                  void _this.track(event.eventType, event.eventProperties);
                });
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      AmplitudeBrowser2.prototype.getUserId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.userId;
      };
      AmplitudeBrowser2.prototype.setUserId = function(userId) {
        if (!this.config) {
          this.q.push(this.setUserId.bind(this, userId));
          return;
        }
        this.config.loggerProvider.debug("function setUserId: ", userId);
        if (userId !== this.config.userId || userId === void 0) {
          this.config.userId = userId;
          setConnectorUserId(userId, this.config.instanceName);
        }
      };
      AmplitudeBrowser2.prototype.getDeviceId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.deviceId;
      };
      AmplitudeBrowser2.prototype.setDeviceId = function(deviceId) {
        if (!this.config) {
          this.q.push(this.setDeviceId.bind(this, deviceId));
          return;
        }
        this.config.loggerProvider.debug("function setDeviceId: ", deviceId);
        this.config.deviceId = deviceId;
        setConnectorDeviceId(deviceId, this.config.instanceName);
      };
      AmplitudeBrowser2.prototype.reset = function() {
        this.setDeviceId(UUID());
        this.setUserId(void 0);
      };
      AmplitudeBrowser2.prototype.getSessionId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.sessionId;
      };
      AmplitudeBrowser2.prototype.setSessionId = function(sessionId) {
        var _a;
        var promises = [];
        if (!this.config) {
          this.q.push(this.setSessionId.bind(this, sessionId));
          return returnWrapper(Promise.resolve());
        }
        if (sessionId === this.config.sessionId) {
          return returnWrapper(Promise.resolve());
        }
        this.config.loggerProvider.debug("function setSessionId: ", sessionId);
        var previousSessionId = this.getSessionId();
        var lastEventTime = this.config.lastEventTime;
        var lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
        this.config.sessionId = sessionId;
        this.config.lastEventTime = void 0;
        this.config.pageCounter = 0;
        if (isSessionTrackingEnabled(this.config.defaultTracking)) {
          if (previousSessionId && lastEventTime) {
            promises.push(this.track(DEFAULT_SESSION_END_EVENT, void 0, {
              device_id: this.previousSessionDeviceId,
              event_id: ++lastEventId,
              session_id: previousSessionId,
              time: lastEventTime + 1,
              user_id: this.previousSessionUserId
            }).promise);
          }
          this.config.lastEventTime = this.config.sessionId;
        }
        var isCampaignEventTracked = this.trackCampaignEventIfNeeded(++lastEventId, promises);
        if (isSessionTrackingEnabled(this.config.defaultTracking)) {
          promises.push(this.track(DEFAULT_SESSION_START_EVENT, void 0, {
            event_id: isCampaignEventTracked ? ++lastEventId : lastEventId,
            session_id: this.config.sessionId,
            time: this.config.lastEventTime
          }).promise);
        }
        this.previousSessionDeviceId = this.config.deviceId;
        this.previousSessionUserId = this.config.userId;
        return returnWrapper(Promise.all(promises));
      };
      AmplitudeBrowser2.prototype.extendSession = function() {
        if (!this.config) {
          this.q.push(this.extendSession.bind(this));
          return;
        }
        this.config.lastEventTime = Date.now();
      };
      AmplitudeBrowser2.prototype.setTransport = function(transport) {
        if (!this.config) {
          this.q.push(this.setTransport.bind(this, transport));
          return;
        }
        this.config.transportProvider = createTransport(transport);
      };
      AmplitudeBrowser2.prototype.identify = function(identify2, eventOptions) {
        if (isInstanceProxy(identify2)) {
          var queue = identify2._q;
          identify2._q = [];
          identify2 = convertProxyObjectToRealObject(new Identify(), queue);
        }
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.user_id) {
          this.setUserId(eventOptions.user_id);
        }
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.device_id) {
          this.setDeviceId(eventOptions.device_id);
        }
        return _super.prototype.identify.call(this, identify2, eventOptions);
      };
      AmplitudeBrowser2.prototype.groupIdentify = function(groupType, groupName, identify2, eventOptions) {
        if (isInstanceProxy(identify2)) {
          var queue = identify2._q;
          identify2._q = [];
          identify2 = convertProxyObjectToRealObject(new Identify(), queue);
        }
        return _super.prototype.groupIdentify.call(this, groupType, groupName, identify2, eventOptions);
      };
      AmplitudeBrowser2.prototype.revenue = function(revenue2, eventOptions) {
        if (isInstanceProxy(revenue2)) {
          var queue = revenue2._q;
          revenue2._q = [];
          revenue2 = convertProxyObjectToRealObject(new Revenue(), queue);
        }
        return _super.prototype.revenue.call(this, revenue2, eventOptions);
      };
      AmplitudeBrowser2.prototype.trackCampaignEventIfNeeded = function(lastEventId, promises) {
        if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign) {
          return false;
        }
        var campaignEvent = this.webAttribution.generateCampaignEvent(lastEventId);
        if (promises) {
          promises.push(this.track(campaignEvent).promise);
        } else {
          this.track(campaignEvent);
        }
        this.config.loggerProvider.log("Tracking attribution.");
        return true;
      };
      AmplitudeBrowser2.prototype.process = function(event) {
        return __awaiter2(this, void 0, void 0, function() {
          var currentTime, isEventInNewSession, shouldSetSessionIdOnNewCampaign;
          return __generator2(this, function(_a) {
            currentTime = Date.now();
            isEventInNewSession = isNewSession(this.config.sessionTimeout, this.config.lastEventTime);
            shouldSetSessionIdOnNewCampaign = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign();
            if (event.event_type !== DEFAULT_SESSION_START_EVENT && event.event_type !== DEFAULT_SESSION_END_EVENT && (!event.session_id || event.session_id === this.getSessionId())) {
              if (isEventInNewSession || shouldSetSessionIdOnNewCampaign) {
                this.setSessionId(currentTime);
                if (shouldSetSessionIdOnNewCampaign) {
                  this.config.loggerProvider.log("Created a new session for new campaign.");
                }
              } else if (!isEventInNewSession) {
                this.trackCampaignEventIfNeeded();
              }
            }
            return [2, _super.prototype.process.call(this, event)];
          });
        });
      };
      AmplitudeBrowser2.prototype.logBrowserOptions = function(browserConfig) {
        try {
          var browserConfigCopy = __assign3(__assign3({}, browserConfig), { apiKey: browserConfig.apiKey.substring(0, 10) + "********" });
          this.config.loggerProvider.debug("Initialized Amplitude with BrowserConfig:", JSON.stringify(browserConfigCopy));
        } catch (e) {
          this.config.loggerProvider.error("Error logging browser config", e);
        }
      };
      return AmplitudeBrowser2;
    }(AmplitudeCore);
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/browser-client-factory.js
var createInstance, browser_client_factory_default;
var init_browser_client_factory = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/browser-client-factory.js"() {
    "use strict";
    init_esm();
    init_browser_client();
    createInstance = function() {
      var client2 = new AmplitudeBrowser();
      return {
        init: debugWrapper(client2.init.bind(client2), "init", getClientLogConfig(client2), getClientStates(client2, ["config"])),
        add: debugWrapper(client2.add.bind(client2), "add", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.plugins"])),
        remove: debugWrapper(client2.remove.bind(client2), "remove", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.plugins"])),
        track: debugWrapper(client2.track.bind(client2), "track", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
        logEvent: debugWrapper(client2.logEvent.bind(client2), "logEvent", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
        identify: debugWrapper(client2.identify.bind(client2), "identify", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
        groupIdentify: debugWrapper(client2.groupIdentify.bind(client2), "groupIdentify", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
        setGroup: debugWrapper(client2.setGroup.bind(client2), "setGroup", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
        revenue: debugWrapper(client2.revenue.bind(client2), "revenue", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
        flush: debugWrapper(client2.flush.bind(client2), "flush", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
        getUserId: debugWrapper(client2.getUserId.bind(client2), "getUserId", getClientLogConfig(client2), getClientStates(client2, ["config", "config.userId"])),
        setUserId: debugWrapper(client2.setUserId.bind(client2), "setUserId", getClientLogConfig(client2), getClientStates(client2, ["config", "config.userId"])),
        getDeviceId: debugWrapper(client2.getDeviceId.bind(client2), "getDeviceId", getClientLogConfig(client2), getClientStates(client2, ["config", "config.deviceId"])),
        setDeviceId: debugWrapper(client2.setDeviceId.bind(client2), "setDeviceId", getClientLogConfig(client2), getClientStates(client2, ["config", "config.deviceId"])),
        reset: debugWrapper(client2.reset.bind(client2), "reset", getClientLogConfig(client2), getClientStates(client2, ["config", "config.userId", "config.deviceId"])),
        getSessionId: debugWrapper(client2.getSessionId.bind(client2), "getSessionId", getClientLogConfig(client2), getClientStates(client2, ["config"])),
        setSessionId: debugWrapper(client2.setSessionId.bind(client2), "setSessionId", getClientLogConfig(client2), getClientStates(client2, ["config"])),
        extendSession: debugWrapper(client2.extendSession.bind(client2), "extendSession", getClientLogConfig(client2), getClientStates(client2, ["config"])),
        setOptOut: debugWrapper(client2.setOptOut.bind(client2), "setOptOut", getClientLogConfig(client2), getClientStates(client2, ["config"])),
        setTransport: debugWrapper(client2.setTransport.bind(client2), "setTransport", getClientLogConfig(client2), getClientStates(client2, ["config"]))
      };
    };
    browser_client_factory_default = createInstance();
  }
});

// node_modules/@amplitude/analytics-browser/lib/esm/index.js
var esm_exports2 = {};
__export(esm_exports2, {
  Identify: () => Identify,
  Revenue: () => Revenue,
  Types: () => esm_exports,
  add: () => add,
  createInstance: () => createInstance,
  extendSession: () => extendSession,
  flush: () => flush,
  getDeviceId: () => getDeviceId,
  getSessionId: () => getSessionId,
  getUserId: () => getUserId,
  groupIdentify: () => groupIdentify,
  identify: () => identify,
  init: () => init,
  logEvent: () => logEvent,
  remove: () => remove,
  reset: () => reset,
  revenue: () => revenue,
  runQueuedFunctions: () => runQueuedFunctions,
  setDeviceId: () => setDeviceId,
  setGroup: () => setGroup,
  setOptOut: () => setOptOut,
  setSessionId: () => setSessionId,
  setTransport: () => setTransport,
  setUserId: () => setUserId,
  track: () => track
});
var add, extendSession, flush, getDeviceId, getSessionId, getUserId, groupIdentify, identify, init, logEvent, remove, reset, revenue, setDeviceId, setGroup, setOptOut, setSessionId, setTransport, setUserId, track;
var init_esm7 = __esm({
  "node_modules/@amplitude/analytics-browser/lib/esm/index.js"() {
    "use strict";
    init_browser_client_factory();
    init_browser_client_factory();
    init_snippet_helper();
    init_esm();
    init_esm3();
    add = browser_client_factory_default.add;
    extendSession = browser_client_factory_default.extendSession;
    flush = browser_client_factory_default.flush;
    getDeviceId = browser_client_factory_default.getDeviceId;
    getSessionId = browser_client_factory_default.getSessionId;
    getUserId = browser_client_factory_default.getUserId;
    groupIdentify = browser_client_factory_default.groupIdentify;
    identify = browser_client_factory_default.identify;
    init = browser_client_factory_default.init;
    logEvent = browser_client_factory_default.logEvent;
    remove = browser_client_factory_default.remove;
    reset = browser_client_factory_default.reset;
    revenue = browser_client_factory_default.revenue;
    setDeviceId = browser_client_factory_default.setDeviceId;
    setGroup = browser_client_factory_default.setGroup;
    setOptOut = browser_client_factory_default.setOptOut;
    setSessionId = browser_client_factory_default.setSessionId;
    setTransport = browser_client_factory_default.setTransport;
    setUserId = browser_client_factory_default.setUserId;
    track = browser_client_factory_default.track;
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/hooks/use-analytics.js
var require_use_analytics = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/hooks/use-analytics.js"(exports2) {
    "use strict";
    var __importDefault = exports2 && exports2.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.initDelay = void 0;
    exports2.initAnalytics = initAnalytics;
    exports2.trackEvent = trackEvent;
    exports2.setinitDelay = setinitDelay;
    var courier_js_1 = __importDefault((init_dist(), __toCommonJS(dist_exports)));
    var analytics_browser_1 = (init_esm7(), __toCommonJS(esm_exports2));
    var function_helpers_1 = require_function_helpers();
    var appcues_helpers_1 = require_appcues_helpers();
    var INIT_DELAY_MS = 200;
    var DEFAULT_TRACK_PRE_INIT_DELAY_MS = 1e4;
    exports2.initDelay = DEFAULT_TRACK_PRE_INIT_DELAY_MS;
    var TRACKING_PLATFORM_NAMES = {
      COURIER: "courier",
      HOTJAR: "hotjar",
      APPCUES: "appcues",
      GTAG: "gtag",
      AMPLITUDE: "amplitude",
      CUSTOMER_IO: "customer.io"
    };
    var didInitAppcues = false;
    var didInitGoogleAnalytics = false;
    var didInitHotjar = false;
    var didInitCourier = false;
    var didInitAmplitude = false;
    var didInitCustomer = false;
    function initAnalytics(params) {
      const getConfigParams = {
        userId: params.userId,
        props: (0, appcues_helpers_1.trackingPropsToHash)(params.userTrackingProps),
        onError: (error) => params.onError(error)
      };
      const configs = getAnaliticsConfigs(getConfigParams);
      configs.forEach((config2) => {
        (0, function_helpers_1.tryWithDelay)(config2);
      });
    }
    function trackEvent({ eventName, eventParams, onError }) {
      const configs = getEventTrackingConfigs({ eventName, eventParams, onError });
      configs.forEach((config2) => {
        const delayMsForTrack = config2.shouldDelay ? exports2.initDelay : 0;
        setTimeout(() => {
          try {
            config2.functionToCall();
          } catch (error) {
            onTrackTrackError({
              error,
              onError,
              eventName,
              eventParams,
              platformName: config2.platformName
            });
          }
        }, delayMsForTrack);
      });
    }
    function getAnaliticsConfigs(analyticsFnParams) {
      const maxAttempts = 10;
      const tryWithDelayShared = {
        delay: INIT_DELAY_MS,
        attemptNumber: 1,
        maxAttempts,
        hasSucceeded: false,
        captureException: analyticsFnParams.onError
      };
      const msgPrefix = "Failed to initialize";
      const msgSuffix = `after ${maxAttempts} attempts`;
      return [
        Object.assign(Object.assign({}, tryWithDelayShared), { functionToCall: () => initAppcues(analyticsFnParams), errorMessage: `${msgPrefix} appcues ${msgSuffix}` }),
        Object.assign(Object.assign({}, tryWithDelayShared), { functionToCall: () => initGoogleAnalytics(analyticsFnParams), errorMessage: `${msgPrefix} GA ${msgSuffix}` }),
        Object.assign(Object.assign({}, tryWithDelayShared), { functionToCall: () => initHotjar(analyticsFnParams), errorMessage: `${msgPrefix} hotjar ${msgSuffix}` }),
        Object.assign(Object.assign({}, tryWithDelayShared), { functionToCall: () => initCourier(analyticsFnParams), errorMessage: `${msgPrefix} courier ${msgSuffix}` }),
        Object.assign(Object.assign({}, tryWithDelayShared), { functionToCall: () => initAmplitude(analyticsFnParams), errorMessage: `${msgPrefix} amplitude ${msgSuffix}` }),
        Object.assign(Object.assign({}, tryWithDelayShared), { functionToCall: () => initCustomerio(analyticsFnParams), errorMessage: `${msgPrefix} customer io ${msgSuffix}` })
      ];
    }
    function initAppcues({ userId, props }) {
      if (!window.Appcues)
        return false;
      if (didInitAppcues)
        return true;
      window.Appcues.identify(userId, props);
      didInitAppcues = true;
      return true;
    }
    function initGoogleAnalytics({ userId, props }) {
      if (!window.gtag)
        return false;
      if (didInitGoogleAnalytics)
        return true;
      didInitGoogleAnalytics = true;
      window.gtag("set", "user_id", userId);
      window.gtag("set", "user_properties", props);
      return didInitGoogleAnalytics;
    }
    function initHotjar({ userId, props }) {
      if (!window.hj)
        return false;
      if (didInitHotjar)
        return true;
      didInitHotjar = true;
      window.hj("identify", userId, props);
      return didInitHotjar;
    }
    function initCourier({ userId, props }) {
      if (didInitCourier)
        return true;
      didInitCourier = true;
      courier_js_1.default.init({
        clientKey: process.env.GATSBY_COURIER_CLIENT_KEY
      });
      const courierspecificProps = Object.assign({ userId }, props);
      void courier_js_1.default.identify(userId, courierspecificProps);
      return didInitCourier;
    }
    function initAmplitude({ userId, props }) {
      if (!window.amplitude)
        return false;
      if (didInitAmplitude)
        return true;
      didInitAmplitude = true;
      if (window.sessionReplay) {
        window.amplitude.add(window.sessionReplay.plugin({ sampleRate: 1 }));
      }
      window.amplitude.init(process.env.GATSBY_AMPLITUDE_API_KEY, userId, {
        fetchRemoteConfig: true,
        autocapture: true
      });
      const identifyEvent = new analytics_browser_1.Identify();
      Object.entries(props).forEach(([key, value]) => {
        if (isPrimitive(value)) {
          identifyEvent.set(key, value);
        }
      });
      window.amplitude.identify(identifyEvent, {
        user_id: userId
      });
      return didInitAmplitude;
    }
    function initCustomerio({ userId, props }) {
      if (!window.analytics)
        return false;
      if (didInitCustomer)
        return true;
      didInitCustomer = true;
      void window.analytics.identify(userId, props);
      return didInitCustomer;
    }
    function getEventTrackingConfigs({ eventName, eventParams, onError }) {
      return [
        {
          functionToCall: () => window.gtag("event", eventName, eventParams),
          platformName: TRACKING_PLATFORM_NAMES.GTAG,
          shouldDelay: !didInitGoogleAnalytics
        },
        {
          functionToCall: () => window.Appcues.track(eventName, eventParams),
          platformName: TRACKING_PLATFORM_NAMES.APPCUES,
          shouldDelay: !didInitAppcues
        },
        {
          functionToCall: () => trackCourier({ eventName, eventParams, onError }),
          platformName: TRACKING_PLATFORM_NAMES.COURIER,
          shouldDelay: !didInitCourier
        },
        {
          functionToCall: () => {
            var _a;
            return (_a = window.hj) === null || _a === void 0 ? void 0 : _a.call(window, "event", eventName);
          },
          platformName: TRACKING_PLATFORM_NAMES.HOTJAR,
          shouldDelay: !didInitHotjar
        },
        {
          functionToCall: () => {
            var _a;
            return (_a = window.amplitude) === null || _a === void 0 ? void 0 : _a.track(eventName, eventParams);
          },
          platformName: TRACKING_PLATFORM_NAMES.AMPLITUDE,
          shouldDelay: !didInitAmplitude
        },
        {
          functionToCall: () => {
            var _a;
            void ((_a = window.analytics) === null || _a === void 0 ? void 0 : _a.track(eventName, eventParams));
          },
          platformName: TRACKING_PLATFORM_NAMES.CUSTOMER_IO,
          shouldDelay: !didInitCustomer
        }
      ];
    }
    function trackCourier({ eventName, eventParams, onError }) {
      void courier_js_1.default.track(eventName, eventParams).catch((error) => {
        onTrackTrackError({
          error,
          onError,
          eventName,
          eventParams,
          platformName: TRACKING_PLATFORM_NAMES.COURIER
        });
      });
    }
    function onTrackTrackError({ error, onError, eventName, eventParams, platformName }) {
      const hint = {
        data: {
          eventName,
          eventParams,
          platform: platformName
        }
      };
      onError(error, hint);
    }
    function setinitDelay(delay2) {
      exports2.initDelay = delay2;
    }
    function isPrimitive(value) {
      return typeof value !== "object" && typeof value !== "function";
    }
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/hooks/hooks.js
var require_hooks = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/hooks/hooks.js"(exports2) {
    "use strict";
    var __createBinding = exports2 && exports2.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    });
    var __exportStar = exports2 && exports2.__exportStar || function(m, exports3) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p)) __createBinding(exports3, m, p);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    __exportStar(require_use_analytics(), exports2);
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/types/types.js
var require_types2 = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/types/types.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
  }
});

// node_modules/@mallardbay/lib-shared-helpers/dist/src/index.js
var require_src = __commonJS({
  "node_modules/@mallardbay/lib-shared-helpers/dist/src/index.js"(exports2) {
    "use strict";
    var __createBinding = exports2 && exports2.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    });
    var __exportStar = exports2 && exports2.__exportStar || function(m, exports3) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p)) __createBinding(exports3, m, p);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    __exportStar(require_constants(), exports2);
    __exportStar(require_helpers(), exports2);
    __exportStar(require_hooks(), exports2);
    __exportStar(require_types2(), exports2);
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Accordion: () => Accordion,
  ActionBanner: () => ActionBanner,
  ActionBannerWithButton: () => ActionBannerWithButton,
  ActionCard: () => ActionCard,
  ActionCardType: () => ActionCardType,
  ActionPill: () => ActionPill,
  ActionRequired: () => ActionRequired,
  AddButton: () => AddButton,
  AddOnsSelector: () => AddOnsSelector,
  AspectMedia: () => AspectMedia,
  AspectMediaCore: () => AspectMediaCore,
  BUTTON_VARIANTS: () => BUTTON_VARIANTS,
  Badge: () => Badge,
  BadgeSuccess: () => BadgeSuccess,
  BadgeVariant: () => BadgeVariant,
  BottomDrawer: () => BottomDrawer,
  Box: () => Box,
  Button: () => Button,
  ButtonPrimary: () => ButtonPrimary,
  ButtonSmall: () => ButtonSmall,
  ButtonVariant: () => ButtonVariant,
  CARD_BRANDS: () => CARD_BRANDS,
  COLOR_MODE_SCRIPT_KEY: () => COLOR_MODE_SCRIPT_KEY,
  CalendarDatePicker: () => CalendarDatePicker,
  Card: () => Card,
  CardList: () => CardList2,
  CardSelect: () => CardSelect,
  CheckoutDatesPreview: () => CheckoutDatesPreview,
  ColorMode: () => ColorMode,
  ColorModeScript: () => ColorModeScript,
  ColorSchemes: () => ColorSchemes,
  ConditionalRenderContainer: () => ConditionalRenderContainer,
  ContrastButton: () => ContrastButton,
  ContrastPillButton: () => ContrastPillButton,
  CopyTextButton: () => CopyTextButton,
  DATE_FORMATS: () => DATE_FORMATS,
  DebouncedInput: () => DebouncedInput,
  Drawer: () => Drawer,
  DrawerPlacement: () => DrawerPlacement,
  DrawerSize: () => DrawerSize,
  DynamicTable: () => DynamicTable,
  DynamicTableView: () => DynamicTableView,
  EllipsisMenu: () => EllipsisMenu,
  ErrorIcon: () => ErrorIcon,
  ExpandableMarkup: () => ExpandableMarkup,
  ExternalLink: () => ExternalLink,
  ExternalLinkButton: () => ExternalLinkButton,
  Heading: () => Heading3,
  HeadingLarge: () => HeadingLarge,
  HeadingMedium: () => HeadingMedium,
  HeadingSmall: () => HeadingSmall,
  HeadingXLarge: () => HeadingXLarge,
  HeadingXSmall: () => HeadingXSmall,
  Highlight: () => Highlight,
  HorizontalStack: () => HorizontalStack,
  HorizontalStackSmallGap: () => HorizontalStackSmallGap,
  HorizontalStackSpaceBetween: () => HorizontalStackSpaceBetween,
  IMAGE_RATIOS: () => IMAGE_RATIOS,
  IconButton: () => IconButton3,
  IconSize: () => IconSize,
  Image: () => Image,
  ImageCard: () => ImageCard,
  ImageCarousel: () => ImageCarousel,
  IncludedAddOns: () => IncludedAddOns,
  Itinerary: () => Itinerary,
  LOGO_ALT_TEXT: () => LOGO_ALT_TEXT,
  LightIconButton: () => LightIconButton,
  LightTrashIconButton: () => LightTrashIconButton,
  Link: () => Link2,
  LinkButton: () => LinkButton,
  ListCard: () => ListCard,
  ListFooter: () => ListFooter,
  LoadingOrErrorContainer: () => LoadingOrErrorContainer,
  MAX_WIDTH: () => MAX_WIDTH,
  MallardBayLogo: () => MallardBayLogo,
  MediaDisplayType: () => MediaDisplayType,
  MediumIconButton: () => MediumIconButton,
  Menu: () => Menu,
  MenuItem: () => MenuItem,
  Modal: () => Modal,
  MultiMediaDisplay: () => MultiMediaDisplay,
  MultiMediaDisplayComponent: () => MultiMediaDisplayComponent,
  NumberInput: () => NumberInput,
  NumberOfGuestsInput: () => NumberOfGuestsInput,
  Orientation: () => Orientation,
  OutlinedButton: () => OutlinedButton,
  PAYMENT_METHOD_TYPE: () => PAYMENT_METHOD_TYPE,
  PLACEHOLDER_IMG_SRC: () => PLACEHOLDER_IMG_SRC,
  Pagination: () => Pagination,
  PaymentMethodCard: () => PaymentMethodCard,
  PaymentMethodCardContent: () => PaymentMethodCardContent,
  PaymentMethodSelector: () => PaymentMethodSelector,
  PillButton: () => PillButton,
  PricingPackageSelector: () => PricingPackageSelector,
  ProgressCard: () => ProgressCard,
  Provider: () => Provider,
  ProviderErrors: () => ProviderErrors,
  ROWS_PER_PAGE_OPTIONS: () => ROWS_PER_PAGE_OPTIONS,
  RadioSelect: () => RadioSelect,
  RatingInput: () => RatingInput,
  ResponsiveIconButton: () => ResponsiveIconButton,
  ResponsiveSlider: () => ResponsiveSlider,
  RowButton: () => RowButton,
  RowsPerPage: () => RowsPerPage,
  SIZES: () => SIZES,
  Search: () => Search,
  SelectInput: () => SelectInput,
  SelectableCard: () => SelectableCard,
  Skeleton: () => Skeleton,
  SkeletonCircle: () => SkeletonCircle,
  SkeletonContainer: () => SkeletonContainer,
  SkeletonFill: () => SkeletonFill,
  SkeletonFillHorizontal: () => SkeletonFillHorizontal,
  SmallIconButton: () => SmallIconButton,
  SortSelect: () => SortSelect,
  Span: () => Span,
  Spinner: () => Spinner,
  SubmitButton: () => SubmitButton,
  TEST_IDS: () => TEST_IDS,
  Table: () => Table,
  TableType: () => TableType,
  TableView: () => TableView,
  TabsList: () => TabsList,
  Tag: () => Tag2,
  TagList: () => TagList,
  TagVariant: () => TagVariant,
  Text: () => Text,
  TextActive: () => TextActive,
  TextBold: () => TextBold,
  TextBoldExtraSmall: () => TextBoldExtraSmall,
  TextBoldLarge: () => TextBoldLarge,
  TextBoldSmall: () => TextBoldSmall,
  TextError: () => TextError,
  TextErrorSmall: () => TextErrorSmall,
  TextExtraSmall: () => TextExtraSmall,
  TextLarge: () => TextLarge,
  TextLargeBold: () => TextLargeBold,
  TextMedium: () => TextMedium,
  TextMediumBold: () => TextMediumBold,
  TextNote: () => TextNote,
  TextNoteSmall: () => TextNoteSmall,
  TextSecondary: () => TextSecondary,
  TextSecondaryExtraSmall: () => TextSecondaryExtraSmall,
  TextSecondaryLarge: () => TextSecondaryLarge,
  TextSecondarySmall: () => TextSecondarySmall,
  TextSmall: () => TextSmall,
  TextSmallNote: () => TextSmallNote,
  TextSmallSecondary: () => TextSmallSecondary,
  TextSmallUnderlined: () => TextSmallUnderlined,
  TextUnderlined: () => TextUnderlined,
  TextUnderlinedSmall: () => TextUnderlinedSmall,
  TextXLargeBold: () => TextXLargeBold,
  Textarea: () => Textarea,
  TextareaWithBackground: () => TextareaWithBackground,
  Timeline: () => Timeline2,
  ToastWithActionContent: () => ToastWithActionContent,
  Tooltip: () => Tooltip,
  TripCalendarDatePicker: () => TripCalendarDatePicker,
  TripSummaryNoBreakdown: () => TripSummaryNoBreakdown,
  UPLOAD_CARE_BASE_DOMAIN: () => UPLOAD_CARE_BASE_DOMAIN,
  UploadCareImageVariant: () => UploadCareImageVariant,
  VISIBILITY_STATES: () => VISIBILITY_STATES,
  VerticalStack: () => VerticalStack,
  VerticalStackStretch: () => VerticalStackStretch,
  WizardContainer: () => WizardContainer,
  WizardNavigation: () => WizardNavigation,
  WizardOverview: () => WizardOverview,
  WizardProvider: () => WizardProvider,
  WizardStep: () => WizardStep,
  componentStyles: () => componentStyles,
  darkTheme: () => darkTheme,
  getErrorToastContentProps: () => getErrorToastContentProps,
  getSuccessToastContentProps: () => getSuccessToastContentProps,
  theme: () => theme,
  useActionBannerColors: () => useActionBannerColors,
  useColors: () => useColors,
  useCoreThemeForProvider: () => useCoreThemeForProvider,
  useIsDarkMode: () => useIsDarkMode,
  useOrientation: () => useOrientation,
  useSetColorMode: () => useSetColorMode,
  useStepsWithCompletionStatus: () => useStepsWithCompletionStatus,
  useTheme: () => useTheme2,
  useToast: () => useToast,
  useToastWithAction: () => useToastWithAction,
  useToastWithActionWithDeferredProps: () => useToastWithActionWithDeferredProps,
  useWizardContext: () => useWizardContext
});
module.exports = __toCommonJS(src_exports);

// src/components/button/button.tsx
var import_react3 = __toESM(require("react"));
var import_react4 = require("@chakra-ui/react");
var import_react_fontawesome = require("@fortawesome/react-fontawesome");
var import_faExternalLink = require("@fortawesome/free-solid-svg-icons/faExternalLink");
var import_faChevronRight = require("@fortawesome/free-solid-svg-icons/faChevronRight");
var import_faPlus = require("@fortawesome/free-solid-svg-icons/faPlus");

// src/utils/use-theme.tsx
var import_react2 = require("@chakra-ui/react");

// src/utils/use-is-dark-mode.tsx
var import_use_prefers_color_scheme = __toESM(require("use-prefers-color-scheme"));

// src/config/constants.ts
var TEST_IDS = {
  ELLIPSIS_MENU: "ELLIPSIS_MENU",
  ACTION_CARD: "ACTION_CARD",
  LOADING_SKELETON: "LOADING_SKELETON",
  IMAGE: "IMAGE",
  IMAGE_SKELETON: "IMAGE_SKELETON",
  HORIZONTAL_IMAGE_CARD: "HORIZONTAL_IMAGE_CARD",
  VERTICAL_IMAGE_CARD: "VERTICAL_IMAGE_CARD",
  NUMBER_OF_GUESTS_INPUT: "NUMBER_OF_GUESTS_INPUT",
  PRICING_PACKAGE_SELECTOR_OPTION: "PRICING_PACKAGE_SELECTOR_OPTION",
  TRIP_PAYMENT_PLAN: "TRIP_PAYMENT_PLAN",
  TRIP_SUMMARY_CONTAINER: "TRIP_SUMMARY_CONTAINER",
  TRIP_TOTAL: "TRIP_TOTAL",
  ITINERARY_INFO_CARD: "ITINERARY_INFO_CARD",
  ITINERARY: "ITINERARY",
  NUMBER_OF_GUESTS_HELP_LABEL: "NUMBER_OF_GUESTS_HELP_LABEL",
  SEARCH_INPUT: "SEARCH_INPUT",
  SEARCH_PILL: "SEARCH_PILL",
  SELECT_INPUT: "SELECT_INPUT",
  PREVIOUS_PAGE: "PREVIOUS_PAGE",
  NEXT_PAGE: "NEXT_PAGE",
  FIRST_PAGE: "FIRST_PAGE",
  LAST_PAGE: "LAST_PAGE",
  PAGE_NUMBER_BUTTON: "PAGE_NUMBER_BUTTON",
  ELLIPSIS_BUTTON: "ELLIPSIS_BUTTON",
  TABLE_PAGINATION: "TABLE_PAGINATION",
  SPINNER: "SPINNER",
  BANNER_ICON: "BANNER_ICON",
  MENU_SEARCH_INPUT: "MENU_SEARCH_INPUT",
  MENU_LOCKED_ITEM_ICON: "MENU_LOCKED_ITEM_ICON",
  WIZARD_OVERVIEW_TITLE: "WIZARD_OVERVIEW_TITLE",
  WIZARD_NAVIGATION: "WIZARD_NAVIGATION",
  LOGO: "LOGO",
  PROGRESS_CARD: "PROGRESS_CARD",
  WIZARD_HEADER: "WIZARD_HEADER",
  WIZARD_STEP_IMAGE: "WIZARD_STEP_IMAGE",
  BANNER_CLOSE_ICON: "BANNER_CLOSE_ICON",
  MEDIA_CAROUSEL: "MEDIA_CAROUSEL",
  MEDIA_GRID: "MEDIA_GRID",
  CAROUSEL_PREV_BUTTON: "CAROUSEL_PREV_BUTTON",
  CAROUSEL_NEXT_BUTTON: "CAROUSEL_NEXT_BUTTON",
  IMAGE_CAROUSEL: "IMAGE_CAROUSEL",
  ASPECT_VIDEO: "ASPECT_VIDEO",
  ASPECT_IMAGE: "ASPECT_IMAGE",
  RESPONSIVE_SLIDER: "RESPONSIVE_SLIDER",
  RESPONSIVE_SLIDER_SCROLL: "RESPONSIVE_SLIDER_SCROLL",
  TOAST_WITH_ACTION_CONTENT: "TOAST_WITH_ACTION_CONTENT",
  TOAST_CONTAINER: "toast-container",
  CLOSE_MODAL_BUTTON: "CLOSE_MODAL_BUTTON"
};
var BUTTON_VARIANTS = {
  GHOST: "ghost"
};
var ColorMode = /* @__PURE__ */ ((ColorMode2) => {
  ColorMode2["Light"] = "light";
  ColorMode2["Dark"] = "dark";
  return ColorMode2;
})(ColorMode || {});
var IconSize = /* @__PURE__ */ ((IconSize2) => {
  IconSize2[IconSize2["Medium"] = 18] = "Medium";
  return IconSize2;
})(IconSize || {});
var ColorSchemes = /* @__PURE__ */ ((ColorSchemes2) => {
  ColorSchemes2["Brand"] = "brand";
  ColorSchemes2["Gray"] = "gray";
  ColorSchemes2["Red"] = "red";
  ColorSchemes2["Green"] = "green";
  ColorSchemes2["Blue"] = "blue";
  ColorSchemes2["Teal"] = "teal";
  ColorSchemes2["Pink"] = "pink";
  ColorSchemes2["Purple"] = "purple";
  ColorSchemes2["Cyan"] = "cyan";
  ColorSchemes2["Orange"] = "orange";
  ColorSchemes2["Yellow"] = "yellow";
  return ColorSchemes2;
})(ColorSchemes || {});
var PLACEHOLDER_IMG_SRC = "https://www.logistec.com/wp-content/uploads/2017/12/placeholder.png";
var UPLOAD_CARE_BASE_DOMAIN = "ucarecdn.com";
var DATE_FORMATS = {
  SLASH: "MM/dd/yyyy"
};
var SIZES = {
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl"
};
var MAX_WIDTH = "1400px";
var IMAGE_RATIOS = {
  FOUR_BY_THREE: 4 / 3,
  THREE_BY_FOUR: 3 / 4,
  SIXTEEN_BY_NINE: 16 / 9
};
var VISIBILITY_STATES = {
  VISIBLE: "visible",
  HIDDEN: "hidden"
};
var ProviderErrors = /* @__PURE__ */ ((ProviderErrors2) => {
  ProviderErrors2["MultiMediaDisplay"] = "useMultiMediaDisplay must be used within a MultiMediaDisplayProvider";
  return ProviderErrors2;
})(ProviderErrors || {});
var UploadCareImageVariant = /* @__PURE__ */ ((UploadCareImageVariant2) => {
  UploadCareImageVariant2["SM_HORIZONTAL"] = "SM_HORIZONTAL";
  UploadCareImageVariant2["MD_HORIZONTAL"] = "MD_HORIZONTAL";
  UploadCareImageVariant2["LG_HORIZONTAL"] = "LG_HORIZONTAL";
  UploadCareImageVariant2["XL_HORIZONTAL"] = "XL_HORIZONTAL";
  return UploadCareImageVariant2;
})(UploadCareImageVariant || {});

// src/utils/use-is-dark-mode.tsx
function useIsDarkMode() {
  return (0, import_use_prefers_color_scheme.default)() === "dark" /* Dark */;
}

// src/utils/use-colors.tsx
var import_react = require("@chakra-ui/react");
var useColors = () => {
  const { colors } = (0, import_react.useTheme)();
  const focusBorder = colors.brand[400];
  const hover = (0, import_react.useColorModeValue)(colors.gray[200], colors.gray[800]);
  const success = colors.green[400];
  const warning = colors.yellow[400];
  const error = colors.red[500];
  const disabled = (0, import_react.useColorModeValue)(colors.gray[400], colors.gray[600]);
  const danger = colors.red[400];
  const text = (0, import_react.useColorModeValue)(colors.black, colors.white);
  const textInverse = (0, import_react.useColorModeValue)(colors.white, colors.black);
  const secondaryText = (0, import_react.useColorModeValue)("#5E5E5E", "#ABABAB");
  const optionText = (0, import_react.useColorModeValue)(colors.gray[600], colors.gray[400]);
  const bg = (0, import_react.useColorModeValue)(colors.white, "#141414");
  const bgSecondary = (0, import_react.useColorModeValue)("#F3F3F3", "#292929");
  const bgTertiary = (0, import_react.useColorModeValue)("#EEEEEE", "#333333");
  const bgDisabled = (0, import_react.useColorModeValue)("#F6F6F6", "#1F1F1F");
  const cardBackground = (0, import_react.useColorModeValue)("#F6F6F6", "#1F1F1F");
  const buttonDisabledText = (0, import_react.useColorModeValue)("#AFAFAF", "#6B6B6B");
  const modalBackground = "var(--modal-bg)";
  const border = "var(--chakra-colors-chakra-border-color)";
  const borderCard = "var(--card-border-color)";
  const borderDark = (0, import_react.useColorModeValue)(colors.gray[300], colors.gray[500]);
  const ellipsisButtonBackground = (0, import_react.useColorModeValue)(
    colors.gray[100],
    colors.gray[700]
  );
  const ellipsisButtonHover = (0, import_react.useColorModeValue)(
    colors.gray[300],
    colors.gray[900]
  );
  const errorBackground = (0, import_react.useColorModeValue)(colors.red[100], colors.red[600]);
  const errorPrimaryText = (0, import_react.useColorModeValue)(colors.red[500], colors.gray[50]);
  const errorSecondaryText = (0, import_react.useColorModeValue)(
    colors.red[800],
    colors.gray[200]
  );
  const brandDefault = (0, import_react.useColorModeValue)(colors.brand[400], colors.brand[200]);
  const brandFocusBorder = colors.brand[500];
  const rowHighlight = (0, import_react.useColorModeValue)(colors.brand[100], colors.brand[400]);
  return {
    rowHighlight,
    bg,
    bgSecondary,
    bgTertiary,
    bgDisabled,
    border,
    borderCard,
    borderDark,
    brandDefault,
    focusBorder,
    errorBackground,
    errorPrimaryText,
    errorSecondaryText,
    hover,
    success,
    warning,
    error,
    disabled,
    danger,
    text,
    textInverse,
    secondaryText,
    optionText,
    cardBackground,
    buttonDisabledText,
    brandFocusBorder,
    ellipsisButtonBackground,
    ellipsisButtonHover,
    modalBackground,
    ...colors
  };
};

// src/utils/use-theme.tsx
function useTheme2() {
  const theme2 = (0, import_react2.useTheme)();
  const isDarkMode = useIsDarkMode();
  const colors = useColors();
  return {
    isDarkMode,
    ...theme2,
    colors: {
      ...colors,
      ...theme2.colors
    }
  };
}

// src/utils/component-styles.ts
function componentStyles(styles) {
  return styles;
}

// src/components/button/button.tsx
var ButtonVariant = /* @__PURE__ */ ((ButtonVariant2) => {
  ButtonVariant2["Ghost"] = "ghost";
  ButtonVariant2["Outline"] = "outline";
  ButtonVariant2["Solid"] = "solid";
  ButtonVariant2["Link"] = "link";
  ButtonVariant2["Unstyled"] = "unstyled";
  return ButtonVariant2;
})(ButtonVariant || {});
function Button({
  style,
  gradientEnabled,
  testId,
  ...props
}) {
  let colorScheme = props.colorScheme;
  let variant = props.variant;
  if (props.variant === "primary") {
    colorScheme = "brand";
    variant = "solid";
  }
  const gradientButtonStyle = useGradientButtonStyle();
  const buttonStyle = gradientEnabled ? { ...gradientButtonStyle, ...style } : style;
  return /* @__PURE__ */ import_react3.default.createElement(
    import_react4.Button,
    {
      ...props,
      "data-testid": testId,
      sx: buttonStyle,
      colorScheme,
      variant
    }
  );
}
function ButtonPrimary({ style, ...props }) {
  return /* @__PURE__ */ import_react3.default.createElement(Button, { ...props, style, colorScheme: "brand" });
}
function PillButton({ style, ...props }) {
  return /* @__PURE__ */ import_react3.default.createElement(Button, { ...props, style, rounded: "full" });
}
function OutlinedButton(props) {
  return /* @__PURE__ */ import_react3.default.createElement(Button, { ...props, variant: "outline" });
}
function ContrastPillButton({
  isInverted,
  ...props
}) {
  const styles = useContrastStyles(isInverted);
  return /* @__PURE__ */ import_react3.default.createElement(PillButton, { ...props, style: { ...styles.button, ...props.style } });
}
function ContrastButton({
  isInverted,
  ...props
}) {
  const styles = useContrastStyles(isInverted);
  return /* @__PURE__ */ import_react3.default.createElement(Button, { ...props, style: { ...styles.button, ...props.style } });
}
function SubmitButton({ style, ...props }) {
  return /* @__PURE__ */ import_react3.default.createElement(Button, { ...props, style, type: "submit" });
}
function AddButton({ style, ...props }) {
  return /* @__PURE__ */ import_react3.default.createElement(
    Button,
    {
      ...props,
      style,
      leftIcon: /* @__PURE__ */ import_react3.default.createElement(import_react_fontawesome.FontAwesomeIcon, { icon: import_faPlus.faPlus })
    }
  );
}
function ExternalLinkButton({
  style,
  shouldShowIcon,
  href,
  ...props
}) {
  const linkPropsOrNothing = getLinkPropsOrNone(href);
  const rightIcon = shouldShowIcon ? /* @__PURE__ */ import_react3.default.createElement(import_react_fontawesome.FontAwesomeIcon, { icon: import_faExternalLink.faExternalLink }) : void 0;
  return /* @__PURE__ */ import_react3.default.createElement(
    import_react4.Button,
    {
      ...props,
      ...linkPropsOrNothing,
      sx: style,
      rightIcon
    }
  );
}
function LinkButton({ style, href, ...props }) {
  const linkPropsOrNothing = getLinkPropsOrNone(href);
  return /* @__PURE__ */ import_react3.default.createElement(
    import_react4.Button,
    {
      ...linkPropsOrNothing,
      variant: "link",
      sx: style,
      ...props
    }
  );
}
function RowButton({ style, testId, ...props }) {
  const defaultStyle = useRowButtonStyle();
  return /* @__PURE__ */ import_react3.default.createElement(
    import_react4.Button,
    {
      "data-testid": testId,
      sx: { ...defaultStyle, ...style },
      ...props,
      variant: "ghost",
      rightIcon: /* @__PURE__ */ import_react3.default.createElement(import_react_fontawesome.FontAwesomeIcon, { icon: import_faChevronRight.faChevronRight })
    }
  );
}
function ButtonSmall({ style, ...props }) {
  return /* @__PURE__ */ import_react3.default.createElement(Button, { ...props, style, size: "sm" });
}
function useRowButtonStyle() {
  return {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    "& > span:last-child": {
      marginLeft: "auto"
    }
  };
}
function useGradientButtonStyle() {
  const backgroundImage = "linear-gradient(90deg, rgba(246,94,56,1) 0%, rgba(246,138,57,1) 50%, rgba(246,94,56,1) 100%)";
  const colors = useColors();
  return {
    color: colors.white,
    fontWeight: 700,
    letterSpacing: "0.5px",
    textShadow: "0 3px 4px rgba(0, 0, 0, 0.4)",
    backgroundSize: "200% auto",
    // Percentage fixes the gradient not filling the entire width on chrome.
    backgroundPosition: "105% center",
    boxShadow: "0 2px 8px 0 rgba(246,116,57,.4)",
    backgroundImage,
    transition: "background-position 0.5s ease",
    _hover: {
      backgroundPosition: "left center"
    },
    _disabled: {
      opacity: 0.8,
      backgroundPosition: "right center",
      color: colors.text,
      backgroundImage: "none",
      boxShadow: "none",
      textShadow: "none",
      letterSpacing: "normal",
      cursor: "not-allowed"
    }
  };
}
function useContrastStyles(isInverted) {
  const theme2 = useTheme2();
  const shouldInvert = isInverted ?? theme2.isDarkMode;
  const borderColor = shouldInvert ? theme2.colors.black : theme2.colors.white;
  return componentStyles({
    button: {
      backgroundColor: theme2.colors.bg,
      border: `1px solid ${borderColor}`,
      color: theme2.colors.text,
      // Our map is always light, so invert it to always keep dark buttons
      filter: shouldInvert ? "invert(1)" : void 0,
      ":hover": {
        backgroundColor: theme2.colors.bg
      }
    }
  });
}
function getLinkPropsOrNone(href) {
  const AnchorTag = "a";
  return href ? { href, as: AnchorTag, target: "_blank" } : {};
}

// src/components/provider.tsx
var import_react5 = __toESM(require("react"));
var import_react6 = require("@chakra-ui/react");
var ALWAYS_ON_TOP_Z_INDEX = 1900;
function Provider(props) {
  const { children, ...otherProps } = props;
  const ref = (0, import_react5.useRef)(null);
  return /* @__PURE__ */ import_react5.default.createElement(
    import_react6.ChakraProvider,
    {
      ...otherProps,
      portalZIndex: ALWAYS_ON_TOP_Z_INDEX,
      toastOptions: {
        portalProps: {
          containerRef: ref
        }
      }
    },
    children,
    /* @__PURE__ */ import_react5.default.createElement("div", { ref, "data-testid": TEST_IDS.TOAST_CONTAINER })
  );
}

// src/components/menu/ellipsis-menu.tsx
var import_react15 = __toESM(require("react"));
var import_faEllipsisVertical = require("@fortawesome/free-solid-svg-icons/faEllipsisVertical");

// src/components/menu/menu.tsx
var import_react13 = __toESM(require("react"));
var import_react14 = require("@chakra-ui/react");
var import_react_fontawesome4 = require("@fortawesome/react-fontawesome");

// src/components/menu/menu-item.tsx
var import_react7 = __toESM(require("react"));
var import_react8 = require("@chakra-ui/react");
var import_react_fontawesome2 = require("@fortawesome/react-fontawesome");
var import_faLock = require("@fortawesome/free-solid-svg-icons/faLock");
var ICON_SIZE = 16;
function MenuItem({
  item: {
    label,
    isDanger,
    icon,
    isLocked,
    isDisabled,
    href,
    onClick,
    hasDivider
  }
}) {
  const styles = useStyles({ isDanger });
  const iconComponent = (0, import_react7.useMemo)(
    () => getIcon({ icon, isLocked }),
    [icon, isLocked]
  );
  const onClickProps = getOnClickProps({ href, onClick });
  return /* @__PURE__ */ import_react7.default.createElement(import_react7.default.Fragment, null, /* @__PURE__ */ import_react7.default.createElement(
    import_react8.MenuItem,
    {
      sx: styles.menuItem,
      icon: iconComponent,
      isDisabled,
      ...onClickProps
    },
    label
  ), hasDivider && /* @__PURE__ */ import_react7.default.createElement(import_react8.Divider, { sx: styles.divider }));
}
function getOnClickProps({ href, onClick }) {
  if (href) {
    return { as: import_react8.Link, href, target: "_blank" };
  }
  if (onClick) {
    return { onClick };
  }
  return {};
}
function getIcon({
  icon,
  isLocked
}) {
  if (isLocked) {
    return /* @__PURE__ */ import_react7.default.createElement(
      import_react_fontawesome2.FontAwesomeIcon,
      {
        icon: import_faLock.faLock,
        "data-testid": TEST_IDS.MENU_LOCKED_ITEM_ICON,
        fontSize: ICON_SIZE
      }
    );
  }
  if (!isIconDefinition(icon)) {
    return icon;
  }
  return /* @__PURE__ */ import_react7.default.createElement(import_react_fontawesome2.FontAwesomeIcon, { icon, fontSize: ICON_SIZE });
}
function isIconDefinition(icon) {
  return typeof icon === "object" && "icon" in icon;
}
function useStyles({ isDanger } = {}) {
  const colors = useColors();
  return componentStyles({
    menuItem: {
      color: isDanger ? colors.danger : void 0
    },
    divider: {
      marginY: 2
    }
  });
}

// src/components/menu/menu-search-input.tsx
var import_react11 = require("@chakra-ui/react");
var import_faSearch = require("@fortawesome/free-solid-svg-icons/faSearch");
var import_react_fontawesome3 = require("@fortawesome/react-fontawesome");
var import_react12 = __toESM(require("react"));

// src/components/horizontal-stack/horizontal-stack.tsx
var import_react9 = __toESM(require("react"));
var import_react10 = require("@chakra-ui/react");
function HorizontalStack({
  style,
  children,
  testId
}) {
  const styles = useStyles2();
  return /* @__PURE__ */ import_react9.default.createElement(import_react10.HStack, { sx: { ...styles.root, ...style }, "data-testid": testId }, children);
}
function HorizontalStackSpaceBetween({
  style,
  children,
  testId
}) {
  const styles = useStyles2();
  return /* @__PURE__ */ import_react9.default.createElement(
    HorizontalStack,
    {
      style: { ...styles.spaceBetween, ...style },
      testId
    },
    children
  );
}
function HorizontalStackSmallGap({
  style,
  children,
  testId
}) {
  const styles = useStyles2();
  return /* @__PURE__ */ import_react9.default.createElement(HorizontalStack, { style: { ...styles.small, ...style }, testId }, children);
}
function useStyles2() {
  return componentStyles({
    root: {
      gap: 3,
      alignItems: "center"
    },
    small: {
      gap: 2
    },
    spaceBetween: {
      justifyContent: "space-between"
    }
  });
}

// src/components/menu/menu-search-input.tsx
function MenuSearchInput({
  searchText,
  onSearchTextChange,
  isSearching,
  placeholder
}) {
  const styles = useStyles3();
  return /* @__PURE__ */ import_react12.default.createElement(import_react12.default.Fragment, null, /* @__PURE__ */ import_react12.default.createElement(HorizontalStackSmallGap, { style: styles.container }, /* @__PURE__ */ import_react12.default.createElement(import_react_fontawesome3.FontAwesomeIcon, { icon: import_faSearch.faSearch, style: styles.icon }), /* @__PURE__ */ import_react12.default.createElement(
    import_react11.Input,
    {
      value: searchText,
      onChange: (event) => onSearchTextChange(event.target.value),
      placeholder,
      variant: "unstyled",
      "data-testid": TEST_IDS.MENU_SEARCH_INPUT
    }
  )), /* @__PURE__ */ import_react12.default.createElement(
    import_react11.Progress,
    {
      isIndeterminate: isSearching,
      colorScheme: "brand" /* Brand */,
      sx: styles.progress
    }
  ));
}
function useStyles3() {
  return componentStyles({
    container: {
      marginX: 3
    },
    progress: { marginY: 2, height: "1px" },
    icon: {
      fontSize: "20px"
    }
  });
}

// src/components/menu/menu.tsx
var ICON_SIZE2 = 16;
function Menu({
  menuItems,
  isLoading,
  menuSearchProps,
  isDisabled,
  menuButtonIcon,
  menuIconColor,
  menuButtonStyles,
  leftIcon,
  rightIcon,
  style,
  testId,
  menuTestId,
  children
}) {
  const styleProps = useStyleProps();
  if (!menuItems.length) return null;
  const menuButtonProps = getMenuButtonProps({
    menuButtonIcon,
    leftIcon,
    rightIcon,
    menuIconColor,
    menuButtonStyles
  });
  return /* @__PURE__ */ import_react13.default.createElement(import_react14.Menu, { ...styleProps.menu }, /* @__PURE__ */ import_react13.default.createElement(
    import_react14.MenuButton,
    {
      "data-testid": testId,
      onClick: (event) => event.stopPropagation(),
      isLoading,
      isDisabled: isDisabled || isLoading,
      sx: style,
      ...menuButtonProps
    },
    children
  ), /* @__PURE__ */ import_react13.default.createElement(import_react14.Portal, null, /* @__PURE__ */ import_react13.default.createElement(
    import_react14.MenuList,
    {
      "data-testid": menuTestId,
      ...styleProps.menuList,
      onClick: (event) => event.stopPropagation()
    },
    menuSearchProps && /* @__PURE__ */ import_react13.default.createElement(MenuSearchInput, { ...menuSearchProps }),
    menuItems.map((item) => /* @__PURE__ */ import_react13.default.createElement(MenuItem, { key: item.label, item }))
  )));
}
function getMenuButtonProps({
  menuButtonIcon,
  leftIcon,
  rightIcon,
  menuIconColor,
  menuButtonStyles
}) {
  if (menuButtonIcon) {
    return {
      as: import_react14.IconButton,
      icon: /* @__PURE__ */ import_react13.default.createElement(
        import_react_fontawesome4.FontAwesomeIcon,
        {
          color: menuIconColor,
          icon: menuButtonIcon,
          fontSize: 16
        }
      ),
      size: "xs",
      sx: menuButtonStyles,
      variant: BUTTON_VARIANTS.GHOST
    };
  }
  return {
    as: import_react14.Button,
    leftIcon: leftIcon ? /* @__PURE__ */ import_react13.default.createElement(import_react_fontawesome4.FontAwesomeIcon, { icon: leftIcon, fontSize: ICON_SIZE2 }) : void 0,
    rightIcon: rightIcon ? /* @__PURE__ */ import_react13.default.createElement(import_react_fontawesome4.FontAwesomeIcon, { icon: rightIcon, fontSize: ICON_SIZE2 }) : void 0
  };
}
function useStyleProps() {
  const menu = {
    gutter: 4
  };
  const menuList = {
    rounded: "lg",
    shadow: "lg"
  };
  return { menu, menuList };
}

// src/components/menu/ellipsis-menu.tsx
function EllipsisMenu({
  menuItems,
  isLoading,
  menuIconColor,
  menuButtonStyles,
  testId,
  menuTestId
}) {
  if (!menuItems.length) return null;
  return /* @__PURE__ */ import_react15.default.createElement(
    Menu,
    {
      menuButtonIcon: import_faEllipsisVertical.faEllipsisVertical,
      menuIconColor,
      menuButtonStyles,
      menuItems,
      isLoading,
      testId: testId || TEST_IDS.ELLIPSIS_MENU,
      menuTestId
    }
  );
}

// src/components/payment-method-card/payment-method-card.tsx
var import_react32 = __toESM(require("react"));

// src/components/payment-method-card/payment-method-card-content.tsx
var import_react26 = __toESM(require("react"));

// src/config/copy-constants.ts
var COPY_CONSTANTS = {
  DEFAULT: "Default",
  ACTION_REQUIRED: "Action Required",
  ACTION_CARDS_VISIBILITY: "Toggle action cards visibility",
  GROUP_PACKAGES: "Group Packages",
  INDIVIDUAL_PACKAGES: "Individual Packages",
  LISTING_HAS_NO_AVAILABILITY: "This listing does not have any availability currently",
  LODGING: "Lodging",
  TROPHIES: "Trophies",
  MEALS: "Meals",
  GEAR_RENTALS: "Gear Rentals",
  OTHER_ADD_ONS: "Other Add-ons",
  MEAL_UPGRADES: "Meal Upgrades",
  OTHERS: "Others",
  ADD_ON: "add-on",
  MAXIMUM: "Maximum",
  UP_TO: "Up to",
  GUEST: "guest",
  DAY_TRIP: "day trip",
  DAY: "day",
  PREVIOUS_MONTH: "Previous month",
  NEXT_MONTH: "Next month",
  CLEAR_DATES: "Clear dates",
  TBD: "TBD",
  STARTS: "starts",
  ENDS: "ends",
  SELECT_DATES: "Select dates",
  INCREMENT: "Increment",
  DECREMENT: "Decrement",
  YOUR_GUESTS: "Your guests",
  NUMBER_OF_GUESTS: "Number of guests",
  MINIMUM: "Minimum",
  PACKAGE_INCLUDES: "Your selected package includes",
  TOTAL_GUESTS: "total guests",
  VIEW_LISTING: "View listing",
  SELECT: "Select",
  DEPOSIT: "Deposit",
  TOTAL: "Total",
  DUE_AFTER_TRIP: "Due after trip",
  ADD: "Add",
  UPDATE: "Update",
  REMOVE: "Remove",
  ADD_ON_HELPER_TEXT_PREFIX: "For more information and examples, please see ",
  THIS_ARTICLE: "this article",
  PERIOD: ".",
  DUE_NOW: "Due Now",
  DUE_AFTER_CONFIRMATION: "Due after confirmation",
  DUE_ON: "Due on",
  PACKAGE: "Package",
  TRIP_SUMMARY: "Trip Summary",
  SEARCH: "Search",
  INCLUDED_ADD_ONS_LABEL: "Add-ons included in this package",
  NO_INCLUDED_ADD_ONS: "This package doesn't include any add-ons.",
  MAKE_PAYABLE_TO: "Make payable to:",
  MAIL_TO: "Mail to:",
  MALLARD_PAY_OUTDOORS: "Mallard Bay Outdoors",
  MB_ADDRESS_LINE_ONE: "1100 West 23rd St Suite 222",
  MB_ADDRESS_LINE_TWO: "Houston Tx, 77008",
  SORT: "Sort",
  VIEW: "View",
  ELLIPSIS: "...",
  PREVIOUS_PAGE: "Previous page",
  NEXT_PAGE: "Next page",
  SHOWING: "Showing",
  OF: "of",
  RESULTS: "results",
  COPIED: "Copied",
  COPY_TO_CLIPBOARD: "Copy to clipboard",
  NO_EXISTING_PAYMENT_METHODS: "No existing payment methods",
  DONE: "Done",
  BACK: "Back",
  NEXT: "Next",
  QUESTIONS: "Questions?",
  STEP: "Step",
  LETS_GET_STARTED: "Let's get started",
  CURRENT_STEP_DESCRIPTION: "is complete! You can now move on to step",
  EXIT: "Exit",
  TRIP: "Trip",
  PREVIOUS: "Previous",
  SHOW_ALL_PHOTOS: "Show all photos",
  SHARE: "Share",
  CLOSE: "Close",
  PHOTO: "Photo",
  VIDEO: "Video",
  SHOW_MORE: "Show more",
  SHOW_LESS: "Show less",
  TOAST_TITLES: {
    SUCCESS: "Success",
    ERROR: "Error"
  },
  PENDING: "Pending"
};
var copy_constants_default = COPY_CONSTANTS;

// src/components/payment-method-selector/payment-method-selector-types.ts
var PAYMENT_METHOD_TYPE = {
  CARD: "CARD",
  BANK_ACCOUNT: "BANK_ACCOUNT",
  CHECK: "CHECK"
};
var CARD_BRANDS = {
  VISA: "visa",
  MASTERCARD: "mastercard",
  DISCOVER: "discover",
  AMEX: "amex"
};

// src/components/payment-method-card/payment-method-icon.tsx
var import_react16 = __toESM(require("react"));
var import_react_fontawesome5 = require("@fortawesome/react-fontawesome");
var import_faCcAmex = require("@fortawesome/free-brands-svg-icons/faCcAmex");
var import_faCcDiscover = require("@fortawesome/free-brands-svg-icons/faCcDiscover");
var import_faCcMastercard = require("@fortawesome/free-brands-svg-icons/faCcMastercard");
var import_faCcVisa = require("@fortawesome/free-brands-svg-icons/faCcVisa");
var import_faCreditCard = require("@fortawesome/free-regular-svg-icons/faCreditCard");
var import_faBank = require("@fortawesome/free-solid-svg-icons/faBank");
var import_faMoneyCheck = require("@fortawesome/free-solid-svg-icons/faMoneyCheck");
function PaymentMethodIcon({ type, brand }) {
  const styleProps = useStyleProps2();
  if (type === PAYMENT_METHOD_TYPE.BANK_ACCOUNT) {
    return /* @__PURE__ */ import_react16.default.createElement(import_react_fontawesome5.FontAwesomeIcon, { icon: import_faBank.faBank, ...styleProps.defaultIcon });
  }
  if (type === PAYMENT_METHOD_TYPE.CHECK) {
    return /* @__PURE__ */ import_react16.default.createElement(import_react_fontawesome5.FontAwesomeIcon, { icon: import_faMoneyCheck.faMoneyCheck, ...styleProps.defaultIcon });
  }
  switch (brand) {
    case CARD_BRANDS.VISA:
      return /* @__PURE__ */ import_react16.default.createElement(import_react_fontawesome5.FontAwesomeIcon, { icon: import_faCcVisa.faCcVisa, ...styleProps.visaCard });
    case CARD_BRANDS.MASTERCARD:
      return /* @__PURE__ */ import_react16.default.createElement(
        import_react_fontawesome5.FontAwesomeIcon,
        {
          icon: import_faCcMastercard.faCcMastercard,
          ...styleProps.masterCard
        }
      );
    case CARD_BRANDS.DISCOVER:
      return /* @__PURE__ */ import_react16.default.createElement(
        import_react_fontawesome5.FontAwesomeIcon,
        {
          icon: import_faCcDiscover.faCcDiscover,
          ...styleProps.discoverCard
        }
      );
    case CARD_BRANDS.AMEX:
      return /* @__PURE__ */ import_react16.default.createElement(import_react_fontawesome5.FontAwesomeIcon, { icon: import_faCcAmex.faCcAmex, ...styleProps.amexCard });
    default:
      return /* @__PURE__ */ import_react16.default.createElement(
        import_react_fontawesome5.FontAwesomeIcon,
        {
          icon: import_faCreditCard.faCreditCard,
          ...styleProps.defaultIcon
        }
      );
  }
}
function useStyleProps2() {
  const defaultIcon = { fontSize: 22 };
  const visaCard = { color: "#1434CB", ...defaultIcon };
  const masterCard = { color: "#EB001B", ...defaultIcon };
  const discoverCard = { color: "#E55C20", ...defaultIcon };
  const amexCard = { color: "#016FD0", ...defaultIcon };
  return { visaCard, masterCard, discoverCard, amexCard, defaultIcon };
}

// src/components/vertical-stack/vertical-stack.tsx
var import_react17 = __toESM(require("react"));
var import_react18 = require("@chakra-ui/react");
function VerticalStack({ style, children, testId }) {
  const styles = useStyles4();
  return /* @__PURE__ */ import_react17.default.createElement(import_react18.VStack, { sx: { ...styles.root, ...style }, "data-testid": testId }, children);
}
function VerticalStackStretch({
  style,
  children,
  testId
}) {
  const styles = useStyles4();
  return /* @__PURE__ */ import_react17.default.createElement(import_react18.VStack, { sx: { ...styles.stretch, ...style }, "data-testid": testId }, children);
}
function useStyles4() {
  return componentStyles({
    root: {
      gap: 4,
      alignItems: "flex-start"
    },
    stretch: {
      gap: 4,
      alignItems: "stretch"
    }
  });
}

// src/components/text/text.tsx
var import_react19 = __toESM(require("react"));
var import_react20 = require("@chakra-ui/react");
function Text({ style, numberOfLines, testId, ...props }) {
  return /* @__PURE__ */ import_react19.default.createElement(
    import_react20.Text,
    {
      "data-testid": testId,
      noOfLines: numberOfLines,
      sx: style,
      ...props
    }
  );
}
function TextExtraSmall({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.xsmall, ...style }, ...props });
}
function TextSmall({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.small, ...style }, ...props });
}
function TextMedium({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.medium, ...style }, ...props });
}
function TextMediumBold({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(TextBold, { style: { ...styles.medium, ...style }, ...props });
}
function TextXLargeBold({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(TextBold, { style: { ...styles.xlarge, ...style }, ...props });
}
function TextLarge({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.large, ...style }, ...props });
}
function TextError({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.error, ...style }, ...props });
}
function TextErrorSmall({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(TextError, { style: { ...styles.small, ...style }, ...props });
}
function TextBold({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.bold, ...style }, ...props });
}
function TextBoldSmall({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(TextBold, { style: { ...styles.small, ...style }, ...props });
}
function TextBoldLarge({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(TextBold, { style: { ...styles.large, ...style }, ...props });
}
function TextBoldExtraSmall({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(TextBold, { style: { ...styles.xsmall, ...style }, ...props });
}
function TextLargeBold(props) {
  return /* @__PURE__ */ import_react19.default.createElement(TextBoldLarge, { ...props });
}
function TextActive({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.active, ...style }, ...props });
}
function TextSecondary({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.secondary, ...style }, ...props });
}
function TextSecondaryExtraSmall({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(TextSecondary, { style: { ...styles.xsmall, ...style }, ...props });
}
function TextSmallSecondary({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.smallSecondary, ...style }, ...props });
}
function TextSecondarySmall(props) {
  return /* @__PURE__ */ import_react19.default.createElement(TextSmallSecondary, { ...props });
}
function TextSecondaryLarge({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(TextSecondary, { style: { ...styles.large, ...style }, ...props });
}
function TextUnderlined({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.underline, ...style }, ...props });
}
function TextUnderlinedSmall({
  style,
  children,
  numberOfLines,
  testId
}) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(
    TextUnderlined,
    {
      style: { ...styles.small, ...style },
      numberOfLines,
      testId
    },
    children
  );
}
function TextSmallUnderlined({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.smallUnderlined, ...style }, ...props });
}
function TextNote({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.note, ...style }, ...props });
}
function TextSmallNote({ style, ...props }) {
  const styles = useStyles5();
  return /* @__PURE__ */ import_react19.default.createElement(Text, { style: { ...styles.smallNote, ...style }, ...props });
}
function TextNoteSmall(props) {
  return /* @__PURE__ */ import_react19.default.createElement(TextSmallNote, { ...props });
}
function useStyles5() {
  const colors = useColors();
  const error = {
    color: colors.error
  };
  const xsmall = {
    fontSize: "12px"
  };
  const small = {
    fontSize: "14px"
  };
  const medium = {
    fontSize: "16px"
  };
  const large = {
    fontSize: "18px"
  };
  const xlarge = {
    fontSize: "22px"
  };
  const bold = {
    fontWeight: "bold"
  };
  const active = {
    fontWeight: "bold",
    color: colors.brandDefault
  };
  const secondary = {
    color: colors.secondaryText
  };
  const smallSecondary = {
    ...small,
    ...secondary
  };
  const smallUnderlined = {
    ...small,
    textDecoration: "underline"
  };
  const note = {
    ...secondary,
    fontStyle: "italic"
  };
  const smallNote = {
    ...smallSecondary,
    fontStyle: "italic"
  };
  const underline = {
    textDecoration: "underline"
  };
  return componentStyles({
    error,
    xsmall,
    small,
    medium,
    large,
    xlarge,
    bold,
    active,
    secondary,
    smallSecondary,
    smallUnderlined,
    note,
    smallNote,
    underline
  });
}

// src/components/box/box.tsx
var import_react21 = __toESM(require("react"));
var import_react22 = require("@chakra-ui/react");
var Box = (0, import_react21.forwardRef)(
  ({ style, testId, isDisabled, onClick, ...props }, ref) => {
    return /* @__PURE__ */ import_react21.default.createElement(
      import_react22.Box,
      {
        ref,
        sx: style,
        "data-testid": testId,
        onClick: (event) => !isDisabled && onClick?.(event),
        ...props
      }
    );
  }
);

// src/components/badge/badge.tsx
var import_react23 = require("@chakra-ui/react");
var import_react24 = __toESM(require("react"));
var BadgeVariant = /* @__PURE__ */ ((BadgeVariant2) => {
  BadgeVariant2["Outline"] = "outline";
  BadgeVariant2["Solid"] = "solid";
  BadgeVariant2["Subtle"] = "subtle";
  return BadgeVariant2;
})(BadgeVariant || {});
function Badge({ style, ...props }) {
  return /* @__PURE__ */ import_react24.default.createElement(import_react23.Badge, { sx: style, ...props });
}
function BadgeSuccess({ style, children }) {
  return /* @__PURE__ */ import_react24.default.createElement(import_react23.Badge, { sx: style, colorScheme: "green" }, children);
}

// src/components/payment-method-card/check-instructions.tsx
var import_react25 = __toESM(require("react"));
function CheckInstructions({ shouldRender }) {
  if (!shouldRender) return null;
  return /* @__PURE__ */ import_react25.default.createElement(import_react25.default.Fragment, null, /* @__PURE__ */ import_react25.default.createElement(Box, null, /* @__PURE__ */ import_react25.default.createElement(Text, null, copy_constants_default.MAKE_PAYABLE_TO), /* @__PURE__ */ import_react25.default.createElement(Text, null, copy_constants_default.MALLARD_PAY_OUTDOORS)), /* @__PURE__ */ import_react25.default.createElement(Box, null, /* @__PURE__ */ import_react25.default.createElement(Text, null, copy_constants_default.MAIL_TO), /* @__PURE__ */ import_react25.default.createElement(Text, null, copy_constants_default.MB_ADDRESS_LINE_ONE), /* @__PURE__ */ import_react25.default.createElement(Text, null, copy_constants_default.MB_ADDRESS_LINE_TWO)));
}

// src/components/payment-method-card/payment-method-card-content.tsx
function PaymentMethodCardContent({
  paymentMethod,
  menuItems = [],
  isMenuLoading
}) {
  const styles = useStyleProps3();
  const shouldRenderMenu = Boolean(menuItems.length);
  const adjustedMenuItems = adjustMenuItems({ menuItems, paymentMethod });
  const isCheck = paymentMethod.type === PAYMENT_METHOD_TYPE.CHECK;
  return /* @__PURE__ */ import_react26.default.createElement(VerticalStack, { style: styles.vStack }, shouldRenderMenu && /* @__PURE__ */ import_react26.default.createElement(Box, { style: styles.menu }, /* @__PURE__ */ import_react26.default.createElement(
    EllipsisMenu,
    {
      menuItems: adjustedMenuItems,
      isLoading: isMenuLoading
    }
  )), /* @__PURE__ */ import_react26.default.createElement(HorizontalStack, null, /* @__PURE__ */ import_react26.default.createElement(
    PaymentMethodIcon,
    {
      type: paymentMethod.type,
      brand: paymentMethod.brand
    }
  ), /* @__PURE__ */ import_react26.default.createElement(TextBoldLarge, { style: styles.capitalize }, paymentMethod.title), paymentMethod.is_default && /* @__PURE__ */ import_react26.default.createElement(BadgeSuccess, null, copy_constants_default.DEFAULT), paymentMethod.is_pending && /* @__PURE__ */ import_react26.default.createElement(Badge, null, copy_constants_default.PENDING)), paymentMethod.subtitle && /* @__PURE__ */ import_react26.default.createElement(Text, { style: styles.capitalize }, paymentMethod.subtitle), /* @__PURE__ */ import_react26.default.createElement(CheckInstructions, { shouldRender: isCheck }));
}
function useStyleProps3() {
  return componentStyles({
    vStack: {
      width: "100%",
      gap: 3
    },
    capitalize: {
      textTransform: "capitalize"
    },
    menu: {
      position: "absolute",
      top: "12px",
      right: "16px"
    }
  });
}
function adjustMenuItems({
  menuItems,
  paymentMethod
}) {
  return menuItems.map(({ onClick, ...menuItem }) => ({
    ...menuItem,
    onClick: () => onClick(paymentMethod)
  }));
}

// src/components/selectable-card/selectable-card.tsx
var import_react31 = __toESM(require("react"));

// src/components/card/card.tsx
var import_react27 = __toESM(require("react"));
var import_react28 = require("@chakra-ui/react");
var Card = (0, import_react27.forwardRef)(
  ({
    style,
    onClick,
    isDisabled,
    onPointerEnter,
    children,
    testId
  }, ref) => {
    const styles = useStyles6({
      hasClickHandler: Boolean(onClick),
      isDisabled
    });
    return /* @__PURE__ */ import_react27.default.createElement(
      import_react28.Card,
      {
        ref,
        sx: { ...styles.root, ...style },
        onClick: (event) => !isDisabled && onClick?.(event),
        onPointerEnter,
        "data-testid": testId
      },
      children
    );
  }
);
function useStyles6({
  hasClickHandler,
  isDisabled
}) {
  const colors = useColors();
  const cursorWithClickHandler = isDisabled ? "not-allowed" : "pointer";
  const root = {
    backgroundColor: colors.cardBackground,
    paddingX: 6,
    paddingY: 4,
    border: `1px solid ${colors.borderCard} !important`,
    borderColor: `${colors.borderCard} !important`,
    boxShadow: "none",
    cursor: hasClickHandler ? cursorWithClickHandler : "default"
  };
  return { root };
}

// src/components/tooltip/tooltip.tsx
var import_react29 = __toESM(require("react"));
var import_react30 = require("@chakra-ui/react");
function Tooltip({
  label,
  children,
  style,
  closeOnClick,
  isDisabled
}) {
  return /* @__PURE__ */ import_react29.default.createElement(
    import_react30.Tooltip,
    {
      label,
      sx: style,
      closeOnClick,
      isDisabled
    },
    children
  );
}

// src/components/selectable-card/selectable-card.tsx
function SelectableCard({
  style,
  isSelected,
  isDisabled,
  tooltip,
  onClick,
  children
}) {
  const styles = useStyles7({ isSelected, isDisabled });
  return /* @__PURE__ */ import_react31.default.createElement(Tooltip, { label: tooltip }, /* @__PURE__ */ import_react31.default.createElement(
    Card,
    {
      style: { ...styles.root, ...style },
      onClick,
      isDisabled
    },
    children
  ));
}
function useStyles7({
  isSelected,
  isDisabled
}) {
  const colors = useColors();
  const isHighlighted = isSelected && !isDisabled;
  const outline = `2px solid ${colors.brandDefault}`;
  const selected = isHighlighted ? { outline } : {};
  const hoverBackgroundColorOrDisabled = isDisabled ? colors.bgDisabled : "inherit";
  const activeBackgroundColorOrDisabled = isDisabled ? colors.bgDisabled : colors.bgTertiary;
  const disabled = isDisabled ? {
    color: colors.disabled,
    backgroundColor: colors.bgDisabled
  } : {};
  return componentStyles({
    root: {
      width: "100%",
      backgroundColor: "inherit",
      padding: 4,
      userSelect: "none",
      position: "relative",
      ":hover": {
        backgroundColor: hoverBackgroundColorOrDisabled
      },
      ":active": {
        backgroundColor: activeBackgroundColorOrDisabled
      },
      ":focus": { outline },
      ...disabled,
      ...selected
    }
  });
}

// src/components/payment-method-card/payment-method-card.tsx
function PaymentMethodCard({
  paymentMethod,
  isSelected,
  menuItems = [],
  isMenuLoading
}) {
  return /* @__PURE__ */ import_react32.default.createElement(SelectableCard, { isSelected }, /* @__PURE__ */ import_react32.default.createElement(
    PaymentMethodCardContent,
    {
      paymentMethod,
      menuItems,
      isMenuLoading
    }
  ));
}

// src/components/payment-method-selector/payment-method-selector.tsx
var import_react36 = __toESM(require("react"));

// src/components/radio-select/radio-select.tsx
var import_react33 = __toESM(require("react"));
var import_react34 = require("@chakra-ui/react");
function RadioSelect({
  style,
  value,
  onChange,
  options,
  getOptionValue,
  renderOption
}) {
  const styles = useStyleProps4();
  return /* @__PURE__ */ import_react33.default.createElement(
    import_react34.RadioGroup,
    {
      sx: { ...styles.radioGroup, ...style },
      value,
      onChange
    },
    options.map((option) => {
      const optionValue = getOptionValue(option);
      return /* @__PURE__ */ import_react33.default.createElement(
        import_react34.Radio,
        {
          key: optionValue,
          sx: styles.radio,
          value: optionValue,
          size: "lg",
          colorScheme: "brand"
        },
        renderOption(option)
      );
    })
  );
}
function useStyleProps4() {
  const colors = useColors();
  return componentStyles({
    radioGroup: {
      ".chakra-radio__label": {
        width: "100%",
        borderRadius: "xl",
        border: `1px solid ${colors.border}`,
        padding: 4,
        marginLeft: 3
      },
      ".chakra-radio__label[data-checked]": {
        outline: `2px solid ${colors.brandDefault}`
      },
      display: "flex",
      flexDirection: "column",
      gap: 4
    },
    radio: { position: "relative" }
  });
}

// src/components/payment-method-selector/payment-method-selector-empty-state.tsx
var import_react35 = __toESM(require("react"));
function PaymentMethodSelectorEmptyState() {
  const styles = useStyles8();
  return /* @__PURE__ */ import_react35.default.createElement(Box, { style: styles.container }, /* @__PURE__ */ import_react35.default.createElement(Text, null, copy_constants_default.NO_EXISTING_PAYMENT_METHODS));
}
function useStyles8() {
  return componentStyles({
    container: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center"
    }
  });
}

// src/components/payment-method-selector/payment-method-selector.tsx
function PaymentMethodSelector({
  paymentMethods = [],
  selectedPaymentMethodId,
  onChange,
  menuItems
}) {
  if (!paymentMethods.length) {
    return /* @__PURE__ */ import_react36.default.createElement(PaymentMethodSelectorEmptyState, null);
  }
  return /* @__PURE__ */ import_react36.default.createElement(Box, null, /* @__PURE__ */ import_react36.default.createElement(
    RadioSelect,
    {
      value: selectedPaymentMethodId ?? "",
      options: paymentMethods,
      onChange,
      getOptionValue: (paymentMethod) => paymentMethod.id,
      renderOption: (paymentMethod) => /* @__PURE__ */ import_react36.default.createElement(
        PaymentMethodCardContent,
        {
          paymentMethod,
          menuItems
        }
      )
    }
  ));
}

// src/components/action-card/action-card.tsx
var import_react38 = require("@chakra-ui/react");
var import_react39 = __toESM(require("react"));
var import_react_fontawesome6 = require("@fortawesome/react-fontawesome");
var import_faChevronRight2 = require("@fortawesome/free-solid-svg-icons/faChevronRight");

// src/utils/action-banner-helpers.ts
var import_react37 = require("@chakra-ui/react");
function useActionBannerColors({
  colorScheme
}) {
  const colors = useColors();
  const baseColorMap = colors[colorScheme];
  const backgroundColor = (0, import_react37.useColorModeValue)(
    baseColorMap["100"],
    baseColorMap["800"]
  );
  const borderColor = (0, import_react37.useColorModeValue)(
    baseColorMap["600"],
    baseColorMap["600"]
  );
  const titleColor = (0, import_react37.useColorModeValue)(
    baseColorMap["800"],
    baseColorMap["50"]
  );
  const textColor = (0, import_react37.useColorModeValue)("black", "white");
  const iconColor = (0, import_react37.useColorModeValue)(
    baseColorMap["500"],
    baseColorMap["200"]
  );
  return {
    titleColor,
    backgroundColor,
    descriptionColor: textColor,
    iconColor,
    ctaColor: textColor,
    borderColor
  };
}

// src/components/action-card/action-card.tsx
var ActionCardType = /* @__PURE__ */ ((ActionCardType2) => {
  ActionCardType2["Error"] = "error";
  ActionCardType2["Warning"] = "warning";
  ActionCardType2["Info"] = "info";
  return ActionCardType2;
})(ActionCardType || {});
function ActionCard({
  title,
  subHeader,
  body,
  icon,
  type,
  ctaProps
}) {
  const styles = useStyles9(type);
  return /* @__PURE__ */ import_react39.default.createElement(import_react38.Card, { ...styles.card, "data-testid": TEST_IDS.ACTION_CARD }, /* @__PURE__ */ import_react39.default.createElement(import_react38.CardHeader, { ...styles.cardHeader }, /* @__PURE__ */ import_react39.default.createElement(HorizontalStack, null, icon, /* @__PURE__ */ import_react39.default.createElement(import_react38.Heading, { ...styles.heading }, title))), !!subHeader && /* @__PURE__ */ import_react39.default.createElement(import_react38.CardBody, { ...styles.body }, subHeader), /* @__PURE__ */ import_react39.default.createElement(import_react38.CardBody, { ...styles.body }, body), ctaProps && /* @__PURE__ */ import_react39.default.createElement(import_react38.CardFooter, { ...styles.cardFooter }, /* @__PURE__ */ import_react39.default.createElement(
    LinkButton,
    {
      leftIcon: ctaProps.icon,
      rightIcon: /* @__PURE__ */ import_react39.default.createElement(import_react_fontawesome6.FontAwesomeIcon, { icon: import_faChevronRight2.faChevronRight }),
      onClick: ctaProps.onClick,
      href: ctaProps.href,
      ...styles.ctaButton
    },
    ctaProps.label
  )));
}
function useTypeColors({ type }) {
  let colorScheme = "red" /* Red */;
  switch (type) {
    case "error" /* Error */:
      colorScheme = "red" /* Red */;
      break;
    case "info" /* Info */:
      colorScheme = "blue" /* Blue */;
      break;
    case "warning" /* Warning */:
      colorScheme = "orange" /* Orange */;
      break;
    default:
      colorScheme = "red" /* Red */;
  }
  const { backgroundColor, titleColor, descriptionColor } = useActionBannerColors({ colorScheme });
  return {
    backgroundColor,
    primaryTextColor: titleColor,
    secondaryTextColor: descriptionColor
  };
}
function useStyles9(type) {
  const typeColors = useTypeColors({ type });
  const heading = {
    size: "sm",
    margin: 0
  };
  const cardHeader = {
    paddingBottom: 3,
    color: typeColors.primaryTextColor
  };
  const body = {
    color: typeColors.secondaryTextColor,
    paddingY: 2
  };
  const card = {
    variant: "filled",
    backgroundColor: typeColors.backgroundColor
  };
  const ctaButton = {
    color: typeColors.primaryTextColor
  };
  const cardFooter = {
    paddingTop: 0,
    justifyContent: "flex-end"
  };
  return {
    heading,
    card,
    body,
    ctaButton,
    cardHeader,
    cardFooter
  };
}

// src/components/action-required/action-required.tsx
var import_react42 = require("@chakra-ui/react");
var import_react43 = __toESM(require("react"));

// src/components/action-required/action-required-header.tsx
var import_react40 = require("@chakra-ui/react");
var import_react41 = __toESM(require("react"));
var import_react_fontawesome7 = require("@fortawesome/react-fontawesome");
var import_faCircle = require("@fortawesome/free-solid-svg-icons/faCircle");
var import_faChevronUp = require("@fortawesome/free-solid-svg-icons/faChevronUp");
var import_faChevronDown = require("@fortawesome/free-solid-svg-icons/faChevronDown");
function ActionRequiredHeader({
  isOpen,
  setIsOpen,
  itemsCount
}) {
  const styles = useStyles10();
  const buttonIcon = isOpen ? import_faChevronUp.faChevronUp : import_faChevronDown.faChevronDown;
  return /* @__PURE__ */ import_react41.default.createElement(HorizontalStack, { ...styles.horizontalStack }, /* @__PURE__ */ import_react41.default.createElement(HorizontalStack, null, /* @__PURE__ */ import_react41.default.createElement(import_react_fontawesome7.FontAwesomeIcon, { icon: import_faCircle.faCircle, ...styles.dot }), /* @__PURE__ */ import_react41.default.createElement(import_react40.Heading, { ...styles.heading }, copy_constants_default.ACTION_REQUIRED), /* @__PURE__ */ import_react41.default.createElement(import_react40.Tag, { ...styles.tag }, itemsCount)), /* @__PURE__ */ import_react41.default.createElement(
    import_react40.IconButton,
    {
      "aria-label": copy_constants_default.ACTION_CARDS_VISIBILITY,
      icon: /* @__PURE__ */ import_react41.default.createElement(import_react_fontawesome7.FontAwesomeIcon, { icon: buttonIcon }),
      variant: BUTTON_VARIANTS.GHOST,
      onClick: () => setIsOpen(!isOpen)
    }
  ));
}
function useStyles10() {
  const colors = useColors();
  const heading = {
    size: "md"
  };
  const tag = {
    colorScheme: "red" /* Red */,
    borderRadius: "full"
  };
  const horizontalStack = {
    style: {
      justifyContent: "space-between",
      width: "100%"
    }
  };
  const dot = {
    color: colors.red[500],
    fontSize: 8
  };
  return {
    heading,
    tag,
    horizontalStack,
    dot
  };
}

// src/components/action-required/action-required.tsx
function ActionRequired({ actionItems }) {
  const styles = useStyles11();
  const itemsCount = actionItems.length;
  const [isOpen, setIsOpen] = (0, import_react43.useState)(!!itemsCount);
  if (!itemsCount) {
    return null;
  }
  return /* @__PURE__ */ import_react43.default.createElement(import_react42.VStack, { ...styles.mainVStack }, /* @__PURE__ */ import_react43.default.createElement(
    ActionRequiredHeader,
    {
      isOpen,
      setIsOpen,
      itemsCount
    }
  ), /* @__PURE__ */ import_react43.default.createElement(import_react42.Collapse, { in: isOpen, ...styles.collapse }, /* @__PURE__ */ import_react43.default.createElement(import_react42.VStack, { ...styles.collapseVStack }, actionItems.map((props) => /* @__PURE__ */ import_react43.default.createElement(import_react42.Box, { key: props.title, ...styles.cardWrapper }, /* @__PURE__ */ import_react43.default.createElement(ActionCard, { ...props }))))));
}
function useStyles11() {
  const mainVStack = {
    gap: 2
  };
  const collapseVStack = {
    gap: 4
  };
  const collapse = {
    style: {
      width: "100%"
    }
  };
  const cardWrapper = {
    width: "100%"
  };
  return {
    mainVStack,
    collapseVStack,
    collapse,
    cardWrapper
  };
}

// src/components/tabs-list/tabs-list.tsx
var import_react46 = __toESM(require("react"));
var import_react47 = require("@chakra-ui/react");

// src/components/tabs-list/tabs-list-button.tsx
var import_react44 = __toESM(require("react"));
var import_react45 = require("@chakra-ui/react");
var import_react_fontawesome8 = require("@fortawesome/react-fontawesome");
var import_faInfoCircle = require("@fortawesome/free-solid-svg-icons/faInfoCircle");
function TabsListButton({
  tabItem
}) {
  const styleProps = useStyleProps5();
  const { label, helperText } = tabItem;
  if (!helperText) {
    return /* @__PURE__ */ import_react44.default.createElement(import_react45.Tab, { ...styleProps.tab }, label);
  }
  return /* @__PURE__ */ import_react44.default.createElement(import_react45.Tab, { ...styleProps.tab }, /* @__PURE__ */ import_react44.default.createElement(import_react45.HStack, null, /* @__PURE__ */ import_react44.default.createElement(import_react45.Text, null, label), /* @__PURE__ */ import_react44.default.createElement(
    import_react45.Tooltip,
    {
      key: `tab-${label}`,
      label: helperText,
      placement: "bottom-start"
    },
    /* @__PURE__ */ import_react44.default.createElement(
      import_react_fontawesome8.FontAwesomeIcon,
      {
        icon: import_faInfoCircle.faInfoCircle,
        ...styleProps.infoIcon
      }
    )
  )));
}
function useStyleProps5() {
  const { secondaryText } = useColors();
  const tab = {
    fontSize: "14px",
    fontWeight: 600,
    whiteSpace: "nowrap",
    borderBottomWidth: "3px",
    textTransform: "capitalize",
    _selected: {
      color: "WindowText",
      borderBottomColor: "WindowText"
    }
  };
  const infoIcon = {
    color: secondaryText
  };
  return { tab, infoIcon };
}

// src/components/tabs-list/tabs-list.tsx
function TabsList({ tabItems, activeIndex, onChange }) {
  const styleProps = useStyleProps6();
  return /* @__PURE__ */ import_react46.default.createElement(
    import_react47.Tabs,
    {
      isLazy: true,
      index: activeIndex,
      onChange,
      ...styleProps.tabs
    },
    /* @__PURE__ */ import_react46.default.createElement(import_react47.Box, { ...styleProps.tabListContainer }, /* @__PURE__ */ import_react46.default.createElement(import_react47.TabList, { ...styleProps.tabList }, tabItems.map((tabItem) => /* @__PURE__ */ import_react46.default.createElement(
      TabsListButton,
      {
        key: `tab-${tabItem.label}`,
        tabItem
      }
    )))),
    /* @__PURE__ */ import_react46.default.createElement(import_react47.TabPanels, null, tabItems.map(({ label, content }) => /* @__PURE__ */ import_react46.default.createElement(
      import_react47.TabPanel,
      {
        key: `tab-panel-${label}`,
        ...styleProps.tabPanel
      },
      content
    )))
  );
}
function useStyleProps6() {
  const { secondaryText } = useColors();
  const tabListContainer = {
    overflowX: "auto",
    css: {
      // Hides scrollbar in browsers
      "&::-webkit-scrollbar": {
        display: "none"
      }
    }
  };
  const tabList = {
    color: secondaryText
  };
  const tabs = {
    flex: 1
  };
  const tabPanel = {
    paddingX: 0
  };
  return { tabListContainer, tabList, tabs, tabPanel };
}

// src/components/modal/modal.tsx
var import_react49 = __toESM(require("react"));
var import_react50 = require("@chakra-ui/react");

// src/utils/use-is-mobile.ts
var import_react48 = require("@chakra-ui/react");
function useIsMobile() {
  return (0, import_react48.useBreakpointValue)({ base: true, md: false }) ?? false;
}

// src/components/modal/modal.tsx
function Modal({
  title,
  shouldShowCloseButton = true,
  shouldPreventClose = false,
  size = "3xl",
  scrollBehavior = "inside",
  shouldAddPadding,
  children,
  isOpen,
  onClose,
  style: bodyStyle,
  contentStyle,
  closeButtonStyle
}) {
  const responsiveSize = useSize({ size });
  const styles = useStyles12({
    shouldAddPadding,
    size: responsiveSize,
    hasTitle: !!title
  });
  return /* @__PURE__ */ import_react49.default.createElement(
    import_react50.Modal,
    {
      size: responsiveSize,
      scrollBehavior,
      isOpen,
      onClose,
      closeOnOverlayClick: !shouldPreventClose
    },
    /* @__PURE__ */ import_react49.default.createElement(import_react50.ModalOverlay, { sx: styles.modalOverlay }),
    /* @__PURE__ */ import_react49.default.createElement(import_react50.ModalContent, { sx: { ...styles.modalContent, ...contentStyle } }, shouldShowCloseButton && !shouldPreventClose && /* @__PURE__ */ import_react49.default.createElement(
      import_react50.ModalCloseButton,
      {
        "data-testid": TEST_IDS.CLOSE_MODAL_BUTTON,
        sx: { ...styles.closeButton, ...closeButtonStyle }
      }
    ), title && /* @__PURE__ */ import_react49.default.createElement(import_react49.default.Fragment, null, /* @__PURE__ */ import_react49.default.createElement(import_react50.ModalHeader, null, title), /* @__PURE__ */ import_react49.default.createElement(import_react50.Divider, null)), /* @__PURE__ */ import_react49.default.createElement(import_react50.ModalBody, { sx: { ...styles.modalBody, ...bodyStyle } }, children))
  );
}
function useSize({ size }) {
  const isMobile = useIsMobile();
  if (isMobile) {
    return "full";
  }
  return size;
}
function useStyles12({
  shouldAddPadding,
  size,
  hasTitle
}) {
  const colors = useColors();
  const contentPadding = shouldAddPadding ? 6 : 0;
  const rounded = size === "full" ? "none" : "xl";
  return componentStyles({
    closeButton: {
      top: 4
    },
    modalContent: {
      rounded,
      backgroundColor: colors.bg,
      border: `1px solid ${colors.border}`
    },
    modalBody: {
      mt: hasTitle ? 4 : -2,
      paddingX: contentPadding,
      paddingBottom: contentPadding
    },
    modalOverlay: {
      backdropFilter: "blur(4px)"
    }
  });
}

// src/components/card-select/card-select.tsx
var import_react54 = __toESM(require("react"));

// src/components/card-select/card-select-group.tsx
var import_react53 = __toESM(require("react"));

// src/components/card-select/card-select-options.tsx
var import_react51 = __toESM(require("react"));
function CardSelectOptions({
  options,
  onSelect,
  renderOption
}) {
  return /* @__PURE__ */ import_react51.default.createElement(import_react51.default.Fragment, null, options.map((option) => /* @__PURE__ */ import_react51.default.createElement(
    SelectableCard,
    {
      key: JSON.stringify(option),
      onClick: () => onSelect(option),
      isSelected: option.isSelected,
      isDisabled: option.isDisabled,
      tooltip: option.disabledTooltip
    },
    renderOption(option)
  )));
}

// src/components/card-select/card-list.tsx
var import_react52 = __toESM(require("react"));
function CardList({ style, title, children }) {
  const styles = useStyles13();
  return /* @__PURE__ */ import_react52.default.createElement(Box, { style: { ...styles.root, ...style } }, /* @__PURE__ */ import_react52.default.createElement(TextBold, { style: styles.title }, title), /* @__PURE__ */ import_react52.default.createElement(VerticalStack, null, children));
}
function useStyles13() {
  const colors = useColors();
  return componentStyles({
    root: {
      width: "100%",
      backgroundColor: colors.bg
    },
    title: {
      marginBottom: 2
    }
  });
}

// src/components/card-select/card-select-group.tsx
function CardSelectGroup({
  style,
  title,
  options,
  onSelect,
  renderOption
}) {
  if (!options.length) return null;
  return /* @__PURE__ */ import_react53.default.createElement(CardList, { style, title }, /* @__PURE__ */ import_react53.default.createElement(
    CardSelectOptions,
    {
      options,
      onSelect,
      renderOption
    }
  ));
}

// src/components/card-select/card-select.tsx
function CardSelect({
  style,
  optionGroups = [],
  options = [],
  onSelect,
  renderOption
}) {
  const styles = useStyles14();
  return /* @__PURE__ */ import_react54.default.createElement(VerticalStack, { style: { ...styles.root, ...style } }, optionGroups.map((optionGroup) => /* @__PURE__ */ import_react54.default.createElement(
    CardSelectGroup,
    {
      key: optionGroup.title,
      ...optionGroup,
      onSelect,
      renderOption
    }
  )), /* @__PURE__ */ import_react54.default.createElement(
    CardSelectOptions,
    {
      options,
      onSelect,
      renderOption
    }
  ));
}
function useStyles14() {
  return componentStyles({
    root: { gap: 6 }
  });
}

// src/components/textarea/textarea.tsx
var import_react55 = __toESM(require("react"));
var import_react56 = require("@chakra-ui/react");
function Textarea({
  style,
  placeholder,
  value,
  onChange,
  testId
}) {
  return /* @__PURE__ */ import_react55.default.createElement(
    import_react56.Textarea,
    {
      sx: style,
      placeholder,
      value,
      onChange: (event) => {
        onChange(event.target.value);
      },
      "data-testid": testId,
      _focusVisible: {
        outline: "none"
      }
    }
  );
}
function TextareaWithBackground({ style, ...props }) {
  const styles = useTextareaWithBackgroundStyles();
  return /* @__PURE__ */ import_react55.default.createElement(Textarea, { style: { ...styles.root, ...style }, ...props });
}
function useTextareaWithBackgroundStyles() {
  const colors = useColors();
  return componentStyles({
    root: {
      backgroundColor: colors.bgSecondary,
      resize: "none",
      "&:focus": {
        outlineColor: colors.text,
        outlineOffset: -1
      }
    }
  });
}

// src/components/tag/tag.tsx
var import_react57 = __toESM(require("react"));
var import_react58 = require("@chakra-ui/react");
var import_react_fontawesome9 = require("@fortawesome/react-fontawesome");
var TagVariant = /* @__PURE__ */ ((TagVariant2) => {
  TagVariant2["Outline"] = "outline";
  TagVariant2["Solid"] = "solid";
  TagVariant2["Subtle"] = "subtle";
  return TagVariant2;
})(TagVariant || {});
function Tag2({
  children,
  style,
  iconStyle,
  leftIcon,
  colorScheme,
  variant,
  onClick
}) {
  const tagStyles = useStyles15();
  return /* @__PURE__ */ import_react57.default.createElement(
    import_react58.Tag,
    {
      sx: { ...tagStyles.tag, ...style },
      colorScheme,
      variant,
      onClick
    },
    leftIcon && /* @__PURE__ */ import_react57.default.createElement(import_react_fontawesome9.FontAwesomeIcon, { icon: leftIcon, style: iconStyle }),
    children
  );
}
function useStyles15() {
  const tag = {
    borderRadius: "full",
    gap: 2
  };
  return { tag };
}

// src/components/span/span.tsx
var import_react59 = __toESM(require("react"));
var import_react60 = require("@chakra-ui/react");
function Span({ style, children, testId }) {
  return /* @__PURE__ */ import_react59.default.createElement(import_react60.Box, { as: "span", sx: style, "data-testid": testId }, children);
}

// src/components/accordion/accordion.tsx
var import_react61 = __toESM(require("react"));
var import_react62 = require("@chakra-ui/react");
function Accordion({ items }) {
  const styles = useStyles16();
  return /* @__PURE__ */ import_react61.default.createElement(import_react62.Accordion, { allowToggle: true }, items.map((item, index2) => /* @__PURE__ */ import_react61.default.createElement(
    import_react62.AccordionItem,
    {
      key: `accordion-item-${index2}`
    },
    /* @__PURE__ */ import_react61.default.createElement(import_react62.AccordionButton, { sx: styles.button }, /* @__PURE__ */ import_react61.default.createElement(Span, { style: styles.title }, /* @__PURE__ */ import_react61.default.createElement("b", null, item.title)), /* @__PURE__ */ import_react61.default.createElement(import_react62.AccordionIcon, null)),
    /* @__PURE__ */ import_react61.default.createElement(import_react62.Divider, null),
    /* @__PURE__ */ import_react61.default.createElement(import_react62.AccordionPanel, { sx: styles.panel }, item.content)
  )));
}
function useStyles16() {
  return componentStyles({
    title: {
      flex: "1",
      textAlign: "left"
    },
    panel: {
      paddingBottom: 4
    },
    button: {
      paddingBottom: 4,
      paddingTop: 4
    }
  });
}

// src/components/tag-list/tag-list.tsx
var import_react63 = __toESM(require("react"));
function TagList({
  style,
  tagConfigs,
  isDisabled,
  variant,
  colorScheme
}) {
  const styles = useStyles17({ isDisabled });
  return /* @__PURE__ */ import_react63.default.createElement(HorizontalStackSmallGap, { style: { ...styles.root, ...style } }, tagConfigs.map(({ icon, name }) => /* @__PURE__ */ import_react63.default.createElement(
    Tag2,
    {
      key: name,
      leftIcon: icon,
      iconStyle: styles.tagIcon,
      variant,
      colorScheme
    },
    /* @__PURE__ */ import_react63.default.createElement(TextBoldExtraSmall, { style: styles.tagLabel }, name)
  )));
}
function useStyles17({ isDisabled }) {
  const colors = useColors();
  const tagColor = isDisabled ? colors.buttonDisabledText : "inherit";
  return componentStyles({
    root: {
      flexWrap: "wrap",
      flex: 1
    },
    tagIcon: {
      color: tagColor
    },
    tagLabel: {
      color: tagColor
    }
  });
}

// src/components/calendar-date-picker/calendar-date-picker.tsx
var import_react70 = __toESM(require("react"));
var import_react_datepicker2 = __toESM(require("react-datepicker"));
var import_react71 = require("@chakra-ui/react");

// src/components/calendar-date-picker/calendar-date-picker-header.tsx
var import_date_fns = require("date-fns");
var import_react69 = __toESM(require("react"));
var import_react_fontawesome11 = require("@fortawesome/react-fontawesome");
var import_faChevronLeft = require("@fortawesome/free-solid-svg-icons/faChevronLeft");
var import_faChevronRight3 = require("@fortawesome/free-solid-svg-icons/faChevronRight");

// src/components/heading/heading.tsx
var import_react64 = __toESM(require("react"));
var import_react65 = require("@chakra-ui/react");
function HeadingXSmall(props) {
  return /* @__PURE__ */ import_react64.default.createElement(HeadingCore, { ...props, size: SIZES.XS, as: "h5" });
}
function HeadingSmall(props) {
  return /* @__PURE__ */ import_react64.default.createElement(HeadingCore, { ...props, size: SIZES.SM, as: "h4" });
}
function Heading3(props) {
  return /* @__PURE__ */ import_react64.default.createElement(HeadingCore, { ...props, size: SIZES.MD, as: "h3" });
}
function HeadingMedium(props) {
  return /* @__PURE__ */ import_react64.default.createElement(HeadingCore, { ...props, size: SIZES.MD, as: "h3" });
}
function HeadingLarge(props) {
  return /* @__PURE__ */ import_react64.default.createElement(HeadingCore, { ...props, size: SIZES.LG, as: "h2" });
}
function HeadingXLarge(props) {
  return /* @__PURE__ */ import_react64.default.createElement(HeadingCore, { ...props, size: SIZES.XL, as: "h1" });
}
function HeadingCore({ style, ...props }) {
  return /* @__PURE__ */ import_react64.default.createElement(import_react65.Heading, { sx: style, ...props });
}

// src/components/calendar-date-picker/month-button.tsx
var import_react68 = __toESM(require("react"));

// src/components/icon-button/icon-button.tsx
var import_react66 = require("@chakra-ui/react");
var import_react67 = __toESM(require("react"));
var import_react_fontawesome10 = require("@fortawesome/react-fontawesome");
var import_faTrashCan = require("@fortawesome/free-regular-svg-icons/faTrashCan");
function IconButton3({
  color,
  colorScheme,
  ariaLabel,
  icon,
  onClick,
  style,
  isDisabled,
  disabled,
  testId,
  variant,
  size = "md",
  shadow
}) {
  return /* @__PURE__ */ import_react67.default.createElement(
    import_react66.IconButton,
    {
      sx: style,
      rounded: "full",
      size,
      color,
      colorScheme: color || colorScheme,
      "aria-label": ariaLabel ?? "",
      icon,
      onClick,
      isDisabled: isDisabled || disabled,
      "data-testid": testId,
      variant,
      shadow
    }
  );
}
function MediumIconButton(props) {
  return /* @__PURE__ */ import_react67.default.createElement(IconButton3, { size: "md", ...props });
}
function SmallIconButton(props) {
  return /* @__PURE__ */ import_react67.default.createElement(IconButton3, { size: "sm", ...props });
}
function LightIconButton({ size = "sm", ...rest }) {
  return /* @__PURE__ */ import_react67.default.createElement(import_react66.LightMode, null, /* @__PURE__ */ import_react67.default.createElement(IconButton3, { size, ...rest }));
}
function LightTrashIconButton({
  size = "sm",
  iconSize = 16,
  ...rest
}) {
  return /* @__PURE__ */ import_react67.default.createElement(import_react66.LightMode, null, /* @__PURE__ */ import_react67.default.createElement(
    IconButton3,
    {
      size,
      icon: /* @__PURE__ */ import_react67.default.createElement(import_react_fontawesome10.FontAwesomeIcon, { icon: import_faTrashCan.faTrashCan, fontSize: iconSize }),
      ...rest
    }
  ));
}
function ResponsiveIconButton({
  label,
  icon,
  ...props
}) {
  const shouldShowText = (0, import_react66.useBreakpointValue)({ base: false, md: true });
  if (shouldShowText) {
    return /* @__PURE__ */ import_react67.default.createElement(Button, { leftIcon: icon, ...props }, label);
  }
  return /* @__PURE__ */ import_react67.default.createElement(IconButton3, { "aria-label": label, icon, ...props });
}

// src/components/calendar-date-picker/month-button.tsx
function MonthNavButton({
  icon,
  onClick,
  isDisabled,
  isVisible,
  ariaLabel
}) {
  const styles = useStyles18({ isVisible });
  return /* @__PURE__ */ import_react68.default.createElement(
    MediumIconButton,
    {
      style: styles.root,
      icon,
      onClick,
      isDisabled,
      ariaLabel,
      variant: "ghost"
    }
  );
}
function useStyles18({ isVisible }) {
  return componentStyles({
    root: {
      // Using styling to hide to preserve layout.
      visibility: isVisible ? "visible" : "hidden"
    }
  });
}

// src/components/calendar-date-picker/calendar-date-picker-header.tsx
function CalendarDatePickerHeader({
  monthDate,
  customHeaderCount,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  monthsShown,
  isInline
}) {
  const styles = useStyles19({ isInline });
  const formattedMonthDate = (0, import_date_fns.format)(monthDate, "MMMM yyyy");
  const shouldShowPrevMonthButton = monthsShown === 1 || customHeaderCount === 0;
  const shouldShowNextMonthButton = monthsShown === 1 || customHeaderCount === monthsShown - 1;
  const iconSize = isInline ? 18 : 16;
  return /* @__PURE__ */ import_react69.default.createElement(HorizontalStackSpaceBetween, { style: styles.root }, /* @__PURE__ */ import_react69.default.createElement(
    MonthNavButton,
    {
      icon: /* @__PURE__ */ import_react69.default.createElement(import_react_fontawesome11.FontAwesomeIcon, { icon: import_faChevronLeft.faChevronLeft, fontSize: iconSize }),
      onClick: decreaseMonth,
      isDisabled: prevMonthButtonDisabled,
      isVisible: shouldShowPrevMonthButton,
      ariaLabel: copy_constants_default.PREVIOUS_MONTH
    }
  ), /* @__PURE__ */ import_react69.default.createElement(HeadingMedium, null, formattedMonthDate), /* @__PURE__ */ import_react69.default.createElement(
    MonthNavButton,
    {
      icon: /* @__PURE__ */ import_react69.default.createElement(
        import_react_fontawesome11.FontAwesomeIcon,
        {
          icon: import_faChevronRight3.faChevronRight,
          fontSize: iconSize
        }
      ),
      onClick: increaseMonth,
      isDisabled: nextMonthButtonDisabled,
      isVisible: shouldShowNextMonthButton,
      ariaLabel: copy_constants_default.NEXT_MONTH
    }
  ));
}
function useStyles19({ isInline }) {
  return componentStyles({
    root: {
      marginBottom: isInline ? 4 : 0
    }
  });
}

// src/components/calendar-date-picker/react-datepicker-container.tsx
var import_styled = __toESM(require("@emotion/styled"));
var import_react_datepicker = require("react-datepicker/dist/react-datepicker.css");
var react_datepicker_container_default = import_styled.default.div`
    --mb-selected-text-color: white;
    --mb-selected-bg-color: var(--chakra-colors-brand-400);
    --mb-bg-color: var(--chakra-colors-chakra-body-bg);
    --mb-border-color: var(--chakra-colors-chakra-border-color);
    --mb-text-color: var(--chakra-colors-chakra-body-text);
    --mb-border-radius: var(--chakra-radii-md);

    /* White contrasts well for both light and dark mode */
    @media (prefers-color-scheme: dark) {
        --mb-selected-bg-color: var(--chakra-colors-brand-200);
    }

    /* This is close to the original radius */

    .calendar-date-picker {
        font-family: "Nunito Sans", sans-serif;
        width: 100%;
        color: inherit;
        background-color: transparent;
        border: 0px;
        display: grid;
        grid-column-gap: 24px;
    }

    .react-datepicker-popper .calendar-date-picker {
        border: 1px solid red;
        border-radius: 8px;
        padding: 0 8px;
        background-color: var(--mb-bg-color);
        border: 1px solid var(--mb-border-color);
        min-width: 250px;
    }

    .calendar-date-picker .react-datepicker__header {
        background-color: transparent;
        border: 0px;
    }

    @media only screen and (min-width: 480px) {
        .calendar-date-picker {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    .calendar-date-picker.single-month {
        grid-template-columns: repeat(1, 1fr);
    }

    .calendar-date-picker .react-datepicker__day-name,
    .calendar-date-picker .react-datepicker__day {
        line-height: 2.5rem;
        width: 100%;
        transition: all 0.2s;
        text-transform: uppercase;
        color: var(--mb-text-color) !important;
    }

    .calendar-date-picker .react-datepicker__month {
        margin: 0;
    }

    .calendar-date-picker .react-datepicker__week,
    .calendar-date-picker .react-datepicker__day-names {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
    }

    .calendar-date-picker .react-datepicker__day-names {
        font-weight: bold;
    }

    .calendar-date-picker .react-datepicker__day--today {
        color: var(--chakra-colors-brand-300) !important;
        font-weight: bold;
        background-color: transparent;
    }

    .calendar-date-picker .react-datepicker__day--selected,  /* Used for single date */
    .calendar-date-picker .react-datepicker__day--highlighted,
    .calendar-date-picker .react-datepicker__day--in-range,
    .calendar-date-picker .react-datepicker__day--range-start,
    .calendar-date-picker .react-datepicker__day--range-end,
    .calendar-date-picker .react-datepicker__day--in-selecting-range,
    .calendar-date-picker .react-datepicker__day:hover,
    /* Ensure today's date is white when it's in the selecting range */
    .calendar-date-picker
        .react-datepicker__day--today.react-datepicker__day--in-selecting-range {
        font-weight: bold;
        color: var(--mb-selected-text-color) !important;
        background-color: var(--mb-selected-bg-color);
    }

    /* Outside of month and disabled */

    .calendar-date-picker .react-datepicker__day--outside-month,
    .calendar-date-picker .react-datepicker__day--disabled {
        opacity: 0.3;
    }

    .calendar-date-picker .react-datepicker__day--disabled {
        cursor: not-allowed;
        text-decoration: line-through;
    }

    /* Selected range */

    .calendar-date-picker .react-datepicker__day--in-selecting-range,
    .calendar-date-picker .react-datepicker__day:hover {
        background-color: var(--mb-selected-bg-color);
    }

    .calendar-date-picker .react-datepicker__day--outside-month {
        pointer-events: none;
        background-color: transparent;
    }

    .react-datepicker-wrapper {
        width: 100%;
    }

    .calendar-date-picker .react-datepicker__triangle {
        display: none;
    }

    .calendar-date-picker .react-datepicker__day--in-range,
    .calendar-date-picker .react-datepicker__day--in-selecting-range {
        border-radius: 0;
    }

    /* Border radius */

    .calendar-date-picker .react-datepicker__day--range-start,
    .calendar-date-picker .react-datepicker__day--selecting-range-start {
        border-top-left-radius: var(--mb-border-radius);
        border-bottom-left-radius: var(--mb-border-radius);
    }

    .calendar-date-picker .react-datepicker__day--range-end,
    .calendar-date-picker .react-datepicker__day--selecting-range-end {
        border-top-right-radius: var(--mb-border-radius);
        border-bottom-right-radius: var(--mb-border-radius);
    }
`;

// src/components/calendar-date-picker/calendar-date-picker.tsx
function CalendarDatePicker({
  style,
  isInline = true,
  selectedDate,
  onChange,
  highlightDates,
  filterDate,
  isSingleMonth = false,
  minDate,
  maxDate,
  startDate,
  endDate,
  isMulti,
  onMonthChange,
  placeholder,
  openToDate,
  calendarStartDayOfWeek = 1
}) {
  const styles = useStyles20({ isInline });
  const monthsShown = isSingleMonth ? 1 : 2;
  return /* @__PURE__ */ import_react70.default.createElement(Box, { style: { ...styles.calendarWrapper, ...style } }, /* @__PURE__ */ import_react70.default.createElement(react_datepicker_container_default, null, /* @__PURE__ */ import_react70.default.createElement(
    import_react_datepicker2.default,
    {
      disabledKeyboardNavigation: true,
      inline: isInline,
      selected: selectedDate,
      customInput: /* @__PURE__ */ import_react70.default.createElement(import_react71.Input, null),
      placeholderText: placeholder,
      onChange: (newValue) => onChange(newValue),
      highlightDates,
      filterDate,
      monthsShown: isSingleMonth ? 1 : 2,
      minDate,
      maxDate,
      startDate,
      endDate,
      selectsRange: isMulti,
      calendarStartDay: calendarStartDayOfWeek,
      calendarClassName: getCalendarClassName({ isSingleMonth }),
      onMonthChange,
      openToDate: openToDate ?? void 0,
      renderDayContents: (dayOfMonth, date) => /* @__PURE__ */ import_react70.default.createElement(
        Box,
        {
          testId: date?.toDateString(),
          style: styles.dateCell
        },
        /* @__PURE__ */ import_react70.default.createElement(Text, null, dayOfMonth)
      ),
      renderCustomHeader: (params) => /* @__PURE__ */ import_react70.default.createElement(
        CalendarDatePickerHeader,
        {
          ...params,
          monthsShown,
          isInline
        }
      )
    }
  )));
}
function useStyles20({ isInline }) {
  const colors = useColors();
  const inlineWrapperStyles = {
    paddingY: 3,
    paddingX: 4,
    borderRadius: "xl",
    border: `1px solid ${colors.border}`,
    overflow: "hidden"
  };
  const nonInlineWrapperStyles = {
    "& input:focus": {
      outlineColor: colors.brandDefault,
      outlineOffset: -1
    }
  };
  return componentStyles({
    dateCell: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    calendarWrapper: isInline ? inlineWrapperStyles : nonInlineWrapperStyles
  });
}
function getCalendarClassName({ isSingleMonth }) {
  return isSingleMonth ? "calendar-date-picker single-month" : "calendar-date-picker";
}

// src/components/external-link/external-link.tsx
var import_react72 = __toESM(require("react"));
var import_react73 = require("@chakra-ui/react");
function ExternalLink({
  id: id2,
  style,
  href,
  isUnderlined,
  rel,
  children
}) {
  const styles = useStyles21({ isUnderlined });
  return /* @__PURE__ */ import_react72.default.createElement(
    import_react73.Link,
    {
      sx: { ...styles.root, ...style },
      id: id2,
      rel,
      href,
      target: "_blank"
    },
    children
  );
}
function useStyles21({ isUnderlined }) {
  return componentStyles({
    root: { textDecoration: isUnderlined ? "underline" : "none" }
  });
}

// src/components/number-input/number-input.tsx
var import_react74 = __toESM(require("react"));
var import_react75 = require("@chakra-ui/react");
var import_react_fontawesome12 = require("@fortawesome/react-fontawesome");
var import_faMinus = require("@fortawesome/free-solid-svg-icons/faMinus");
var import_faPlus2 = require("@fortawesome/free-solid-svg-icons/faPlus");
var MIN_DEFAULT = 1;
var MAX_DEFAULT = 50;
var STEP_DEFAULT = 1;
function NumberInput({
  testId,
  style,
  value,
  onChange,
  onChangeNullable,
  min = MIN_DEFAULT,
  max = MAX_DEFAULT,
  step = STEP_DEFAULT,
  isDisabled,
  shouldShowButtons = true
}) {
  const styles = useStyles22({ shouldShowButtons });
  const { getInputProps, getIncrementButtonProps, getDecrementButtonProps } = (0, import_react75.useNumberInput)({
    min,
    max,
    step,
    isDisabled,
    onChange: (valueAsString, valueAsNumber) => {
      if (!valueAsString) {
        onChangeNullable?.(null);
        return;
      }
      onChangeNullable?.(valueAsNumber);
      onChange?.(valueAsNumber);
    }
  });
  return /* @__PURE__ */ import_react74.default.createElement(HorizontalStackSmallGap, { style: { ...styles.root, ...style } }, shouldShowButtons && /* @__PURE__ */ import_react74.default.createElement(
    import_react75.IconButton,
    {
      "aria-label": copy_constants_default.DECREMENT,
      icon: /* @__PURE__ */ import_react74.default.createElement(
        import_react_fontawesome12.FontAwesomeIcon,
        {
          icon: import_faMinus.faMinus,
          fontSize: 18 /* Medium */
        }
      ),
      sx: styles.button,
      ...getDecrementButtonProps()
    }
  ), /* @__PURE__ */ import_react74.default.createElement(
    import_react75.Input,
    {
      "data-testid": testId,
      sx: styles.input,
      ...getInputProps(),
      value: value ?? void 0
    }
  ), shouldShowButtons && /* @__PURE__ */ import_react74.default.createElement(
    import_react75.IconButton,
    {
      "aria-label": copy_constants_default.INCREMENT,
      icon: /* @__PURE__ */ import_react74.default.createElement(
        import_react_fontawesome12.FontAwesomeIcon,
        {
          icon: import_faPlus2.faPlus,
          fontSize: 18 /* Medium */
        }
      ),
      sx: styles.button,
      ...getIncrementButtonProps()
    }
  ));
}
function useStyles22({ shouldShowButtons }) {
  const colors = useColors();
  return componentStyles({
    root: {
      width: shouldShowButtons ? "200px" : "100%"
    },
    button: {
      size: "sm",
      isRound: true
    },
    input: {
      textAlign: shouldShowButtons ? "center" : "left",
      "&:focus": {
        outlineColor: colors.brandDefault,
        outlineOffset: -1
      }
    }
  });
}

// src/components/rating-input/rating-input.tsx
var import_react76 = __toESM(require("react"));
var import_react77 = require("@chakra-ui/react");
var import_lib_shared_helpers = __toESM(require_src());
var import_react_fontawesome13 = require("@fortawesome/react-fontawesome");
var import_faStar = require("@fortawesome/free-regular-svg-icons/faStar");
var import_faStar2 = require("@fortawesome/free-solid-svg-icons/faStar");
function RatingInput({
  value = 0,
  onChange,
  testId,
  style = {},
  containerStyle = {},
  numberOfStars = 5
}) {
  const styles = useStyleProps7();
  const mergedRootStyle = { ...styles.root, ...containerStyle };
  const mergedIconStyle = { ...styles.icon, ...style };
  const ratings = (0, import_lib_shared_helpers.getArrayOfCount)(numberOfStars);
  return /* @__PURE__ */ import_react76.default.createElement(import_react77.HStack, { "data-testid": testId, ...mergedRootStyle }, ratings.map((rating) => {
    const oneIndexedRating = rating + 1;
    const key = `${testId}-${oneIndexedRating}`;
    return /* @__PURE__ */ import_react76.default.createElement(
      import_react_fontawesome13.FontAwesomeIcon,
      {
        "data-testid": key,
        key,
        icon: rating < value ? import_faStar2.faStar : import_faStar.faStar,
        style: mergedIconStyle,
        onClick: () => onChange(oneIndexedRating)
      }
    );
  }));
}
function useStyleProps7() {
  const colors = useColors();
  return componentStyles({
    root: {
      spacing: 2
    },
    icon: {
      cursor: "pointer",
      color: colors.text,
      fontSize: 22
    }
  });
}

// src/components/skeleton/skeleton.tsx
var import_react79 = __toESM(require("react"));
var import_react80 = require("@chakra-ui/react");
var import_lib_shared_helpers2 = __toESM(require_src());

// src/components/conditional-render-container/conditional-render-container.tsx
var import_react78 = __toESM(require("react"));
function ConditionalRenderContainer({
  shouldRender = false,
  children,
  style
}) {
  if (!shouldRender) return null;
  return /* @__PURE__ */ import_react78.default.createElement(Box, { style }, children);
}

// src/components/skeleton/skeleton.tsx
var DEFAUT_HEIGHT = "1rem";
function Skeleton({ height, width, rows = 1 }) {
  const heightToUse = height ?? DEFAUT_HEIGHT;
  const widthToUse = width ?? void 0;
  const arr = (0, import_lib_shared_helpers2.getArrayOfCount)(rows);
  return (
    // The empty fragment is needed to prevent a ts error
    /* @__PURE__ */ import_react79.default.createElement(import_react79.default.Fragment, null, arr.map((_, index2) => /* @__PURE__ */ import_react79.default.createElement(
      import_react80.Skeleton,
      {
        "data-testid": TEST_IDS.LOADING_SKELETON,
        key: index2,
        height: heightToUse,
        width: widthToUse,
        marginBottom: "2"
      }
    )))
  );
}
function SkeletonFill() {
  return /* @__PURE__ */ import_react79.default.createElement(Skeleton, { height: "100%", width: "100%" });
}
function SkeletonFillHorizontal(props) {
  return /* @__PURE__ */ import_react79.default.createElement(Skeleton, { width: "100%", ...props });
}
function SkeletonCircle(props) {
  return /* @__PURE__ */ import_react79.default.createElement(import_react80.SkeletonCircle, { "data-testid": TEST_IDS.LOADING_SKELETON, ...props });
}
function SkeletonContainer({
  children,
  isLoaded
}) {
  return /* @__PURE__ */ import_react79.default.createElement(import_react80.Skeleton, { "data-testid": TEST_IDS.LOADING_SKELETON, isLoaded }, /* @__PURE__ */ import_react79.default.createElement(ConditionalRenderContainer, { shouldRender: isLoaded }, children));
}

// src/entity-components/add-ons-selector/add-ons-selector.tsx
var import_react91 = __toESM(require("react"));
var import_lib_shared_helpers6 = __toESM(require_src());

// src/entity-components/add-ons-selector/add-ons-selector-provider.tsx
var import_react81 = __toESM(require("react"));

// src/entity-components/add-ons-selector/add-ons-selector-helpers.ts
function useQuantitiesKeyedByAddOnId(selectedAddOns) {
  const accumulator = {};
  return selectedAddOns.reduce(
    (addOnsKeyedById, addOn) => ({
      ...addOnsKeyedById,
      [addOn.id]: addOn.quantity
    }),
    accumulator
  );
}
function useAddOnsGroupedByCategory(addOns) {
  const accumulator = {};
  return addOns.reduce((groupedAddOns, addOn) => {
    const existingInGroup = groupedAddOns[addOn.category] ?? [];
    const updatedGroup = [...existingInGroup, addOn];
    return { ...groupedAddOns, [addOn.category]: updatedGroup };
  }, accumulator);
}

// src/entity-components/add-ons-selector/add-ons-selector-provider.tsx
var AddOnsSelectorContext = (0, import_react81.createContext)({
  addOns: [],
  selectedAddOns: [],
  onQuantityChange: () => {
  },
  addButtonLabel: "",
  updateButtonLabel: "",
  quantitiesKeyedByAddOnId: {}
});
function AddOnsSelectorProvider({
  addOns,
  selectedAddOns,
  onQuantityChange,
  addButtonLabel = copy_constants_default.ADD,
  updateButtonLabel = copy_constants_default.UPDATE,
  children
}) {
  const quantitiesKeyedByAddOnId = useQuantitiesKeyedByAddOnId(selectedAddOns);
  const contextValue = (0, import_react81.useMemo)(
    () => ({
      addOns,
      selectedAddOns,
      onQuantityChange,
      addButtonLabel,
      updateButtonLabel,
      quantitiesKeyedByAddOnId
    }),
    [
      addOns,
      selectedAddOns,
      onQuantityChange,
      addButtonLabel,
      updateButtonLabel,
      quantitiesKeyedByAddOnId
    ]
  );
  return /* @__PURE__ */ import_react81.default.createElement(AddOnsSelectorContext.Provider, { value: contextValue }, children);
}
function useAddOnsSelector() {
  return (0, import_react81.useContext)(AddOnsSelectorContext);
}

// src/entity-components/add-ons-selector/add-ons-selector-add-ons-group.tsx
var import_react90 = __toESM(require("react"));

// src/entity-components/add-ons-selector/add-ons-selector-item.tsx
var import_react88 = __toESM(require("react"));
var import_react89 = require("@chakra-ui/react");
var import_faCheckCircle = require("@fortawesome/free-solid-svg-icons/faCheckCircle");
var import_react_fontawesome14 = require("@fortawesome/react-fontawesome");
var import_lib_shared_helpers5 = __toESM(require_src());

// src/components/image/image.tsx
var import_react82 = require("@chakra-ui/react");
var import_react83 = __toESM(require("react"));

// src/utils/upload-care-helpers.ts
var DEFAULT_WIDTH = 800;
function resizeUrl({
  url,
  width,
  shouldSkipResize = false,
  variant
}) {
  const modifiers = ["/"];
  if (!shouldSkipResize) {
    modifiers.push(`-/resize/${width ?? DEFAULT_WIDTH}/`);
  }
  const variantModfier = getVariant(variant);
  modifiers.push(variantModfier);
  const modifiersAsString = modifiers.join("");
  return `${url}${modifiersAsString}`;
}
function getVariant(variant) {
  switch (variant) {
    case "SM_HORIZONTAL" /* SM_HORIZONTAL */:
      return "-/scale_crop/200x120/smart_faces/";
    case "MD_HORIZONTAL" /* MD_HORIZONTAL */:
      return "-/scale_crop/500x400/smart_faces/";
    case "LG_HORIZONTAL" /* LG_HORIZONTAL */:
      return "-/scale_crop/900x700/smart_faces/";
    case "XL_HORIZONTAL" /* XL_HORIZONTAL */:
      return "-/scale_crop/1200x1000/smart_faces/";
    default:
      return "";
  }
}

// src/components/image/image.tsx
function Image({
  src,
  onLoad,
  skeletonStyles = {},
  style,
  showFallback = true,
  testId = TEST_IDS.IMAGE,
  width,
  shouldSkipUploadCareResize,
  variant,
  ...props
}) {
  const isUploadCareImage = src?.includes(UPLOAD_CARE_BASE_DOMAIN);
  const srcWithPlaceholder = src || PLACEHOLDER_IMG_SRC;
  const resizedSrc = isUploadCareImage ? resizeUrl({ url: srcWithPlaceholder, variant, width }) : srcWithPlaceholder;
  const fallback = showFallback ? /* @__PURE__ */ import_react83.default.createElement(import_react82.Skeleton, { "data-testid": TEST_IDS.IMAGE_SKELETON, ...skeletonStyles }) : void 0;
  return /* @__PURE__ */ import_react83.default.createElement(
    import_react82.Image,
    {
      "data-testid": testId,
      src: resizedSrc,
      onLoad,
      fallback,
      sx: style,
      ...props
    }
  );
}

// src/entity-components/add-ons-selector/add-ons-selector-modal.tsx
var import_react86 = __toESM(require("react"));
var import_react87 = require("@chakra-ui/react");
var import_lib_shared_helpers4 = __toESM(require_src());

// src/entity-components/add-ons-selector/add-ons-selector-modal-controls.tsx
var import_react85 = __toESM(require("react"));

// src/entity-components/add-ons-selector/add-ons-selector-modal-helper-text.tsx
var import_lib_shared_helpers3 = __toESM(require_src());
var import_react84 = __toESM(require("react"));

// src/utils/url-helpers.ts
var RESOURCES_URL = "https://resources.mallardbay.com/";
var ADD_ON_PRICING_INFO_KNOWLEDGE_PATH = "how-does-add-on-pricing-work";
function getAddOnPricingInfoUrl() {
  return `${RESOURCES_URL}${ADD_ON_PRICING_INFO_KNOWLEDGE_PATH}`;
}

// src/entity-components/add-ons-selector/add-ons-selector-modal-helper-text.tsx
function AddOnsSelectorModalHelperText({
  style,
  addOn,
  quantity
}) {
  const styles = useStyles23();
  const label = (0, import_lib_shared_helpers3.getAddOnPriceCalculationInformation)({
    priceByGuest: addOn.price_by_guest,
    priceByDay: addOn.price_by_day,
    quantity
  });
  if (!label) return null;
  return /* @__PURE__ */ import_react84.default.createElement(VerticalStack, { style: { ...styles.root, ...style } }, /* @__PURE__ */ import_react84.default.createElement(TextErrorSmall, null, label), /* @__PURE__ */ import_react84.default.createElement(TextSmall, null, copy_constants_default.ADD_ON_HELPER_TEXT_PREFIX, /* @__PURE__ */ import_react84.default.createElement(ExternalLink, { href: getAddOnPricingInfoUrl(), isUnderlined: true }, copy_constants_default.THIS_ARTICLE), copy_constants_default.PERIOD));
}
function useStyles23() {
  return componentStyles({
    root: { gap: 2 }
  });
}

// src/entity-components/add-ons-selector/add-ons-selector-modal-controls.tsx
function AddOnsSelectorModalControls({
  onClose,
  addOn
}) {
  const styles = useStyles24();
  const {
    quantitiesKeyedByAddOnId,
    onQuantityChange,
    addButtonLabel,
    updateButtonLabel
  } = useAddOnsSelector();
  const initialQuantity = quantitiesKeyedByAddOnId[addOn.id];
  const [quantity, setQuantity] = (0, import_react85.useState)(initialQuantity ?? 1);
  const onAddButtonClick = () => {
    onQuantityChange({ addOn, quantity });
    onClose();
  };
  const onRemoveButtonClick = () => {
    onQuantityChange({ addOn, quantity: 0 });
    onClose();
  };
  return /* @__PURE__ */ import_react85.default.createElement(import_react85.default.Fragment, null, /* @__PURE__ */ import_react85.default.createElement(HorizontalStackSpaceBetween, { style: styles.root }, /* @__PURE__ */ import_react85.default.createElement(NumberInput, { value: quantity, onChange: setQuantity }), /* @__PURE__ */ import_react85.default.createElement(HorizontalStack, null, Boolean(initialQuantity) && /* @__PURE__ */ import_react85.default.createElement(
    Button,
    {
      style: styles.removeButton,
      onClick: onRemoveButtonClick
    },
    copy_constants_default.REMOVE
  ), /* @__PURE__ */ import_react85.default.createElement(ButtonPrimary, { onClick: onAddButtonClick }, initialQuantity ? updateButtonLabel : addButtonLabel))), /* @__PURE__ */ import_react85.default.createElement(AddOnsSelectorModalHelperText, { addOn, quantity }));
}
function useStyles24() {
  return componentStyles({
    root: {
      flexDirection: { base: "column", sm: "row" },
      gap: { base: 5, sm: 3 }
    },
    removeButton: {
      marginLeft: "auto"
    }
  });
}

// src/entity-components/add-ons-selector/add-ons-selector-modal.tsx
var IMAGE_RATIO = IMAGE_RATIOS.FOUR_BY_THREE;
function AddOnsSelectorModal({
  isOpen,
  onClose,
  addOn,
  CustomModalComponent
}) {
  const styles = useStyles25();
  const size = (0, import_react87.useBreakpointValue)({ base: "full", sm: "lg" });
  const { priceLabel } = (0, import_lib_shared_helpers4.getPriceLabelAndSublabel)(addOn);
  const { onQuantityChange } = useAddOnsSelector();
  if (CustomModalComponent) {
    return /* @__PURE__ */ import_react86.default.createElement(
      CustomModalComponent,
      {
        addOn,
        isOpen,
        onClose,
        onQuantityChange
      }
    );
  }
  return /* @__PURE__ */ import_react86.default.createElement(
    Modal,
    {
      isOpen,
      onClose,
      title: addOn.name,
      shouldShowCloseButton: true,
      style: styles.root,
      size
    },
    /* @__PURE__ */ import_react86.default.createElement(import_react87.AspectRatio, { ratio: IMAGE_RATIO }, /* @__PURE__ */ import_react86.default.createElement(Image, { src: addOn.images?.[0], alt: addOn.name })),
    /* @__PURE__ */ import_react86.default.createElement(VerticalStack, { style: styles.content }, addOn.description && /* @__PURE__ */ import_react86.default.createElement(Text, null, addOn.description), /* @__PURE__ */ import_react86.default.createElement(TextBoldLarge, null, priceLabel), /* @__PURE__ */ import_react86.default.createElement(AddOnsSelectorModalControls, { onClose, addOn }))
  );
}
function useStyles25() {
  return componentStyles({
    root: {
      marginTop: 0,
      paddingTop: 0,
      textAlign: { base: "center", sm: "left" }
    },
    content: {
      padding: 6,
      alignItems: "stretch"
    }
  });
}

// src/entity-components/add-ons-selector/add-ons-selector-item.tsx
function AddOnsSelectorItem({
  style,
  addOn,
  shouldHideBottomBorder,
  CustomModalComponent
}) {
  const { isOpen, onClose, onOpen } = (0, import_react89.useDisclosure)();
  const { quantitiesKeyedByAddOnId } = useAddOnsSelector();
  const { priceLabel, priceSublabel } = (0, import_lib_shared_helpers5.getPriceLabelAndSublabel)(addOn);
  const styles = useStyles26({ shouldHideBottomBorder });
  const buttonSize = (0, import_react89.useBreakpointValue)({ base: "sm", sm: "md" });
  const quantity = quantitiesKeyedByAddOnId[addOn.id];
  const buttonLabel = quantity ? copy_constants_default.UPDATE : copy_constants_default.SELECT;
  const buttonIcon = quantity ? /* @__PURE__ */ import_react88.default.createElement(import_react_fontawesome14.FontAwesomeIcon, { icon: import_faCheckCircle.faCheckCircle }) : void 0;
  return /* @__PURE__ */ import_react88.default.createElement(Box, { style: { ...styles.root, ...style }, onClick: onOpen }, /* @__PURE__ */ import_react88.default.createElement(
    Image,
    {
      style: styles.image,
      src: addOn.images?.[0],
      alt: addOn.name
    }
  ), /* @__PURE__ */ import_react88.default.createElement(Box, { style: styles.descriptionContainer }, /* @__PURE__ */ import_react88.default.createElement(TextBold, null, addOn.name), /* @__PURE__ */ import_react88.default.createElement(TextSecondarySmall, null, priceSublabel)), /* @__PURE__ */ import_react88.default.createElement(HorizontalStack, { style: styles.priceAndButton }, /* @__PURE__ */ import_react88.default.createElement(TextBold, null, priceLabel), /* @__PURE__ */ import_react88.default.createElement(
    ButtonPrimary,
    {
      variant: "outline",
      leftIcon: buttonIcon,
      size: buttonSize
    },
    buttonLabel
  )), /* @__PURE__ */ import_react88.default.createElement(
    AddOnsSelectorModal,
    {
      isOpen,
      onClose,
      addOn,
      CustomModalComponent
    }
  ));
}
function useStyles26({
  shouldHideBottomBorder
}) {
  const colors = useColors();
  return componentStyles({
    root: {
      cursor: "pointer",
      alignSelf: "stretch",
      display: "flex",
      alignItems: "center",
      gap: 6,
      paddingBottom: shouldHideBottomBorder ? 0 : 5,
      borderBottom: shouldHideBottomBorder ? "none" : `1px solid ${colors.border}`
    },
    image: {
      objectFit: "cover",
      objectPosition: "center",
      width: "60px",
      height: "50px",
      borderRadius: "md"
    },
    descriptionContainer: {
      flex: 1
    },
    priceAndButton: {
      flexDirection: { base: "column-reverse", sm: "row" },
      alignItems: { base: "flex-end", sm: "center" },
      gap: { base: 2, sm: 5 }
    }
  });
}

// src/entity-components/add-ons-selector/add-ons-selector-add-ons-group.tsx
var CATEGORY_TO_TITLE_MAP = {
  ["GUN_RENTAL" /* GunRental */]: copy_constants_default.GEAR_RENTALS,
  ["MEAL_UPGRADE" /* MealUpgrade */]: copy_constants_default.MEAL_UPGRADES,
  ["TROPHY" /* Trophy */]: copy_constants_default.TROPHIES,
  ["OTHER" /* Other */]: copy_constants_default.OTHERS
};
function AddOnsSelectorAddOnsGroup({
  style,
  addOns = [],
  category,
  CustomModalComponent
}) {
  const styles = useStyles27();
  const title = CATEGORY_TO_TITLE_MAP[category];
  return /* @__PURE__ */ import_react90.default.createElement(Box, { style: { ...styles.root, ...style } }, /* @__PURE__ */ import_react90.default.createElement(TextBoldLarge, { style: styles.title }, title), /* @__PURE__ */ import_react90.default.createElement(VerticalStack, { style: styles.addOnsList }, addOns.map((addOn, idx) => /* @__PURE__ */ import_react90.default.createElement(
    AddOnsSelectorItem,
    {
      key: addOn.id,
      addOn,
      shouldHideBottomBorder: idx === addOns.length - 1,
      CustomModalComponent
    }
  ))));
}
function useStyles27() {
  const colors = useColors();
  return componentStyles({
    root: { width: "100%" },
    title: {
      borderBottom: `1px solid ${colors.border}`,
      marginBottom: 5,
      paddingBottom: 1
    },
    addOnsList: { gap: 5 }
  });
}

// src/entity-components/add-ons-selector/add-ons-selector.tsx
function AddOnsSelector({
  style,
  addOns,
  selectedAddOns,
  onQuantityChange,
  addButtonLabel,
  updateButtonLabel,
  CustomModalComponent
}) {
  const styles = useStyles28();
  const addOnsGroupedByCategory = useAddOnsGroupedByCategory(addOns);
  const categories = (0, import_lib_shared_helpers6.sortCategories)(Object.keys(addOnsGroupedByCategory));
  return /* @__PURE__ */ import_react91.default.createElement(
    AddOnsSelectorProvider,
    {
      addOns,
      selectedAddOns,
      onQuantityChange: (newValue) => (
        // The generic AddOnType can't be passed through the provider. Need to cast here
        // so this gets called with the same fragment type the parent component passed in.
        onQuantityChange?.(newValue)
      ),
      addButtonLabel,
      updateButtonLabel
    },
    /* @__PURE__ */ import_react91.default.createElement(VerticalStack, { style: { ...styles.groupsContainer, ...style } }, categories.map((category) => /* @__PURE__ */ import_react91.default.createElement(
      AddOnsSelectorAddOnsGroup,
      {
        key: category,
        addOns: addOnsGroupedByCategory[category],
        category,
        CustomModalComponent
      }
    )))
  );
}
function useStyles28() {
  return componentStyles({
    root: { gap: 5 },
    groupsContainer: { gap: 6 }
  });
}

// src/entity-components/included-add-ons/included-add-ons.tsx
var import_react93 = __toESM(require("react"));

// src/entity-components/included-add-ons/included-add-ons-item.tsx
var import_react92 = __toESM(require("react"));
var import_react_fontawesome15 = require("@fortawesome/react-fontawesome");
function IncludedAddOnsItem({
  style,
  title,
  items,
  icon
}) {
  const styles = useStyles29();
  return /* @__PURE__ */ import_react92.default.createElement(Card, { style: { ...styles.root, ...style } }, /* @__PURE__ */ import_react92.default.createElement(HorizontalStack, { style: styles.header }, /* @__PURE__ */ import_react92.default.createElement(import_react_fontawesome15.FontAwesomeIcon, { icon, fontSize: 18 /* Medium */ }), /* @__PURE__ */ import_react92.default.createElement(TextBold, null, title)), /* @__PURE__ */ import_react92.default.createElement(Text, { style: styles.description }, items.join(", ")));
}
function useStyles29() {
  return componentStyles({
    root: {
      backgroundColor: "none",
      gap: 3
    },
    header: {
      textTransform: "uppercase"
    },
    description: {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis"
    }
  });
}

// src/entity-components/included-add-ons/included-add-ons-helpers.tsx
var import_faCirclePlus = require("@fortawesome/free-solid-svg-icons/faCirclePlus");
var import_faLocationCrosshairs = require("@fortawesome/free-solid-svg-icons/faLocationCrosshairs");
var import_faTrophy = require("@fortawesome/free-solid-svg-icons/faTrophy");
var import_faUtensils = require("@fortawesome/free-solid-svg-icons/faUtensils");
function useIncludedAddOnItems({
  trophyAddOns,
  gearRentalAddOns,
  mealUpgradeAddOns,
  otherAddOns
}) {
  return [
    {
      title: copy_constants_default.TROPHIES,
      items: mapAddOnsToNamesList(trophyAddOns),
      icon: import_faTrophy.faTrophy
    },
    {
      title: copy_constants_default.GEAR_RENTALS,
      items: mapAddOnsToNamesList(gearRentalAddOns),
      icon: import_faLocationCrosshairs.faLocationCrosshairs
    },
    {
      title: copy_constants_default.MEALS,
      items: mapAddOnsToNamesList(mealUpgradeAddOns),
      icon: import_faUtensils.faUtensils
    },
    {
      title: copy_constants_default.OTHER_ADD_ONS,
      items: mapAddOnsToNamesList(otherAddOns),
      icon: import_faCirclePlus.faCirclePlus
    }
  ].filter((addOn) => addOn.items.length > 0);
}
function mapAddOnsToNamesList(addOns) {
  return addOns.map(({ name }) => name);
}

// src/entity-components/included-add-ons/included-add-ons.tsx
function IncludedAddOns({
  style,
  title = copy_constants_default.INCLUDED_ADD_ONS_LABEL,
  trophyAddOns,
  gearRentalAddOns,
  mealUpgradeAddOns,
  otherAddOns
}) {
  const styles = useStyles30();
  const allAddons = useIncludedAddOnItems({
    trophyAddOns,
    gearRentalAddOns,
    mealUpgradeAddOns,
    otherAddOns
  });
  return /* @__PURE__ */ import_react93.default.createElement(VerticalStack, { style: { ...styles.root, ...style } }, /* @__PURE__ */ import_react93.default.createElement(TextBoldLarge, null, title), /* @__PURE__ */ import_react93.default.createElement(
    ConditionalRenderContainer,
    {
      style: styles.grid,
      shouldRender: Boolean(allAddons.length)
    },
    allAddons.map((addOn) => /* @__PURE__ */ import_react93.default.createElement(
      IncludedAddOnsItem,
      {
        key: addOn.title,
        title: addOn.title,
        items: addOn.items,
        icon: addOn.icon
      }
    ))
  ), /* @__PURE__ */ import_react93.default.createElement(ConditionalRenderContainer, { shouldRender: !allAddons.length }, /* @__PURE__ */ import_react93.default.createElement(TextSecondary, null, copy_constants_default.NO_INCLUDED_ADD_ONS)));
}
function useStyles30() {
  return componentStyles({
    root: {
      alignItems: "stretch",
      gap: 3
    },
    grid: {
      display: "grid",
      gridGap: 4,
      gridTemplateColumns: {
        base: "1fr",
        sm: "repeat(2, 1fr)",
        lg: "repeat(3, 1fr)"
      }
    }
  });
}

// src/entity-components/checkout-dates-preview/checkout-dates-preview.tsx
var import_react98 = __toESM(require("react"));

// src/utils/formatting-helpers.ts
var import_pluralize = __toESM(require("pluralize"));
var DEFAULT_SHORT_DATE_NO_YEAR_FORMAT = "MMM d";
function pluralize(count, noun) {
  const pluralizedNoun = (0, import_pluralize.default)(noun, count);
  return `${count} ${pluralizedNoun}`;
}
function formatPrice(price, shouldHideZeroCents = true) {
  const formattedPrice = centsToDollars(price).toLocaleString(void 0, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const trimmedPrice = shouldHideZeroCents ? formattedPrice.replace(".00", "") : formattedPrice;
  return `$${trimmedPrice}`;
}
function getCleanEnum(enumValue) {
  return enumValue.replace(/_/g, " ").split(" ").map((str) => str.charAt(0) + str.slice(1).toLowerCase()).join(" ");
}
function centsToDollars(cents) {
  return cents / 100;
}

// src/entity-components/checkout-dates-preview/clear-dates-button.tsx
var import_react94 = __toESM(require("react"));
var import_react_fontawesome16 = require("@fortawesome/react-fontawesome");
var import_faXmarkCircle = require("@fortawesome/free-solid-svg-icons/faXmarkCircle");
function ClearDatesButton({
  isDisabled,
  onClick
}) {
  const styles = useStyles31();
  return /* @__PURE__ */ import_react94.default.createElement(Box, { style: styles.buttonWrapper }, /* @__PURE__ */ import_react94.default.createElement(
    MediumIconButton,
    {
      ariaLabel: copy_constants_default.CLEAR_DATES,
      isDisabled,
      onClick,
      icon: /* @__PURE__ */ import_react94.default.createElement(import_react_fontawesome16.FontAwesomeIcon, { icon: import_faXmarkCircle.faXmarkCircle }),
      style: styles.smClearButton
    }
  ), /* @__PURE__ */ import_react94.default.createElement(
    Button,
    {
      disabled: isDisabled,
      onClick,
      rightIcon: /* @__PURE__ */ import_react94.default.createElement(import_react_fontawesome16.FontAwesomeIcon, { icon: import_faXmarkCircle.faXmarkCircle }),
      style: styles.fullClearButton
    },
    copy_constants_default.CLEAR_DATES
  ));
}
function useStyles31() {
  return {
    smClearButton: {
      display: { base: "none", md: "flex" },
      backgroundColor: "transparent",
      ":hover": {
        backgroundColor: "transparent"
      }
    },
    fullClearButton: {
      display: { base: "flex", md: "none" },
      backgroundColor: "transparent"
    },
    buttonWrapper: {
      margin: "auto",
      paddingBottom: { base: 1, md: 0 },
      paddingRight: { base: 0, md: "10px" }
    }
  };
}

// src/entity-components/checkout-dates-preview/check-in-item.tsx
var import_react95 = __toESM(require("react"));
function CheckInItem({ item, isLoading }) {
  const styles = useStyles32();
  const { title, label, helperText } = getTextDisplays(item);
  if (isLoading) {
    return /* @__PURE__ */ import_react95.default.createElement(HorizontalStackSpaceBetween, { style: styles.container }, /* @__PURE__ */ import_react95.default.createElement(Skeleton, { width: "80px", height: "24px", rows: 2 }));
  }
  return /* @__PURE__ */ import_react95.default.createElement(HorizontalStackSpaceBetween, { style: styles.container }, /* @__PURE__ */ import_react95.default.createElement(TextBold, null, title), /* @__PURE__ */ import_react95.default.createElement(Tooltip, { label: helperText }, label));
}
function getTextDisplays(item) {
  const helperText = item?.helper_text ?? "";
  const hasTooltipText = Boolean(helperText);
  const title = item?.title ?? "";
  const itemLabel = item?.label ?? "";
  const label = hasTooltipText ? copy_constants_default.TBD : itemLabel;
  return { title, label, helperText };
}
function useStyles32() {
  return componentStyles({
    container: { width: "100%" }
  });
}

// src/entity-components/checkout-dates-preview/trip-date-item.tsx
var import_react97 = __toESM(require("react"));

// src/entity-components/checkout-dates-preview/date-value.tsx
var import_date_fns2 = require("date-fns");
var import_react96 = __toESM(require("react"));
function DateValue({
  date,
  noDatesCopy = copy_constants_default.SELECT_DATES
}) {
  const TextComponent = date ? Text : TextNote;
  return /* @__PURE__ */ import_react96.default.createElement(TextComponent, null, formatDateText({ date, noDatesCopy }));
}
function formatDateText({
  date,
  noDatesCopy
}) {
  return date ? (0, import_date_fns2.format)(date, DEFAULT_SHORT_DATE_NO_YEAR_FORMAT) : noDatesCopy;
}

// src/entity-components/checkout-dates-preview/trip-date-item.tsx
function TripDateItem({ label, date, noDatesCopy }) {
  const styles = useStyles33();
  return /* @__PURE__ */ import_react97.default.createElement(HorizontalStackSpaceBetween, { style: styles.root }, /* @__PURE__ */ import_react97.default.createElement(TextBold, null, label), /* @__PURE__ */ import_react97.default.createElement(DateValue, { date, noDatesCopy }));
}
function useStyles33() {
  return componentStyles({
    root: { width: "100%" }
  });
}

// src/entity-components/checkout-dates-preview/checkout-dates-preview.tsx
function CheckoutDatesPreview({
  dates,
  checkInItineraryItem,
  checkOutItineraryItem,
  onChange,
  listingType,
  isLoading = false,
  hasItinerary = true,
  noDatesCopy
}) {
  const styles = useStyles34({ hasItinerary });
  const isClearButtonDisabled = dates.length === 0;
  const lastDate = dates[dates.length - 1];
  const isLoadingData = hasItinerary && isLoading;
  return /* @__PURE__ */ import_react98.default.createElement(Box, { style: styles.outerStyle }, /* @__PURE__ */ import_react98.default.createElement(Box, { style: styles.dateWrapper }, /* @__PURE__ */ import_react98.default.createElement(
    TripDateItem,
    {
      label: getTripLabel(listingType),
      date: dates[0],
      noDatesCopy
    }
  ), /* @__PURE__ */ import_react98.default.createElement(
    CheckInItem,
    {
      item: checkInItineraryItem,
      isLoading: isLoadingData
    }
  )), /* @__PURE__ */ import_react98.default.createElement(Box, { style: styles.divider }), /* @__PURE__ */ import_react98.default.createElement(Box, { style: styles.dateWrapper }, /* @__PURE__ */ import_react98.default.createElement(
    TripDateItem,
    {
      label: getTripLabel(listingType, true),
      date: lastDate,
      noDatesCopy
    }
  ), /* @__PURE__ */ import_react98.default.createElement(
    CheckInItem,
    {
      item: checkOutItineraryItem,
      isLoading: isLoadingData
    }
  )), onChange && /* @__PURE__ */ import_react98.default.createElement(
    ClearDatesButton,
    {
      isDisabled: isClearButtonDisabled,
      onClick: () => onChange([])
    }
  ));
}
function getTripLabel(listingType, isEnding = false) {
  const endsOrStartsText = isEnding ? copy_constants_default.ENDS : copy_constants_default.STARTS;
  return `${getListingTypeLabel(listingType)} ${endsOrStartsText}`;
}
function getListingTypeLabel(listingType) {
  switch (listingType) {
    case "HUNTING" /* Hunting */:
    case "FISHING" /* Fishing */:
    case "BLAST_CAST" /* BlastCast */:
      return getCleanEnum(listingType);
    default:
      return copy_constants_default.TRIP;
  }
}
function useStyles34({ hasItinerary }) {
  const colors = useColors();
  return componentStyles({
    outerStyle: {
      width: "100%",
      display: "flex",
      flexDirection: { base: "column", md: "row" },
      justifyContent: "center",
      boxSizing: "border-box",
      borderRadius: "xl",
      border: `1px solid ${colors.border}`,
      minHeight: hasItinerary ? "70px" : "30px"
    },
    divider: {
      minWidth: "1px",
      minHeight: "1px",
      backgroundColor: colors.border
    },
    dateWrapper: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      padding: "5px 15px",
      alignItems: "flex-start",
      justifyContent: "center",
      marginY: { base: 1, md: 0 }
    }
  });
}

// src/entity-components/number-of-guests-input/number-of-guests-input.tsx
var import_react100 = __toESM(require("react"));

// src/entity-components/number-of-guests-input/number-of-guests-input-label.tsx
var import_react99 = __toESM(require("react"));
function NumberOfGuestsInputLabel({
  label,
  minGuests,
  maxGuests,
  shouldHideMaxHelpText,
  labelStyle
}) {
  const minHelpText = `${copy_constants_default.MINIMUM} ${minGuests}`;
  const maxHelpText = `${copy_constants_default.MAXIMUM} ${maxGuests}`;
  return /* @__PURE__ */ import_react99.default.createElement(Box, null, /* @__PURE__ */ import_react99.default.createElement(TextBoldLarge, { style: labelStyle }, label), /* @__PURE__ */ import_react99.default.createElement(HorizontalStackSmallGap, null, /* @__PURE__ */ import_react99.default.createElement(
    TextSecondarySmall,
    {
      "data-testid": TEST_IDS.NUMBER_OF_GUESTS_HELP_LABEL
    },
    minHelpText
  ), !shouldHideMaxHelpText && /* @__PURE__ */ import_react99.default.createElement(import_react99.default.Fragment, null, /* @__PURE__ */ import_react99.default.createElement(Text, null, "\xB7"), /* @__PURE__ */ import_react99.default.createElement(
    TextSecondarySmall,
    {
      "data-testid": TEST_IDS.NUMBER_OF_GUESTS_HELP_LABEL
    },
    maxHelpText
  ))));
}

// src/utils/entity-helpers.ts
function isPricingPerDay(entity) {
  return entity?.price_by_day === "PER_DAY" /* PerDay */;
}
function isPricingPerGuest(entity) {
  return entity?.price_by_guest === "PER_GUEST" /* PerGuest */;
}
function isPricingSetGuest(entity) {
  return entity?.price_by_guest === "SET_GUEST" /* SetGuest */;
}
function getPriceUnit(entity) {
  const isPerGuest = isPricingPerGuest(entity);
  const isPerDay = isPricingPerDay(entity);
  const dayUnit = isPerDay ? `/ ${copy_constants_default.DAY}` : "";
  const guestUnit = isPerGuest ? `/ ${copy_constants_default.GUEST}` : "";
  if (dayUnit && guestUnit) return `${dayUnit} ${guestUnit}`;
  if (!dayUnit && !guestUnit) return "";
  return dayUnit || guestUnit;
}

// src/entity-components/number-of-guests-input/number-of-guests-input.tsx
function NumberOfGuestsInput({
  style,
  labelStyle,
  pricingPackage,
  label = copy_constants_default.NUMBER_OF_GUESTS,
  value,
  onChange,
  onChangeNullable,
  isDisabled,
  shouldAlwaysRenderIfNoPricingPackage
}) {
  const styles = useStyles35();
  const shouldRender = shouldAlwaysRenderIfNoPricingPackage || !!pricingPackage;
  if (!shouldRender) {
    return null;
  }
  const { minGuests, maxGuests } = getMinAndMaxGuests({
    pricingPackage,
    noMaxGuests: !pricingPackage && shouldAlwaysRenderIfNoPricingPackage
  });
  const isPerGuest = isPricingPerGuest(pricingPackage);
  const setGuestLabel = `${copy_constants_default.PACKAGE_INCLUDES} ${pricingPackage?.guests_included} ${copy_constants_default.TOTAL_GUESTS}`;
  const shouldDisplayInput = isPerGuest || shouldAlwaysRenderIfNoPricingPackage && !pricingPackage;
  const shouldDisplayLabel = isPerGuest || !pricingPackage;
  return /* @__PURE__ */ import_react100.default.createElement(Box, { style: { ...styles.root, ...style } }, shouldDisplayLabel ? /* @__PURE__ */ import_react100.default.createElement(
    NumberOfGuestsInputLabel,
    {
      label,
      minGuests,
      maxGuests,
      shouldHideMaxHelpText: !pricingPackage,
      labelStyle
    }
  ) : /* @__PURE__ */ import_react100.default.createElement(TextBoldLarge, null, setGuestLabel), shouldDisplayInput && /* @__PURE__ */ import_react100.default.createElement(
    NumberInput,
    {
      testId: TEST_IDS.NUMBER_OF_GUESTS_INPUT,
      value,
      onChange,
      onChangeNullable,
      min: minGuests,
      max: maxGuests,
      isDisabled
    }
  ));
}
function useStyles35() {
  return componentStyles({
    root: {
      display: "flex",
      flexDirection: { base: "column", sm: "row" },
      justifyContent: { base: "flex-start", sm: "space-between" },
      alignItems: { base: "flex-start", sm: "center" },
      gap: 2
    }
  });
}
function getMinAndMaxGuests({
  pricingPackage,
  noMaxGuests
}) {
  const isSetGuest = isPricingSetGuest(pricingPackage);
  const minGuests = isSetGuest ? pricingPackage?.guests_included : pricingPackage?.min_guests;
  const maxGuests = getMaxGuests({
    isSetGuest,
    pricingPackage,
    noMaxGuests
  });
  return { minGuests: minGuests ?? 1, maxGuests: maxGuests ?? 1 };
}
function getMaxGuests({
  isSetGuest,
  pricingPackage,
  noMaxGuests
}) {
  if (noMaxGuests) return 100;
  return isSetGuest ? pricingPackage?.guests_included : pricingPackage?.max_guests;
}

// src/entity-components/pricing-package-selector/pricing-package-selector.tsx
var import_react103 = __toESM(require("react"));

// src/entity-components/pricing-package-selector/pricing-package-selector-option.tsx
var import_react102 = __toESM(require("react"));

// src/entity-components/pricing-package-selector/pricing-package-add-on-tags.tsx
var import_react101 = __toESM(require("react"));
var import_faHome = require("@fortawesome/free-solid-svg-icons/faHome");
var import_faLocationCrosshairs2 = require("@fortawesome/free-solid-svg-icons/faLocationCrosshairs");
var import_faTrophy2 = require("@fortawesome/free-solid-svg-icons/faTrophy");
var import_faUtensils2 = require("@fortawesome/free-solid-svg-icons/faUtensils");
var import_faPlus3 = require("@fortawesome/free-solid-svg-icons/faPlus");
function PricingPackageAddOnTags({
  addOnNames,
  isDisabled
}) {
  if (!addOnNames.length) return null;
  const tagConfigs = getTagConfigs(addOnNames);
  return /* @__PURE__ */ import_react101.default.createElement(TagList, { tagConfigs, isDisabled });
}
function getTagConfigs(addOnNames) {
  return addOnNames.map((name) => ({ icon: getIcon2(name), name }));
}
function getIcon2(addOnName) {
  switch (addOnName) {
    case copy_constants_default.LODGING:
      return import_faHome.faHome;
    case copy_constants_default.TROPHIES:
      return import_faTrophy2.faTrophy;
    case copy_constants_default.MEALS:
      return import_faUtensils2.faUtensils;
    case copy_constants_default.GEAR_RENTALS:
      return import_faLocationCrosshairs2.faLocationCrosshairs;
    default:
      return import_faPlus3.faPlus;
  }
}

// src/entity-components/pricing-package-selector/pricing-package-selector-helpers.ts
function getSelectOptionGroups({
  pricingPackages,
  hasAvailability,
  selectedPricingPackage
}) {
  const options = mapPricingPackagesToSelectOptions({
    pricingPackages,
    hasAvailability,
    selectedPricingPackage
  });
  const groupOptions = options.filter(
    (option) => isPricingSetGuest(option.value)
  );
  const individualOptions = options.filter(
    (option) => isPricingPerGuest(option.value)
  );
  return [
    {
      title: copy_constants_default.GROUP_PACKAGES,
      options: groupOptions
    },
    {
      title: copy_constants_default.INDIVIDUAL_PACKAGES,
      options: individualOptions
    }
  ];
}
function getAddOnNames(pricingPackage) {
  const addOnNames = [];
  if (pricingPackage.lodging_included) addOnNames.push(copy_constants_default.LODGING);
  if (pricingPackage.trophies.length) addOnNames.push(copy_constants_default.TROPHIES);
  if (pricingPackage.gear_rentals.length) addOnNames.push(copy_constants_default.GEAR_RENTALS);
  if (pricingPackage.meal_upgrades.length) addOnNames.push(copy_constants_default.MEALS);
  if (pricingPackage.other_add_ons.length) {
    const otherCount = pricingPackage.other_add_ons.length;
    addOnNames.push(pluralize(otherCount, copy_constants_default.ADD_ON));
  }
  return addOnNames;
}
function getGuestsLabel(pricingPackage) {
  const isPerGuest = isPricingPerGuest(pricingPackage);
  const prefix = isPerGuest ? copy_constants_default.MAXIMUM : copy_constants_default.UP_TO;
  const guestsCount = isPerGuest ? pricingPackage.max_guests : pricingPackage.guests_included;
  const suffix = pluralize(guestsCount ?? 1, copy_constants_default.GUEST);
  return `${prefix} ${suffix}`;
}
function getDaysLabel(pricingPackage) {
  if (isPricingPerDay(pricingPackage)) return "";
  return `${pricingPackage.days_included} ${copy_constants_default.DAY_TRIP}`;
}
function mapPricingPackagesToSelectOptions({
  pricingPackages,
  hasAvailability,
  selectedPricingPackage
}) {
  return pricingPackages.map((pricingPackage) => {
    const { isDisabled, tooltip } = getDisabledTooltipInfo({
      pricingPackage,
      hasAvailability
    });
    return {
      value: pricingPackage,
      isSelected: pricingPackage.id === selectedPricingPackage?.id,
      isDisabled,
      disabledTooltip: tooltip
    };
  });
}
function getDisabledTooltipInfo({
  pricingPackage,
  hasAvailability = true
}) {
  const isDisabled = !pricingPackage.is_available || !hasAvailability;
  const tooltip = hasAvailability ? pricingPackage.not_available_reason : copy_constants_default.LISTING_HAS_NO_AVAILABILITY;
  return { isDisabled, tooltip };
}

// src/entity-components/pricing-package-selector/pricing-package-selector-option.tsx
function PricingPackageSelectorOption({
  pricingPackage,
  isDisabled
}) {
  const styles = useStyles36();
  const addOnNames = getAddOnNames(pricingPackage);
  const guestsLabel = getGuestsLabel(pricingPackage);
  const daysLabel = getDaysLabel(pricingPackage);
  const priceUnit = getPriceUnit(pricingPackage);
  return /* @__PURE__ */ import_react102.default.createElement(import_react102.default.Fragment, null, /* @__PURE__ */ import_react102.default.createElement(
    Box,
    {
      style: styles.header,
      "data-testid": TEST_IDS.PRICING_PACKAGE_SELECTOR_OPTION
    },
    /* @__PURE__ */ import_react102.default.createElement(TextBold, null, pricingPackage.name),
    /* @__PURE__ */ import_react102.default.createElement(HorizontalStackSmallGap, null, /* @__PURE__ */ import_react102.default.createElement(TextSecondarySmall, null, guestsLabel), daysLabel && /* @__PURE__ */ import_react102.default.createElement(TextSecondarySmall, null, "\u2022"), /* @__PURE__ */ import_react102.default.createElement(TextSecondarySmall, null, daysLabel))
  ), /* @__PURE__ */ import_react102.default.createElement(HorizontalStack, null, /* @__PURE__ */ import_react102.default.createElement(
    PricingPackageAddOnTags,
    {
      addOnNames,
      isDisabled
    }
  ), /* @__PURE__ */ import_react102.default.createElement(HorizontalStackSmallGap, { style: styles.priceContainer }, /* @__PURE__ */ import_react102.default.createElement(TextBoldLarge, null, formatPrice(pricingPackage.price)), priceUnit && /* @__PURE__ */ import_react102.default.createElement(TextSecondarySmall, null, priceUnit))));
}
function useStyles36() {
  return componentStyles({
    header: { marginBottom: 3 },
    priceContainer: { marginLeft: "auto" }
  });
}

// src/entity-components/pricing-package-selector/pricing-package-selector.tsx
function PricingPackageSelector({
  style,
  pricingPackages,
  selectedPricingPackage,
  hasAvailability,
  onSelect
}) {
  const selectOptionGroups = getSelectOptionGroups({
    pricingPackages,
    hasAvailability,
    selectedPricingPackage
  });
  return /* @__PURE__ */ import_react103.default.createElement(
    CardSelect,
    {
      style,
      optionGroups: selectOptionGroups,
      onSelect: (option) => onSelect(option.value),
      renderOption: (option) => /* @__PURE__ */ import_react103.default.createElement(
        PricingPackageSelectorOption,
        {
          pricingPackage: option.value,
          isDisabled: option.isDisabled
        }
      )
    }
  );
}

// src/entity-components/trip-calendar-date-picker/trip-calendar-date-picker.tsx
var import_react104 = __toESM(require("react"));
var import_lib_shared_helpers8 = __toESM(require_src());

// src/entity-components/trip-calendar-date-picker/trip-calendar-date-picker-helpers.tsx
var import_date_fns3 = require("date-fns");
var import_lib_shared_helpers7 = __toESM(require_src());
function getItineraryCheckInItems(itinerary) {
  const checkInItem = itinerary?.items.find(
    (item) => item.type === "CHECK_IN" /* CheckIn */
  );
  const checkOutItem = itinerary?.items.find(
    (item) => item.type === "CHECK_OUT" /* CheckOut */
  );
  return { checkInItem, checkOutItem };
}
function filterDatesByAvailability({
  isDisabled,
  dates,
  availableDates,
  isPricingPackageSetDay,
  highlightedDates
}) {
  return (dt) => {
    if (isDisabled) {
      return dates.includes(dt);
    }
    const availDates = isPricingPackageSetDay ? highlightedDates : availableDates;
    const firstSelDt = dates[0] ?? dt;
    const [start, end] = [firstSelDt, dt].sort(import_date_fns3.compareAsc);
    const interval = { start, end };
    const isDateAvailable = availableDates.some(
      (date) => (0, import_date_fns3.isSameDay)(date, dt)
    );
    if (dates[0] && dates[1]) {
      return isDateAvailable;
    }
    return (0, import_lib_shared_helpers7.hasConsecutiveAvailability)(interval, availDates);
  };
}

// src/entity-components/trip-calendar-date-picker/trip-calendar-date-picker.tsx
function TripCalendarDatePicker({
  style,
  availableDates,
  dates,
  openToDate,
  onChange,
  onMonthChange,
  isDisabled,
  isLoading,
  listingType,
  tripItinerary,
  hasItinerary = true,
  isPricingPackageSetDay = false,
  daysIncludedInPackage,
  isSingleMonth = false,
  shouldHideHeader = false,
  shouldDisablePastDates = true,
  calendarStartDayOfWeek
}) {
  const styles = useStyles37();
  const { checkInItem, checkOutItem } = getItineraryCheckInItems(tripItinerary);
  const minDate = shouldDisablePastDates ? /* @__PURE__ */ new Date() : void 0;
  const highlightedDates = isPricingPackageSetDay ? (0, import_lib_shared_helpers8.getValidStartsForPackage)(availableDates, daysIncludedInPackage) : [];
  const datesToHighlight = (0, import_lib_shared_helpers8.getSelectedDatesForCalendar)(
    dates[0] ?? null,
    dates[1] ?? null
  );
  function handleDateSelect(datesLocal) {
    const newDates = (0, import_lib_shared_helpers8.getDatesOnDateSelect)(datesLocal, {
      pricingPackageDaysIncluded: daysIncludedInPackage,
      pricingPackageIsSetDay: isPricingPackageSetDay
    });
    onChange(newDates);
  }
  const availabilityDateFilter = filterDatesByAvailability({
    isDisabled,
    dates,
    availableDates,
    isPricingPackageSetDay,
    highlightedDates
  });
  const openToDateToUse = openToDate ?? dates[0] ?? availableDates[0] ?? null;
  return /* @__PURE__ */ import_react104.default.createElement(VerticalStack, { style: { ...styles.root, ...style } }, /* @__PURE__ */ import_react104.default.createElement(ConditionalRenderContainer, { shouldRender: !shouldHideHeader }, /* @__PURE__ */ import_react104.default.createElement(
    CheckoutDatesPreview,
    {
      dates,
      listingType,
      hasItinerary,
      checkInItineraryItem: checkInItem,
      checkOutItineraryItem: checkOutItem,
      isLoading,
      onChange
    }
  )), /* @__PURE__ */ import_react104.default.createElement(
    CalendarDatePicker,
    {
      openToDate: openToDateToUse,
      onChange: handleDateSelect,
      onMonthChange,
      highlightDates: datesToHighlight,
      filterDate: availabilityDateFilter,
      isSingleMonth,
      startDate: dates[0],
      endDate: dates[1],
      isMulti: true,
      minDate,
      calendarStartDayOfWeek
    }
  ));
}
function useStyles37() {
  return componentStyles({
    root: {
      alignItems: "stretch"
    }
  });
}

// src/theme.tsx
var import_react105 = require("@chakra-ui/react");
var import_colord = require("colord");
var theme = createTheme();
var darkTheme = createDarkModeTheme(theme);
function useCoreThemeForProvider() {
  const isDarkMode = useIsDarkMode();
  return isDarkMode ? darkTheme : theme;
}
function createTheme() {
  const customTheme = getCustomTheme();
  return (0, import_react105.extendTheme)(customTheme, ...getExtendThemeExtensions());
}
function createDarkModeTheme(extendedTheme) {
  const customTheme = getCustomTheme();
  const darkThemeColors = JSON.parse(JSON.stringify(extendedTheme.colors));
  Object.entries(darkThemeColors).forEach(([key, value]) => {
    if (value && typeof value === "object") {
      Object.entries(value).forEach(([key2, value2]) => {
        const colorSchemes = Object.values(ColorSchemes);
        if (colorSchemes.includes(key)) {
          darkThemeColors[key][key2] = (0, import_colord.colord)(value2).darken(0.15).toHex();
        } else {
          darkThemeColors[key][key2] = value2;
        }
      });
    }
  });
  return (0, import_react105.extendTheme)(
    { isDark: true, ...customTheme, colors: darkThemeColors },
    ...getExtendThemeExtensions()
  );
}
function getCustomTheme() {
  const config2 = {
    useSystemColorMode: true,
    initialColorMode: "system"
  };
  const colors = {
    brand: {
      50: "#ffe9db",
      100: "#ffc8ae",
      200: "#ffa97e",
      300: "#ff8d4c",
      400: "#ff741a",
      500: "#e64b00",
      600: "#b42e00",
      700: "#811700",
      800: "#4f0700",
      900: "#200004"
    },
    // Default grays are blueish, so we override them
    gray: {
      50: "#F9F9F9",
      100: "#F0F0F0",
      200: "#E0E0E0",
      300: "#D0D0D0",
      400: "#B0B0B0",
      500: "#909090",
      600: "#707070",
      700: "#505050",
      800: "#303030",
      900: "#101010"
    }
  };
  const fonts = {
    body: `"Nunito Sans", sans-serif`,
    heading: `"Nunito Sans", sans-serif`,
    mono: `"Nunito Sans", sans-serif`
  };
  const semanticTokens = {
    colors: {
      // Variable overrides go here
      "chakra-body-bg": {
        _light: "white",
        _dark: "#141414"
      },
      "chakra-subtle-bg": {
        _light: "white",
        _dark: "#141414"
      },
      "chakra-border-color": {
        _light: "var(--chakra-colors-gray-200)",
        _dark: "var(--chakra-colors-gray-700)"
      }
    }
  };
  const shadows = {
    pill: "0px 2px 4px rgba(0, 0, 0, 0.25)"
  };
  const borders = {
    pill: "1px solid hsla(0, 0%, 0%, 0.08)"
  };
  const globalStyles = {
    // Custom variables go here
    ":root": {
      // A little DARKER than `chakra-border-color`
      "--card-border-color": "var(--chakra-colors-gray-300)"
    },
    "[data-theme='dark']": {
      // A little LIGHTER than `chakra-border-color`
      "--card-border-color": "var(--chakra-colors-gray-600)"
    }
  };
  return {
    config: config2,
    colors,
    fonts,
    semanticTokens,
    shadows,
    borders,
    styles: {
      global: globalStyles
    }
  };
}
function getExtendThemeExtensions() {
  return [
    (0, import_react105.withDefaultColorScheme)({
      colorScheme: "brand",
      components: ["Switch", "Tag", "Checkbox", "Radio"]
    })
  ];
}

// src/utils/use-set-color-mode.tsx
var import_react106 = require("@chakra-ui/react");
var import_react107 = require("react");
function useSetColorMode() {
  const { setColorMode } = (0, import_react106.useColorMode)();
  const isDark = useIsDarkMode();
  const colorModeToSet = isDark ? "dark" /* Dark */ : "light" /* Light */;
  (0, import_react107.useEffect)(() => {
    setColorMode(colorModeToSet);
  }, [isDark]);
}

// src/components/image-card/image-card.tsx
var import_react124 = __toESM(require("react"));

// src/utils/use-orientation.ts
var import_react108 = require("@chakra-ui/react");
var Orientation = /* @__PURE__ */ ((Orientation2) => {
  Orientation2["Horizontal"] = "horizontal";
  Orientation2["Vertical"] = "vertical";
  Orientation2["Responsive"] = "responsive";
  return Orientation2;
})(Orientation || {});
function useOrientation(orientation, config2 = {
  base: "vertical" /* Vertical */,
  md: "horizontal" /* Horizontal */
}) {
  const responsiveOrientation = (0, import_react108.useBreakpointValue)(config2);
  if (orientation === "responsive" /* Responsive */) {
    return responsiveOrientation;
  }
  return orientation;
}

// src/components/image-card/image-card-container.tsx
var import_react120 = __toESM(require("react"));

// src/components/image-card/horizontal-image-card-container.tsx
var import_react116 = require("@chakra-ui/react");
var import_react117 = __toESM(require("react"));

// src/components/image-card/clickable-card.tsx
var import_react109 = require("@chakra-ui/react");
var import_react110 = __toESM(require("react"));
function ClickableCard({
  onClick,
  children,
  isDisabled,
  isHighlighted = false,
  style,
  testId
}) {
  const isOnCLickDisabled = !onClick || !!isDisabled;
  const styles = useStyles38({ isOnCLickDisabled, isHighlighted });
  return /* @__PURE__ */ import_react110.default.createElement(
    import_react109.Card,
    {
      onClick: isOnCLickDisabled ? () => {
      } : onClick,
      sx: { ...styles.card, ...style },
      "data-testid": testId
    },
    children
  );
}
function useStyles38({
  isOnCLickDisabled,
  isHighlighted
}) {
  const colors = useColors();
  return componentStyles({
    card: {
      width: "100%",
      height: "100%",
      cursor: isOnCLickDisabled ? "default" : "pointer",
      borderRadius: "xl",
      overflow: "hidden",
      backgroundColor: colors.bg,
      border: `1px solid ${colors.border}`,
      ...isHighlighted && {
        border: `1px solid ${colors.focusBorder}`
      },
      // card styles
      _hover: {
        boxShadow: `rgba(0, 0, 0, 0.16) 0px 1px 15px`
        // TODO pull from theme
      }
    }
  });
}

// src/components/image-card/image-card-pill.tsx
var import_react111 = require("@chakra-ui/react");
var import_react112 = __toESM(require("react"));
function ImageCardPill({ label }) {
  const styles = useStyles39();
  if (!label) return null;
  return /* @__PURE__ */ import_react112.default.createElement(Box, { style: styles.container }, /* @__PURE__ */ import_react112.default.createElement(Box, { style: styles.label }, label));
}
function useStyles39() {
  const theme2 = (0, import_react111.useTheme)();
  const colors = useColors();
  return componentStyles({
    container: {
      background: colors.bg,
      opacity: 0.9,
      borderRadius: "full",
      paddingTop: "4px",
      paddingBottom: "4px",
      paddingLeft: "10px",
      paddingRight: "10px",
      position: "absolute",
      width: "fit-content",
      top: "16px",
      left: "16px",
      boxShadow: theme2.shadows.pill,
      border: theme2.borders.pill
    },
    label: {
      fontSize: {
        base: "12px",
        md: "14px"
      },
      fontWeight: "600",
      color: colors.text
    }
  });
}

// src/components/image-with-pill/image-with-pill.tsx
var import_react114 = require("@chakra-ui/react");
var import_react115 = __toESM(require("react"));

// src/components/link/link.tsx
var import_react113 = __toESM(require("react"));
var import_gatsby_link = require("gatsby-link");
var import_styled2 = __toESM(require("@emotion/styled"));
function LinkUnstyled({ ref, ...props }) {
  return /* @__PURE__ */ import_react113.default.createElement(import_gatsby_link.Link, { ...props });
}
var Link2 = (0, import_styled2.default)(LinkUnstyled)`
    :hover {
        text-decoration: underline;
    }
`;

// src/components/image-with-pill/image-with-pill.tsx
function ImageWithPill({
  imageSrc,
  imageAlt,
  ratio = 16 / 9,
  isLoading = false,
  linkTo,
  pill,
  maxHeight,
  style,
  ...props
}) {
  const styles = useStyles40();
  if (isLoading) {
    return /* @__PURE__ */ import_react115.default.createElement(import_react114.AspectRatio, { ratio, sx: style }, /* @__PURE__ */ import_react115.default.createElement(import_react114.Skeleton, { style: styles.skeleton }));
  }
  return (
    // href will never be "" because of the ternary operator above
    /* @__PURE__ */ import_react115.default.createElement(
      import_react114.AspectRatio,
      {
        ratio,
        sx: style,
        as: linkTo ? Link2 : void 0,
        to: linkTo || ""
      },
      /* @__PURE__ */ import_react115.default.createElement(import_react115.default.Fragment, null, /* @__PURE__ */ import_react115.default.createElement(
        Image,
        {
          src: imageSrc,
          alt: imageAlt,
          showFallback: false,
          ...props,
          style: styles.image
        }
      ), pill && /* @__PURE__ */ import_react115.default.createElement(Box, { style: styles.pillContainer }, pill))
    )
  );
}
function useStyles40() {
  return componentStyles({
    pillContainer: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%"
    },
    skeleton: {
      width: "100%",
      height: "100%"
    },
    image: {
      objectFit: "cover",
      objectPosition: "center",
      width: "100%",
      height: "100%"
    }
  });
}

// src/components/image-card/horizontal-image-card-container.tsx
function HorizontalImageCardContainer({
  onClick,
  headerImageSrc,
  headerImageAlt,
  headerImageRatio = 16 / 9,
  isLoading,
  isDisabled,
  pillLabel,
  topRightCornerContent,
  linkTo,
  testId,
  isHighlighted,
  style,
  imageStyle,
  hideImage,
  uploadCareImageVariant,
  children
}) {
  const styles = useStyles41();
  const isOnCLickDisabled = !onClick || Boolean(isDisabled) || Boolean(isLoading);
  const pill = /* @__PURE__ */ import_react117.default.createElement(ImageCardPill, { label: pillLabel });
  return /* @__PURE__ */ import_react117.default.createElement(
    ClickableCard,
    {
      isDisabled: isOnCLickDisabled,
      isHighlighted,
      onClick,
      style,
      testId
    },
    /* @__PURE__ */ import_react117.default.createElement(
      ConditionalRenderContainer,
      {
        shouldRender: !!topRightCornerContent,
        style: styles.topRightCornerContent
      },
      topRightCornerContent
    ),
    /* @__PURE__ */ import_react117.default.createElement(
      import_react116.CardBody,
      {
        ...styles.cardBody,
        "data-testid": TEST_IDS.HORIZONTAL_IMAGE_CARD
      },
      /* @__PURE__ */ import_react117.default.createElement(HorizontalStack, { style: styles.stack }, !hideImage && /* @__PURE__ */ import_react117.default.createElement(
        ImageWithPill,
        {
          linkTo,
          imageSrc: headerImageSrc,
          imageAlt: headerImageAlt,
          ratio: headerImageRatio,
          style: { ...styles.image, ...imageStyle },
          isLoading,
          pill,
          variant: uploadCareImageVariant
        }
      ), children)
    )
  );
}
function useStyles41() {
  const theme2 = useTheme2();
  return componentStyles({
    image: {
      width: "200px",
      borderRadius: "xl",
      overflow: "hidden"
    },
    cardBody: {
      width: "full"
    },
    topRightCornerContent: {
      position: "absolute",
      top: "13px",
      right: "13px",
      zIndex: theme2.zIndices.overlay
    },
    container: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%"
    },
    stack: {
      alignItems: "stretch",
      gap: 5
    }
  });
}

// src/components/image-card/vertical-image-card-container.tsx
var import_react118 = require("@chakra-ui/react");
var import_react119 = __toESM(require("react"));
function VerticalImageCardContainer({
  onClick,
  headerImageSrc,
  headerImageAlt,
  headerImageRatio = 16 / 9,
  isLoading,
  isDisabled,
  pillLabel,
  topRightCornerContent,
  linkTo,
  testId,
  isHighlighted,
  style,
  imageStyle,
  hideImage,
  uploadCareImageVariant,
  children
}) {
  const styles = useStyles42();
  const isOnCLickDisabled = !onClick || Boolean(isDisabled) || Boolean(isLoading);
  const pill = /* @__PURE__ */ import_react119.default.createElement(ImageCardPill, { label: pillLabel });
  return /* @__PURE__ */ import_react119.default.createElement(
    ClickableCard,
    {
      isDisabled: isOnCLickDisabled,
      isHighlighted,
      onClick,
      style,
      testId
    },
    /* @__PURE__ */ import_react119.default.createElement(Box, { style: styles.container }, /* @__PURE__ */ import_react119.default.createElement(
      ConditionalRenderContainer,
      {
        shouldRender: !!topRightCornerContent,
        style: styles.topRightCornerContent
      },
      topRightCornerContent
    ), !hideImage && /* @__PURE__ */ import_react119.default.createElement(
      ImageWithPill,
      {
        linkTo,
        imageSrc: headerImageSrc,
        imageAlt: headerImageAlt,
        ratio: headerImageRatio,
        style: { ...styles.image, ...imageStyle },
        isLoading,
        pill,
        variant: uploadCareImageVariant
      }
    ), /* @__PURE__ */ import_react119.default.createElement(
      import_react118.CardBody,
      {
        ...styles.cardBody,
        "data-testid": TEST_IDS.VERTICAL_IMAGE_CARD
      },
      children
    ))
  );
}
function useStyles42() {
  return componentStyles({
    image: {
      width: "100%",
      height: "100%",
      maxHeight: "200px"
    },
    cardBody: {
      width: "100%"
    },
    topRightCornerContent: {
      position: "absolute",
      top: "13px",
      right: "13px",
      zIndex: 200
    },
    container: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%"
    }
  });
}

// src/components/image-card/image-card-container.tsx
function ImageCardContainer({
  orientation = "vertical" /* Vertical */,
  ...props
}) {
  const cardOrientation = useOrientation(orientation);
  if (cardOrientation === "horizontal" /* Horizontal */) {
    return /* @__PURE__ */ import_react120.default.createElement(HorizontalImageCardContainer, { ...props });
  }
  return /* @__PURE__ */ import_react120.default.createElement(VerticalImageCardContainer, { ...props });
}

// src/components/image-card/image-card-content.tsx
var import_react122 = require("@chakra-ui/react");
var import_react123 = __toESM(require("react"));

// src/components/image-card/image-card-title.tsx
var import_react121 = __toESM(require("react"));
function ImageCardTitle({
  linkTo,
  title
}) {
  const styles = useStyles43();
  return /* @__PURE__ */ import_react121.default.createElement(HeadingMedium, { style: styles.title }, linkTo ? /* @__PURE__ */ import_react121.default.createElement(Link2, { to: linkTo }, title) : title);
}
function useStyles43() {
  const titleLineCount = 2;
  const titleLineHeightEm = 1.3;
  const titleHeight = `${titleLineHeightEm * titleLineCount}em`;
  const titleLineHeight = `${titleLineHeightEm}em`;
  return componentStyles({
    title: {
      textDecoration: "none",
      // Show a max of two lines, then ellipsis
      // https://stackoverflow.com/a/32585024
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkitBoxOrient": "vertical",
      "-webkitLineClamp": 2,
      // Fallback
      lineHeight: titleLineHeight,
      height: titleHeight,
      // This number was stratigically set to allow long names to be displayed. Changing it should be done with caution.
      fontSize: "14px !important",
      textAlign: "left"
    }
  });
}

// src/components/image-card/image-card-content.tsx
function ImageCardContent({
  aboveTitleText,
  title,
  subtitle,
  children,
  isLoading,
  linkTo
}) {
  const styles = useStyles44();
  if (isLoading) {
    return /* @__PURE__ */ import_react123.default.createElement(SkeletonFillHorizontal, { rows: 2 });
  }
  return /* @__PURE__ */ import_react123.default.createElement(VerticalStack, { style: styles.root }, aboveTitleText && /* @__PURE__ */ import_react123.default.createElement(import_react122.Box, { style: styles.aboveTitleText }, aboveTitleText), title && /* @__PURE__ */ import_react123.default.createElement(ImageCardTitle, { title, linkTo }), subtitle && /* @__PURE__ */ import_react123.default.createElement(Text, { style: styles.subtitle }, subtitle), /* @__PURE__ */ import_react123.default.createElement(import_react122.Box, { style: styles.box }, children));
}
function useStyles44() {
  const colors = useColors();
  const theColor = colors.secondaryText;
  return componentStyles({
    aboveTitleText: {
      fontSize: "14px",
      fontWeight: 300,
      color: theColor,
      marginBottom: "0.2em"
    },
    subtitle: {
      marginTop: "4px",
      fontSize: "16px",
      color: theColor,
      userSelect: "none",
      width: "100%"
    },
    root: {
      flex: 1,
      alignItems: "flex-start",
      gap: 0
    },
    box: {
      width: "100%"
    }
  });
}

// src/components/image-card/image-card.tsx
function ImageCard({
  orientation = "vertical" /* Vertical */,
  isLoading,
  linkTo,
  aboveTitleText,
  title,
  subtitle,
  children,
  ...props
}) {
  return /* @__PURE__ */ import_react124.default.createElement(
    ImageCardContainer,
    {
      orientation,
      isLoading,
      linkTo,
      ...props
    },
    /* @__PURE__ */ import_react124.default.createElement(
      ImageCardContent,
      {
        isLoading,
        linkTo,
        aboveTitleText,
        title,
        subtitle
      },
      children
    )
  );
}

// src/utils/color-mode-script.tsx
var import_react125 = __toESM(require("react"));
var import_react126 = require("@chakra-ui/react");
var COLOR_MODE_SCRIPT_KEY = "chakra-ui-no-flash";
function ColorModeScript() {
  return /* @__PURE__ */ import_react125.default.createElement(
    import_react126.ColorModeScript,
    {
      initialColorMode: theme.config.initialColorMode,
      key: COLOR_MODE_SCRIPT_KEY
    }
  );
}

// src/components/timeline/timeline.tsx
var import_react129 = __toESM(require("react"));

// src/components/timeline/timeline-item.tsx
var import_react127 = require("@chakra-ui/react");
var import_date_fns4 = require("date-fns");
var import_react128 = __toESM(require("react"));
var CIRCLE_SIZE = 16;
function TimelineItem({ timelineEvent, isFirst, orientation }) {
  const { title, timestamp, date } = timelineEvent;
  const styles = useStyles45({ orientation, timestamp });
  return /* @__PURE__ */ import_react128.default.createElement(import_react127.Flex, { sx: styles.root }, !isFirst && /* @__PURE__ */ import_react128.default.createElement(import_react127.Box, { sx: styles.line }), /* @__PURE__ */ import_react128.default.createElement(import_react127.Circle, { size: `${CIRCLE_SIZE}px`, sx: styles.circle }), /* @__PURE__ */ import_react128.default.createElement(import_react127.Box, { sx: styles.content }, /* @__PURE__ */ import_react128.default.createElement(TextBold, null, title), /* @__PURE__ */ import_react128.default.createElement(TextSecondarySmall, null, date)));
}
function useStyles45({
  orientation,
  timestamp
}) {
  const colors = useColors();
  const lineThickness = 2;
  const lineSideOffset = CIRCLE_SIZE / 2 - lineThickness / 2;
  const lineOffset = `calc(50% + ${CIRCLE_SIZE * 0.75}px)`;
  const lineLength = `calc(100% - ${CIRCLE_SIZE * 1.5}px)`;
  const lineStyles = orientation === "vertical" /* Vertical */ ? {
    width: `${lineThickness}px`,
    bottom: lineOffset,
    height: lineLength,
    left: `${lineSideOffset}px`
  } : {
    height: `${lineThickness}px`,
    right: lineOffset,
    width: lineLength,
    top: `${lineSideOffset}px`
  };
  const isInPast = (0, import_date_fns4.isPast)(timestamp);
  const shouldUseSecondaryColor = !isInPast || !timestamp;
  const color = shouldUseSecondaryColor ? colors.gray[400] : colors.brandDefault;
  return componentStyles({
    root: {
      flexDirection: orientation === "vertical" /* Vertical */ ? "row" : "column",
      position: "relative",
      alignItems: "center",
      flex: 1
    },
    line: {
      background: color,
      position: "absolute",
      ...lineStyles
    },
    circle: {
      background: color,
      zIndex: 1
    },
    content: {
      textAlign: orientation === "horizontal" /* Horizontal */ ? "center" : "left",
      paddingY: 4,
      paddingX: 6,
      width: "fit-content"
    }
  });
}

// src/components/timeline/timeline.tsx
function Timeline2({
  events,
  orientation = "responsive" /* Responsive */
}) {
  const timelineOrientation = useOrientation(orientation);
  const styles = useStyles46({ orientation: timelineOrientation });
  const Container = timelineOrientation === "vertical" /* Vertical */ ? VerticalStack : HorizontalStack;
  return /* @__PURE__ */ import_react129.default.createElement(Container, { style: styles.root }, events.map((event, index2) => {
    return /* @__PURE__ */ import_react129.default.createElement(
      TimelineItem,
      {
        key: event.timestamp,
        timelineEvent: event,
        isFirst: index2 === 0,
        orientation: timelineOrientation
      }
    );
  }));
}
function useStyles46({ orientation }) {
  return componentStyles({
    root: {
      width: "100%",
      height: "100%",
      gap: 0,
      justifyContent: "space-between",
      position: "relative",
      alignItems: orientation === "vertical" /* Vertical */ ? "stretch" : "start"
    }
  });
}

// src/entity-components/itinerary/itinerary.tsx
var import_react134 = __toESM(require("react"));

// src/entity-components/itinerary/itinerary-info-card.tsx
var import_react132 = __toESM(require("react"));

// src/entity-components/itinerary/itinerary-info-card-content.tsx
var import_react131 = __toESM(require("react"));

// src/entity-components/itinerary/itinerary-view-listing-link.tsx
var import_react130 = __toESM(require("react"));
var import_react_fontawesome17 = require("@fortawesome/react-fontawesome");
var import_faArrowRight = require("@fortawesome/free-solid-svg-icons/faArrowRight");

// src/utils/navigation-helpers.ts
var WEB_NAVIGATION_URLS = {
  INTERNAL: {
    LISTING: "/listing"
  }
};
function getListingRoute(id2) {
  return `${WEB_NAVIGATION_URLS.INTERNAL.LISTING}/${id2}`;
}

// src/entity-components/itinerary/itinerary-view-listing-link.tsx
function ItineraryViewListingLink({
  listing
}) {
  const styles = useStyles47();
  return /* @__PURE__ */ import_react130.default.createElement(Link2, { to: getListingRoute(listing.id), style: styles.root }, /* @__PURE__ */ import_react130.default.createElement(HorizontalStack, { style: styles.stack }, /* @__PURE__ */ import_react130.default.createElement(TextBold, { style: styles.label }, copy_constants_default.VIEW_LISTING), /* @__PURE__ */ import_react130.default.createElement(import_react_fontawesome17.FontAwesomeIcon, { icon: import_faArrowRight.faArrowRight })));
}
function useStyles47() {
  const colors = useColors();
  return componentStyles({
    root: {
      color: colors.brandDefault,
      width: "max-content"
    },
    stack: {
      alignItems: "center"
    },
    label: {
      textWrap: "nowrap"
    }
  });
}

// src/entity-components/itinerary/itinerary-info-card-content.tsx
function ItineraryInfoContent({
  label,
  listing,
  shouldHideListingLink
}) {
  const styles = useStyles48();
  const aboveTitleText = getAboveTitleText(listing);
  return /* @__PURE__ */ import_react131.default.createElement(VerticalStack, { style: styles.vStack }, /* @__PURE__ */ import_react131.default.createElement(TextExtraSmall, null, aboveTitleText), /* @__PURE__ */ import_react131.default.createElement(TextLarge, { style: styles.title }, listing.title), /* @__PURE__ */ import_react131.default.createElement(HorizontalStackSpaceBetween, { style: styles.stack }, /* @__PURE__ */ import_react131.default.createElement(TextSecondary, { numberOfLines: 2, style: styles.label }, label), /* @__PURE__ */ import_react131.default.createElement(
    ConditionalRenderContainer,
    {
      shouldRender: !shouldHideListingLink
    },
    /* @__PURE__ */ import_react131.default.createElement(ItineraryViewListingLink, { listing })
  )));
}
function useStyles48() {
  return componentStyles({
    stack: {
      width: "100%"
    },
    vStack: {
      gap: 0,
      padding: 4,
      width: "100%"
    },
    title: {
      marginBottom: 4
    },
    label: {
      textAlign: "left"
    }
  });
}
function getAboveTitleText(listing) {
  const cityAndState = listing.location?.city ? `${listing.location.city}, ${listing.location.state}` : listing.location?.state;
  return `${getCleanEnum(listing.type ?? "")} \u2022 ${cityAndState}`;
}

// src/entity-components/itinerary/itinerary-info-card.tsx
function ItineraryInfoCard({
  listing,
  label,
  orientation,
  shouldHideListingLink
}) {
  const styles = useStyles49();
  const media = listing.photos[0];
  return /* @__PURE__ */ import_react132.default.createElement(
    ImageCard,
    {
      orientation,
      headerImageSrc: media?.url,
      headerImageAlt: media?.description ?? "",
      style: styles.imageCard,
      testId: TEST_IDS.ITINERARY_INFO_CARD
    },
    /* @__PURE__ */ import_react132.default.createElement(
      ItineraryInfoContent,
      {
        label,
        listing,
        shouldHideListingLink
      }
    )
  );
}
function useStyles49() {
  return componentStyles({
    imageCard: {
      marginBottom: 4
    }
  });
}

// src/entity-components/itinerary/itinerary-timeline.tsx
var import_react133 = __toESM(require("react"));
function ItineraryTimeline({
  itineraryItems,
  orientation
}) {
  const timelineEvents = mapItineraryItemsToEvents(itineraryItems);
  return /* @__PURE__ */ import_react133.default.createElement(Timeline2, { events: timelineEvents, orientation });
}
function mapItineraryItemsToEvents(itineraryItems) {
  return itineraryItems.map((item) => {
    return {
      title: item.title,
      timestamp: item.timestamp,
      date: item.helper_text ?? item.label
    };
  });
}

// src/entity-components/itinerary/itinerary.tsx
function Itinerary({
  itinerary,
  listing,
  hideInfoCard,
  orientation = "responsive" /* Responsive */,
  shouldHideListingLink
}) {
  const itineraryOrientation = useOrientation(orientation, {
    base: "vertical" /* Vertical */,
    lg: "horizontal" /* Horizontal */
  });
  const styles = useStyles50();
  if (!itinerary || !listing) {
    return null;
  }
  return /* @__PURE__ */ import_react134.default.createElement(VerticalStack, { style: styles.root, "data-testid": TEST_IDS.ITINERARY }, /* @__PURE__ */ import_react134.default.createElement(HeadingMedium, { style: styles.heading }, itinerary.title), !hideInfoCard && /* @__PURE__ */ import_react134.default.createElement(
    ItineraryInfoCard,
    {
      label: itinerary.label || "",
      listing,
      orientation: itineraryOrientation,
      shouldHideListingLink
    }
  ), /* @__PURE__ */ import_react134.default.createElement(
    ItineraryTimeline,
    {
      itineraryItems: itinerary.items,
      orientation: itineraryOrientation
    }
  ));
}
function useStyles50() {
  return componentStyles({
    root: {
      gap: 4,
      alignItems: "center"
    },
    heading: {
      textAlign: "left",
      width: "100%"
    }
  });
}

// src/entity-components/trip-summary/trip-summary-no-breakdown.tsx
var import_react138 = require("@chakra-ui/react");
var import_react139 = __toESM(require("react"));

// src/entity-components/trip-summary/trip-payment-plan.tsx
var import_date_fns5 = require("date-fns");
var import_react135 = __toESM(require("react"));
function TripPaymentPlan({
  paymentPlan,
  isDueNow = false
}) {
  const styles = useStyles51();
  const payments = paymentPlan?.payments ?? [];
  return /* @__PURE__ */ import_react135.default.createElement(VerticalStack, { style: styles.stack, testId: TEST_IDS.TRIP_PAYMENT_PLAN }, payments.map((payment, index2) => {
    const paymentLabel = getPaymentLabel({
      isDueNow,
      paymentDate: payment.date,
      paymentOrder: index2
    });
    const paymentValue = formatPrice(payment.value);
    return /* @__PURE__ */ import_react135.default.createElement(HorizontalStackSpaceBetween, { key: payment.id }, /* @__PURE__ */ import_react135.default.createElement(Text, null, paymentLabel), /* @__PURE__ */ import_react135.default.createElement(TextBold, null, paymentValue));
  }));
}
function useStyles51() {
  return componentStyles({
    stack: { width: "100%", marginTop: 6, alignItems: "stretch", gap: 2 }
  });
}
function getFirstPaymentLabel(isDueNow) {
  return isDueNow ? copy_constants_default.DUE_NOW : copy_constants_default.DUE_AFTER_CONFIRMATION;
}
function getFuturePaymentLabel(date) {
  return `${copy_constants_default.DUE_ON} ${(0, import_date_fns5.format)(date, DATE_FORMATS.SLASH)}`;
}
function getPaymentLabel({
  isDueNow,
  paymentDate,
  paymentOrder
}) {
  return paymentOrder === 0 ? getFirstPaymentLabel(isDueNow) : getFuturePaymentLabel(paymentDate);
}

// src/entity-components/trip-summary/trip-summary-container.tsx
var import_react136 = __toESM(require("react"));
function TripSummaryContainer({
  pricingPackages,
  style,
  children
}) {
  const styles = useStyles52();
  const numberOfPricingPackages = pricingPackages.length;
  const packagesLabel = pluralize(
    numberOfPricingPackages,
    copy_constants_default.PACKAGE
  );
  return /* @__PURE__ */ import_react136.default.createElement(
    Card,
    {
      style: { ...styles.root, ...style },
      testId: TEST_IDS.TRIP_SUMMARY_CONTAINER
    },
    /* @__PURE__ */ import_react136.default.createElement(HeadingMedium, { style: styles.heading }, copy_constants_default.TRIP_SUMMARY),
    /* @__PURE__ */ import_react136.default.createElement(TextBold, { style: styles.text }, packagesLabel),
    /* @__PURE__ */ import_react136.default.createElement(VerticalStack, null, pricingPackages.map((pricingPackage) => /* @__PURE__ */ import_react136.default.createElement(Card, { key: pricingPackage.id, style: styles.card }, /* @__PURE__ */ import_react136.default.createElement(
      PricingPackageSelectorOption,
      {
        pricingPackage
      }
    )))),
    children
  );
}
function useStyles52() {
  const colors = useColors();
  return componentStyles({
    root: {
      backgroundColor: colors.bg
    },
    card: { width: "100%", backgroundColor: colors.bg },
    heading: { marginBottom: 4 },
    text: { marginBottom: 4 }
  });
}

// src/entity-components/trip-summary/trip-total.tsx
var import_react137 = __toESM(require("react"));
function TripTotal({ paymentTotal }) {
  const styles = useStyles53();
  const total = formatPrice(paymentTotal);
  return /* @__PURE__ */ import_react137.default.createElement(
    HorizontalStackSpaceBetween,
    {
      style: styles.stack,
      testId: TEST_IDS.TRIP_TOTAL
    },
    /* @__PURE__ */ import_react137.default.createElement(HeadingMedium, null, copy_constants_default.TOTAL),
    /* @__PURE__ */ import_react137.default.createElement(HeadingMedium, null, total)
  );
}
function useStyles53() {
  return componentStyles({
    stack: { width: "100%" }
  });
}

// src/entity-components/trip-summary/trip-summary-no-breakdown.tsx
function TripSummaryNoBreakdown({
  pricingPackages,
  paymentTotal,
  paymentPlan,
  children
}) {
  const styles = useStyles54();
  const isLoading = !pricingPackages || isNaN(paymentTotal) || !paymentPlan;
  return /* @__PURE__ */ import_react139.default.createElement(SkeletonContainer, { isLoaded: !isLoading }, /* @__PURE__ */ import_react139.default.createElement(TripSummaryContainer, { pricingPackages }, /* @__PURE__ */ import_react139.default.createElement(import_react138.Divider, { sx: styles.divider }), /* @__PURE__ */ import_react139.default.createElement(TripTotal, { paymentTotal }), /* @__PURE__ */ import_react139.default.createElement(TripPaymentPlan, { paymentPlan, isDueNow: true }), children));
}
function useStyles54() {
  return componentStyles({
    divider: { marginY: 6 }
  });
}

// src/components/debounced-input/debounced-input.tsx
var import_react141 = __toESM(require("react"));
var import_react142 = require("@chakra-ui/react");

// src/utils/use-debounce.ts
var import_react140 = require("react");
function useDebounceCallback({
  value,
  callBack,
  delay: delay2 = 300
}) {
  (0, import_react140.useEffect)(
    () => {
      const handler = setTimeout(() => {
        callBack(value);
      }, delay2);
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay2]
    // Only re-call effect if value or delay changes
  );
}

// src/components/debounced-input/debounced-input.tsx
var INPUT_MODE = "text";
function DebouncedInput({
  debounceTime: debounceTime2 = 500,
  value,
  onChange,
  testId,
  style,
  size = "sm",
  placeholder
}) {
  const [localText, setLocalText] = (0, import_react141.useState)();
  useDebounceCallback({
    value: localText,
    callBack: (debouncedValue) => {
      if (debouncedValue === void 0) {
        return;
      }
      onChange(debouncedValue);
    },
    delay: debounceTime2
  });
  const styles = useStyles55();
  return /* @__PURE__ */ import_react141.default.createElement(
    import_react142.Input,
    {
      "data-testid": testId,
      inputMode: INPUT_MODE,
      size,
      value: localText ?? value,
      onChange: (event) => {
        setLocalText(event.target.value);
      },
      sx: { ...styles.input, ...style },
      placeholder
    }
  );
}
function useStyles55() {
  const colors = useColors();
  return componentStyles({
    input: {
      focusBorderColor: colors.brandFocusBorder,
      _focusVisible: {
        borderColor: colors.brandFocusBorder
      }
    }
  });
}

// src/components/action-pill/action-pill.tsx
var import_react143 = require("@chakra-ui/react");
var import_react144 = __toESM(require("react"));
var import_react_fontawesome18 = require("@fortawesome/react-fontawesome");
function ActionPill({
  children,
  icon,
  label,
  style,
  testId,
  size = "sm"
}) {
  const styles = useStyles56();
  return /* @__PURE__ */ import_react144.default.createElement(
    import_react143.InputGroup,
    {
      size,
      "data-testid": testId,
      sx: { ...styles.inputGroup, ...style }
    },
    /* @__PURE__ */ import_react144.default.createElement(import_react143.InputLeftAddon, { sx: styles.inputLeftAddon }, /* @__PURE__ */ import_react144.default.createElement(import_react143.HStack, null, /* @__PURE__ */ import_react144.default.createElement(import_react_fontawesome18.FontAwesomeIcon, { icon, fontSize: 18 }), /* @__PURE__ */ import_react144.default.createElement(Text, null, label))),
    children
  );
}
function useStyles56() {
  return componentStyles({
    inputGroup: {
      roundedLeft: "3xl",
      overflow: "hidden"
    },
    inputLeftAddon: {
      paddingLeft: 4
    }
  });
}

// src/components/search/search.tsx
var import_faSearch2 = require("@fortawesome/free-solid-svg-icons/faSearch");
var import_react145 = __toESM(require("react"));
var SIZE = "sm";
function Search({ value, onChange, style, placeholder }) {
  const styles = useStyles57();
  return /* @__PURE__ */ import_react145.default.createElement(
    ActionPill,
    {
      size: SIZE,
      label: copy_constants_default.SEARCH,
      icon: import_faSearch2.faSearch,
      testId: TEST_IDS.SEARCH_PILL,
      style
    },
    /* @__PURE__ */ import_react145.default.createElement(
      DebouncedInput,
      {
        size: SIZE,
        value,
        onChange,
        testId: TEST_IDS.SEARCH_INPUT,
        style: styles.input,
        placeholder
      }
    )
  );
}
function useStyles57() {
  return componentStyles({
    input: {
      roundedRight: "3xl",
      roundedLeft: "none"
    }
  });
}

// src/components/select-input/select-input.tsx
var import_react146 = require("@chakra-ui/react");
var import_react147 = __toESM(require("react"));
function SelectInput({
  items,
  size,
  style,
  onChange,
  value,
  isDisabled,
  placeholder
}) {
  const styles = useStyles58();
  return /* @__PURE__ */ import_react147.default.createElement(
    import_react146.Select,
    {
      "data-testid": TEST_IDS.SELECT_INPUT,
      size,
      sx: { ...styles.select, ...style },
      onChange: (event) => onChange(event.target.value),
      value,
      isDisabled,
      placeholder
    },
    items.map((item) => /* @__PURE__ */ import_react147.default.createElement("option", { key: item.value, value: item.value }, item.label))
  );
}
function useStyles58() {
  const colors = useColors();
  return componentStyles({
    select: {
      focusBorderColor: colors.brandFocusBorder,
      _focusVisible: {
        borderColor: colors.brandFocusBorder
      }
    }
  });
}

// src/entity-components/sort-select/sort-select.tsx
var import_react148 = __toESM(require("react"));
var import_faArrowsAltV = require("@fortawesome/free-solid-svg-icons/faArrowsAltV");
var SIZE2 = "sm";
function SortSelect({ options, value, onChange }) {
  const styles = useStyles59();
  return /* @__PURE__ */ import_react148.default.createElement(ActionPill, { icon: import_faArrowsAltV.faArrowsAltV, label: copy_constants_default.SORT, size: SIZE2 }, /* @__PURE__ */ import_react148.default.createElement(
    SelectInput,
    {
      style: styles.input,
      value,
      onChange,
      items: options.map(({ key, label }) => ({ label, value: key })),
      size: SIZE2
    }
  ));
}
function useStyles59() {
  return componentStyles({
    input: {
      roundedRight: "3xl"
    }
  });
}

// src/components/pagination/pagination.tsx
var import_react150 = __toESM(require("react"));
var import_lib_shared_helpers9 = __toESM(require_src());
var import_react_fontawesome19 = require("@fortawesome/react-fontawesome");
var import_faChevronLeft2 = require("@fortawesome/free-solid-svg-icons/faChevronLeft");
var import_faChevronRight4 = require("@fortawesome/free-solid-svg-icons/faChevronRight");

// src/components/pagination/page-number-button.tsx
var import_react149 = __toESM(require("react"));
function PageNumberButton({
  pageNumber,
  currentPage,
  index: index2,
  pageNumbers,
  totalPages,
  onPageChange
}) {
  const styles = useStyles60();
  if (pageNumber === copy_constants_default.ELLIPSIS) {
    return /* @__PURE__ */ import_react149.default.createElement(
      ButtonSmall,
      {
        testId: TEST_IDS.ELLIPSIS_BUTTON,
        variant: "ghost" /* Ghost */,
        onClick: () => handleEllipsisClick({
          index: index2,
          pageNumbers,
          totalPages,
          onPageChange
        }),
        style: styles.ellipsis
      },
      copy_constants_default.ELLIPSIS
    );
  }
  const variant = pageNumber === currentPage ? "solid" /* Solid */ : "ghost" /* Ghost */;
  return /* @__PURE__ */ import_react149.default.createElement(
    ButtonSmall,
    {
      testId: TEST_IDS.PAGE_NUMBER_BUTTON,
      variant,
      onClick: () => onPageChange(pageNumber)
    },
    pageNumber
  );
}
function handleEllipsisClick({
  index: index2,
  pageNumbers,
  totalPages,
  onPageChange
}) {
  const isLeftEllipsis = pageNumbers[index2 - 1] === 1;
  if (isLeftEllipsis) {
    const prevPage = Math.max(pageNumbers[index2 + 1] - 2, 1);
    onPageChange(prevPage);
    return;
  }
  const nextPage = Math.min(
    pageNumbers[index2 - 1] + 2,
    totalPages
  );
  onPageChange(nextPage);
}
function useStyles60() {
  return componentStyles({
    ellipsis: {
      height: 8,
      minWidth: 8
    }
  });
}

// src/components/pagination/pagination.tsx
function Pagination({
  currentPage,
  totalPages,
  onPageChange
}) {
  const pageNumbers = getPageNumbers({
    currentPage,
    totalPages
  });
  return /* @__PURE__ */ import_react150.default.createElement(HorizontalStack, null, /* @__PURE__ */ import_react150.default.createElement(HorizontalStackSmallGap, null, /* @__PURE__ */ import_react150.default.createElement(
    SmallIconButton,
    {
      testId: TEST_IDS.PREVIOUS_PAGE,
      "aria-label": copy_constants_default.PREVIOUS_PAGE,
      icon: /* @__PURE__ */ import_react150.default.createElement(import_react_fontawesome19.FontAwesomeIcon, { icon: import_faChevronLeft2.faChevronLeft }),
      variant: "ghost" /* Ghost */,
      isDisabled: currentPage === 1,
      onClick: () => onPageChange(currentPage - 1)
    }
  ), /* @__PURE__ */ import_react150.default.createElement(HorizontalStackSmallGap, null, pageNumbers.map((pageNumber, index2) => /* @__PURE__ */ import_react150.default.createElement(
    PageNumberButton,
    {
      key: `${pageNumber}-${index2}`,
      pageNumber,
      currentPage,
      index: index2,
      pageNumbers,
      totalPages,
      onPageChange
    }
  ))), /* @__PURE__ */ import_react150.default.createElement(
    SmallIconButton,
    {
      testId: TEST_IDS.NEXT_PAGE,
      "aria-label": copy_constants_default.NEXT_PAGE,
      icon: /* @__PURE__ */ import_react150.default.createElement(import_react_fontawesome19.FontAwesomeIcon, { icon: import_faChevronRight4.faChevronRight }),
      variant: "ghost" /* Ghost */,
      isDisabled: currentPage === totalPages,
      onClick: () => onPageChange(currentPage + 1)
    }
  )));
}
var SIBLING_COUNT = 1;
function getPageNumbers({
  currentPage,
  totalPages
}) {
  const leftSiblingIndex = Math.max(currentPage - SIBLING_COUNT, 1);
  const rightSiblingIndex = Math.min(currentPage + SIBLING_COUNT, totalPages);
  const shouldShowLeftDots = leftSiblingIndex > 2;
  const shouldShowRightDots = rightSiblingIndex < totalPages - 1;
  if (!shouldShowLeftDots && shouldShowRightDots) {
    const leftItemCount = 3;
    const leftRange = (0, import_lib_shared_helpers9.getArrayOfCount)(leftItemCount).map(
      (index2) => index2 + 1
    );
    return [...leftRange, copy_constants_default.ELLIPSIS, totalPages];
  }
  if (shouldShowLeftDots && !shouldShowRightDots) {
    const rightItemCount = 3;
    const rightRange = (0, import_lib_shared_helpers9.getArrayOfCount)(rightItemCount).map(
      (index2) => totalPages - rightItemCount + index2 + 1
    );
    return [1, copy_constants_default.ELLIPSIS, ...rightRange];
  }
  if (shouldShowLeftDots && shouldShowRightDots) {
    const middleRange = (0, import_lib_shared_helpers9.getArrayOfCount)(
      rightSiblingIndex - leftSiblingIndex + 1
    ).map((index2) => leftSiblingIndex + index2);
    return [
      1,
      copy_constants_default.ELLIPSIS,
      ...middleRange,
      copy_constants_default.ELLIPSIS,
      totalPages
    ];
  }
  return (0, import_lib_shared_helpers9.getArrayOfCount)(totalPages).map((index2) => index2 + 1);
}

// src/components/list-footer/list-footer.tsx
var import_react152 = require("@chakra-ui/react");
var import_react153 = __toESM(require("react"));

// src/components/list-footer/results.tsx
var import_react151 = __toESM(require("react"));
function Results({
  totalResults,
  rowsPerPage,
  currentPage
}) {
  const startRow = (currentPage - 1) * rowsPerPage + 1;
  const endRow = Math.min(startRow - 1 + rowsPerPage, totalResults);
  const showingText = getShowingText(startRow, endRow);
  return /* @__PURE__ */ import_react151.default.createElement(HorizontalStackSmallGap, null, /* @__PURE__ */ import_react151.default.createElement(TextSmall, null, copy_constants_default.SHOWING), /* @__PURE__ */ import_react151.default.createElement(TextBoldSmall, null, showingText), /* @__PURE__ */ import_react151.default.createElement(TextSmall, null, copy_constants_default.OF), /* @__PURE__ */ import_react151.default.createElement(TextBoldSmall, null, totalResults), /* @__PURE__ */ import_react151.default.createElement(TextSmall, null, copy_constants_default.RESULTS));
}
function getShowingText(startRow, endRow) {
  return `${startRow} - ${endRow}`;
}

// src/components/list-footer/list-footer.tsx
function ListFooter({
  totalResults,
  rowsPerPage,
  currentPage,
  onPageChange
}) {
  const styles = useStyles61();
  const totalPages = Math.ceil(totalResults / rowsPerPage);
  return /* @__PURE__ */ import_react153.default.createElement(import_react152.Flex, { sx: styles.root }, /* @__PURE__ */ import_react153.default.createElement(
    Results,
    {
      totalResults,
      rowsPerPage,
      currentPage
    }
  ), /* @__PURE__ */ import_react153.default.createElement(
    Pagination,
    {
      currentPage,
      totalPages,
      onPageChange
    }
  ));
}
function useStyles61() {
  return componentStyles({
    root: {
      flexDirection: { base: "column", md: "row" },
      justifyContent: { base: "center", md: "space-between" },
      alignItems: "center",
      gap: 2
    }
  });
}

// src/components/table/table.tsx
var import_react159 = __toESM(require("react"));
var import_react160 = require("@chakra-ui/react");

// src/components/table/table-row.tsx
var import_react157 = require("@chakra-ui/react");
var import_react158 = __toESM(require("react"));

// src/components/table/table-column.tsx
var import_react155 = __toESM(require("react"));
var import_react156 = require("@chakra-ui/react");

// src/utils/use-is-overflowing.ts
var import_react154 = require("react");
function useIsOverflowing({
  ref
}) {
  const [isOverflowing, setIsOverflowing] = (0, import_react154.useState)(false);
  (0, import_react154.useEffect)(() => {
    if (getIsOverflowing(ref.current)) {
      setIsOverflowing(true);
      return;
    }
    setIsOverflowing(false);
  }, [isOverflowing]);
  return {
    isOverflowing
  };
}
function getIsOverflowing(textContainer) {
  if (textContainer) {
    return textContainer.offsetHeight < textContainer.scrollHeight || textContainer.offsetWidth < textContainer.scrollWidth;
  }
  return false;
}

// src/components/table/table-column.tsx
function TableColumn({ columnConfig, isHeader }) {
  const {
    value,
    isTruncated,
    isHighlighted,
    isStickyLeft,
    isStickyRight,
    maxWidth,
    highlightColor,
    showTooltip
  } = columnConfig;
  const styleProps = useStyleProps8({
    isTruncated,
    isHighlighted,
    maxWidth,
    highlightColor,
    isStickyLeft,
    isStickyRight
  });
  const ref = (0, import_react155.useRef)(null);
  const { isOverflowing } = useIsOverflowing({ ref });
  const ColumnComponent = isHeader ? import_react156.Th : import_react156.Td;
  const isTooltipEnabled = getIsTooltipEnabled({
    value,
    isOverflowing,
    isTruncated,
    showTooltip
  });
  return /* @__PURE__ */ import_react155.default.createElement(Tooltip, { isDisabled: !isTooltipEnabled, label: value }, /* @__PURE__ */ import_react155.default.createElement(ColumnComponent, { ref, ...styleProps.cell }, value));
}
function useStyleProps8({
  isHighlighted,
  isTruncated,
  maxWidth = "100px",
  highlightColor,
  isStickyLeft,
  isStickyRight
}) {
  const colors = useColors();
  const cell = {
    color: highlightColor ?? "WindowText",
    fontWeight: isHighlighted ? "bold" : "normal",
    borderBottom: `1px solid ${colors.border}`,
    ...isTruncated && {
      maxWidth,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    ...isStickyLeft && {
      left: 0,
      position: "sticky",
      bgColor: "inherit",
      // prevents overflow from sticky affecting the table scroll container
      overflow: "hidden"
    },
    ...isStickyRight && {
      right: 0,
      position: "sticky",
      bgColor: "inherit",
      // prevents overflow from sticky affecting the table scroll container
      overflow: "hidden"
    }
  };
  return { cell };
}
function getIsTooltipEnabled({
  value,
  isOverflowing,
  isTruncated,
  showTooltip
}) {
  if (showTooltip) return true;
  return Boolean(typeof value === "string" && isOverflowing && isTruncated);
}

// src/components/table/table-row.tsx
function TableRow({ row, isHeader }) {
  const enrichedRow = getRowWithEnrichedColumns(row);
  const { columns, onRowClick, isHighlighted } = enrichedRow;
  const isRowClickable = Boolean(onRowClick);
  const styleProps = useStyleProps9({
    isRowClickable,
    isRowHighlighted: isHighlighted
  });
  return /* @__PURE__ */ import_react158.default.createElement(import_react157.Tr, { ...styleProps.row, onClick: onRowClick }, columns.map((columnConfig, colIdx) => /* @__PURE__ */ import_react158.default.createElement(
    TableColumn,
    {
      key: `column-${colIdx}-${columnConfig.value}`,
      columnConfig,
      isHeader
    }
  )));
}
function getRowWithEnrichedColumns(row) {
  const columnsWithActionCell = attachActionCell(row);
  return attachImage(columnsWithActionCell);
}
function attachActionCell(row) {
  const { actionCell } = row;
  if (!actionCell) return row;
  return {
    ...row,
    columns: [...row.columns, { value: actionCell, isStickyRight: true }]
  };
}
function attachImage(row) {
  const styles = getImageStyles();
  const { imageProps } = row;
  if (!imageProps) return row;
  const imageComponent = /* @__PURE__ */ import_react158.default.createElement(ImageWithPill, { ratio: 1, ...imageProps, style: styles.image });
  return {
    ...row,
    columns: [{ value: imageComponent }, ...row.columns]
  };
}
function getImageStyles() {
  return componentStyles({
    image: {
      borderRadius: "xl",
      overflow: "hidden",
      width: "70px"
    }
  });
}
function useStyleProps9({
  isRowClickable,
  isRowHighlighted = false
}) {
  const { bgSecondary, rowHighlight } = useColors();
  const rowBgColor = isRowHighlighted ? rowHighlight : "inherit";
  const row = {
    bgColor: rowBgColor,
    _hover: isRowClickable ? { bgColor: bgSecondary, cursor: "pointer" } : void 0
  };
  return { row };
}

// src/components/table/table.tsx
var TABLE_VARIANT = "simple";
function Table({
  headerRow,
  dataRows,
  emptyMessage,
  size = SIZES.SM,
  isLoading
}) {
  const styles = useStyles62();
  if (!dataRows.length && emptyMessage && !isLoading) {
    return /* @__PURE__ */ import_react159.default.createElement(TextMedium, { style: styles.emptyMessage }, emptyMessage);
  }
  const enrichedHeaderRow = enrichHeaderRow(headerRow, dataRows);
  return /* @__PURE__ */ import_react159.default.createElement(import_react160.TableContainer, { sx: styles.root }, /* @__PURE__ */ import_react159.default.createElement(import_react160.Table, { variant: TABLE_VARIANT, size, sx: styles.table }, /* @__PURE__ */ import_react159.default.createElement(import_react160.Thead, { sx: styles.tableHead }, /* @__PURE__ */ import_react159.default.createElement(TableRow, { row: enrichedHeaderRow, isHeader: true })), /* @__PURE__ */ import_react159.default.createElement(import_react160.Tbody, { sx: styles.tableBody }, dataRows.map((row, idx) => /* @__PURE__ */ import_react159.default.createElement(TableRow, { key: `row-${idx}`, row })))));
}
function enrichHeaderRow(headerRow, dataRows) {
  const hasActionCell = dataRows.some((row) => row.actionCell);
  const hasImage = dataRows.some((row) => row.imageProps);
  const headerColumns = [...headerRow.columns];
  if (hasActionCell) {
    headerColumns.push({ value: null, isStickyRight: true });
  }
  if (hasImage) {
    headerColumns.unshift({ value: null });
  }
  return {
    ...headerRow,
    columns: headerColumns
  };
}
function useStyles62() {
  return componentStyles({
    root: {
      width: "100%",
      fontSize: "sm",
      overflowX: "auto",
      boxSizing: "border-box",
      padding: 0,
      border: "none",
      backgroundColor: "inherit"
    },
    table: {
      backgroundColor: "inherit"
    },
    tableBody: {
      backgroundColor: "inherit"
    },
    tableHead: {
      backgroundColor: "inherit"
    },
    emptyMessage: {
      my: 8,
      textAlign: "center"
    }
  });
}

// src/components/table/table-view.tsx
var import_react164 = __toESM(require("react"));
var import_react165 = require("@chakra-ui/react");

// src/components/table/table-pagination.tsx
var import_react161 = __toESM(require("react"));
function TablePagination({
  count,
  page,
  pageSize,
  onPageChange,
  isSticky = true
}) {
  const styles = useStyles63({ isSticky });
  if (!count) {
    return null;
  }
  return /* @__PURE__ */ import_react161.default.createElement(Box, { testId: TEST_IDS.TABLE_PAGINATION, style: styles.container }, /* @__PURE__ */ import_react161.default.createElement(
    ListFooter,
    {
      totalResults: count,
      rowsPerPage: pageSize,
      currentPage: page,
      onPageChange
    }
  ));
}
function useStyles63({ isSticky }) {
  return componentStyles({
    container: {
      width: "100%",
      position: isSticky ? "sticky" : "relative",
      px: 4,
      py: 2,
      bottom: 0,
      zIndex: 1,
      bgColor: "inherit"
    }
  });
}

// src/components/error-message/error-message.tsx
var import_react162 = __toESM(require("react"));
var import_react163 = require("@chakra-ui/react");
function ErrorMessage({ error, shouldAddPadding, ...boxProps }) {
  const styles = useStyles64({ shouldAddPadding });
  if (!error) return null;
  return /* @__PURE__ */ import_react162.default.createElement(Box, { style: styles.root, ...boxProps }, /* @__PURE__ */ import_react162.default.createElement(import_react163.Alert, { sx: styles.alert, status: "error" }, /* @__PURE__ */ import_react162.default.createElement(import_react163.AlertIcon, null), error.message));
}
function useStyles64({ shouldAddPadding }) {
  return componentStyles({
    root: {
      paddingX: shouldAddPadding ? "4" : "0",
      width: "100%"
    },
    alert: {
      borderRadius: "md"
    }
  });
}

// src/components/table/table-view.tsx
function TableView({
  isLoading,
  error,
  shouldIncludeBorder = false,
  paginationProps,
  ...tableProps
}) {
  const styleProps = useStyleProps10({ shouldIncludeBorder });
  return /* @__PURE__ */ import_react164.default.createElement(import_react164.default.Fragment, null, /* @__PURE__ */ import_react164.default.createElement(import_react165.Box, { ...styleProps.container }, /* @__PURE__ */ import_react164.default.createElement(Table, { ...tableProps }), isLoading && /* @__PURE__ */ import_react164.default.createElement(
    import_react165.Progress,
    {
      isIndeterminate: isLoading,
      ...styleProps.progress
    }
  ), /* @__PURE__ */ import_react164.default.createElement(ErrorMessage, { error, ...styleProps.error })), paginationProps && /* @__PURE__ */ import_react164.default.createElement(TablePagination, { ...paginationProps }));
}
function useStyleProps10({
  shouldIncludeBorder
}) {
  const { border, bg } = useColors();
  return componentStyles({
    container: {
      bgColor: bg,
      ...shouldIncludeBorder && {
        borderWidth: "1px",
        borderRadius: "lg",
        overflow: "hidden",
        borderColor: border
      }
    },
    progress: {
      height: "2px",
      colorScheme: "brand" /* Brand */
    },
    error: {
      paddingX: 4,
      paddingY: 6
    }
  });
}

// src/components/dynamic-table/dynamic-table-view.tsx
var import_react172 = __toESM(require("react"));
var import_react173 = require("@chakra-ui/react");

// src/components/dynamic-table/dynamic-table.tsx
var import_react170 = require("@chakra-ui/react");
var import_react171 = __toESM(require("react"));

// src/components/card-list/card-list.tsx
var import_react169 = __toESM(require("react"));

// src/components/list-card/list-card.tsx
var import_react168 = __toESM(require("react"));

// src/components/list-card/list-card-line-items.tsx
var import_react167 = __toESM(require("react"));

// src/components/list-card/list-card-line-item.tsx
var import_react166 = __toESM(require("react"));
function ListCardLineItem({ lineItem }) {
  return /* @__PURE__ */ import_react166.default.createElement(HorizontalStackSpaceBetween, null, /* @__PURE__ */ import_react166.default.createElement(LineItemLabel, { label: lineItem.label }), /* @__PURE__ */ import_react166.default.createElement(LineItemValue, { value: lineItem.value }));
}
function LineItemValue({ value }) {
  if ((0, import_react166.isValidElement)(value)) return value;
  return /* @__PURE__ */ import_react166.default.createElement(TextSmall, null, value);
}
function LineItemLabel({ label }) {
  if ((0, import_react166.isValidElement)(label)) return label;
  return /* @__PURE__ */ import_react166.default.createElement(TextBoldSmall, null, label, ":");
}

// src/components/list-card/list-card-line-items.tsx
function ListCardLineItems({
  lineItems,
  shouldOffsetItems
}) {
  const styles = useStyles65({ shouldOffsetItems });
  return /* @__PURE__ */ import_react167.default.createElement(VerticalStackStretch, { style: styles.root }, lineItems.map((lineItem, index2) => /* @__PURE__ */ import_react167.default.createElement(
    ListCardLineItem,
    {
      key: `line-item-${index2}`,
      lineItem
    }
  )));
}
function useStyles65({ shouldOffsetItems }) {
  return componentStyles({
    root: {
      gap: 2,
      flex: 1,
      ...shouldOffsetItems && {
        marginTop: "40px"
      }
    }
  });
}

// src/components/list-card/list-card.tsx
function ListCard({
  lineItems,
  topRightCornerContent,
  hideImage,
  orientation = "horizontal" /* Horizontal */,
  imageStyle,
  ...imageCardProps
}) {
  const styles = useStyles66();
  const cardOrientation = useOrientation(orientation);
  const shouldOffsetItems = !!topRightCornerContent && (!!hideImage || cardOrientation === "horizontal" /* Horizontal */);
  return /* @__PURE__ */ import_react168.default.createElement(
    ImageCardContainer,
    {
      ...imageCardProps,
      imageStyle: { ...styles.defaultImage, ...imageStyle },
      orientation: cardOrientation,
      hideImage,
      topRightCornerContent
    },
    /* @__PURE__ */ import_react168.default.createElement(
      ListCardLineItems,
      {
        lineItems,
        shouldOffsetItems
      }
    )
  );
}
function useStyles66() {
  return componentStyles({
    defaultImage: {
      width: "min(150px, 25vw)",
      height: "min(150px, 25vw)",
      minWidth: "100px",
      minHeight: "100px",
      margin: "auto 0"
    }
  });
}

// src/components/card-list/card-list.tsx
function CardList2({
  headerRow,
  dataRows,
  emptyMessage,
  cardOrientation = "horizontal" /* Horizontal */
}) {
  const styles = useStyles67();
  const orientation = useOrientation(cardOrientation);
  if (!dataRows.length && emptyMessage) {
    return /* @__PURE__ */ import_react169.default.createElement(TextMedium, { style: styles.emptyMessage }, emptyMessage);
  }
  const cardProps = mapDataToCardProps(dataRows, headerRow);
  return /* @__PURE__ */ import_react169.default.createElement(VerticalStackStretch, { style: styles.root }, cardProps.map((props, index2) => /* @__PURE__ */ import_react169.default.createElement(
    ListCard,
    {
      key: `card-${index2}`,
      ...props,
      orientation
    }
  )));
}
function mapDataToCardProps(dataRows, headerRow) {
  return dataRows.map((row) => mapRowToCardProps(row, headerRow));
}
function mapRowToCardProps(row, headerRow) {
  const lineItems = row.columns.map((column, index2) => ({
    label: headerRow.columns[index2]?.value,
    value: column.value
  }));
  return {
    lineItems,
    headerImageAlt: row.imageProps?.imageAlt,
    headerImageSrc: row.imageProps?.imageSrc,
    headerImageRatio: row.imageProps?.ratio,
    topRightCornerContent: row.actionCell,
    hideImage: !row.imageProps,
    onClick: row.onRowClick
  };
}
function useStyles67() {
  return componentStyles({
    root: {
      width: "100%",
      fontSize: "sm"
    },
    emptyMessage: {
      my: 8,
      textAlign: "center"
    }
  });
}

// src/components/dynamic-table/dynamic-table.tsx
var TableType = /* @__PURE__ */ ((TableType2) => {
  TableType2["Dynamic"] = "dynamic";
  TableType2["Table"] = "table";
  TableType2["CardList"] = "card-list";
  return TableType2;
})(TableType || {});
function DynamicTable({
  tableType = "dynamic" /* Dynamic */,
  ...props
}) {
  const showDynamicTable = (0, import_react170.useBreakpointValue)({
    base: false,
    md: true
  });
  if (tableType === "table" /* Table */) {
    return /* @__PURE__ */ import_react171.default.createElement(Table, { ...props });
  }
  if (tableType === "card-list" /* CardList */) {
    return /* @__PURE__ */ import_react171.default.createElement(CardList2, { ...props });
  }
  if (showDynamicTable) {
    return /* @__PURE__ */ import_react171.default.createElement(Table, { ...props });
  }
  return /* @__PURE__ */ import_react171.default.createElement(CardList2, { ...props });
}

// src/components/dynamic-table/dynamic-table-view.tsx
function DynamicTableView({
  isLoading,
  error,
  shouldIncludeBorder = false,
  paginationProps,
  containerProps,
  ...tableProps
}) {
  const styleProps = useStyleProps11({ shouldIncludeBorder });
  return /* @__PURE__ */ import_react172.default.createElement(import_react172.default.Fragment, null, /* @__PURE__ */ import_react172.default.createElement(import_react173.Box, { ...styleProps.container, ...containerProps }, /* @__PURE__ */ import_react172.default.createElement(DynamicTable, { ...tableProps }), isLoading && /* @__PURE__ */ import_react172.default.createElement(
    import_react173.Progress,
    {
      isIndeterminate: isLoading,
      ...styleProps.progress
    }
  ), /* @__PURE__ */ import_react172.default.createElement(ErrorMessage, { error, ...styleProps.error })), paginationProps && /* @__PURE__ */ import_react172.default.createElement(TablePagination, { ...paginationProps }));
}
function useStyleProps11({
  shouldIncludeBorder
}) {
  const { border } = useColors();
  return componentStyles({
    container: {
      overflow: "hidden",
      bgColor: "inherit",
      ...shouldIncludeBorder && {
        borderWidth: "1px",
        borderRadius: "lg",
        borderColor: border
      }
    },
    progress: {
      height: "2px",
      colorScheme: "brand" /* Brand */
    },
    error: {
      paddingX: 4,
      paddingY: 6
    }
  });
}

// src/components/rows-per-page/rows-per-page.tsx
var import_react174 = __toESM(require("react"));
var import_faList = require("@fortawesome/free-solid-svg-icons/faList");
var ROWS_PER_PAGE_OPTIONS = [
  { label: "10 per page", value: 10 },
  { label: "25 per page", value: 25 },
  { label: "50 per page", value: 50 }
];
var SIZE3 = "sm";
function RowsPerPage({ value, onChange }) {
  const styles = useStyles68();
  return /* @__PURE__ */ import_react174.default.createElement(ActionPill, { icon: import_faList.faList, label: copy_constants_default.VIEW, size: SIZE3 }, /* @__PURE__ */ import_react174.default.createElement(
    SelectInput,
    {
      style: styles.input,
      value: String(value),
      onChange: (selectedValue) => onChange(Number(selectedValue)),
      items: ROWS_PER_PAGE_OPTIONS,
      size: SIZE3
    }
  ));
}
function useStyles68() {
  return componentStyles({
    input: {
      roundedRight: "3xl"
    }
  });
}

// src/components/highlight/highlight.tsx
var import_react175 = require("@chakra-ui/react");
var import_react176 = __toESM(require("react"));
function Highlight({ query, children, style }) {
  const styles = useStyles69();
  return /* @__PURE__ */ import_react176.default.createElement(import_react175.Highlight, { query, styles: { ...styles.root, ...style } }, children);
}
function useStyles69() {
  const colors = useColors();
  return componentStyles({
    root: {
      backgroundColor: colors.warning
    }
  });
}

// src/components/copy-text-button/copy-text-button.tsx
var import_react177 = require("@chakra-ui/react");
var import_react178 = __toESM(require("react"));
var import_react_fontawesome20 = require("@fortawesome/react-fontawesome");
var import_faCopy = require("@fortawesome/free-regular-svg-icons/faCopy");
function CopyTextButton({ textToCopy, children }) {
  const { onCopy, hasCopied, value } = (0, import_react177.useClipboard)(textToCopy);
  const label = hasCopied ? copy_constants_default.COPIED : copy_constants_default.COPY_TO_CLIPBOARD;
  return /* @__PURE__ */ import_react178.default.createElement(Tooltip, { closeOnClick: false, label }, /* @__PURE__ */ import_react178.default.createElement(
    import_react177.Button,
    {
      onClick: onCopy,
      rightIcon: /* @__PURE__ */ import_react178.default.createElement(import_react_fontawesome20.FontAwesomeIcon, { icon: import_faCopy.faCopy })
    },
    children || value
  ));
}

// src/components/loading-or-error-container/loading-or-error-container.tsx
var import_react182 = __toESM(require("react"));

// src/components/spinner/spinner.tsx
var import_react179 = require("@chakra-ui/react");
var import_react180 = __toESM(require("react"));
function Spinner({ size = "lg", noPadding, shouldInvertColor }) {
  const styles = useStyles70({ noPadding });
  const { colors } = useTheme2();
  const spinnerColor = shouldInvertColor ? colors.textInverse : colors.text;
  return /* @__PURE__ */ import_react180.default.createElement(Box, { style: styles.root }, /* @__PURE__ */ import_react180.default.createElement(
    import_react179.Spinner,
    {
      "data-testid": TEST_IDS.SPINNER,
      size,
      color: spinnerColor
    }
  ));
}
function useStyles70({ noPadding }) {
  return componentStyles({
    root: {
      alignSelf: "center",
      textAlign: "center",
      paddingTop: noPadding ? "0" : "96px"
    }
  });
}

// src/components/error-icon/error-icon.tsx
var import_react181 = __toESM(require("react"));
var import_react_fontawesome21 = require("@fortawesome/react-fontawesome");
var import_faCircleExclamation = require("@fortawesome/free-solid-svg-icons/faCircleExclamation");
function ErrorIcon({ errorMsg, noMargin = false }) {
  const styles = useStyles71({ noMargin });
  return /* @__PURE__ */ import_react181.default.createElement(Box, { style: styles.root }, /* @__PURE__ */ import_react181.default.createElement(import_react_fontawesome21.FontAwesomeIcon, { icon: import_faCircleExclamation.faCircleExclamation, fontSize: 52 }), /* @__PURE__ */ import_react181.default.createElement(TextBoldLarge, null, "Error: ", errorMsg));
}
function useStyles71({ noMargin }) {
  return componentStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginTop: noMargin ? "0" : 12,
      marginRight: noMargin ? "0" : "auto",
      marginBottom: "0",
      marginLeft: noMargin ? "0" : "auto",
      paddingX: 6,
      gap: 2
    }
  });
}

// src/utils/type-helpers.ts
function isString(value) {
  return typeof value === "string";
}

// src/components/loading-or-error-container/loading-or-error-container.tsx
function LoadingOrErrorContainer({
  style,
  isLoading = false,
  error = null,
  shouldRenderChildren = false,
  noMargin = false,
  noPadding = false,
  children = null
}) {
  const errorMessage = isString(error) ? error : error?.message;
  if (isLoading) return /* @__PURE__ */ import_react182.default.createElement(Spinner, { noPadding });
  if (errorMessage) {
    return /* @__PURE__ */ import_react182.default.createElement(ErrorIcon, { errorMsg: errorMessage, noMargin });
  }
  return /* @__PURE__ */ import_react182.default.createElement(
    ConditionalRenderContainer,
    {
      style,
      shouldRender: shouldRenderChildren
    },
    children
  );
}

// src/components/action-banner/action-banner.tsx
var import_react183 = __toESM(require("react"));
var import_react_fontawesome22 = require("@fortawesome/react-fontawesome");
var import_faLightbulb = require("@fortawesome/free-regular-svg-icons/faLightbulb");
var import_faTimes = require("@fortawesome/free-solid-svg-icons/faTimes");
function ActionBanner({
  title,
  ctaLabel,
  ctaUrl,
  colorScheme = "blue" /* Blue */,
  icon = import_faLightbulb.faLightbulb,
  IconComponent,
  iconSize = 22,
  style,
  children,
  ctaOnClick,
  hideIconBackground,
  noIconPadding,
  buttonVariant = "link" /* Link */,
  titleStyle = {},
  buttonStyle = {},
  onClose
}) {
  const isMobile = useIsMobile();
  const styles = useStyles72({
    colorScheme,
    hideIconBackground,
    iconSize,
    isMobile,
    hasCloseButton: !!onClose,
    noIconPadding
  });
  const shouldRenderCta = ctaLabel && (ctaUrl || ctaOnClick);
  const ContainerComponent = isMobile ? VerticalStack : HorizontalStack;
  return /* @__PURE__ */ import_react183.default.createElement(ContainerComponent, { style: { ...styles.banner, ...style } }, onClose && /* @__PURE__ */ import_react183.default.createElement(
    import_react_fontawesome22.FontAwesomeIcon,
    {
      icon: import_faTimes.faTimes,
      style: styles.closeIcon,
      onClick: onClose,
      "data-testid": TEST_IDS.BANNER_CLOSE_ICON
    }
  ), /* @__PURE__ */ import_react183.default.createElement(HorizontalStack, { style: styles.bodyContainer }, /* @__PURE__ */ import_react183.default.createElement(Box, { style: styles.iconContainer }, IconComponent ?? /* @__PURE__ */ import_react183.default.createElement(
    import_react_fontawesome22.FontAwesomeIcon,
    {
      "data-testid": TEST_IDS.BANNER_ICON,
      style: styles.icon,
      icon
    }
  )), /* @__PURE__ */ import_react183.default.createElement(VerticalStack, { style: styles.titleContainer }, title && /* @__PURE__ */ import_react183.default.createElement(Text, { style: { ...styles.title, ...titleStyle } }, title), /* @__PURE__ */ import_react183.default.createElement(Box, { style: styles.childrenContainer }, children))), shouldRenderCta && /* @__PURE__ */ import_react183.default.createElement(HorizontalStack, { style: styles.ctaContainer }, /* @__PURE__ */ import_react183.default.createElement(
    LinkButton,
    {
      href: ctaUrl,
      style: { ...styles.cta, ...buttonStyle },
      onClick: ctaOnClick,
      variant: buttonVariant
    },
    ctaLabel
  )));
}
function useStyles72({
  colorScheme,
  hideIconBackground,
  iconSize,
  isMobile,
  hasCloseButton,
  noIconPadding
}) {
  const {
    backgroundColor,
    iconColor,
    titleColor,
    descriptionColor,
    ctaColor,
    borderColor
  } = useActionBannerColors({ colorScheme });
  const closeIconStyle = {
    position: "absolute",
    top: 10,
    right: "10px",
    cursor: "pointer",
    fontSize: "18px",
    color: titleColor
  };
  const bannerStyle = {
    backgroundColor,
    borderRadius: 20,
    padding: "1rem",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    display: "flex",
    alignItems: "center",
    flex: 1,
    justifyContent: "space-between",
    borderColor,
    borderWidth: "1px",
    position: "relative"
  };
  return componentStyles({
    banner: bannerStyle,
    bodyContainer: {
      width: "100%",
      alignItems: "center",
      gap: "12px",
      ...hasCloseButton && isMobile && {
        marginTop: "1rem"
      }
    },
    iconContainer: {
      backgroundColor: hideIconBackground ? "transparent" : iconColor,
      borderRadius: "50%",
      aspectRatio: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: noIconPadding ? "0" : "0.7rem"
    },
    icon: {
      color: hideIconBackground ? iconColor : borderColor,
      width: iconSize,
      height: iconSize
    },
    title: {
      fontWeight: "bold",
      fontSize: "16px",
      color: titleColor
    },
    titleContainer: {
      width: "100%",
      justifyContent: "space-around",
      gap: 0
    },
    childrenContainer: {
      fontSize: "14px",
      margin: "4px 0 0",
      color: descriptionColor,
      fontWeight: "semi-bold",
      width: "100%"
    },
    cta: {
      fontSize: "12px",
      fontWeight: "bold",
      color: ctaColor,
      textDecoration: "underline",
      ...hasCloseButton && !isMobile && {
        marginRight: "1rem"
      }
    },
    closeIcon: closeIconStyle,
    ctaContainer: {
      ...isMobile && {
        alignSelf: "flex-end"
      }
    }
  });
}

// src/components/action-banner-with-button/action-banner-with-button.tsx
var import_react184 = __toESM(require("react"));
function ActionBannerWithButton({
  title,
  description,
  buttonLabel,
  buttonOnClick,
  style,
  children,
  colorScheme = "blue" /* Blue */
}) {
  const styles = useStyles73({ colorScheme });
  return /* @__PURE__ */ import_react184.default.createElement(Card, { style: { ...styles.card, ...style } }, /* @__PURE__ */ import_react184.default.createElement(HorizontalStackSpaceBetween, { style: styles.content }, /* @__PURE__ */ import_react184.default.createElement(Box, { style: styles.contentContainer }, /* @__PURE__ */ import_react184.default.createElement(TextBold, { style: styles.title }, title), /* @__PURE__ */ import_react184.default.createElement(TextSmall, { style: styles.description }, description)), /* @__PURE__ */ import_react184.default.createElement(
    Button,
    {
      style: styles.button,
      onClick: buttonOnClick,
      colorScheme
    },
    buttonLabel
  )), /* @__PURE__ */ import_react184.default.createElement(Box, { style: styles.childrenContainer }, children));
}
function useStyles73({ colorScheme }) {
  const { backgroundColor, titleColor, descriptionColor, borderColor } = useActionBannerColors({
    colorScheme
  });
  return componentStyles({
    card: {
      backgroundColor,
      borderColor,
      borderWidth: "1px"
    },
    content: {
      flexDirection: { base: "column", md: "row" },
      alignItems: { base: "flex-start", md: "center" }
    },
    contentContainer: {
      flex: 1
    },
    button: {
      flexShrink: 0
    },
    title: {
      color: titleColor,
      lineHeight: "24px"
    },
    description: {
      color: descriptionColor,
      lineHeight: "24px",
      weight: "600"
    },
    childrenContainer: {
      marginTop: "16px",
      width: "100%"
    }
  });
}

// src/components/drawer/drawer.tsx
var import_react185 = __toESM(require("react"));
var import_react186 = require("@chakra-ui/react");
var DrawerPlacement = /* @__PURE__ */ ((DrawerPlacement2) => {
  DrawerPlacement2["Bottom"] = "bottom";
  DrawerPlacement2["Top"] = "top";
  DrawerPlacement2["Left"] = "left";
  DrawerPlacement2["Right"] = "right";
  DrawerPlacement2["Start"] = "start";
  DrawerPlacement2["End"] = "end";
  return DrawerPlacement2;
})(DrawerPlacement || {});
var DrawerSize = /* @__PURE__ */ ((DrawerSize2) => {
  DrawerSize2["ExtraSmall"] = "xs";
  DrawerSize2["Small"] = "sm";
  DrawerSize2["Medium"] = "md";
  DrawerSize2["Large"] = "lg";
  DrawerSize2["ExtraLarge"] = "xl";
  DrawerSize2["Full"] = "full";
  return DrawerSize2;
})(DrawerSize || {});
function Drawer({
  style,
  isOpen = false,
  onClose,
  placement,
  size,
  children,
  shouldHideCloseButton
}) {
  const styles = useStyles74();
  return /* @__PURE__ */ import_react185.default.createElement(
    import_react186.Drawer,
    {
      isOpen,
      onClose,
      placement,
      size
    },
    /* @__PURE__ */ import_react185.default.createElement(import_react186.DrawerOverlay, null),
    /* @__PURE__ */ import_react185.default.createElement(import_react186.DrawerContent, { sx: styles.content }, !shouldHideCloseButton && /* @__PURE__ */ import_react185.default.createElement(import_react186.DrawerCloseButton, null), /* @__PURE__ */ import_react185.default.createElement(import_react186.DrawerBody, { sx: { ...styles.body, ...style } }, children))
  );
}
function useStyles74() {
  const colors = useColors();
  return componentStyles({
    content: {
      backgroundColor: colors.bg,
      border: `1px solid ${colors.border}`
    },
    body: {
      padding: "10px 0 0 0"
    }
  });
}

// src/components/drawer/bottom-drawer.tsx
var import_react187 = __toESM(require("react"));
function BottomDrawer({
  isOpen,
  onClose,
  shouldRenderFullHeight,
  shouldHaveHorizontalPadding,
  shouldHaveExtraBottomPadding,
  children
}) {
  const styles = useStyles75({
    shouldHaveHorizontalPadding,
    shouldHaveExtraBottomPadding
  });
  const drawerSize = shouldRenderFullHeight ? "full" /* Full */ : "xl" /* ExtraLarge */;
  return /* @__PURE__ */ import_react187.default.createElement(
    Drawer,
    {
      style: styles.root,
      isOpen,
      onClose,
      size: drawerSize,
      placement: "bottom" /* Bottom */
    },
    children
  );
}
function useStyles75({
  shouldHaveHorizontalPadding,
  shouldHaveExtraBottomPadding
}) {
  return componentStyles({
    root: {
      marginX: shouldHaveHorizontalPadding ? 4 : 0,
      marginTop: 8,
      marginBottom: shouldHaveExtraBottomPadding ? 12 : 4
    }
  });
}

// src/components/progress-card/progress-card.tsx
var import_react191 = require("@chakra-ui/react");
var import_react_fontawesome24 = require("@fortawesome/react-fontawesome");
var import_react192 = __toESM(require("react"));

// src/components/progress-card/progress-with-label.tsx
var import_react190 = __toESM(require("react"));

// src/components/progress-card/progress-with-complete.tsx
var import_react188 = __toESM(require("react"));
var import_react189 = require("@chakra-ui/react");
var import_react_fontawesome23 = require("@fortawesome/react-fontawesome");
var import_faCheckCircle2 = require("@fortawesome/free-regular-svg-icons/faCheckCircle");
var PROGRESS_SIZE = "24px";
function ProgressWithComplete({
  percentComplete
}) {
  const colors = useColors();
  const isComplete = percentComplete === 100;
  if (isComplete) {
    return /* @__PURE__ */ import_react188.default.createElement(import_react_fontawesome23.FontAwesomeIcon, { icon: import_faCheckCircle2.faCheckCircle, fontSize: PROGRESS_SIZE });
  }
  return /* @__PURE__ */ import_react188.default.createElement(
    import_react189.CircularProgress,
    {
      value: percentComplete,
      size: PROGRESS_SIZE,
      color: colors.text,
      trackColor: colors.bgTertiary
    }
  );
}

// src/components/progress-card/progress-with-label.tsx
function ProgressWithLabel({
  percentComplete,
  isActive
}) {
  const styles = useStyles76(percentComplete, isActive);
  const percentCompleteText = getPercentCompleteText(percentComplete);
  return /* @__PURE__ */ import_react190.default.createElement(HorizontalStackSmallGap, { style: styles.container }, /* @__PURE__ */ import_react190.default.createElement(ProgressWithComplete, { percentComplete }), /* @__PURE__ */ import_react190.default.createElement(TextBoldSmall, null, percentCompleteText));
}
function useStyles76(percentComplete, isActive) {
  const color = useProgressColor(percentComplete, isActive);
  return componentStyles({
    container: {
      marginTop: "auto",
      color
    }
  });
}
function getPercentCompleteText(percentComplete) {
  const formattedPercent = `${percentComplete}%`;
  return `${formattedPercent} ${copy_constants_default.DONE}`;
}
function useProgressColor(percentComplete, isActive) {
  const colors = useColors();
  if (percentComplete === 100) return colors.success;
  if (percentComplete === 0 && !isActive) return colors.secondaryText;
  return void 0;
}

// src/components/progress-card/progress-card.tsx
function ProgressCard(props) {
  const { isActive } = props;
  const Wrapper = isActive ? import_react191.DarkMode : import_react192.Fragment;
  return /* @__PURE__ */ import_react192.default.createElement(Wrapper, null, /* @__PURE__ */ import_react192.default.createElement(ProgressCardContent, { ...props }));
}
function ProgressCardContent({
  icon,
  title,
  description,
  percentComplete,
  stepNumber,
  style,
  onClick,
  isActive,
  testId = TEST_IDS.PROGRESS_CARD
}) {
  const styles = useStyles77({ isActive });
  return /* @__PURE__ */ import_react192.default.createElement(
    Card,
    {
      style: { ...style, ...styles.card },
      testId,
      onClick
    },
    /* @__PURE__ */ import_react192.default.createElement(VerticalStackStretch, { style: styles.verticalStack }, /* @__PURE__ */ import_react192.default.createElement(HorizontalStackSpaceBetween, null, /* @__PURE__ */ import_react192.default.createElement(Box, { style: styles.stepNumber }, /* @__PURE__ */ import_react192.default.createElement(TextBoldSmall, null, stepNumber)), /* @__PURE__ */ import_react192.default.createElement(import_react191.Icon, { as: import_react_fontawesome24.FontAwesomeIcon, icon, sx: styles.icon })), /* @__PURE__ */ import_react192.default.createElement(TextXLargeBold, { style: styles.title }, title), /* @__PURE__ */ import_react192.default.createElement(Text, { style: styles.description }, description), /* @__PURE__ */ import_react192.default.createElement(
      ProgressWithLabel,
      {
        percentComplete,
        isActive
      }
    ))
  );
}
function useStyles77({ isActive }) {
  const STEP_NUMBER_SIZE = "40px";
  const colors = useColors();
  const descriptionColor = isActive ? colors.text : colors.secondaryText;
  return componentStyles({
    card: {
      padding: "24px",
      ...isActive && {
        backgroundColor: colors.brand[400]
      },
      borderRadius: "24px"
    },
    verticalStack: {
      height: "100%",
      gap: "24px"
    },
    stepNumber: {
      width: STEP_NUMBER_SIZE,
      height: STEP_NUMBER_SIZE,
      borderRadius: "full",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: colors.brand[400],
      color: colors.white,
      filter: isActive ? "brightness(0.9)" : void 0
    },
    description: {
      color: descriptionColor
    },
    icon: {
      color: isActive ? colors.white : colors.brand[400],
      fontSize: { base: "40px", md: "80px" }
    },
    title: {
      fontSize: { base: "18px", md: "22px" }
    }
  });
}

// src/components/mallard-bay-logo/mallard-bay-logo.tsx
var import_react193 = require("@chakra-ui/react");
var import_react194 = __toESM(require("react"));

// src/images/mb-logo-dark.svg
var mb_logo_dark_default = 'data:image/svg+xml,<svg xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" version="1.1" id="svg2" sodipodi:docname="Mallard Bay Logos-28.eps" viewBox="10.39 223.86 457.95 49.91">%0A  <defs id="defs6"/>%0A  <sodipodi:namedview id="namedview4" pagecolor="%23ffffff" bordercolor="%23000000" borderopacity="0.25" inkscape:showpageshadow="2" inkscape:pageopacity="0.0" inkscape:pagecheckerboard="0" inkscape:deskcolor="%23d1d1d1"/>%0A  <g id="g8" inkscape:groupmode="layer" inkscape:label="ink_ext_XXXXXX" transform="matrix(1.3333333,0,0,-1.3333333,0,480)">%0A    <g id="g10" transform="scale(0.1)">%0A      <path d="m 3063.64,1745.74 c 8.56,-0.5 25.23,-1.95 34.13,-3.61 3.15,-0.54 6.28,-1.22 9.54,-1.93 60.48,-13.82 111.65,-50.91 147.73,-57.92 18.2,-3.53 27.73,-9.39 45.82,-0.66 16.62,8.03 26.44,14.22 38.07,23.88 -26.31,1.77 -127.15,42.98 -169.9,53.81 -36.95,9.22 -71.27,10.77 -83.87,11.33 -4.31,-7.12 -14.71,-16.25 -21.52,-24.9" style="fill:%23100f0d;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path12"/>%0A      <path d="m 3148.51,1652.99 c 8.21,-5 17.86,-10.24 29.8,-16.34 22.17,-11.13 34.48,-9.43 42.68,-5.63 8.34,3.77 28.28,16.27 40.27,27.28 -20.25,1.69 -42.3,11.07 -67.44,23.79 -12.14,-7.84 -28.17,-18.02 -45.31,-29.1" style="fill:%23100f0d;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path14"/>%0A      <path d="m 3492.9,1796.08 c -12.73,-12.21 -32.41,-19.68 -56.61,-15.59 -16.4,2.77 -78.71,13.67 -147.11,25.66 -65.55,11.51 -130.65,23.13 -151.48,20.1 -41.39,-5.99 -58.12,-38.12 -87.25,-73.33 -12.54,-15.15 -61.35,-72.17 -69.47,-81.89 l 67.73,114.5 c 21.87,41.52 46.25,77.53 93.34,78.2 145.67,2.1 335.45,-64.78 370.5,-27.44 -0.45,-12.22 -7.15,-28.21 -19.65,-40.21" style="fill:%23100f0d;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path16"/>%0A      <path d="m 3196.34,1770.31 c -40.15,10.8 -81.75,18.64 -102.76,13.76 35.9,50.3 130.85,15.44 168.86,7.1 38.01,-8.36 143.14,-29.29 170.15,-32.61 -13.02,-12.85 -36.13,-26.63 -54.57,-32.82 -18.43,-6.19 -34.4,-4.41 -57.8,4.4 -23.41,8.81 -83.73,29.39 -123.88,40.17" style="fill:%23100f0d;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path18"/>%0A      <path d="m 3088.77,1615.17 c 7.32,-7.05 13.87,-12.24 18.82,-14.96 18.28,-10.15 24.25,-15.56 40.09,-9.75 15.69,5.67 27.32,12.19 39.93,18.86 -24.47,8.69 -44.09,18.91 -60.9,29.76 -12.86,-8.2 -25.86,-16.37 -37.94,-23.91" style="fill:%23100f0d;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path20"/>%0A      <path d="m 3034.86,1583.12 c 4.86,-7.26 12.02,-12.87 23.65,-13.58 20.72,-1.3 44.82,5.47 48.94,5.88 -12.75,6.08 -25.62,15.47 -37.81,28.05 -15.23,-9.36 -27.67,-16.69 -34.78,-20.35" style="fill:%23100f0d;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path22"/>%0A      <path d="m 172.68,1832.13 c 15.461,63.69 4.066,73.65 -5.285,82.91 l 1.218,6.04 h 140.75 l 8.953,-154.43 85.43,154.43 H 536.77 l -1.223,-6.04 c -14.238,-9.26 -30.508,-19.22 -45.969,-82.91 L 441.98,1635.7 c -15.457,-63.69 -4.066,-73.65 5.29,-82.91 l -1.219,-6.04 H 293.098 l 1.218,6.04 c 14.239,9.26 30.508,19.22 45.965,82.91 l 45.157,185.76 -131.805,-238.06 h -29.285 l -16.684,242.32 -45.965,-190.02 c -15.461,-63.69 -4.066,-73.65 5.289,-82.91 l -1.222,-6.04 H 77.8945 l 1.2227,6.04 c 14.2383,9.26 30.5118,19.22 45.9728,82.91 l 47.59,196.43" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path24"/>%0A      <path d="m 616.863,1797.26 -50.847,-115.65 h 45.562 z m -144.414,-208.17 1.633,6.76 c 16.27,10.32 28.473,24.91 41.898,55.87 l 73.223,166.17 c 13.426,30.96 14.238,45.55 6.914,55.87 l 1.625,6.76 h 143.606 l -1.625,-6.76 c -12.207,-10.32 -18.715,-24.91 -19.938,-55.87 l -8.137,-166.17 c -1.218,-30.96 3.665,-45.55 15.055,-55.87 l -1.629,-6.76 H 588.391 l 1.629,6.76 c 12.203,10.32 18.71,24.91 19.929,55.87 l 0.406,4.98 h -55.32 l -2.039,-4.98 c -13.422,-30.96 -14.234,-45.55 -6.91,-55.87 l -1.629,-6.76 h -72.008" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path26"/>%0A      <path d="m 814.543,1817.89 c 7.32,30.96 5.293,45.55 -4.07,55.87 l 1.632,6.76 h 136.684 l -1.633,-6.76 c -14.234,-10.32 -23.593,-24.91 -30.91,-55.87 l -50.445,-207.45 h 1.219 c 58.175,0 123.668,91.45 130.582,104.26 h 7.728 L 962.617,1589.09 H 741.316 l 1.633,6.76 c 14.235,10.32 23.594,24.91 30.914,55.87 l 40.68,166.17" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path28"/>%0A      <path d="m 1064.3,1817.89 c 7.32,30.96 5.28,45.55 -4.08,55.87 l 1.64,6.76 h 136.68 l -1.63,-6.76 c -14.24,-10.32 -23.59,-24.91 -30.91,-55.87 l -50.45,-207.45 h 1.22 c 58.17,0 123.67,91.45 130.58,104.26 h 7.73 l -42.71,-125.61 h -221.3 l 1.625,6.76 c 14.235,10.32 23.595,24.91 30.915,55.87 l 40.69,166.17" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path30"/>%0A      <path d="m 1385.23,1797.26 -50.85,-115.65 h 45.57 z m -144.41,-208.17 1.63,6.76 c 16.27,10.32 28.47,24.91 41.9,55.87 l 73.22,166.17 c 13.43,30.96 14.24,45.55 6.92,55.87 l 1.62,6.76 h 143.61 l -1.63,-6.76 c -12.21,-10.32 -18.71,-24.91 -19.94,-55.87 l -8.13,-166.17 c -1.22,-30.96 3.66,-45.55 15.05,-55.87 l -1.63,-6.76 h -136.68 l 1.63,6.76 c 12.2,10.32 18.71,24.91 19.93,55.87 l 0.41,4.98 h -55.33 l -2.03,-4.98 c -13.43,-30.96 -14.24,-45.55 -6.92,-55.87 l -1.62,-6.76 h -72.01" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path32"/>%0A      <path d="m 1667.93,1749.93 h 5.69 c 34.58,0 55.33,29.18 61.43,54.44 6.1,25.27 -0.41,54.8 -34.98,54.8 h -5.7 z m -85.02,67.96 c 7.32,30.96 5.29,45.55 -4.07,55.87 l 1.63,6.76 h 193.63 c 53.7,0 75.26,-32.39 64.68,-75.79 -8.95,-36.3 -36.61,-65.12 -76.48,-73.66 l 11.4,-82.91 c 4.06,-28.82 6.1,-44.13 17.08,-52.66 l -1.62,-6.41 h -130.59 l 1.63,6.41 c 9.76,9.96 9.76,22.77 7.73,52.66 l -5.29,78.64 h -0.41 l -18.3,-75.08 c -7.32,-30.96 -5.29,-45.55 4.07,-55.87 l -1.63,-6.76 h -136.69 l 1.63,6.76 c 14.24,10.32 23.6,24.91 30.92,55.87 l 40.68,166.17" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path34"/>%0A      <path d="m 1929.88,1610.44 h 3.66 c 49.22,0 68.75,93.94 76.07,124.19 7.32,30.24 33.36,124.54 -15.86,124.54 h -3.67 z m 54.1,-21.35 H 1805.4 l 1.62,6.76 c 14.24,10.32 23.6,24.91 30.92,55.87 l 40.68,166.17 c 7.32,30.96 5.29,45.55 -4.07,55.87 l 1.63,6.76 h 178.59 c 83.39,0 67.52,-90.02 54.1,-145.54 -13.02,-53.73 -44.75,-145.89 -124.89,-145.89" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path36"/>%0A      <path d="m 2352.09,1776.26 c 64.27,2.49 99.67,118.13 29.7,123.12 z m -50.44,-208.16 h 5.69 c 67.12,0 119.6,186.81 42.31,186.81 h -2.85 z m -37.84,264.03 c 15.46,63.69 4.07,73.65 -5.28,82.91 l 1.22,6.04 h 186.31 c 105.36,0 92.75,-115.29 14.64,-153.72 74.04,-42.34 15.46,-220.61 -93.15,-220.61 h -198.52 l 1.22,6.04 c 14.24,9.26 30.51,19.22 45.97,82.91 l 47.59,196.43" style="fill:%23100f0d;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path38"/>%0A      <path d="m 2632.34,1797.26 -50.85,-115.65 h 45.56 z m -144.42,-208.17 1.63,6.76 c 16.28,10.32 28.48,24.91 41.91,55.87 l 73.22,166.17 c 13.42,30.96 14.24,45.55 6.91,55.87 l 1.63,6.76 h 143.6 l -1.62,-6.76 c -12.21,-10.32 -18.72,-24.91 -19.94,-55.87 l -8.14,-166.17 c -1.22,-30.96 3.67,-45.55 15.06,-55.87 l -1.63,-6.76 h -136.69 l 1.63,6.76 c 12.21,10.32 18.71,24.91 19.93,55.87 l 0.41,4.98 h -55.32 l -2.04,-4.98 c -13.42,-30.96 -14.24,-45.55 -6.91,-55.87 l -1.63,-6.76 h -72.01" style="fill:%23100f0d;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path40"/>%0A      <path d="m 2941.48,1730 -19.12,-78.28 c -7.32,-30.96 -5.28,-45.55 4.07,-55.87 l -1.63,-6.76 h -136.68 l 1.63,6.76 c 14.23,10.32 23.59,24.91 30.91,55.87 l 17.9,72.95 -19.52,93.22 c -6.92,31.32 -7.33,45.55 -21.15,55.87 l 1.22,6.76 h 132.61 l -1.22,-6.76 c -14.24,-8.18 -12.2,-24.55 -5.7,-55.87 l 8.95,-44.83 30.11,44.83 c 21.15,31.67 30.1,47.69 23.19,55.87 l 1.62,6.76 h 67.53 l -1.62,-6.76 c -19.53,-10.32 -32.95,-24.2 -54.11,-55.87 L 2941.48,1730" style="fill:%23100f0d;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path42"/>%0A    </g>%0A  </g>%0A</svg>';

// src/images/mb-logo-light.svg
var mb_logo_light_default = 'data:image/svg+xml,<svg xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" version="1.1" id="svg2" sodipodi:docname="Mallard Bay Logos-14.eps" viewBox="10.39 223.86 457.95 49.91">%0A  <defs id="defs6"/>%0A  <sodipodi:namedview id="namedview4" pagecolor="%23ffffff" bordercolor="%23000000" borderopacity="0.25" inkscape:showpageshadow="2" inkscape:pageopacity="0.0" inkscape:pagecheckerboard="0" inkscape:deskcolor="%23d1d1d1"/>%0A  <g id="g8" inkscape:groupmode="layer" inkscape:label="ink_ext_XXXXXX" transform="matrix(1.3333333,0,0,-1.3333333,0,480)">%0A    <g id="g10" transform="scale(0.1)">%0A      <path d="m 3063.64,1745.74 c 8.56,-0.5 25.23,-1.95 34.13,-3.61 3.15,-0.54 6.28,-1.22 9.54,-1.93 60.48,-13.82 111.65,-50.91 147.73,-57.92 18.2,-3.53 27.73,-9.39 45.82,-0.66 16.62,8.03 26.44,14.22 38.07,23.88 -26.31,1.77 -127.15,42.98 -169.9,53.81 -36.95,9.22 -71.27,10.77 -83.87,11.33 -4.31,-7.12 -14.71,-16.25 -21.52,-24.9" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path12"/>%0A      <path d="m 3148.51,1652.99 c 8.21,-5 17.86,-10.24 29.8,-16.34 22.17,-11.13 34.48,-9.43 42.68,-5.64 8.34,3.78 28.28,16.28 40.27,27.29 -20.25,1.69 -42.3,11.07 -67.44,23.79 -12.14,-7.84 -28.17,-18.02 -45.31,-29.1" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path14"/>%0A      <path d="m 3492.9,1796.08 c -12.73,-12.21 -32.41,-19.68 -56.61,-15.59 -16.4,2.77 -78.71,13.67 -147.11,25.66 -65.55,11.51 -130.65,23.13 -151.48,20.1 -41.39,-5.99 -58.12,-38.12 -87.26,-73.33 -12.53,-15.15 -61.34,-72.17 -69.46,-81.89 l 67.73,114.5 c 21.87,41.52 46.25,77.53 93.34,78.2 145.67,2.1 335.45,-64.78 370.5,-27.44 -0.45,-12.22 -7.15,-28.21 -19.65,-40.21" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path16"/>%0A      <path d="m 3196.34,1770.31 c -40.15,10.8 -81.75,18.64 -102.76,13.76 35.9,50.3 130.85,15.44 168.86,7.1 38.01,-8.36 143.14,-29.29 170.15,-32.61 -13.02,-12.85 -36.13,-26.63 -54.57,-32.82 -18.43,-6.19 -34.4,-4.41 -57.8,4.4 -23.41,8.81 -83.74,29.38 -123.88,40.17" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path18"/>%0A      <path d="m 3088.77,1615.17 c 7.32,-7.05 13.87,-12.24 18.82,-14.96 18.28,-10.15 24.25,-15.56 40.09,-9.75 15.69,5.67 27.32,12.19 39.93,18.86 -24.47,8.69 -44.09,18.91 -60.9,29.76 -12.86,-8.2 -25.86,-16.37 -37.94,-23.91" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path20"/>%0A      <path d="m 3034.86,1583.11 c 4.86,-7.25 12.02,-12.86 23.65,-13.57 20.72,-1.3 44.82,5.47 48.94,5.88 -12.75,6.08 -25.62,15.47 -37.81,28.05 -15.23,-9.36 -27.67,-16.69 -34.78,-20.36" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path22"/>%0A      <path d="m 172.68,1832.13 c 15.461,63.69 4.066,73.65 -5.285,82.91 l 1.218,6.04 h 140.75 l 8.953,-154.43 85.43,154.43 H 536.77 l -1.223,-6.04 c -14.238,-9.26 -30.508,-19.22 -45.969,-82.91 L 441.98,1635.7 c -15.457,-63.69 -4.066,-73.65 5.29,-82.91 l -1.219,-6.04 H 293.098 l 1.218,6.04 c 14.239,9.26 30.508,19.22 45.965,82.91 l 45.157,185.75 -131.805,-238.05 h -29.285 l -16.684,242.32 -45.965,-190.02 c -15.461,-63.69 -4.066,-73.65 5.289,-82.91 l -1.222,-6.04 H 77.8945 l 1.2227,6.04 c 14.2383,9.26 30.5118,19.22 45.9728,82.91 l 47.59,196.43" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path24"/>%0A      <path d="m 616.863,1797.26 -50.847,-115.65 h 45.562 z m -144.414,-208.17 1.633,6.76 c 16.27,10.32 28.473,24.91 41.898,55.87 l 73.223,166.17 c 13.426,30.96 14.238,45.55 6.914,55.87 l 1.625,6.76 h 143.606 l -1.625,-6.76 c -12.207,-10.32 -18.715,-24.91 -19.938,-55.87 l -8.137,-166.17 c -1.218,-30.96 3.665,-45.55 15.055,-55.87 l -1.629,-6.76 H 588.391 l 1.629,6.76 c 12.203,10.32 18.71,24.91 19.929,55.87 l 0.406,4.98 h -55.32 l -2.039,-4.98 c -13.422,-30.96 -14.234,-45.55 -6.91,-55.87 l -1.629,-6.76 h -72.008" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path26"/>%0A      <path d="m 814.543,1817.89 c 7.32,30.96 5.293,45.55 -4.07,55.87 l 1.632,6.76 h 136.684 l -1.633,-6.76 c -14.234,-10.32 -23.593,-24.91 -30.91,-55.87 l -50.445,-207.45 h 1.219 c 58.175,0 123.668,91.45 130.582,104.26 h 7.728 L 962.617,1589.09 H 741.316 l 1.633,6.76 c 14.235,10.32 23.594,24.91 30.914,55.87 l 40.68,166.17" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path28"/>%0A      <path d="m 1064.3,1817.89 c 7.32,30.96 5.28,45.55 -4.08,55.87 l 1.64,6.76 h 136.68 l -1.63,-6.76 c -14.24,-10.32 -23.59,-24.91 -30.91,-55.87 l -50.45,-207.45 h 1.22 c 58.17,0 123.67,91.45 130.58,104.26 h 7.73 l -42.71,-125.61 h -221.3 l 1.625,6.76 c 14.235,10.32 23.595,24.91 30.915,55.87 l 40.69,166.17" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path30"/>%0A      <path d="m 1385.23,1797.26 -50.85,-115.65 h 45.57 z m -144.41,-208.17 1.63,6.76 c 16.27,10.32 28.47,24.91 41.9,55.87 l 73.22,166.17 c 13.43,30.96 14.24,45.55 6.92,55.87 l 1.62,6.76 h 143.61 l -1.63,-6.76 c -12.21,-10.32 -18.71,-24.91 -19.94,-55.87 l -8.13,-166.17 c -1.22,-30.96 3.66,-45.55 15.05,-55.87 l -1.63,-6.76 h -136.68 l 1.63,6.76 c 12.2,10.32 18.71,24.91 19.93,55.87 l 0.41,4.98 h -55.33 l -2.03,-4.98 c -13.43,-30.96 -14.24,-45.55 -6.92,-55.87 l -1.62,-6.76 h -72.01" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path32"/>%0A      <path d="m 1667.93,1749.93 h 5.69 c 34.58,0 55.33,29.18 61.43,54.44 6.1,25.27 -0.41,54.8 -34.98,54.8 h -5.7 z m -85.02,67.96 c 7.32,30.96 5.29,45.55 -4.07,55.87 l 1.63,6.76 h 193.63 c 53.7,0 75.26,-32.39 64.68,-75.79 -8.95,-36.3 -36.61,-65.12 -76.48,-73.66 l 11.4,-82.91 c 4.06,-28.82 6.1,-44.13 17.08,-52.66 l -1.62,-6.41 h -130.59 l 1.63,6.41 c 9.76,9.96 9.76,22.77 7.73,52.66 l -5.29,78.64 h -0.41 l -18.3,-75.08 c -7.32,-30.96 -5.29,-45.55 4.07,-55.87 l -1.63,-6.76 h -136.69 l 1.63,6.76 c 14.24,10.32 23.6,24.91 30.92,55.87 l 40.68,166.17" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path34"/>%0A      <path d="m 1929.88,1610.44 h 3.66 c 49.22,0 68.75,93.94 76.07,124.19 7.32,30.24 33.36,124.54 -15.86,124.54 h -3.67 z m 54.1,-21.35 H 1805.4 l 1.62,6.76 c 14.24,10.32 23.6,24.91 30.92,55.87 l 40.68,166.17 c 7.32,30.96 5.29,45.55 -4.07,55.87 l 1.63,6.76 h 178.59 c 83.39,0 67.52,-90.02 54.1,-145.54 -13.02,-53.73 -44.75,-145.89 -124.89,-145.89" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path36"/>%0A      <path d="m 2352.09,1776.26 c 64.27,2.49 99.67,118.13 29.7,123.12 z m -50.44,-208.16 h 5.69 c 67.12,0 119.6,186.81 42.31,186.81 h -2.85 z m -37.84,264.03 c 15.46,63.69 4.07,73.65 -5.28,82.91 l 1.22,6.04 h 186.31 c 105.36,0 92.75,-115.29 14.64,-153.72 74.04,-42.34 15.46,-220.61 -93.15,-220.61 h -198.52 l 1.22,6.04 c 14.24,9.26 30.51,19.22 45.97,82.91 l 47.59,196.43" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path38"/>%0A      <path d="m 2632.34,1797.26 -50.85,-115.65 h 45.56 z m -144.42,-208.17 1.63,6.76 c 16.28,10.32 28.48,24.91 41.91,55.87 l 73.22,166.17 c 13.42,30.96 14.24,45.55 6.91,55.87 l 1.63,6.76 h 143.6 l -1.62,-6.76 c -12.21,-10.32 -18.72,-24.91 -19.94,-55.87 l -8.14,-166.17 c -1.22,-30.96 3.67,-45.55 15.06,-55.87 l -1.63,-6.76 h -136.69 l 1.63,6.76 c 12.21,10.32 18.71,24.91 19.93,55.87 l 0.41,4.98 h -55.32 l -2.04,-4.98 c -13.42,-30.96 -14.24,-45.55 -6.91,-55.87 l -1.63,-6.76 h -72.01" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path40"/>%0A      <path d="m 2941.48,1730 -19.12,-78.28 c -7.32,-30.96 -5.28,-45.55 4.07,-55.87 l -1.63,-6.76 h -136.68 l 1.63,6.76 c 14.23,10.32 23.59,24.91 30.91,55.87 l 17.9,72.95 -19.52,93.22 c -6.92,31.32 -7.33,45.55 -21.15,55.87 l 1.22,6.76 h 132.61 l -1.22,-6.76 c -14.24,-8.18 -12.2,-24.55 -5.7,-55.87 l 8.95,-44.83 30.11,44.83 c 21.15,31.67 30.1,47.69 23.19,55.87 l 1.62,6.76 h 67.53 l -1.62,-6.76 c -19.53,-10.32 -32.95,-24.2 -54.11,-55.87 L 2941.48,1730" style="fill:%23f2581c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path42"/>%0A    </g>%0A  </g>%0A</svg>';

// src/images/mb-logo-small.svg
var mb_logo_small_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" style="enable-background:new 0 0 360 360;" xml:space="preserve" viewBox="27.31 93 309.68 195.01">%0A<style type="text/css">%0A%09.st0{fill:%23FF6C0E;}%0A</style>%0A<g>%0A%09<path class="st0" d="M71.83,180.93c5.22-0.33,15.41-0.68,20.93-0.33c1.95,0.09,3.89,0.27,5.92,0.46   c37.63,3.91,71.34,22.58,93.7,24.17c11.28,0.8,17.48,3.64,27.79-2.98c9.47-6.09,14.96-10.56,21.29-17.27   c-16.06,0.87-80.14-16.64-106.82-20.04c-23.04-2.86-43.93-1.27-51.61-0.67C80.94,168.9,75.32,175.19,71.83,180.93z"/>%0A%09<path class="st0" d="M130.05,230.82c5.34,2.42,11.57,4.88,19.24,7.69c14.24,5.1,21.57,3.17,26.25,0.26   c4.77-2.9,15.92-11.94,22.36-19.49c-12.38,0.47-26.43-3.58-42.58-9.43C148.57,215.5,139.61,222.84,130.05,230.82z"/>%0A%09<path class="st0" d="M327.98,118.79c-6.8,8.34-18.17,14.3-33.12,13.62c-10.14-0.47-48.66-2.47-90.95-4.69   c-40.53-2.13-80.8-4.36-93.18-1c-24.61,6.68-32.37,27.36-47.41,50.83c-6.47,10.1-31.81,48.22-36.01,54.7l32.56-74.31   c10.18-26.74,22.28-50.34,50.74-54.22C198.63,91.7,318.45,118.19,336.91,93C337.54,100.43,334.66,110.61,327.98,118.79z"/>%0A%09<path class="st0" d="M150.35,156.26c-25.1-3.58-50.86-5.25-63.22-0.75c18.03-33.09,78.08-19,101.7-16.75   c23.62,2.25,88.81,7.17,105.41,7.19c-6.93,8.74-19.91,18.78-30.61,23.89c-10.7,5.1-20.5,5.21-35.32,1.6   C213.49,167.84,175.45,159.83,150.35,156.26z"/>%0A%09<path class="st0" d="M96.68,258.12c4.95,3.73,9.3,6.38,12.5,7.67c11.81,4.8,15.83,7.63,24.99,2.95c9.07-4.59,15.64-9.4,22.78-14.36   c-15.45-3.45-28.08-8.19-39.06-13.52C110.7,246.75,103.43,252.66,96.68,258.12z"/>%0A%09<path class="st0" d="M66.41,281.5c3.47,4.04,8.22,6.9,15.31,6.47c12.64-0.74,26.73-6.62,29.2-7.17   c-8.17-2.74-16.65-7.48-24.96-14.2C77.43,273.4,70.44,278.75,66.41,281.5z"/>%0A</g>%0A</svg>';

// src/components/mallard-bay-logo/mallard-bay-logo.tsx
var LOGO_ALT_TEXT = "mallardbay-logo";
function MallardBayLogo() {
  const styles = useStyles78();
  const BigLogo = (0, import_react193.useColorModeValue)(mb_logo_dark_default, mb_logo_light_default);
  const logoSrc = (0, import_react193.useBreakpointValue)(
    { base: mb_logo_small_default, sm: BigLogo },
    { fallback: BigLogo }
  );
  return /* @__PURE__ */ import_react194.default.createElement(
    Image,
    {
      src: logoSrc,
      alt: LOGO_ALT_TEXT,
      style: styles.logo,
      showFallback: false,
      testId: TEST_IDS.LOGO
    }
  );
}
function useStyles78() {
  return componentStyles({
    logo: {
      width: { base: "40px", sm: "180px" }
    }
  });
}

// src/components/wizard-overview/wizard-overview.tsx
var import_react196 = require("@chakra-ui/react");
var import_react197 = __toESM(require("react"));

// src/components/wizard-overview/wizard-overview-title-content.tsx
var import_faInfoCircle2 = require("@fortawesome/free-solid-svg-icons/faInfoCircle");
var import_react195 = __toESM(require("react"));
function WizardOverviewTitleContent({
  title,
  highlightedTitle,
  description,
  informationDescription
}) {
  const styles = useStyles79();
  const { firstWord, remainingWords } = splitHighlightedTitle(highlightedTitle);
  return /* @__PURE__ */ import_react195.default.createElement(
    Box,
    {
      style: styles.titleContainer,
      testId: TEST_IDS.WIZARD_OVERVIEW_TITLE
    },
    /* @__PURE__ */ import_react195.default.createElement(Box, null, /* @__PURE__ */ import_react195.default.createElement(HeadingXLarge, { style: styles.title }, /* @__PURE__ */ import_react195.default.createElement(Box, { style: styles.titleBox }, title), /* @__PURE__ */ import_react195.default.createElement(
      Box,
      {
        style: {
          ...styles.highlightedTitle,
          ...styles.titleBox
        }
      },
      " ",
      firstWord
    ), /* @__PURE__ */ import_react195.default.createElement(Box, { style: styles.highlightedTitle }, remainingWords)), /* @__PURE__ */ import_react195.default.createElement(TextSecondary, null, description)),
    informationDescription && /* @__PURE__ */ import_react195.default.createElement(
      ActionBanner,
      {
        colorScheme: "blue" /* Blue */,
        icon: import_faInfoCircle2.faInfoCircle,
        hideIconBackground: true,
        style: styles.informationBanner
      },
      /* @__PURE__ */ import_react195.default.createElement(TextSmall, null, informationDescription)
    )
  );
}
function useStyles79() {
  const colors = useColors();
  return {
    title: {
      // shrink title down to 40px as the screen gets smaller
      fontSize: "clamp(40px, 10vw, 50px)"
    },
    titleBox: {
      display: "inline"
    },
    highlightedTitle: {
      color: colors.brand[400]
    },
    titleContainer: {
      marginBottom: "clamp(16px, 4vw, 56px)",
      display: "flex",
      justifyContent: "space-between",
      flexDirection: { base: "column", lg: "row" },
      width: "100%",
      gap: "16px"
    },
    informationBanner: {
      height: "fit-content",
      marginTop: "auto",
      maxWidth: "800px"
    }
  };
}
function splitHighlightedTitle(title) {
  const firstWord = title.split(" ")[0];
  const remainingWords = title.split(" ").slice(1).join(" ");
  return { firstWord, remainingWords };
}

// src/components/wizard-overview/wizard-overview.tsx
function WizardOverview({
  steps,
  title,
  highlightedTitle,
  description,
  currentStep,
  informationDescription
}) {
  const styles = useStyles80();
  return /* @__PURE__ */ import_react197.default.createElement(Box, { style: styles.container }, /* @__PURE__ */ import_react197.default.createElement(
    WizardOverviewTitleContent,
    {
      title,
      highlightedTitle,
      description,
      informationDescription
    }
  ), /* @__PURE__ */ import_react197.default.createElement(import_react196.Grid, { style: styles.grid }, steps.map((step, index2) => /* @__PURE__ */ import_react197.default.createElement(
    ProgressCard,
    {
      key: step.type,
      ...step,
      stepNumber: index2 + 1,
      isActive: index2 + 1 === currentStep
    }
  ))));
}
function useStyles80() {
  return {
    container: {
      width: "100%",
      height: "100%"
    },
    grid: {
      gap: "24px",
      gridTemplateColumns: "repeat(auto-fit, minmax(256px, 1fr))",
      width: "100%",
      alignItems: "stretch",
      justifyItems: "stretch"
    }
  };
}

// src/components/wizard-container/wizard-container.tsx
var import_react200 = __toESM(require("react"));

// src/components/wizard-container/wizard-header.tsx
var import_react198 = require("@chakra-ui/react");
var import_react199 = __toESM(require("react"));
function WizardHeader({
  onExitClick,
  profileButton,
  progress
}) {
  const shouldShowProgress = progress !== void 0;
  const styles = useStyles81(shouldShowProgress);
  return /* @__PURE__ */ import_react199.default.createElement(Box, { style: styles.container }, /* @__PURE__ */ import_react199.default.createElement(
    HorizontalStackSpaceBetween,
    {
      style: styles.stack,
      testId: TEST_IDS.WIZARD_HEADER
    },
    /* @__PURE__ */ import_react199.default.createElement(MallardBayLogo, null),
    /* @__PURE__ */ import_react199.default.createElement(HorizontalStack, null, onExitClick && /* @__PURE__ */ import_react199.default.createElement(
      Button,
      {
        variant: "outline" /* Outline */,
        onClick: onExitClick
      },
      copy_constants_default.EXIT
    ), profileButton)
  ), /* @__PURE__ */ import_react199.default.createElement(
    import_react198.Progress,
    {
      style: styles.progress,
      value: progress,
      colorScheme: "brand" /* Brand */
    }
  ));
}
function useStyles81(shouldShowProgress) {
  const theme2 = useTheme2();
  const colors = useColors();
  return componentStyles({
    stack: {
      width: "100%",
      paddingY: "16px",
      paddingX: { base: "16px", md: "40px" }
    },
    progress: {
      width: "100%",
      height: "4px",
      display: shouldShowProgress ? "block" : "none"
    },
    container: {
      width: "100%",
      position: "fixed",
      top: "0",
      left: "0",
      backgroundColor: colors.bg,
      borderBottom: {
        base: `1px solid ${colors.border}`,
        md: "unset"
      },
      zIndex: theme2.zIndices.sticky
    }
  });
}

// src/components/wizard-container/wizard-container.tsx
function WizardContainer({
  onExitClick,
  children,
  profileButton,
  progress,
  centerContent = true
}) {
  const styles = useStyles82(centerContent);
  return /* @__PURE__ */ import_react200.default.createElement(Box, { style: styles.container }, /* @__PURE__ */ import_react200.default.createElement(
    WizardHeader,
    {
      onExitClick,
      profileButton,
      progress
    }
  ), /* @__PURE__ */ import_react200.default.createElement(Box, { style: styles.content }, children));
}
function useStyles82(centerContent) {
  return {
    container: {
      minHeight: "80dvh",
      paddingY: centerContent ? "94px" : "100px",
      paddingX: { base: "32px", md: "56px" },
      display: "flex",
      justifyContent: "center",
      alignItems: centerContent ? "center" : "flex-start"
    },
    content: {
      width: "min(100%, 1500px)"
    }
  };
}

// src/components/wizard-step/wizard-step.tsx
var import_react204 = require("@chakra-ui/react");
var import_react205 = __toESM(require("react"));

// src/components/wizard-step/wizard-step-image.tsx
var import_react201 = require("@chakra-ui/react");
var import_react202 = __toESM(require("react"));
var IMAGE_ALT = "Wizard step image";
function WizardStepImage({
  imageSrc,
  showFallback = true
}) {
  const styles = useStyles83();
  const aspectRatio = (0, import_react201.useBreakpointValue)({
    base: IMAGE_RATIOS.SIXTEEN_BY_NINE,
    lg: IMAGE_RATIOS.THREE_BY_FOUR
  });
  const maxWidth = (0, import_react201.useBreakpointValue)({
    base: "100%",
    lg: "500px"
  });
  if (!imageSrc) {
    return null;
  }
  return /* @__PURE__ */ import_react202.default.createElement(
    import_react201.AspectRatio,
    {
      ratio: aspectRatio,
      maxWidth,
      sx: styles.container,
      "data-testid": TEST_IDS.WIZARD_STEP_IMAGE
    },
    /* @__PURE__ */ import_react202.default.createElement(Image, { src: imageSrc, alt: IMAGE_ALT, showFallback })
  );
}
function useStyles83() {
  return componentStyles({
    container: {
      borderRadius: "12px",
      overflow: "hidden"
    }
  });
}

// src/components/wizard-step/wizard-step-title-content.tsx
var import_react203 = __toESM(require("react"));
function WizardStepTitleContent({
  stepNumber,
  stepTitle,
  pageTitle,
  pageDescription,
  imageSrc
}) {
  const styles = useStyles84();
  const stepNumberText = getStepNumberText(stepNumber);
  return /* @__PURE__ */ import_react203.default.createElement(VerticalStackStretch, { style: styles.container }, /* @__PURE__ */ import_react203.default.createElement(Box, null, /* @__PURE__ */ import_react203.default.createElement(TextExtraSmall, null, stepNumberText), /* @__PURE__ */ import_react203.default.createElement(TextBold, null, stepTitle)), /* @__PURE__ */ import_react203.default.createElement(Box, { style: styles.imageContainer }, /* @__PURE__ */ import_react203.default.createElement(WizardStepImage, { imageSrc })), /* @__PURE__ */ import_react203.default.createElement(VerticalStackStretch, { style: styles.titleContainer }, /* @__PURE__ */ import_react203.default.createElement(HeadingLarge, { style: styles.pageTitle }, pageTitle), /* @__PURE__ */ import_react203.default.createElement(Text, null, pageDescription)));
}
function getStepNumberText(stepNumber) {
  return `${copy_constants_default.STEP.toUpperCase()} ${stepNumber}`;
}
function useStyles84() {
  return componentStyles({
    container: {
      gap: "40px",
      marginBottom: "40px"
    },
    titleContainer: {
      gap: "8px"
    },
    imageContainer: {
      display: { base: "block", lg: "none" }
    },
    pageTitle: {
      fontSize: { base: "24px", xl: "32px" }
    }
  });
}

// src/components/wizard-step/wizard-step.tsx
function WizardStep({
  imageSrc,
  children,
  ...titleProps
}) {
  const isMobile = (0, import_react204.useBreakpointValue)({ base: true, lg: false });
  const shouldShowTitleInMainContent = !!imageSrc || isMobile;
  const styles = useStyles85();
  return /* @__PURE__ */ import_react205.default.createElement(HorizontalStack, { style: styles.container }, /* @__PURE__ */ import_react205.default.createElement(Box, { style: styles.asideContent }, /* @__PURE__ */ import_react205.default.createElement(WizardStepImage, { imageSrc }), !shouldShowTitleInMainContent && /* @__PURE__ */ import_react205.default.createElement(
    WizardStepTitleContent,
    {
      ...titleProps,
      imageSrc
    }
  )), /* @__PURE__ */ import_react205.default.createElement(Box, { style: styles.mainContent }, shouldShowTitleInMainContent && /* @__PURE__ */ import_react205.default.createElement(
    WizardStepTitleContent,
    {
      ...titleProps,
      imageSrc
    }
  ), children));
}
function useStyles85() {
  return componentStyles({
    container: {
      gap: "60px",
      alignItems: "flex-start",
      justifyContent: "center"
    },
    asideContent: {
      display: { base: "none", lg: "block" },
      minWidth: "min(350px, 100%)",
      width: "600px"
    },
    mainContent: {
      maxWidth: "600px",
      overflowY: "auto",
      // for scrollbar
      paddingRight: { base: "0px", lg: "18px" },
      maxHeight: { base: "unset", lg: "calc(100dvh - 195px)" }
    }
  });
}

// src/entity-components/multi-media-display/multi-media-display.tsx
var import_react225 = __toESM(require("react"));

// src/entity-components/multi-media-display/media-modal.tsx
var import_react221 = __toESM(require("react"));
var import_react_fontawesome26 = require("@fortawesome/react-fontawesome");
var import_faArrowUpFromBracket = require("@fortawesome/free-solid-svg-icons/faArrowUpFromBracket");
var import_faXmark = require("@fortawesome/free-solid-svg-icons/faXmark");

// src/entity-components/multi-media-display/multi-media-display-provider.tsx
var import_react206 = __toESM(require("react"));
var MultiMediaDisplayContext = (0, import_react206.createContext)(void 0);
function MultiMediaDisplayProvider({
  children,
  video,
  images,
  isLoading,
  imageWidth,
  imageVariant,
  shouldDisableImageHoverFilter,
  maxImageWidth
}) {
  const [videoProgress, setVideoProgress] = (0, import_react206.useState)(0);
  const [currentImageIndex, setCurrentImageIndex] = (0, import_react206.useState)(0);
  const [isMediaModalOpen, setIsMediaModalOpen] = (0, import_react206.useState)(false);
  const mediaWithTypes = [
    ...video ? [{ ...video, type: "video" /* Video */ }] : [],
    ...images.map((image) => ({ ...image, type: "image" /* Image */ }))
  ];
  const filteredMediaWithTypes = mediaWithTypes.filter(
    (media) => Boolean(media.url)
  );
  const value = (0, import_react206.useMemo)(() => {
    return {
      videoProgress,
      setVideoProgress,
      currentImageIndex,
      setCurrentImageIndex,
      isMediaModalOpen,
      setIsMediaModalOpen,
      mediaWithTypes: filteredMediaWithTypes,
      isLoading,
      imageWidth,
      imageVariant,
      shouldDisableImageHoverFilter,
      maxImageWidth
    };
  }, [
    videoProgress,
    currentImageIndex,
    isMediaModalOpen,
    filteredMediaWithTypes,
    isLoading,
    imageWidth,
    imageVariant,
    shouldDisableImageHoverFilter,
    maxImageWidth
  ]);
  return /* @__PURE__ */ import_react206.default.createElement(MultiMediaDisplayContext.Provider, { value }, children);
}
var useMultiMediaDisplay = () => {
  const context = (0, import_react206.useContext)(MultiMediaDisplayContext);
  if (context === void 0) {
    throw new Error("useMultiMediaDisplay must be used within a MultiMediaDisplayProvider" /* MultiMediaDisplay */);
  }
  return context;
};

// src/entity-components/multi-media-display/media-carousel.tsx
var import_react220 = __toESM(require("react"));

// src/components/image-carousel/image-carousel.tsx
var import_react213 = __toESM(require("react"));

// src/components/responsive-slider/responsive-slider.tsx
var import_react212 = __toESM(require("react"));

// src/components/responsive-slider/responsive-slider-buttons.tsx
var import_react207 = __toESM(require("react"));
var import_react_fontawesome25 = require("@fortawesome/react-fontawesome");
var import_faChevronLeft3 = require("@fortawesome/free-solid-svg-icons/faChevronLeft");
var import_faChevronRight5 = require("@fortawesome/free-solid-svg-icons/faChevronRight");
function ResponsiveSliderButtons({
  onLeftClick,
  onRightClick,
  isLeftButtonDisabled,
  isRightButtonDisabled,
  shouldRender = true,
  shouldOverlayButtons
}) {
  const styles = useStyles86({ shouldOverlayButtons });
  const buttonConfigs = getButtonConfigs({
    onLeftClick,
    onRightClick,
    isLeftButtonDisabled,
    isRightButtonDisabled
  });
  if (!shouldRender) return null;
  return /* @__PURE__ */ import_react207.default.createElement(HorizontalStackSmallGap, { style: styles.root }, buttonConfigs.map((config2) => /* @__PURE__ */ import_react207.default.createElement(
    MediumIconButton,
    {
      key: config2.ariaLabel,
      style: styles.iconButton,
      ...config2
    }
  )));
}
function useStyles86({
  shouldOverlayButtons
}) {
  if (!shouldOverlayButtons) return { root: {}, iconButton: {} };
  return componentStyles({
    root: {
      position: "absolute",
      left: 0,
      right: 0,
      top: "50%",
      transform: "translateY(-50%)",
      justifyContent: "space-between",
      marginX: 6,
      zIndex: 1,
      pointerEvents: "none"
    },
    iconButton: { pointerEvents: "auto" }
  });
}
function getButtonConfigs({
  onLeftClick,
  onRightClick,
  isLeftButtonDisabled,
  isRightButtonDisabled
}) {
  return [
    {
      ariaLabel: copy_constants_default.PREVIOUS,
      onClick: onLeftClick,
      icon: /* @__PURE__ */ import_react207.default.createElement(import_react_fontawesome25.FontAwesomeIcon, { icon: import_faChevronLeft3.faChevronLeft }),
      isDisabled: isLeftButtonDisabled
    },
    {
      ariaLabel: copy_constants_default.NEXT,
      onClick: onRightClick,
      icon: /* @__PURE__ */ import_react207.default.createElement(import_react_fontawesome25.FontAwesomeIcon, { icon: import_faChevronRight5.faChevronRight }),
      isDisabled: isRightButtonDisabled
    }
  ];
}

// src/components/responsive-slider/responsive-slider-progress.tsx
var import_react211 = __toESM(require("react"));

// src/components/responsive-slider/responsive-slider-progress-item.tsx
var import_react210 = __toESM(require("react"));

// src/components/responsive-slider/responsive-slider-helpers.ts
var import_react208 = require("react");
var import_radash = require("radash");
var import_react209 = require("@chakra-ui/react");
var NAV_ENABLED_SCROLL_DISTANCE = 20;
var SCROLL_DEBOUNCE_DELAY = 100;
var DEFAULT_ITEM_COUNT_PER_SIZE = { BASE: 1, SM: 2, MD: 3, LG: 4 };
var DEFAULT_MAX_ITEMS_RENDERED = 4;
var DEFAULT_AUTO_PLAY_DELAY = 5e3;
var PROGRESS_ITEM_SIZE = 10;
var PROGRESS_ITEM_SPACING = 8;
function useHandleNavButtonPress(args) {
  return () => handleNavButtonPress(args);
}
function useHandleScroll(args) {
  return (0, import_radash.debounce)(
    { delay: SCROLL_DEBOUNCE_DELAY },
    () => handleOnScroll(args)
  );
}
function useShouldRenderNavButtons({
  items,
  maxItemsRendered,
  shouldHideButtons
}) {
  const itemCountPerSize = getItemCountPerSize({ maxItemsRendered });
  const countBeingRendered = (0, import_react209.useBreakpointValue)({
    base: itemCountPerSize.base,
    sm: itemCountPerSize.sm,
    md: itemCountPerSize.md,
    lg: itemCountPerSize.lg
  });
  if (!countBeingRendered || shouldHideButtons) return false;
  return countBeingRendered < items.length;
}
function useAutoPlay({
  isAutoPlayEnabled,
  currentItemIndex,
  itemRefs,
  containerRef,
  delay: delay2
}) {
  const timerRef = (0, import_react208.useRef)(null);
  const clearCurrentTimeout = () => {
    if (!timerRef.current) return;
    clearTimeout(timerRef.current);
  };
  const resetAutoplay = () => {
    clearCurrentTimeout();
    timerRef.current = setTimeout(
      () => scrollToItemAtIndex({
        itemRefs,
        containerRef,
        targetIndex: currentItemIndex + 1
      }),
      delay2
    );
  };
  (0, import_react208.useEffect)(() => {
    if (!isAutoPlayEnabled) {
      clearCurrentTimeout();
      return;
    }
    resetAutoplay();
  }, [isAutoPlayEnabled, currentItemIndex]);
  (0, import_react208.useEffect)(() => {
    return clearCurrentTimeout;
  }, []);
  return { resetAutoplay };
}
function useScrollToInitialCurrentItemIndex({
  itemRefs,
  containerRef,
  initialCurrentItemIndex
}) {
  (0, import_react208.useEffect)(() => {
    if (!initialCurrentItemIndex) return;
    scrollToItemAtIndex({
      itemRefs,
      containerRef,
      targetIndex: initialCurrentItemIndex,
      shouldAnimate: false
    });
  }, []);
}
function handleOnScroll({
  containerRef,
  itemRefs,
  setIsLeftButtonDisabled,
  setIsRightButtonDisabled,
  setCurrentItemIndex,
  onSwipe,
  resetAutoplay
}) {
  if (!containerRef.current) return;
  const { closestItemIdx } = findClosestItemIdxBasedOnScrollPosition({
    itemRefs,
    containerElement: containerRef.current
  });
  setCurrentItemIndex(closestItemIdx);
  const containerScrollLeft = Math.ceil(containerRef.current.scrollLeft);
  const containerScrollWidth = containerRef.current.scrollWidth;
  const containerWidth = containerRef.current.offsetWidth;
  const scrollableWidth = containerScrollWidth - containerWidth;
  setIsLeftButtonDisabled(containerScrollLeft === 0);
  setIsRightButtonDisabled(containerScrollLeft === scrollableWidth);
  onSwipe?.(closestItemIdx);
  resetAutoplay();
}
function handleNavButtonPress({
  containerRef,
  itemRefs,
  isNextPress
}) {
  if (!containerRef.current) return;
  const { closestItemIdx, distance } = findClosestItemIdxBasedOnScrollPosition({
    itemRefs,
    containerElement: containerRef.current
  });
  if (distance > NAV_ENABLED_SCROLL_DISTANCE) return;
  const indexOffset = isNextPress ? 1 : -1;
  const targetIndex = closestItemIdx + indexOffset;
  scrollToItemAtIndex({ itemRefs, containerRef, targetIndex });
}
function scrollToItemAtIndex({
  itemRefs,
  containerRef,
  targetIndex,
  shouldAnimate = true
}) {
  const isTargetPastEnd = targetIndex === itemRefs.current.length;
  const adjustedTargetIndex = isTargetPastEnd ? 0 : targetIndex;
  const targetItem = itemRefs.current[adjustedTargetIndex];
  if (!targetItem || !containerRef.current) return;
  const containerOffsetLeft = containerRef.current.offsetLeft;
  const scrollToLeft = targetItem.offsetLeft - containerOffsetLeft;
  containerRef.current.scrollTo({
    left: scrollToLeft,
    behavior: shouldAnimate ? "smooth" : "instant"
  });
}
function findClosestItemIdxBasedOnScrollPosition({
  itemRefs,
  containerElement
}) {
  const containerScrollLeft = Math.floor(containerElement.scrollLeft);
  const containerOffsetLeft = containerElement.offsetLeft;
  const closestItemIdx = itemRefs.current.findIndex((item) => {
    if (!item) return false;
    return item.offsetLeft >= containerScrollLeft + containerOffsetLeft;
  });
  const closestItemOffsetLeft = itemRefs.current[closestItemIdx]?.offsetLeft ?? 0;
  const adjustedScrollLeft = containerOffsetLeft + containerScrollLeft;
  const distance = Math.abs(closestItemOffsetLeft - adjustedScrollLeft);
  return { closestItemIdx, distance };
}
function getItemCountPerSize({
  maxItemsRendered
}) {
  return {
    base: Math.min(DEFAULT_ITEM_COUNT_PER_SIZE.BASE, maxItemsRendered),
    sm: Math.min(DEFAULT_ITEM_COUNT_PER_SIZE.SM, maxItemsRendered),
    md: Math.min(DEFAULT_ITEM_COUNT_PER_SIZE.MD, maxItemsRendered),
    lg: Math.min(DEFAULT_ITEM_COUNT_PER_SIZE.LG, maxItemsRendered)
  };
}

// src/components/responsive-slider/responsive-slider-progress-item.tsx
function ResponsiveSliderProgressItem({
  itemIndex,
  currentItemIndex
}) {
  const styles = useStyles87({ itemIndex, currentItemIndex });
  return /* @__PURE__ */ import_react210.default.createElement(Box, { style: styles.root });
}
function useStyles87({
  itemIndex,
  currentItemIndex
}) {
  const colors = useColors();
  const isCurrentItem = itemIndex === currentItemIndex;
  const scale = isCurrentItem ? 1 : 0.75;
  const backgroundColor = isCurrentItem ? colors.brandDefault : colors.borderDark;
  const opacity = getOpacity({ itemIndex, currentItemIndex });
  return componentStyles({
    root: {
      width: `${PROGRESS_ITEM_SIZE}px`,
      height: `${PROGRESS_ITEM_SIZE}px`,
      backgroundColor,
      borderRadius: "50%",
      transform: `scale(${scale})`,
      transformOrigin: "center",
      marginRight: `${PROGRESS_ITEM_SPACING}px`,
      opacity,
      transition: "transform 0.5s"
    }
  });
}
function getOpacity({
  itemIndex,
  currentItemIndex
}) {
  const difference = Math.abs(currentItemIndex - itemIndex);
  switch (difference) {
    case 0:
      return 1;
    case 1:
      return 0.75;
    case 2:
      return 0.5;
    case 3:
      return 0.25;
    default:
      return 0;
  }
}

// src/components/responsive-slider/responsive-slider-progress.tsx
function ResponsiveSliderProgress({
  numberOfItems,
  currentItemIndex,
  shouldRender
}) {
  const styles = useStyles88({ currentItemIndex });
  const items = new Array(numberOfItems).fill(null).map((_, idx) => idx);
  if (!shouldRender || numberOfItems < 2) return null;
  return /* @__PURE__ */ import_react211.default.createElement(HorizontalStack, { style: styles.root }, /* @__PURE__ */ import_react211.default.createElement(HorizontalStackSmallGap, { style: styles.innerContainer }, items.map((idx) => /* @__PURE__ */ import_react211.default.createElement(
    ResponsiveSliderProgressItem,
    {
      key: idx,
      itemIndex: idx,
      currentItemIndex
    }
  ))));
}
function useStyles88({ currentItemIndex }) {
  const itemSizeWithSpacing = PROGRESS_ITEM_SIZE + PROGRESS_ITEM_SPACING;
  const currentItemOffset = itemSizeWithSpacing * currentItemIndex;
  return componentStyles({
    root: {
      position: "absolute",
      justifyContent: "center",
      left: 0,
      right: 0,
      bottom: 6,
      pointerEvents: "none",
      transform: `translateX(${-currentItemOffset}px)`,
      transition: "transform 0.5s",
      zIndex: "1"
    },
    innerContainer: {
      transform: "translateX(50%)",
      gap: 0
    }
  });
}

// src/components/responsive-slider/responsive-slider.tsx
function ResponsiveSlider({
  testId = TEST_IDS.RESPONSIVE_SLIDER,
  style,
  title,
  onSwipe,
  maxItemsRendered = DEFAULT_MAX_ITEMS_RENDERED,
  shouldOverlayButtons,
  shouldHideButtons,
  shouldAutoPlay,
  autoPlayDelay = DEFAULT_AUTO_PLAY_DELAY,
  shouldRenderProgress,
  initialCurrentItemIndex = 0,
  children
}) {
  const styles = useStyles89({ maxItemsRendered, shouldOverlayButtons });
  const containerRef = (0, import_react212.useRef)(null);
  const itemRefs = (0, import_react212.useRef)([]);
  const items = import_react212.Children.toArray(children);
  const isAutoPlayEnabled = Boolean(shouldAutoPlay) && items.length > 1;
  const [isLeftButtonDisabled, setIsLeftButtonDisabled] = (0, import_react212.useState)(true);
  const [isRightButtonDisabled, setIsRightButtonDisabled] = (0, import_react212.useState)(false);
  const [currentItemIndex, setCurrentItemIndex] = (0, import_react212.useState)(
    initialCurrentItemIndex
  );
  const { resetAutoplay } = useAutoPlay({
    isAutoPlayEnabled,
    currentItemIndex,
    itemRefs,
    containerRef,
    delay: autoPlayDelay
  });
  const handleScroll = useHandleScroll({
    containerRef,
    itemRefs,
    setIsLeftButtonDisabled,
    setIsRightButtonDisabled,
    setCurrentItemIndex,
    onSwipe,
    resetAutoplay
  });
  const handleLeftButtonPress = useHandleNavButtonPress({
    containerRef,
    itemRefs,
    isNextPress: false
  });
  const handleRightButtonPress = useHandleNavButtonPress({
    containerRef,
    itemRefs,
    isNextPress: true
  });
  const shouldRenderNavButtons = useShouldRenderNavButtons({
    items,
    maxItemsRendered,
    shouldHideButtons
  });
  useScrollToInitialCurrentItemIndex({
    itemRefs,
    containerRef,
    initialCurrentItemIndex
  });
  return /* @__PURE__ */ import_react212.default.createElement(Box, { style: { ...styles.root, ...style }, testId }, /* @__PURE__ */ import_react212.default.createElement(HorizontalStackSpaceBetween, { style: styles.header }, title && /* @__PURE__ */ import_react212.default.createElement(HeadingMedium, null, title), /* @__PURE__ */ import_react212.default.createElement(
    ResponsiveSliderButtons,
    {
      onLeftClick: handleLeftButtonPress,
      onRightClick: handleRightButtonPress,
      isLeftButtonDisabled,
      isRightButtonDisabled,
      shouldRender: shouldRenderNavButtons,
      shouldOverlayButtons
    }
  )), /* @__PURE__ */ import_react212.default.createElement(
    Box,
    {
      testId: TEST_IDS.RESPONSIVE_SLIDER_SCROLL,
      onScroll: handleScroll,
      ref: containerRef,
      style: styles.sliderContainer
    },
    items.map((item, idx) => /* @__PURE__ */ import_react212.default.createElement(
      Box,
      {
        key: idx,
        ref: (ref) => itemRefs.current[idx] = ref,
        style: styles.sliderItem
      },
      item
    ))
  ), /* @__PURE__ */ import_react212.default.createElement(
    ResponsiveSliderProgress,
    {
      numberOfItems: items.length,
      currentItemIndex,
      shouldRender: shouldRenderProgress
    }
  ));
}
function useStyles89({
  maxItemsRendered,
  shouldOverlayButtons
}) {
  const itemCountPerSize = getItemCountPerSize({ maxItemsRendered });
  return componentStyles({
    root: { position: "relative" },
    header: {
      marginBottom: shouldOverlayButtons ? 0 : 2,
      paddingX: 2
    },
    sliderContainer: {
      display: "flex",
      overflowX: "scroll",
      "&::-webkit-scrollbar": { display: "none" },
      scrollSnapType: "x mandatory"
    },
    sliderItem: {
      flexGrow: 0,
      flexShrink: 0,
      width: {
        base: `${100 / itemCountPerSize.base}%`,
        sm: `${100 / itemCountPerSize.sm}%`,
        md: `${100 / itemCountPerSize.md}%`,
        lg: `${100 / itemCountPerSize.lg}%`
      },
      paddingX: "10px",
      scrollSnapAlign: "start"
    }
  });
}

// src/components/image-carousel/image-carousel.tsx
function ImageCarousel({
  showButtons,
  children,
  shouldRoundCorners = false,
  shouldShowBorders = false,
  onSwipe,
  initialCurrentItemIndex,
  shouldHide,
  testId = TEST_IDS.IMAGE_CAROUSEL,
  shouldAutoPlay,
  autoPlayDelay,
  shouldRenderProgress = true
}) {
  const styles = useStyles90({ shouldRoundCorners, shouldShowBorders });
  if (shouldHide) return null;
  return /* @__PURE__ */ import_react213.default.createElement(Box, { style: styles.root, testId }, /* @__PURE__ */ import_react213.default.createElement(Box, { style: styles.innerContainer }, /* @__PURE__ */ import_react213.default.createElement(
    ResponsiveSlider,
    {
      onSwipe,
      maxItemsRendered: 1,
      initialCurrentItemIndex,
      shouldHideButtons: !showButtons,
      shouldAutoPlay,
      autoPlayDelay,
      shouldRenderProgress,
      shouldOverlayButtons: true
    },
    children
  )));
}
function useStyles90({
  shouldRoundCorners,
  shouldShowBorders
}) {
  const colors = useColors();
  return componentStyles({
    root: {
      overflow: "hidden",
      position: "relative",
      transform: "translateZ(0)",
      borderRadius: shouldRoundCorners ? "xl" : "none",
      border: shouldShowBorders ? `1px solid ${colors.border}` : "none"
    },
    // Offsets the horizontal padding of the slider items
    // to fill the root container.
    innerContainer: {
      position: "relative",
      width: "calc(100% + 20px)",
      left: "-10px"
    }
  });
}

// src/entity-components/aspect-media/aspect-media.tsx
var import_react219 = __toESM(require("react"));

// src/entity-components/aspect-media/aspect-media-core.tsx
var import_react218 = __toESM(require("react"));

// src/entity-components/aspect-media/aspect-image.tsx
var import_react216 = __toESM(require("react"));

// src/entity-components/aspect-media/media-aspect-box.tsx
var import_react214 = require("@chakra-ui/react");
var import_react215 = __toESM(require("react"));
function MediaAspectBox({
  style,
  children,
  openMediaModal,
  aspectRatio = 4 / 3,
  testId,
  shouldDisableImageHoverFilter
}) {
  const styles = useStyles91({ shouldDisableImageHoverFilter });
  return /* @__PURE__ */ import_react215.default.createElement(import_react214.AspectRatio, { sx: { ...styles.mediaBox, ...style }, ratio: aspectRatio }, /* @__PURE__ */ import_react215.default.createElement(Box, { onClick: openMediaModal, testId }, children));
}
function useStyles91({
  shouldDisableImageHoverFilter
}) {
  const colors = useColors();
  const filter4 = shouldDisableImageHoverFilter ? {} : { filter: "brightness(80%)" };
  return componentStyles({
    mediaBox: {
      backgroundColor: colors.bg,
      _hover: {
        cursor: "pointer",
        ...filter4
      }
    }
  });
}

// src/entity-components/aspect-media/aspect-image.tsx
var ALT_TEXT = "details-image";
function AspectImage({
  style,
  image,
  isQueryLoading,
  openMediaModal,
  aspectRatio,
  imageWidth,
  imageVariant,
  shouldDisableImageHoverFilter = false
}) {
  const styles = useStyles92({ shouldDisableImageHoverFilter });
  return /* @__PURE__ */ import_react216.default.createElement(
    MediaAspectBox,
    {
      style,
      openMediaModal,
      aspectRatio,
      testId: TEST_IDS.ASPECT_IMAGE,
      shouldDisableImageHoverFilter
    },
    isQueryLoading ? /* @__PURE__ */ import_react216.default.createElement(SkeletonFill, null) : /* @__PURE__ */ import_react216.default.createElement(
      Image,
      {
        src: image,
        alt: ALT_TEXT,
        style: styles.image,
        width: imageWidth,
        variant: imageVariant
      }
    )
  );
}
function useStyles92({
  shouldDisableImageHoverFilter
}) {
  const filter4 = shouldDisableImageHoverFilter ? {} : { filter: "brightness(80%)" };
  const hover = {
    cursor: "pointer",
    ...filter4
  };
  const transition = shouldDisableImageHoverFilter ? {} : { transitionProperty: "filter", transitionDuration: "300ms" };
  return {
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
      ...transition,
      ":hover": hover
    }
  };
}

// src/entity-components/aspect-media/aspect-video.tsx
var import_react217 = __toESM(require("react"));
var import_react_player = __toESM(require("react-player"));
function AspectVideo({
  style,
  video,
  showControls = false,
  openMediaModal,
  videoProgress,
  setVideoProgress,
  aspectRatio
}) {
  const playerRef = (0, import_react217.useRef)(null);
  const isMobile = useIsMobile();
  const [isPlaying, setIsPlaying] = (0, import_react217.useState)(false);
  (0, import_react217.useEffect)(() => {
    setIsPlaying(!isMobile);
  }, [isMobile]);
  (0, import_react217.useEffect)(() => {
    if (playerRef.current && videoProgress) {
      playerRef.current.seekTo(videoProgress, "fraction");
    }
  }, []);
  return /* @__PURE__ */ import_react217.default.createElement(
    MediaAspectBox,
    {
      style,
      openMediaModal,
      aspectRatio,
      testId: TEST_IDS.ASPECT_VIDEO
    },
    /* @__PURE__ */ import_react217.default.createElement(
      import_react_player.default,
      {
        url: video,
        playing: isPlaying,
        loop: true,
        muted: true,
        controls: showControls,
        pip: showControls,
        width: "100%",
        height: "100%",
        onProgress: (prog) => {
          setVideoProgress?.(prog.played);
        },
        onClick: () => setIsPlaying((prev) => !prev)
      }
    )
  );
}

// src/entity-components/aspect-media/aspect-media-core.tsx
function AspectMediaCore({
  style,
  media,
  showControls,
  openMediaModal,
  isLoading,
  videoProgress,
  setVideoProgress,
  aspectRatio,
  imageWidth,
  imageVariant,
  shouldDisableImageHoverFilter
}) {
  if (!media) return null;
  if (media.type === "image" /* Image */) {
    return /* @__PURE__ */ import_react218.default.createElement(
      AspectImage,
      {
        style,
        image: media.url,
        isQueryLoading: isLoading,
        openMediaModal,
        aspectRatio,
        imageWidth,
        imageVariant,
        shouldDisableImageHoverFilter
      }
    );
  }
  return /* @__PURE__ */ import_react218.default.createElement(
    AspectVideo,
    {
      style,
      video: media.url,
      openMediaModal,
      showControls,
      videoProgress,
      setVideoProgress,
      aspectRatio
    }
  );
}

// src/entity-components/aspect-media/aspect-media.tsx
function AspectMedia({
  style,
  media,
  index: index2,
  showControls,
  imageWidth,
  imageVariant,
  shouldDisableImageHoverFilter
}) {
  const {
    isLoading,
    videoProgress,
    setVideoProgress,
    setIsMediaModalOpen,
    setCurrentImageIndex
  } = useMultiMediaDisplay();
  return /* @__PURE__ */ import_react219.default.createElement(
    AspectMediaCore,
    {
      style,
      media,
      showControls,
      openMediaModal: () => {
        setCurrentImageIndex(index2);
        setIsMediaModalOpen(true);
      },
      isLoading,
      videoProgress,
      setVideoProgress,
      imageWidth,
      imageVariant,
      shouldDisableImageHoverFilter
    }
  );
}

// src/entity-components/multi-media-display/media-carousel.tsx
function MediaCarousel({ limitDisplayCount }) {
  const {
    mediaWithTypes,
    setCurrentImageIndex,
    currentImageIndex,
    imageVariant,
    imageWidth,
    shouldDisableImageHoverFilter
  } = useMultiMediaDisplay();
  const displayCount = limitDisplayCount ? 5 : mediaWithTypes.length;
  const mediaWithTypesToDisplay = mediaWithTypes.slice(0, displayCount);
  return /* @__PURE__ */ import_react220.default.createElement(
    ImageCarousel,
    {
      testId: TEST_IDS.MEDIA_CAROUSEL,
      onSwipe: setCurrentImageIndex,
      initialCurrentItemIndex: currentImageIndex,
      showButtons: true
    },
    mediaWithTypesToDisplay.map((media, index2) => /* @__PURE__ */ import_react220.default.createElement(
      AspectMedia,
      {
        key: media.url,
        media,
        index: index2,
        showControls: true,
        imageVariant,
        imageWidth,
        shouldDisableImageHoverFilter
      }
    ))
  );
}

// src/entity-components/multi-media-display/media-modal.tsx
function MediaModal({ handleCopyOrShare }) {
  const {
    isMediaModalOpen,
    setIsMediaModalOpen,
    currentImageIndex,
    mediaWithTypes,
    maxImageWidth
  } = useMultiMediaDisplay();
  const styles = useStyles93({ maxWidth: maxImageWidth });
  const currentDescription = useCurrentDescription();
  const onClose = () => setIsMediaModalOpen(false);
  const mediaCount = mediaWithTypes.length;
  const mediaCountText = `${currentImageIndex + 1} / ${mediaCount}`;
  if (!isMediaModalOpen) {
    return null;
  }
  return /* @__PURE__ */ import_react221.default.createElement(
    Drawer,
    {
      isOpen: isMediaModalOpen,
      onClose,
      size: "full" /* Full */,
      placement: "bottom" /* Bottom */,
      style: styles.drawer,
      shouldHideCloseButton: true
    },
    /* @__PURE__ */ import_react221.default.createElement(Box, { style: styles.root }, /* @__PURE__ */ import_react221.default.createElement(Box, { style: styles.top }, /* @__PURE__ */ import_react221.default.createElement(
      PillButton,
      {
        leftIcon: /* @__PURE__ */ import_react221.default.createElement(import_react_fontawesome26.FontAwesomeIcon, { icon: import_faXmark.faXmark }),
        onClick: onClose
      },
      copy_constants_default.CLOSE
    ), /* @__PURE__ */ import_react221.default.createElement(Box, { style: styles.count }, mediaCountText), /* @__PURE__ */ import_react221.default.createElement(
      PillButton,
      {
        leftIcon: /* @__PURE__ */ import_react221.default.createElement(import_react_fontawesome26.FontAwesomeIcon, { icon: import_faArrowUpFromBracket.faArrowUpFromBracket }),
        onClick: handleCopyOrShare
      },
      copy_constants_default.SHARE
    )), /* @__PURE__ */ import_react221.default.createElement(Box, { style: styles.middle }, /* @__PURE__ */ import_react221.default.createElement(MediaCarousel, null)), /* @__PURE__ */ import_react221.default.createElement(Box, { style: styles.bottom }, currentDescription))
  );
}
function useCurrentDescription() {
  const { currentImageIndex, mediaWithTypes } = useMultiMediaDisplay();
  const currentMedia = mediaWithTypes[currentImageIndex];
  const description = currentMedia?.description || "";
  if (description) {
    return description;
  }
  if (currentMedia?.type === "image" /* Image */) {
    return `${copy_constants_default.PHOTO} ${currentImageIndex + 1}`;
  }
  return copy_constants_default.VIDEO;
}
function useStyles93({ maxWidth = "1000px" }) {
  return {
    top: {
      height: "10vh",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      paddingLeft: "2rem",
      paddingRight: "2rem"
    },
    count: {
      fontSize: "16px",
      fontWeight: 700
    },
    root: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 7
    },
    middle: {
      width: "100%",
      maxWidth
    },
    bottom: {
      height: "10vh",
      boxSizing: "border-box",
      textAlign: "center",
      fontSize: "15px",
      paddingTop: 7
    },
    drawer: {
      marginTop: 0,
      marginBottom: 0
    }
  };
}

// src/entity-components/multi-media-display/multi-media-display-component.tsx
var import_react224 = __toESM(require("react"));

// src/entity-components/multi-media-display/media-grid.tsx
var import_react223 = __toESM(require("react"));

// src/entity-components/multi-media-display/media-grid-item.tsx
var import_react222 = __toESM(require("react"));
function MediaGridItem({ media, mediaCount, index: index2 }) {
  const styles = useStyles94({ mediaCount, index: index2 });
  const { imageVariant, imageWidth, shouldDisableImageHoverFilter } = useMultiMediaDisplay();
  return /* @__PURE__ */ import_react222.default.createElement(
    AspectMedia,
    {
      key: media.url,
      style: styles.root,
      media,
      index: index2,
      imageVariant,
      imageWidth,
      shouldDisableImageHoverFilter
    }
  );
}
function useStyles94({
  mediaCount,
  index: index2
}) {
  return componentStyles({
    root: {
      gridArea: getGridArea({ mediaCount, index: index2 }),
      maxHeight: "530px"
    }
  });
}
function getGridArea({
  mediaCount,
  index: index2
}) {
  switch (mediaCount) {
    case 1:
      return getOneMediaGridArea();
    case 2:
      return getTwoMediaGridArea(index2);
    case 3:
      return getThreeMediaGridArea(index2);
    case 4:
      return getFourMediaGridArea(index2);
    case 5:
      return getFiveMediaGridArea(index2);
    default:
      return "";
  }
}
var INDEX_ZERO_GRID_AREAS = {
  ONE: "1 / 1 / 3 / 5",
  TWO_OR_MORE: "1 / 1 / 3 / 3"
};
var INDEX_ONE_GRID_AREAS = {
  TWO: "1 / 3 / 3 / 5",
  THREE: "1 / 3 / 3 / 4",
  FOUR: "1 / 3 / 3 / 4",
  FIVE: "1 / 3 / 2 / 4"
};
var INDEX_TWO_GRID_AREAS = {
  THREE: "1 / 4 / 3 / 5",
  FOUR: "1 / 4 / 2 / 5",
  FIVE: "1 / 4 / 2 / 5"
};
var INDEX_THREE_GRID_AREAS = {
  FOUR: "2 / 4 / 3 / 5",
  FIVE: "2 / 3 / 3 / 4"
};
var INDEX_FOUR_GRID_AREAS = {
  FIVE: "2 / 4 / 3 / 5"
};
function getOneMediaGridArea() {
  return INDEX_ZERO_GRID_AREAS.ONE;
}
function getTwoMediaGridArea(index2) {
  switch (index2) {
    case 0:
      return INDEX_ZERO_GRID_AREAS.TWO_OR_MORE;
    case 1:
      return INDEX_ONE_GRID_AREAS.TWO;
    default:
      return "";
  }
}
function getThreeMediaGridArea(index2) {
  switch (index2) {
    case 0:
      return INDEX_ZERO_GRID_AREAS.TWO_OR_MORE;
    case 1:
      return INDEX_ONE_GRID_AREAS.THREE;
    case 2:
      return INDEX_TWO_GRID_AREAS.THREE;
    default:
      return "";
  }
}
function getFourMediaGridArea(index2) {
  switch (index2) {
    case 0:
      return INDEX_ZERO_GRID_AREAS.TWO_OR_MORE;
    case 1:
      return INDEX_ONE_GRID_AREAS.FOUR;
    case 2:
      return INDEX_TWO_GRID_AREAS.FOUR;
    case 3:
      return INDEX_THREE_GRID_AREAS.FOUR;
    default:
      return "";
  }
}
function getFiveMediaGridArea(index2) {
  switch (index2) {
    case 0:
      return INDEX_ZERO_GRID_AREAS.TWO_OR_MORE;
    case 1:
      return INDEX_ONE_GRID_AREAS.FIVE;
    case 2:
      return INDEX_TWO_GRID_AREAS.FIVE;
    case 3:
      return INDEX_THREE_GRID_AREAS.FIVE;
    case 4:
      return INDEX_FOUR_GRID_AREAS.FIVE;
    default:
      return "";
  }
}

// src/entity-components/multi-media-display/media-grid.tsx
function MediaGrid({ isCompact }) {
  const { mediaWithTypes, setIsMediaModalOpen } = useMultiMediaDisplay();
  const styles = useStyles95(isCompact);
  const mediaToShowCount = isCompact ? 3 : 5;
  const mediaWithTypesToDisplay = mediaWithTypes.slice(0, mediaToShowCount);
  const mediaCount = mediaWithTypesToDisplay.length;
  return /* @__PURE__ */ import_react223.default.createElement(Box, { style: styles.root, testId: TEST_IDS.MEDIA_GRID }, /* @__PURE__ */ import_react223.default.createElement(Box, { style: styles.grid }, mediaWithTypesToDisplay.map((media, index2) => /* @__PURE__ */ import_react223.default.createElement(
    MediaGridItem,
    {
      key: media.url,
      media,
      mediaCount,
      index: index2
    }
  ))), /* @__PURE__ */ import_react223.default.createElement(Box, { style: styles.buttonContainer }, /* @__PURE__ */ import_react223.default.createElement(
    Button,
    {
      style: styles.button,
      variant: "outlined",
      onClick: () => setIsMediaModalOpen(true)
    },
    copy_constants_default.SHOW_ALL_PHOTOS
  )));
}
function useStyles95(isCompact) {
  const colors = useColors();
  return componentStyles({
    root: {
      position: "relative",
      borderRadius: 4,
      overflow: "hidden",
      transform: "translateZ(0)"
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gridTemplateRows: "repeat(2, 1fr)",
      gap: 2
    },
    buttonContainer: {
      position: "absolute",
      display: isCompact ? "none" : "block",
      bottom: 5,
      right: 5
    },
    button: {
      borderRadius: "20px",
      backgroundColor: colors.bgSecondary,
      height: "35px",
      fontSize: "14px"
    }
  });
}

// src/entity-components/multi-media-display/multi-media-display-component.tsx
var MediaDisplayType = /* @__PURE__ */ ((MediaDisplayType2) => {
  MediaDisplayType2["CAROUSEL"] = "carousel";
  MediaDisplayType2["GRID"] = "grid";
  MediaDisplayType2["GRID_COMPACT"] = "grid-compact";
  return MediaDisplayType2;
})(MediaDisplayType || {});
function MultiMediaDisplayComponent({ type }) {
  switch (type) {
    case "carousel" /* CAROUSEL */:
      return /* @__PURE__ */ import_react224.default.createElement(MediaCarousel, { limitDisplayCount: true });
    case "grid" /* GRID */:
      return /* @__PURE__ */ import_react224.default.createElement(MediaGrid, null);
    case "grid-compact" /* GRID_COMPACT */:
      return /* @__PURE__ */ import_react224.default.createElement(MediaGrid, { isCompact: true });
  }
}

// src/entity-components/multi-media-display/multi-media-display.tsx
function MultiMediaDisplay({
  video,
  images,
  type,
  handleCopyOrShare,
  imageWidth,
  imageVariant,
  shouldDisableImageHoverFilter,
  maxImageWidth
}) {
  return /* @__PURE__ */ import_react225.default.createElement(
    MultiMediaDisplayProvider,
    {
      video,
      images,
      imageWidth,
      imageVariant,
      shouldDisableImageHoverFilter,
      maxImageWidth
    },
    /* @__PURE__ */ import_react225.default.createElement(MultiMediaDisplayComponent, { type }),
    /* @__PURE__ */ import_react225.default.createElement(MediaModal, { handleCopyOrShare })
  );
}

// src/components/expandable-markup/expandable-markup.tsx
var import_react230 = __toESM(require("react"));

// src/components/expandable-markup/truncated-markup.tsx
var import_react229 = __toESM(require("react"));
var import_interweave = require("interweave");

// src/utils/use-truncate-markup.ts
var import_react226 = require("react");
var useTruncateMarkup = ({
  markup,
  allowedTags = ["<p>", "<strong>", "<em>", "<u>"],
  maxLength = 500,
  shouldTruncate = true
}) => {
  const originalMarkup = markup ?? "";
  const [transformedMarkup, setTransformedMarkup] = (0, import_react226.useState)(originalMarkup);
  const isLongerThanMax = originalMarkup.length > maxLength;
  const isTruncated = isLongerThanMax && shouldTruncate;
  function closing(tag) {
    return `</${tag.slice(1)}`;
  }
  function hangingTags(str) {
    const tagsArr = [];
    str.split("").forEach((character, idx) => {
      allowedTags.forEach((tag) => {
        if (idx + tag.length >= str.length) return;
        if (str.slice(idx, idx + tag.length) === tag) {
          tagsArr.push(tag);
        } else if (str.slice(idx, idx + tag.length + 1) === closing(tag)) {
          tagsArr.pop();
        }
      });
    });
    return tagsArr;
  }
  (0, import_react226.useEffect)(() => {
    if (!shouldTruncate || !isLongerThanMax) {
      setTransformedMarkup(originalMarkup);
      return;
    }
    const sliceIndex = originalMarkup.slice(maxLength, maxLength + 6).indexOf("<") + maxLength;
    const shortenedDesc = originalMarkup.slice(0, sliceIndex);
    const hanging = hangingTags(shortenedDesc).reverse();
    setTransformedMarkup(
      `${shortenedDesc}...${hanging.map((tag) => closing(tag)).join("")}`
    );
  }, [originalMarkup, allowedTags, maxLength, shouldTruncate]);
  return { isTruncated, transformedMarkup };
};

// src/utils/use-is-client-side.ts
var import_react227 = require("react");
function useIsClientSide() {
  const [isClientSide, setIsClientSide] = (0, import_react227.useState)(false);
  (0, import_react227.useEffect)(() => {
    setIsClientSide(true);
  }, []);
  return isClientSide;
}

// src/components/expandable-markup/show-more-button.tsx
var import_react228 = __toESM(require("react"));
function ShowMoreButton({
  onClick,
  isTruncated,
  shouldHide
}) {
  const styles = useStyles96();
  if (shouldHide) return null;
  return /* @__PURE__ */ import_react228.default.createElement(Button, { style: styles.button, onClick }, isTruncated ? copy_constants_default.SHOW_MORE : copy_constants_default.SHOW_LESS);
}
function useStyles96() {
  const colors = useColors();
  return componentStyles({
    button: {
      fontWeight: 600,
      color: colors.brandDefault,
      textDecoration: "underline",
      backgroundColor: "transparent",
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      marginTop: "16px",
      marginBottom: "16px",
      _hover: {
        backgroundColor: "transparent"
      }
    }
  });
}

// src/components/expandable-markup/truncated-markup.tsx
var ALLOWED_HTML_TAGS = [
  "p",
  "strong",
  "em",
  "u",
  "a",
  "li",
  "ul",
  "ol",
  "br"
];
function TruncatedMarkup({
  title,
  markup,
  onShowMoreClick,
  shouldTruncate = true,
  testId,
  hideTruncateButton,
  maxLength,
  isCompact,
  isLargeTitle
}) {
  const styles = useStyles97(isCompact);
  const transform = useTransformMarkup();
  const { isTruncated: isOverflow, transformedMarkup: transformedDesc } = useTruncateMarkup({ markup, shouldTruncate, maxLength });
  const shouldHideTruncateButton = !isOverflow && shouldTruncate || !!hideTruncateButton;
  const TitleComponent = isLargeTitle ? HeadingMedium : Text;
  return /* @__PURE__ */ import_react229.default.createElement(Box, null, title && /* @__PURE__ */ import_react229.default.createElement(TitleComponent, { style: styles.title }, title), /* @__PURE__ */ import_react229.default.createElement(Box, { style: styles.markupContainer, testId }, /* @__PURE__ */ import_react229.default.createElement(
    import_interweave.Markup,
    {
      allowList: ALLOWED_HTML_TAGS,
      content: transformedDesc,
      transform
    }
  )), /* @__PURE__ */ import_react229.default.createElement(
    ShowMoreButton,
    {
      onClick: onShowMoreClick,
      isTruncated: isOverflow,
      shouldHide: shouldHideTruncateButton
    }
  ));
}
function useTransformMarkup() {
  const styles = useStyles97();
  const isClientSide = useIsClientSide();
  if (!isClientSide) return () => void 0;
  return function(element, children) {
    const isAnchor = element instanceof HTMLAnchorElement;
    if (!isAnchor) {
      return void 0;
    }
    const { href = "" } = element;
    return /* @__PURE__ */ import_react229.default.createElement("a", { style: styles.anchor, href }, children);
  };
}
function useStyles97(isCompact) {
  const colors = useColors();
  const lineHeight = isCompact ? "16px" : "24px";
  return componentStyles({
    title: {
      marginTop: 0,
      marginBottom: 4
    },
    anchor: {
      color: colors.brandDefault
    },
    markupContainer: {
      fontWeight: 300,
      lineHeight,
      //styling for bullet lists in markup
      textOverflow: "ellipsis",
      "& li": {
        listStylePosition: "inside"
      }
    }
  });
}

// src/components/expandable-markup/expandable-markup.tsx
function ExpandableMarkup({
  testId,
  title,
  markup,
  isCompact,
  isLargeTitle,
  maxLength,
  hideShowMoreButton
}) {
  const [isExpanded, setIsExpanded] = (0, import_react230.useState)(false);
  const toggleIsExpanded = () => setIsExpanded((curIsExpanded) => !curIsExpanded);
  return /* @__PURE__ */ import_react230.default.createElement(
    TruncatedMarkup,
    {
      testId,
      title,
      markup,
      onShowMoreClick: toggleIsExpanded,
      shouldTruncate: !isExpanded,
      isCompact,
      isLargeTitle,
      maxLength,
      hideTruncateButton: hideShowMoreButton
    }
  );
}

// src/components/wizard-container/wizard-navigation.tsx
var import_react231 = __toESM(require("react"));
function WizardNavigation({
  onBackClick,
  onNextClick,
  onQuestionsClick,
  currentStep,
  isNextDisabled,
  hideDescription,
  shouldHideQuestions,
  isLoading
}) {
  const styles = useStyles98(hideDescription, shouldHideQuestions);
  const description = getDescription(currentStep);
  return /* @__PURE__ */ import_react231.default.createElement(
    HorizontalStackSpaceBetween,
    {
      style: styles.container,
      testId: TEST_IDS.WIZARD_NAVIGATION
    },
    /* @__PURE__ */ import_react231.default.createElement(Box, { style: styles.backButtonContainer }, onBackClick && /* @__PURE__ */ import_react231.default.createElement(
      Button,
      {
        variant: "ghost" /* Ghost */,
        onClick: onBackClick,
        isLoading
      },
      copy_constants_default.BACK
    )),
    /* @__PURE__ */ import_react231.default.createElement(TextSmall, { style: styles.description }, description),
    /* @__PURE__ */ import_react231.default.createElement(HorizontalStack, { style: styles.nextContainer }, /* @__PURE__ */ import_react231.default.createElement(
      Button,
      {
        style: styles.questionsButton,
        variant: "link" /* Link */,
        colorScheme: "brand" /* Brand */,
        onClick: onQuestionsClick
      },
      copy_constants_default.QUESTIONS
    ), /* @__PURE__ */ import_react231.default.createElement(
      ButtonPrimary,
      {
        type: "submit",
        onClick: onNextClick,
        isDisabled: isNextDisabled,
        isLoading
      },
      copy_constants_default.NEXT
    ))
  );
}
function useStyles98(hideDescription, shouldHideQuestions) {
  const colors = useColors();
  return {
    questionsButton: {
      display: shouldHideQuestions ? "none" : "block"
    },
    container: {
      width: "100%",
      position: "fixed",
      bottom: "0",
      left: "0",
      padding: "24px",
      backgroundColor: colors.bg,
      borderTop: `1px solid ${colors.border}`
    },
    nextContainer: {
      display: { base: "contents", sm: "flex" }
    },
    backButtonContainer: {
      display: { base: "none", sm: "flex" }
    },
    description: {
      display: { base: "none", md: hideDescription ? "none" : "block" }
    }
  };
}
function getDescription(currentStep) {
  if (!currentStep) {
    return copy_constants_default.LETS_GET_STARTED;
  }
  return `${copy_constants_default.STEP} ${currentStep} ${copy_constants_default.CURRENT_STEP_DESCRIPTION} ${currentStep + 1}`;
}

// src/components/wizard-container/wizard-provider.tsx
var import_react232 = __toESM(require("react"));

// src/components/wizard-container/wizard-helpers.tsx
function mapSteps(mainSteps) {
  return mainSteps.flatMap((mainStep, index2) => {
    const mainNavigationStep = {
      type: mainStep.type,
      stepNumber: index2 + 1,
      stepTitle: mainStep.title,
      path: `/${mainStep.type}`
    };
    if (mainStep.steps) {
      return [
        mainNavigationStep,
        ...mainStep.steps.map((step, stepIndex) => ({
          ...mainNavigationStep,
          type: step.type,
          pageTitle: step.title,
          pageDescription: step.description,
          path: `/${mainStep.type}/${step.type}`,
          isPageStep: true,
          percentComplete: stepIndex / (mainStep.steps?.length || 1) * 100
        }))
      ];
    }
    return [mainNavigationStep];
  });
}
function mapStepsToNavigationSteps(mainSteps, stepsEnrichmentMap) {
  const mappedSteps = mapSteps(mainSteps);
  return mappedSteps.map((step, index2) => ({
    ...step,
    previousType: mappedSteps[index2 - 1]?.type,
    nextType: mappedSteps[index2 + 1]?.type,
    ...stepsEnrichmentMap[step.type]
  }));
}

// src/components/wizard-container/wizard-provider.tsx
var WizardContext = (0, import_react232.createContext)({
  navigationSteps: [],
  mainSteps: [],
  currentNavigationStep: void 0,
  mainStepTypes: [],
  childStepTypes: [],
  isFirstLoad: true,
  setIsFirstLoad: () => {
  }
});
function WizardProvider({
  children,
  mainSteps,
  stepsEnrichmentMap,
  currentStepType
}) {
  const [isFirstLoad, setIsFirstLoad] = (0, import_react232.useState)(true);
  const navigationSteps = (0, import_react232.useMemo)(
    () => mapStepsToNavigationSteps(mainSteps, stepsEnrichmentMap),
    [mainSteps, stepsEnrichmentMap]
  );
  const defaultNavigationStep = navigationSteps[0];
  const currentNavigationStepByType = navigationSteps.find(
    (step) => step.type === currentStepType
  );
  const currentNavigationStep = currentNavigationStepByType || defaultNavigationStep;
  const mainStepsWithCompletionStatus = useStepsWithCompletionStatus(
    mainSteps,
    navigationSteps,
    currentStepType
  );
  const mainStepTypes = (0, import_react232.useMemo)(
    () => mainStepsWithCompletionStatus.map((step) => step.type),
    [mainStepsWithCompletionStatus]
  );
  const childStepTypes = (0, import_react232.useMemo)(
    () => mainStepsWithCompletionStatus.flatMap((step) => step.steps?.map((child) => child.type)).filter((type) => type !== void 0),
    [mainStepsWithCompletionStatus]
  );
  const value = (0, import_react232.useMemo)(
    () => ({
      navigationSteps,
      currentNavigationStep,
      mainSteps: mainStepsWithCompletionStatus,
      mainStepTypes,
      childStepTypes,
      isFirstLoad,
      setIsFirstLoad
    }),
    [
      navigationSteps,
      currentNavigationStep,
      mainStepsWithCompletionStatus,
      mainStepTypes,
      childStepTypes,
      isFirstLoad,
      setIsFirstLoad
    ]
  );
  return /* @__PURE__ */ import_react232.default.createElement(WizardContext.Provider, { value }, children);
}
function useWizardContext() {
  return (0, import_react232.useContext)(WizardContext);
}
function useStepsWithCompletionStatus(mainSteps, navigationSteps, currentStepType) {
  return (0, import_react232.useMemo)(() => {
    if (!currentStepType) return mainSteps;
    const currentStepIndex = navigationSteps.findIndex(
      (step) => step.type === currentStepType
    );
    return mainSteps.map((mainStep) => {
      const updatedChildSteps = mainStep.steps?.map((childStep) => {
        const childStepNavIndex = navigationSteps.findIndex(
          (navStep) => navStep.type === childStep.type
        );
        const isChildStepCompleted = childStepNavIndex < currentStepIndex;
        return {
          ...childStep,
          isCompleted: isChildStepCompleted
        };
      }) || [];
      const totalChildSteps = updatedChildSteps.length;
      const completedChildSteps = updatedChildSteps.filter(
        (step) => step.isCompleted
      ).length;
      const percentComplete = totalChildSteps > 0 ? completedChildSteps / totalChildSteps * 100 : 0;
      return {
        ...mainStep,
        percentComplete: Math.round(percentComplete),
        steps: updatedChildSteps
      };
    });
  }, [mainSteps, navigationSteps, currentStepType]);
}

// src/utils/use-toast.tsx
var import_react236 = require("@chakra-ui/react");
var import_faXmarkCircle2 = require("@fortawesome/pro-regular-svg-icons/faXmarkCircle");
var import_faCheckCircle3 = require("@fortawesome/pro-regular-svg-icons/faCheckCircle");
var import_react237 = __toESM(require("react"));

// src/components/toast-content/toast-content.tsx
var import_react233 = __toESM(require("react"));
var import_react_fontawesome27 = require("@fortawesome/react-fontawesome");
var import_react234 = require("@chakra-ui/react");
function ToastContent({
  title,
  description,
  icon,
  onClose,
  colorScheme = "green" /* Green */
}) {
  const styles = useStyles99({ colorScheme });
  return /* @__PURE__ */ import_react233.default.createElement(Box, { style: styles.root }, /* @__PURE__ */ import_react233.default.createElement(HorizontalStack, null, /* @__PURE__ */ import_react233.default.createElement(import_react_fontawesome27.FontAwesomeIcon, { icon, ...styles.icon }), /* @__PURE__ */ import_react233.default.createElement(TextBoldLarge, { style: styles.title }, title), /* @__PURE__ */ import_react233.default.createElement(import_react234.CloseButton, { sx: styles.closeButton, onClick: onClose })), /* @__PURE__ */ import_react233.default.createElement(Text, { style: styles.description }, description));
}
function useStyles99({ colorScheme }) {
  const {
    backgroundColor,
    iconColor,
    titleColor,
    borderColor,
    descriptionColor
  } = useActionBannerColors({ colorScheme });
  const theme2 = useTheme2();
  return componentStyles({
    root: {
      backgroundColor,
      borderColor,
      borderWidth: 2,
      paddingX: 6,
      paddingY: 4,
      position: "relative",
      borderRadius: "xl",
      boxShadow: theme2.shadows.md
    },
    title: {
      color: titleColor,
      flex: 1
    },
    icon: {
      color: iconColor,
      fontSize: 18
    },
    closeButton: {
      position: "absolute",
      right: 2,
      top: 2
    },
    description: {
      color: descriptionColor,
      marginTop: 1
    }
  });
}

// src/components/toast-with-action-content/toast-with-action-content.tsx
var import_react235 = __toESM(require("react"));
var import_react_fontawesome28 = require("@fortawesome/react-fontawesome");
function ToastWithActionContent({
  message,
  icon,
  iconColor,
  actionLabel,
  onActionClick,
  onClose,
  testId = TEST_IDS.TOAST_WITH_ACTION_CONTENT
}) {
  const styles = useStyles100();
  return /* @__PURE__ */ import_react235.default.createElement(Box, { onClick: onClose }, /* @__PURE__ */ import_react235.default.createElement(HorizontalStack, { style: styles.root, testId }, /* @__PURE__ */ import_react235.default.createElement(import_react_fontawesome28.FontAwesomeIcon, { icon, color: iconColor }), /* @__PURE__ */ import_react235.default.createElement(Text, null, message), /* @__PURE__ */ import_react235.default.createElement(Button, { onClick: onActionClick }, actionLabel)));
}
function useStyles100() {
  const colors = useColors();
  return componentStyles({
    root: {
      border: `1px solid ${colors.border}`,
      paddingX: 4,
      paddingY: 2,
      borderRadius: "xl"
    }
  });
}

// src/utils/use-toast.tsx
var DEFAULT_ACTION_TOAST_DURATION = 8e3;
var COMMON_TOAST_OPTIONS = {
  position: "top",
  duration: 5e3,
  isClosable: true
};
function useToast() {
  const showSuccess = useSuccessToast();
  const showError = useErrorToast();
  return { showSuccess, showError };
}
function useToastWithActionWithDeferredProps({
  duration = DEFAULT_ACTION_TOAST_DURATION
} = {}) {
  const toast = (0, import_react236.useToast)();
  return ({
    isClosable = true,
    ...contentProps
  }) => showToastWithAction({
    contentProps,
    isClosable,
    duration,
    toast
  });
}
function useToastWithAction({
  duration = DEFAULT_ACTION_TOAST_DURATION,
  isClosable = false,
  ...contentProps
}) {
  const toast = (0, import_react236.useToast)();
  return () => showToastWithAction({
    contentProps,
    duration,
    isClosable,
    toast
  });
}
function showToastWithAction({
  contentProps,
  duration,
  isClosable,
  toast
}) {
  return toast({
    ...COMMON_TOAST_OPTIONS,
    duration,
    render: ({ onClose }) => /* @__PURE__ */ import_react237.default.createElement(
      ToastWithActionContent,
      {
        ...contentProps,
        onClose: isClosable ? onClose : void 0
      }
    )
  });
}
function useSuccessToast(options = {}) {
  return useToastCore(getSuccessToastContentProps(), options);
}
function useErrorToast(options = {}) {
  return useToastCore(getErrorToastContentProps(), options);
}
function useToastCore(toastContentProps, options = {}) {
  const toast = (0, import_react236.useToast)();
  return (descriptionOrError) => {
    const description = descriptionOrError instanceof Error ? descriptionOrError.message : descriptionOrError;
    toast({
      ...COMMON_TOAST_OPTIONS,
      ...options,
      render: ({ onClose }) => /* @__PURE__ */ import_react237.default.createElement(
        ToastContent,
        {
          ...toastContentProps,
          description,
          onClose
        }
      )
    });
  };
}
function getSuccessToastContentProps() {
  return {
    icon: import_faCheckCircle3.faCheckCircle,
    title: copy_constants_default.TOAST_TITLES.SUCCESS,
    colorScheme: "green" /* Green */
  };
}
function getErrorToastContentProps() {
  return {
    icon: import_faXmarkCircle2.faXmarkCircle,
    title: copy_constants_default.TOAST_TITLES.ERROR,
    colorScheme: "red" /* Red */
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Accordion,
  ActionBanner,
  ActionBannerWithButton,
  ActionCard,
  ActionCardType,
  ActionPill,
  ActionRequired,
  AddButton,
  AddOnsSelector,
  AspectMedia,
  AspectMediaCore,
  BUTTON_VARIANTS,
  Badge,
  BadgeSuccess,
  BadgeVariant,
  BottomDrawer,
  Box,
  Button,
  ButtonPrimary,
  ButtonSmall,
  ButtonVariant,
  CARD_BRANDS,
  COLOR_MODE_SCRIPT_KEY,
  CalendarDatePicker,
  Card,
  CardList,
  CardSelect,
  CheckoutDatesPreview,
  ColorMode,
  ColorModeScript,
  ColorSchemes,
  ConditionalRenderContainer,
  ContrastButton,
  ContrastPillButton,
  CopyTextButton,
  DATE_FORMATS,
  DebouncedInput,
  Drawer,
  DrawerPlacement,
  DrawerSize,
  DynamicTable,
  DynamicTableView,
  EllipsisMenu,
  ErrorIcon,
  ExpandableMarkup,
  ExternalLink,
  ExternalLinkButton,
  Heading,
  HeadingLarge,
  HeadingMedium,
  HeadingSmall,
  HeadingXLarge,
  HeadingXSmall,
  Highlight,
  HorizontalStack,
  HorizontalStackSmallGap,
  HorizontalStackSpaceBetween,
  IMAGE_RATIOS,
  IconButton,
  IconSize,
  Image,
  ImageCard,
  ImageCarousel,
  IncludedAddOns,
  Itinerary,
  LOGO_ALT_TEXT,
  LightIconButton,
  LightTrashIconButton,
  Link,
  LinkButton,
  ListCard,
  ListFooter,
  LoadingOrErrorContainer,
  MAX_WIDTH,
  MallardBayLogo,
  MediaDisplayType,
  MediumIconButton,
  Menu,
  MenuItem,
  Modal,
  MultiMediaDisplay,
  MultiMediaDisplayComponent,
  NumberInput,
  NumberOfGuestsInput,
  Orientation,
  OutlinedButton,
  PAYMENT_METHOD_TYPE,
  PLACEHOLDER_IMG_SRC,
  Pagination,
  PaymentMethodCard,
  PaymentMethodCardContent,
  PaymentMethodSelector,
  PillButton,
  PricingPackageSelector,
  ProgressCard,
  Provider,
  ProviderErrors,
  ROWS_PER_PAGE_OPTIONS,
  RadioSelect,
  RatingInput,
  ResponsiveIconButton,
  ResponsiveSlider,
  RowButton,
  RowsPerPage,
  SIZES,
  Search,
  SelectInput,
  SelectableCard,
  Skeleton,
  SkeletonCircle,
  SkeletonContainer,
  SkeletonFill,
  SkeletonFillHorizontal,
  SmallIconButton,
  SortSelect,
  Span,
  Spinner,
  SubmitButton,
  TEST_IDS,
  Table,
  TableType,
  TableView,
  TabsList,
  Tag,
  TagList,
  TagVariant,
  Text,
  TextActive,
  TextBold,
  TextBoldExtraSmall,
  TextBoldLarge,
  TextBoldSmall,
  TextError,
  TextErrorSmall,
  TextExtraSmall,
  TextLarge,
  TextLargeBold,
  TextMedium,
  TextMediumBold,
  TextNote,
  TextNoteSmall,
  TextSecondary,
  TextSecondaryExtraSmall,
  TextSecondaryLarge,
  TextSecondarySmall,
  TextSmall,
  TextSmallNote,
  TextSmallSecondary,
  TextSmallUnderlined,
  TextUnderlined,
  TextUnderlinedSmall,
  TextXLargeBold,
  Textarea,
  TextareaWithBackground,
  Timeline,
  ToastWithActionContent,
  Tooltip,
  TripCalendarDatePicker,
  TripSummaryNoBreakdown,
  UPLOAD_CARE_BASE_DOMAIN,
  UploadCareImageVariant,
  VISIBILITY_STATES,
  VerticalStack,
  VerticalStackStretch,
  WizardContainer,
  WizardNavigation,
  WizardOverview,
  WizardProvider,
  WizardStep,
  componentStyles,
  darkTheme,
  getErrorToastContentProps,
  getSuccessToastContentProps,
  theme,
  useActionBannerColors,
  useColors,
  useCoreThemeForProvider,
  useIsDarkMode,
  useOrientation,
  useSetColorMode,
  useStepsWithCompletionStatus,
  useTheme,
  useToast,
  useToastWithAction,
  useToastWithActionWithDeferredProps,
  useWizardContext
});
